(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'rx',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'rzModule',
            'ui.carousel'
            //'vs-repeat'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();
// TODO: hacer como los demas services (estaba apurado por la demo)

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('User', User)
        .factory('UserByFacebook', UserByFacebook);

    User.$inject = ['$resource'];
    UserByFacebook.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:id', {}, {
            'query': { method: 'GET' },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }

    function UserByFacebook ($resource) {
        var service = $resource('api/users/facebook/:facebookId', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('showResult', showResult);

    showResult.$inject = [];

    function showResult () {
        return {
            subject: new Rx.BehaviorSubject(),
            subscribe: function(callback) {
              return this.subject.subscribe(callback);
            },
            sendMessage: function(msg) {
              this.subject.onNext(msg);
            },
            desubscribe: function () {
                this.subject.observers = [];
            }
          };
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/account/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];
    function Principal ($q, Account) {
        var _identitySubject = new Rx.BehaviorSubject(undefined),
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            getIdentitySubject: getIdentitySubject,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identitySubject.onNext(identity);
            _authenticated = _identitySubject.value !== null;
        }

        function getIdentitySubject() {
            return _identitySubject;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identitySubject.value || !_identitySubject.value.Authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identitySubject.value.Authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.Authorities && _id.Authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true || !angular.isDefined(_identitySubject.value)) {
                Account.get().$promise
                    .then(getAccountThen)
                    .catch(getAccountCatch);
            } else {
                deferred.resolve(_identitySubject.value);
            }

            return deferred.promise;

            function getAccountThen (account) {
                _identitySubject.onNext(account.data);
                _authenticated = true;
                deferred.resolve(_identitySubject.value);
            }

            function getAccountCatch () {
                _identitySubject.onNext(null);
                _authenticated = false;
                deferred.resolve(_identitySubject.value);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identitySubject.value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$http'];

    function PasswordResetInit($http) {
        return {
            save:save,
            getResetToken : getResetToken
        };

        function save(mail) {
            var user = { Email: mail};
            return $http.post('api/account/reset-password/token', user);
        }

        function getResetToken(user) {
            return $http.post('api/account/reset-password/token', user);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$http'];

    function PasswordResetFinish($http) {
        return {
            save : resetPassword
        };

        function resetPassword(data) {
            return $http.post('api/account/reset-password', data);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            });
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            });
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function toParams(obj) {
            var params = [];

            for (var key in obj) {
                params.push(key + '=' + encodeURIComponent(obj[key]));
            }

            return params.join('&');
        }

        function login (credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                grant_type: credentials.grant_type
            };

            return $http.post( 'token', toParams(data)).success(authenticateSuccess);

            function authenticateSuccess (data) {
                if (angular.isDefined(data.access_token) && data.token_type === 'bearer') {
                    service.storeAuthenticationToken(data.access_token, credentials.rememberMe);

                    return data.access_token;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();
            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource( 'api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['$sessionStorage', '$localStorage',
                    function ($sessionStorage, $localStorage) {
                        $sessionStorage.proyectoId = null;
                        $sessionStorage.cliente = null;
                        $sessionStorage.Imagen = null;
                        $localStorage = null;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$rootScope', '$state','Principal', '$timeout', 'Auth'];

    function HomeController ($rootScope, $state, Principal, $timeout, Auth) {

        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.grant_type = 'password';
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true,
                grant_type: 'password'
            };
            vm.authenticationError = false;
        }

        function login (event) {
            if(event != null) {
                event.preventDefault();
            }

            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe,
                grant_type: vm.grant_type
            }).then(function () {
                vm.authenticationError = false;


                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                $state.go('dashboard', {},{reload:true});

                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (resp) {
                if (resp.data.error === 'invalid_grant') {
                    vm.authenticationError = true;
                }

                if (resp.data.error === 'no_client') {
                    vm.noClientError = true;
                }
            });
        }

        function register () {
            $state.go('register');
        }

        function requestResetPassword () {
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('perfectStoreDashboardApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var fileURL = 'data:' + type +';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
                '<iframe src="' +
                fileURL +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            );
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
   'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('tendencias', {
            templateUrl: 'app/components/tendencias/tendencias.html',
            controller: 'TendenciasController',
            controllerAs: 'vm',
            bindings: {
                resultadoTendenciasIndicador: '=',
                mostrarTendencias: '=',
                cargandoTendencias: '='
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('TendenciasController', TendenciasController);

    TendenciasController.$inject = ['showResult'];

    function TendenciasController (showResult) {
        var vm = this;
        var meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio',
            'Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
        var trimestres = ["Enero a Marzo", "Abril a Junio",
            "Julio a Septiembre","Octubre a Diciembre"];
        var semestres = ["Enero a Junio",
            "Julio a Diciembre"];
        vm.mostrar = false;
        vm.disableMes = true;
        vm.disableTri = false;
        vm.datosMes = [];
        vm.datosTri = [];
        vm.datosSe = [];
        vm.datosAnio = [];
        var ultDatos = [];
        var ultDatosTri = [];
        var ultDatosSe = [];
        var ultDatosAnio = [];
        var labelsDatos = [];
        var labelsDatosTri = [];
        var labelsDatosSe = [];
        var labelsDatosAnio = [];
        var dt = new Date();
        dt.setMonth(dt.getMonth()-1);
        var myChart;

        vm.cargarTendencias = cargarTendencias;
        vm.cambioTri = cambioTri;
        vm.cambioMes = cambioMes;
        vm.cambioSe = cambioSe;
        vm.cambioAnio = cambioAnio;
        vm.change = change;
        vm.cargaChart = cargaChart;

        var showResultSubscribe = showResult.subscribe(function (x) {
            if(x === "cargaChartTendencia"){
                vm.change();
                vm.mostrarTendencias = true;
            }
        });

        function cargarTendencias(){
            var msg = "cargarTendencias";
            showResult.sendMessage(msg);
        }

        function cargaChart() {
            var ctx = document.getElementById("myChart").getContext('2d');

            var bgGrd = ctx.createLinearGradient(150.000, 0.000, 150.000, 300.000);
            // Add colors
            bgGrd.addColorStop(0.000, 'rgba(0, 0, 0, 0.2)');
            bgGrd.addColorStop(1.000, 'rgba(255, 255, 255, 0.000)');
            var grd = ctx.createLinearGradient(0.000, 150.000, 300.000, 150.000);
            // Add colors
            grd.addColorStop(0.500, 'rgba(72, 189, 231, 1)');
            grd.addColorStop(1.000, 'rgba(57, 210, 163, 1)');

            vm.datosAnio = [
                {
                    data: ultDatosAnio,
                    backgroundColor: bgGrd,
                    borderColor: grd,
                    borderWidth: 10
                }
            ];

            vm.dataAnio = {
                labels: labelsDatosAnio,
                datasets: vm.datosAnio
            };

            vm.datosSe = [
                {
                    data: ultDatosSe,
                    backgroundColor: bgGrd,
                    borderColor: grd,
                    borderWidth: 10
                }
            ];

            vm.dataSe = {
                labels: labelsDatosSe,
                datasets: vm.datosSe
            };

            vm.datosTri = [
                {
                    data: ultDatosTri,
                    backgroundColor: bgGrd,
                    borderColor: grd,
                    borderWidth: 10
                }
            ];

            vm.dataTri = {
                labels: labelsDatosTri,
                datasets: vm.datosTri
            };


            vm.datosMes = [
                {
                    data: ultDatos,
                    backgroundColor: bgGrd,
                    borderColor: grd,
                    borderWidth: 10
                }
            ];

            vm.dataMes = {
                labels: labelsDatos,
                datasets: vm.datosMes
            };

            var orangeGradient = ctx.createLinearGradient(0, 0, 0, 400);
            orangeGradient.addColorStop(0, '#fdbba9');
            orangeGradient.addColorStop(1, 'white');

            vm.myChart = new Chart(ctx,
                {
                    type: 'line',
                    data: {
                        labels: labelsDatos,
                        datasets: [{
                            data: ultDatos,
                            fill: true,
                            // fillColor : gradient,
                            backgroundColor: orangeGradient,
                            hoverBackgroundColor: orangeGradient,
                            hoverBorderWidth: 2,
                            pointBackgroundColor: "#f96332",
                            pointBorderColor: "#FFFFFF",
                            pointBorderWidth: 2,
                            pointRadius: 4,
                            borderWidth: 8
                        }]
                    },
                    options:
                        {
                            legend:
                                {
                                    display: false
                                }

                        }
                });
        }

        function change() {
            if(vm.myChart != null){
                vm.myChart.destroy();
            }
            myChart = null;
            labelsDatos = [];
            labelsDatosTri = [];
            labelsDatosSe = [];
            labelsDatosAnio = [];
            ultDatos = [];
            ultDatosTri = [];
            ultDatosSe = [];
            ultDatosAnio = [];
            //console.log(vm.resultadoTendenciasIndicador);
            if(vm.resultadoTendenciasIndicador.length !== 0) {
                var cont = 0;
                var acum = 0;
                var contSe = 0;
                var acumSe = 0;
                var contAn = 0;
                var acumAn = 0;
                angular.forEach(vm.resultadoTendenciasIndicador, function (item) {
                    var label = meses[item.mes-1] + ' - ' + item.anio;
                    labelsDatos.push(label);
                    ultDatos.push(parseFloat(item.valor).toFixed(2));
                    acum = acum + parseFloat(item.valor);
                    acumSe = acumSe + parseFloat(item.valor);
                    acumAn = acumAn + parseFloat(item.valor);
                    if (item.mes === 6 || item.mes === 12) {
                        var labelSe;
                        if(item.mes === 6){
                            labelSe = semestres[0] + ' - ' + item.anio;
                        }
                        else{
                            labelSe = semestres[1] + ' - ' + item.anio;
                        }
                        ultDatosSe.push(parseFloat(acumSe).toFixed(2));
                        labelsDatosSe.push(labelSe);
                        contSe = 0;
                        acumSe = 0;
                    }
                    if (item.mes === 12) {
                        var labelAnio = item.anio;
                        ultDatosAnio.push(parseFloat(acumAn).toFixed(2));
                        if(labelAnio == null){
                            labelAnio = dt.getFullYear();
                        }
                        labelsDatosAnio.push(labelAnio);
                        contAn = 0;
                        acumAn = 0;
                    }
                    if(item.mes === 3 || item.mes === 6 || item.mes === 9 || item.mes === 12){
                        var labelTri;
                        if (item.mes === 3){
                            labelTri = trimestres[0] + ' - ' + item.anio;
                        }
                        else if (item.mes === 6){
                            labelTri = trimestres[1] + ' - ' + item.anio;
                        }
                        else if (item.mes === 9){
                            labelTri = trimestres[2] + ' - ' + item.anio;
                        }
                        else{
                            labelTri = trimestres[3] + ' - ' + item.anio;
                        }
                        ultDatosTri.push(parseFloat(acum).toFixed(2));
                        labelsDatosTri.push(labelTri);
                        cont = 0;
                        acum = 0;
                    }
                    else {
                        cont = cont + 1;
                        contSe = contSe + 1;
                        contAn = contAn + 1;
                    }
                });
                if(cont !== 0){
                    ultDatosTri.push(parseFloat(acum).toFixed(2));
                }
                if(contSe !== 0){
                    ultDatosSe.push(parseFloat(acumSe).toFixed(2));
                }
                if(contAn !== 0){
                    ultDatosAnio.push(parseFloat(acumAn).toFixed(2));
                }
                cargaChart();
            }
            else{
            }
        }

        function cambioAnio() {
            vm.myChart.data.labels = vm.dataAnio.labels;
            vm.myChart.data.datasets[0].data = vm.dataAnio.datasets[0].data;
            vm.myChart.update();
            vm.disableTri = false;
            vm.disableMes = false;
            vm.disableSe = false;
            vm.disableAnio = true;
        }

        function cambioSe() {
            vm.myChart.data.labels = vm.dataSe.labels;
            vm.myChart.data.datasets[0].data = vm.dataSe.datasets[0].data;
            vm.myChart.update();
            vm.disableTri = false;
            vm.disableMes = false;
            vm.disableSe = true;
            vm.disableAnio = false;
        }

        function cambioTri() {
            vm.myChart.data.labels = vm.dataTri.labels;
            vm.myChart.data.datasets[0].data = vm.dataTri.datasets[0].data;
            vm.myChart.update();
            vm.disableTri = true;
            vm.disableMes = false;
            vm.disableSe = false;
            vm.disableAnio = false;
        }

        function cambioMes() {
            vm.myChart.data.labels = vm.dataMes.labels;
            vm.myChart.data.datasets[0].data = vm.dataMes.datasets[0].data;
            vm.myChart.update();
            vm.disableTri = false;
            vm.disableMes = true;
            vm.disableSe = false;
            vm.disableAnio = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('TarjetasModalController', TarjetasModalController);

    TarjetasModalController.$inject = ['$uibModalInstance', '$http', 'filterList', '$sessionStorage', 'entity'];

    function TarjetasModalController($uibModalInstance, $http, filterList, $sessionStorage, entity) {
        var vm = this;

        vm.posiciones = [1,2,3];

        vm.graficas = [];

        vm.graficas = entity.data;

        vm.posicionElegida = null;

        vm.graficaElegida = null;

        vm.graficasElegidas = [{Pos: 1}, {Pos: 2}, {Pos: 3}];

        vm.proyectoId = $sessionStorage.proyectoId;

        vm.mostrarGuardar = false;

        angular.forEach(vm.graficasElegidas, function (obj) {
            filterList.find(function(value) {
                if (value.Pos === obj.Pos) {
                    obj.IdGrafica = value.IdGrafica;
                    obj.IdProyecto = value.IdProyecto;
                    vm.graficas.find(function(grafica) {
                        if (grafica.IdGrafica === obj.IdGrafica) {
                            obj.NombreGrafica = grafica.SubTituloGrafica + " - " + grafica.TituloGrafica;
                        }
                    })
                }
            });
        });

        vm.agregarGrafica = agregarGrafica;
        vm.cambioPos = cambioPos;
        vm.save = save;
        vm.deleteGrafica = deleteGrafica;



        function agregarGrafica() {
            angular.forEach(vm.graficasElegidas, function (obj) {
                if(obj.Pos === vm.posicionElegida){
                    obj.IdGrafica = vm.graficaElegida.IdGrafica;
                    obj.NombreGrafica = vm.graficaElegida.SubTituloGrafica + " - " + vm.graficaElegida.TituloGrafica;
                    obj.IdProyecto = vm.proyectoId;
                }
            });
        }

        function cambioPos() {
            vm.mostrarGuardar = false;
            angular.forEach(vm.graficasElegidas, function (obj) {
                if(obj.Pos === vm.posicionElegida){
                    if(obj.IdGrafica){
                        vm.graficas.find(function(value) {
                            if (value.IdGrafica === obj.IdGrafica) {
                                vm.graficaElegida = value;
                                vm.mostrarGuardar = true;
                            }
                        })
                    }
                }
            })
        }

        function save() {
            $http.post('api/grafica/' + vm.proyectoId, vm.graficasElegidas).then(function () {
                $uibModalInstance.close();
            });
        }

        function deleteGrafica(pos){
            vm.graficasElegidas[pos-1] = {Pos: pos};
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('tarjetas', {
            templateUrl: 'app/components/tarjetas/tarjetas.html',
            controller: 'TarjetasController',
            controllerAs: 'vm',
            bindings: {
                resultadoGraficaSecundaria: '=',
                graficasSecundarias: '=',
                graficaNoConfigurada: '=',
                cargandoGraficaSecundarias: '='
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('TarjetasController', TarjetasController);

    TarjetasController.$inject = ['showResult', '$uibModal','$sessionStorage'];

    function TarjetasController(showResult,$uibModal,$sessionStorage) {
        var vm = this;
        var ctx = document.getElementById('chart-pos-1').getContext('2d');

        var orangeGradient = ctx.createLinearGradient(0, 0, 0, 270);
        orangeGradient.addColorStop(0, '#fdbba9');
        orangeGradient.addColorStop(1, 'white');

        var greenGradient = ctx.createLinearGradient(0, 0, 0, 270);
        greenGradient.addColorStop(0, '#bfefc4');
        greenGradient.addColorStop(1, 'white');

        var lightblueGradient = ctx.createLinearGradient(0, 0, 0, 270);
        lightblueGradient.addColorStop(0, '#80cbff');
        lightblueGradient.addColorStop(1, 'white');

        vm.titulo = ["-","-","-"];

        vm.subTitulo = ["-","-","-"];

        vm.tipo = [null,null,null];

        
        if($sessionStorage.nombreProyecto == "DURACELLARG"){
            vm.mostrarlabel = [true, true, true];
        }
        else{
            vm.mostrarlabel = [false, false, false];
        }

        var colors = ["#f96332", "#18ce0f", "#44b2ff"];

        var Chart1 = [null,null,null];

        vm.cargarGrafico = cargarGrafico;
        vm.configurarGraficos = configurarGraficos;
        vm.cambiarTipo = cambiarTipo;
        vm.cambiarLabel = cambiarLabel;
        vm.sendEventGraficaSecundariaCarga = sendEventGraficaSecundariaCarga;

        showResult.subscribe(function(x) {
            if (x === "cargaGrafico1") {
                mostrarLabelsSobreGraficos();
                cargarGrafico(1);
            }
            if (x === "cargaGrafico2") {
                mostrarLabelsSobreGraficos();
                cargarGrafico(2);
            }
            if (x === "cargaGrafico3") {
                mostrarLabelsSobreGraficos();
                cargarGrafico(3);
            }
            if (x === "limpiar"){
                limpiarGraficos();
            }
        });


        function mostrarLabelsSobreGraficos(){
            if($sessionStorage.nombreProyecto == "DURACELLARG"){
                vm.mostrarlabel = [true, true, true];
            }
            else{
                vm.mostrarlabel = [false, false, false];
            }
        }

        function limpiarGraficos() {
            if(Chart1[0] != null){
                Chart1[0].destroy();
            }
            if(Chart1[1] != null){
                Chart1[1].destroy();
            }
            if(Chart1[2] != null){
                Chart1[2].destroy();
            }
        }

        function cambiarTipo(indice) {
            angular.forEach(vm.resultadoGraficaSecundaria, function (obj, index) {
                if(obj.Pos === (indice + 1)){
                    var tipo = obj.tipoGrafica.TiposGrafica;
                    if(tipo === "line"){
                        obj.tipoGrafica.TiposGrafica = 'bar';
                    }
                    else{
                        obj.tipoGrafica.TiposGrafica = 'line';
                    }
                    if(Chart1[indice] != null){
                        Chart1[indice].destroy();
                    }
                    cargarGrafico(index + 1);
                }
            });
        }

        function cambiarLabel(indice) {
            vm.mostrarlabel[indice] = !vm.mostrarlabel[indice];
            angular.forEach(vm.resultadoGraficaSecundaria, function (obj, index) {
                if(obj.Pos === (indice + 1)){
                    Chart1[indice].destroy();
                    cargarGrafico(index + 1);
                }
            });
        }

        function cargarGrafico(i) {
            var labels = [];
            var data = [];

            

            angular.forEach(vm.resultadoGraficaSecundaria[i-1].resultados, function (obj) {
                if(obj.resultado >= 0.01){
                    var labelToPush = "";
                    angular.forEach(obj.nombresFiltros, function (label) {
                        labelToPush = labelToPush + "" + label;
                    });
                    labels.push(labelToPush);
                    data.push(Math.round(obj.resultado * 100));
                }
            });

            var pos = vm.resultadoGraficaSecundaria[i-1].Pos;

            vm.titulo[pos - 1] = vm.resultadoGraficaSecundaria[i-1].grafica.TituloGrafica;
            vm.subTitulo[pos - 1] = vm.resultadoGraficaSecundaria[i-1].grafica.SubTituloGrafica;
            vm.tipo[pos - 1] = vm.resultadoGraficaSecundaria[i-1].tipoGrafica.TiposGrafica;
            var tipo = vm.resultadoGraficaSecundaria[i-1].tipoGrafica.TiposGrafica;

            var gradient;
            if(i === 1){
                gradient = orangeGradient;
            }
            if(i === 2){
                gradient = greenGradient;
            }
            if(i === 3){
                gradient = lightblueGradient;
            }

            var plugins = null;

            if(vm.mostrarlabel[pos-1])
            {
                plugins = [{
                    afterDatasetsDraw: function (chart, easing) {
                        // To only draw at the end of animation, check for easing === 1
                        var ctx = chart.ctx;
                        chart.data.datasets.forEach(function (dataset, i) {
                            var band = false;
                            var meta = chart.getDatasetMeta(i);
                            if (!meta.hidden) {
                                meta.data.forEach(function (element, index) {
                                    // Draw the text in black, with the specified font
                                    ctx.fillStyle = 'rgb(0, 0, 0)';
                                    var fontSize = 8;
                                    var fontStyle = 'normal';
                                    var fontFamily = 'Roboto';
                                    ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
                                    // Just naively convert to string for now
                                    var dataString = chart.data.labels[index];
                                    // Make sure alignment settings are correct
                                    ctx.textAlign = 'center';
                                    ctx.textBaseline = 'middle';
                                    //var padding = 10;
                                    var padding = 0;
                                    var position = element.tooltipPosition();
                                    if (band) {
                                        band = false;
                                        ctx.fillText(dataString, position.x, position.y + (fontSize / 2) + padding);
                                    } else {
                                        band = true;
                                        ctx.fillText(dataString, position.x, position.y - (fontSize / 2) - padding);
                                    }
                                });
                            }
                        });
                    }
                }];
            }

            Chart1[pos-1] = new Chart(document.getElementById("chart-pos-"+pos), {
                plugins: plugins,
                type: tipo,
                data: {
                    labels: labels,
                    datasets: [{
                        label: vm.resultadoGraficaSecundaria[i-1].grafica.DescripcionResultado,
                        data: data,
                        borderColor: colors[i-1],
                        fill: true,
                        backgroundColor: gradient,
                        hoverBackgroundColor: gradient,
                        hoverBorderWidth: 2,
                        pointBackgroundColor: colors[i-1],
                        pointBorderColor: "#FFFFFF",
                        pointBorderWidth: 2,
                        pointRadius: 4
                    }]
                },
                options: {
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    title: {
                        display: false,
                        text: ''
                    },
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            display: false,
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: "#000000",
                                fontFamily: "Arial",
                                fontSize: 8
                            }
                        }],
                        yAxes: [{
                            display: true,
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: "#000000",
                                fontFamily: "Arial",
                                fontSize: 12,
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });
        }

        function sendEventGraficaSecundariaCarga() {
            var msg = "cargarGraficas";
            showResult.sendMessage(msg);
        }

        function configurarGraficos() {
            var graficosActuales = vm.graficasSecundarias;
            vm.proyectoId = $sessionStorage.proyectoId;
            $uibModal.open({
                templateUrl: 'app/components/tarjetas/tarjetas-modal.html',
                controller: 'TarjetasModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    filterList: function (){
                        return graficosActuales;
                    },
                    entity: ['$http', function($http) {
                        return $http.get('api/grafica/all/' + vm.proyectoId);
                    }]
                }
            }).result.then(function (result) {
                if(Chart1[0] != null){
                    Chart1[0].destroy();
                }
                if(Chart1[1] != null){
                    Chart1[1].destroy();
                }
                if(Chart1[2] != null){
                    Chart1[2].destroy();
                }
                vm.sendEventGraficaSecundariaCarga();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('tablero', {
            templateUrl: 'app/components/tablero/tablero.html',
            controller: 'TableroController',
            controllerAs: 'vm',
            bindings: {
                proyectoId: '=',
                cliente : '=',
                indicadorCanal: '=',
                menuPrincipal: '='
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('TableroController', TableroController);

    TableroController.$inject = ['$rootScope','$scope', '$http', '$timeout',  'Principal', 'showResult', '$uibModal'];

    function TableroController($rootScope, $scope, $http, $timeout, Principal, showResult, $uibModal) {
        var vm = this;
        vm.filtros = { Geografia: {}, Distribucion: {}, Cadena: {} };
        vm.indicadores = {};
        var date = new Date;
        var year = date.getFullYear();
        var trimesterMonth = date.getMonth()-2;
        var day = date.getDate();
        if (trimesterMonth === 0){
            trimesterMonth = 12;
            year = date.getFullYear()-1;
        } else if (trimesterMonth === -1) {
            trimesterMonth = 11;
            year = date.getFullYear()-1;
        } else if (trimesterMonth === -2){
            trimesterMonth = 10;
            year = date.getFullYear()-1;
        }
        var lastMonth = (new Date(new Date().setDate(new Date().getDate()-30))).toLocaleString("sv-SE")
        var lastMonthString = lastMonth.substring(0,10)
        vm.fechas = { fechadesde: 'null' , fechahasta: 'null' };
        vm.loaded = {};
        vm.menu = {};
        vm.menuElegido = {};
        vm.menuTablero = {};
        vm.crumbMenu = {};
        vm.hideMenu = false;
        vm.usuarioId = Principal.identity().$$state.value.Id;
        vm.returnMenu = returnMenu;
        vm.setOpcion = setOpcion;
        vm.mostrarFiltros = mostrarFiltros;
        vm.proyectColombia = proyectColombia;

        //load data only after menu is loaded
        var watch = $rootScope.$watch('isMenuLoaded', function (ìsMenuLoaded) {
            if(ìsMenuLoaded){
                loadCanales();
            }
        }, true);

        function loadCanales() {
            vm.indicadores = {};
            if(vm.proyectoId) {
                    $http.get('api/canales/' + vm.proyectoId).then(function (response) {
                    vm.canales = response.data;
                    loadMenuTablero();
                });
            }
        }

        function getIndicadores() {
            var promises = []
            angular.forEach(vm.canales, function (canal) {
                var promise = loadCanal(canal);
                promise.then(function () {
                    vm.loaded[canal.Nombre] = true;
                })
                promises.push(promise);
            });
            return Promise.all(promises);
        }

        function loadMenuTablero(){
            vm.menuTablero = {};
            $http.get('api/menuTablero/proyecto/' + vm.proyectoId).then(function (response) {
                const menuRes = response.data;
                angular.forEach(menuRes, function(res){
                    vm.menuTablero[res.IdMenu] = res.Titulo;
                })
                getIndicadores();
            });
        }

        function loadCanal(canal) {
            vm.loaded[canal.Nombre] = false;
            vm.menu = {};
            var resolvePromise,
                promise = new Promise(function (resolve) {
                    resolvePromise = resolve;
                }),
                promises = [],
                menuCanal = {};
            $http.get('api/indicadorTablero/' + vm.cliente.IdCliente + '/' + vm.proyectoId + '/' + canal.IdCanal).then(function (response) {
                const resTablero = response.data;
                //Armo el menu del canal
                angular.forEach(resTablero, function (indi){
                    if (indi.IdMenu !== null){
                        angular.forEach(vm.menuTablero, function (titulo, key){
                            if (indi.IdMenu == key){
                                indi['NombreMenu'] = titulo;
                            }
                        })
                        // promises.push(addNameMenu(indi));
                    }
                    if (indi.IdMenuPadre !== null){
                        if (!menuCanal[indi.IdMenuPadre]) menuCanal[indi.IdMenuPadre] = [];
                        menuCanal[indi.IdMenuPadre][indi.Orden] = indi;
                    }
                    else {
                        if (!menuCanal[0]) menuCanal[0] = [];
                        menuCanal[0][indi.Orden] = indi;
                    }
                });
                //Elimino los null
                angular.forEach(menuCanal, function(m, index){
                    menuCanal[index] = m.filter(function(){
                        return true
                    });
                })
                //Cargo indicador
                angular.forEach(resTablero, function (indicador) {
                    if (indicador.IdIndicador !== null){
                        promises.push(loadIndicador(canal, indicador));
                    }
                })
                Promise.all(promises).then(function () {
                    resolvePromise();
                    if (!angular.equals(menuCanal,{})){
                        vm.menu[canal.Nombre] = angular.copy(menuCanal);
                        //Si tiene indicadores le cargo la preview de resultados
                        angular.forEach(vm.menu[canal.Nombre][0], function(m, index){
                            if (m.IdIndicador !== null){
                                angular.forEach(vm.indicadores[canal.Nombre][0], function(indi){
                                    if (indi.info.IdIndicador === m.IdIndicador){
                                        vm.menu[canal.Nombre][0][index] = angular.copy(indi);
                                    }
                                });
                            }
                        });
                        vm.menuPrincipal = angular.copy(vm.menu);
                        //Agrego el nombre del indicador al menuPrincipal
                        angular.forEach(vm.menuPrincipal[canal.Nombre], function(menuAgrupado,index1){
                            angular.forEach(menuAgrupado, function(menu, index2){
                                if (menu.IdIndicador !== null){
                                    angular.forEach(vm.indicadores[canal.Nombre], function(indiAgrupado){
                                        angular.forEach(indiAgrupado, function(indi){
                                            if (menu.IdIndicador === indi.info.IdIndicador){
                                                vm.menuPrincipal[canal.Nombre][index1][index2]["NombreMenu"] = indi.info.NombreIndicador;
                                            }
                                        });
                                    });
                                }
                            })
                        });

                        // console.log('vm.menuPrincipal',vm.menuPrincipal);
                        // console.log('vm.menu',vm.menu);
                    }
                });
            });
            return promise;
        }

        function returnMenu(menuActual, canalActual){
            var idMenuPadre,
                idMenu,
                menuCanal = {};
            idMenuPadre = menuActual.IdMenuPadre;
            menuCanal = vm.menu[canalActual];
            //Busco el menu padre
            angular.forEach(menuCanal, function(menuInterno){
                angular.forEach(menuInterno, function(indi){
                    if (indi.IdMenu !== undefined && indi.IdMenu !== null){
                        if(indi.IdMenu === idMenuPadre){
                            idMenu = indi.IdMenuPadre === null ? 0 : indi.IdMenuPadre;
                        }
                    }
                });
            });
            //Si tiene indicadores les cargo la preview de resultados
            angular.forEach(menuCanal[idMenu], function(m, index){
                if (m.IdIndicador !== null){
                    angular.forEach(vm.indicadores[canalActual][idMenu], function(indi){
                        if (indi.info.IdIndicador === m.IdIndicador){
                            menuCanal[idMenu][index] = angular.copy(indi);
                        }
                    });
                }
            });
            vm.menuElegido[canalActual] = angular.copy(menuCanal[idMenu]);
            //Elimino del crumbMenu el menu y submenus elegido
            angular.forEach(vm.crumbMenu[canalActual], function(crumb, index){
                if (crumb.IdMenu === idMenuPadre){
                    vm.crumbMenu[canalActual].splice(index);
                }
            });
        }

        // function addNameMenu(indi){
        //     var resolvePromise,
        //     promise = new Promise(function (resolve) {
        //         resolvePromise = resolve;
        //     });
        //     $http.get('api/menuTablero/' + indi.IdMenu).then(function (response) {
        //         const menuData = response.data;
        //         indi['NombreMenu'] = menuData.Titulo;
        //         indi['Filtros'] = menuData.Filtro;
        //         resolvePromise();
        //     });
        //     return promise;
        // }

        function loadIndicador(canal, indicadorEntry) {
            var indicador = { canal: canal, span: indicadorEntry.Span},
                resolvePromise,
                promise = new Promise(function (resolve) {
                    resolvePromise = resolve;
                });
            const dataIndicador = {
                "idProyecto": "" + vm.proyectoId,
                "idUsuario": "" + vm.usuarioId,
                "nombrecanal": "" + canal.Nombre,
                "idIndicador": "" + indicadorEntry.IdIndicador,
                "idMenuPadre": "" + indicadorEntry.IdMenuPadre,
                "fil": cargarFiltros(),
                "fechadesde": ( vm.fechas.fechadesde ? vm.fechas.fechadesde : lastMonthString ),
                "fechahasta": vm.fechas.fechahasta,
                "vision": []
            };
            console.log(dataIndicador)
            $http.get('api/indicadores/indicador/' + indicadorEntry.IdIndicador).then(function (response) {
                indicador.info = response.data;
                indicador.IdMenuPadre = indicadorEntry.IdMenuPadre === null ? 0 : indicadorEntry.IdMenuPadre;
                if (indicador.info.IdPerfectStore) {
                    var dataPerfectStore = angular.copy(dataIndicador);
                    dataPerfectStore.idIndicador = indicador.info.IdPerfectStore;
                    $http.post('api/resultado/perfectStore/multipleKpi', dataPerfectStore).then(function (response) {
                        indicador.isPerfectStore = true;
                        indicador.resultado = response.data[0];
                        indicador.secundarias = response.data.slice(1);
                        if (!vm.indicadores[canal.Nombre]) vm.indicadores[canal.Nombre] = {};
                        if (!vm.indicadores[canal.Nombre][indicador.IdMenuPadre]) vm.indicadores[canal.Nombre][indicador.IdMenuPadre] = {};
                        vm.indicadores[canal.Nombre][indicador.IdMenuPadre][indicadorEntry.Orden] = indicador;
                        resolvePromise();
                    });
                }
                else if (indicador.info.IdMedidaIndicador === 1068){
                    indicador.resultado = {};
                    indicador.secundarias = {};
                    if (indicadorEntry.IdMenuPadre != null){
                        var MenuPadre = [];
                        $http.get('api/indicadorTablero/' + indicadorEntry.IdIndicador + '/' + indicadorEntry.IdMenuPadre).then(function (response) {
                            const resTablero = response.data;
                            angular.forEach(resTablero, function(tablero) {
                                angular.forEach(vm.menuTablero, function (titulo, key){
                                    if (tablero.IdMenu == key){
                                        MenuPadre.unshift(titulo);
                                        indicador.info["MenuPadre"] = MenuPadre;
                                    }
                                });
                            });
                            if (!vm.indicadores[canal.Nombre]) vm.indicadores[canal.Nombre] = {};
                            if (!vm.indicadores[canal.Nombre][indicador.IdMenuPadre]) vm.indicadores[canal.Nombre][indicador.IdMenuPadre] = {};
                            vm.indicadores[canal.Nombre][indicador.IdMenuPadre][indicadorEntry.Orden] = indicador;
                            resolvePromise();
                        });
                    }
                    else {
                        if (!vm.indicadores[canal.Nombre]) vm.indicadores[canal.Nombre] = {};
                        if (!vm.indicadores[canal.Nombre][indicador.IdMenuPadre]) vm.indicadores[canal.Nombre][indicador.IdMenuPadre] = {};
                        vm.indicadores[canal.Nombre][indicador.IdMenuPadre][indicadorEntry.Orden] = indicador;
                        resolvePromise();
                    }
                }
                else {
                    $http.post('api/resultado/indicadores', dataIndicador).then(function (response) {
                        indicador.resultado = response.data[0];
                        indicador.secundarias = [];
                        $http.get('api/medidas/secundarias/' + indicadorEntry.IdIndicador).then(function (response) {
                            angular.forEach(response.data, function (secundaria) {
                                const dataSecu = {
                                    "medidaSecundariaId": secundaria.IdMedidaSecundaria,
                                    "idProyecto": "" + vm.proyectoId,
                                    "idUsuario": "" + vm.usuarioId,
                                    "nombrecanal": "" + canal.Nombre,
                                    "idIndicador": "" + indicadorEntry.IdIndicador,
                                    "idMenuPadre": "" + indicadorEntry.IdMenuPadre,
                                    "fil": [],
                                    "fechadesde": ( vm.fechas.fechadesde ? vm.fechas.fechadesde : lastMonthString ),
                                    "fechahasta": vm.fechas.fechahasta,
                                    "vision": [],
                                };
                                $http.post('api/resultado/secundario', dataSecu).then(function (response) {
                                    angular.forEach(response.data, function (obj, index) {
                                        obj.Medida = angular.copy(secundaria);
                                        indicador.secundarias.push(obj);
                                    });
                                    if (indicadorEntry.IdMenuPadre != null){
                                        var MenuPadre = [];
                                        $http.get('api/indicadorTablero/' + indicadorEntry.IdIndicador + '/' + indicadorEntry.IdMenuPadre).then(function (response) {
                                            const resTablero = response.data;
                                            angular.forEach(resTablero, function(tablero) {
                                                angular.forEach(vm.menuTablero, function (titulo, key){
                                                    if (tablero.IdMenu == key){
                                                        MenuPadre.unshift(titulo);
                                                        indicador.info["MenuPadre"] = MenuPadre;
                                                    }
                                                });
                                                // $http.get('api/menuTablero/' + tablero.IdMenu).then(function (response) {
                                                //     const resMenu = response.data;
                                                //     MenuPadre.unshift(resMenu.Titulo);
                                                //     indicador.info["MenuPadre"] = MenuPadre;
                                                // });
                                            });
                                            if (!vm.indicadores[canal.Nombre]) vm.indicadores[canal.Nombre] = {};
                                            if (!vm.indicadores[canal.Nombre][indicador.IdMenuPadre]) vm.indicadores[canal.Nombre][indicador.IdMenuPadre] = {};
                                            vm.indicadores[canal.Nombre][indicador.IdMenuPadre][indicadorEntry.Orden] = indicador;
                                            resolvePromise();
                                        });
                                    }
                                    else {
                                        if (!vm.indicadores[canal.Nombre]) vm.indicadores[canal.Nombre] = {};
                                        if (!vm.indicadores[canal.Nombre][indicador.IdMenuPadre]) vm.indicadores[canal.Nombre][indicador.IdMenuPadre] = {};
                                        vm.indicadores[canal.Nombre][indicador.IdMenuPadre][indicadorEntry.Orden] = indicador;
                                        resolvePromise();
                                    }
                                });
                            });
                        });
                    });
                }
            });
            return promise;
        }

        function setOpcion(opcion,canal) {
            if (opcion !== undefined && canal !== undefined){
                vm.menuElegido[canal.Nombre] = {};
                if (opcion.IdIndicador === null && opcion.IdMenu !== null){
                    vm.menuElegido[canal.Nombre] = angular.copy(vm.menu[canal.Nombre][opcion.IdMenu]);
                    angular.forEach(vm.menu[canal.Nombre][opcion.IdMenu], function(op, index){
                        if (op.IdIndicador !== null){
                            angular.forEach(vm.indicadores[canal.Nombre][opcion.IdMenu], function(indi){
                                if (indi.info.IdIndicador === op.IdIndicador){
                                    vm.menuElegido[canal.Nombre][index] = angular.copy(indi);
                                }
                            });
                        }
                    });
                    vm.hideMenu = true;
                    if (!vm.crumbMenu[canal.Nombre]) vm.crumbMenu[canal.Nombre] = [];
                    vm.crumbMenu[canal.Nombre].push(opcion);
                }
                else{
                    vm.hideMenu = false;
                    vm.crumbMenu[canal.Nombre] = [];
                    opcion.info["IdMenuPadre"] = opcion.IdMenuPadre;
                    vm.indicadorCanal = { canal: opcion.canal, indicador: opcion.info }
                }
            }
        }

        function mostrarFiltros(canalNombre) {
            var canal = vm.canales.filter(function (canal) { return canal.Nombre == canalNombre })[0];
            $uibModal.open({
                templateUrl: 'app/components/tablero/filtros.html',
                controller: 'FiltrosTableroController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    filtros: function () { return vm.filtros },
                    proyectoId: function () { return vm.proyectoId },
                    canalElegido: function () { return canalNombre },
                    fechas: function () { return vm.fechas },
                    indicadores: function () { return vm.indicadores[canalNombre] }
                }
            }).result.then(function (result) {
                vm.filtros = result.filtros;
                vm.fechas = result.fechas;
                loadCanal(canal).then(function () {
                    vm.loaded[canal.Nombre] = true;
                });
            });
        }

        function cargarFiltros() {
            vm.arregloFiltros = [];
            var valueFilterGeo = vm.filtros.Geografia;
            var colFilterGeo = vm.filtros.ColumnaGeografia;
            var valueFilterDis = vm.filtros.Distribucion;
            var colFilterDis = vm.filtros.ColumnaDistribucion;
            var valueAdicional = vm.filtros.Adicionales;

            if (!vm.filtros.Geografia) {
                valueFilterGeo = "null";
                colFilterGeo = "null";
            }
            if (!vm.filtros.Distribucion) {
                valueFilterDis = "null";
                colFilterDis = "null";
            }
            if (!vm.filtros.Adicionales) {
                valueAdicional = "null";
            }

            if (valueFilterGeo !== "null") {
                angular.forEach(valueFilterGeo, function (item) {
                    vm.arregloFiltros.push({
                        valorFiltroGeografia: item.valor.toString(),
                        columnaFiltroGeografia: item.columna.toString(),
                        valorFiltroDistribucion: "null",
                        columnaFiltroDistribucion: "null",
                        table: item.table.toString()
                    })
                });
            }
            if (valueFilterDis !== "null") {
                angular.forEach(valueFilterDis, function (item) {
                    vm.arregloFiltros.push({
                        valorFiltroDistribucion: item.valor.toString(),
                        columnaFiltroDistribucion: item.columna.toString(),
                        valorFiltroGeografia: "null",
                        columnaFiltroGeografia: "null",
                        table: item.table.toString()
                    })
                });
            }
            if (valueAdicional !== "null") {
                angular.forEach(valueAdicional, function (item) {
                    var geografia = false;
                    angular.forEach(vm.filtrosvisiones.m_Item2[0].VisionValues, function (filtro) {
                        if (filtro.OptionValue === item.columna) {
                            geografia = true;
                        }
                    });
                    if (geografia) {
                        vm.arregloFiltros.push({
                            valorFiltroGeografia: item.valor.toString(),
                            columnaFiltroGeografia: item.columna.toString(),
                            valorFiltroDistribucion: "null",
                            columnaFiltroDistribucion: "null",
                            table: item.table.toString()
                        })
                    }
                    else {
                        vm.arregloFiltros.push({
                            valorFiltroGeografia: "null",
                            columnaFiltroGeografia: "null",
                            valorFiltroDistribucion: item.valor.toString(),
                            columnaFiltroDistribucion: item.columna.toString(),
                            table: item.table.toString()
                        })
                    }
                });
            }
            if(vm.arregloFiltros.length == 0) return [{"valorFiltroGeografia":"null","columnaFiltroGeografia":"null","valorFiltroDistribucion":"null","columnaFiltroDistribucion":"null"}];
            return vm.arregloFiltros;
        }

        //Formato pesos para Colombia Precios
        function proyectColombia(medidaIndicador, secu) {
            if (vm.proyectoId == 25 || vm.proyectoId == 60){
                if (medidaIndicador.info.IdMedidaIndicador == 1033 && secu.Medida.IdMedidaSecundaria == 36){
                    vm.valor = parseFloat(secu.resultado).format(2, 3, '.', ',');
                    return true;
                }
            }
            return false;
        }
        Number.prototype.format = function(n, x, s, c) {
            var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
                num = this.toFixed(Math.max(0, ~~n));
            return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('FiltrosTableroController', FiltrosTableroController);

    FiltrosTableroController.$inject = ['$http', '$uibModalInstance', 'filtros', 'fechas', 'proyectoId', 'canalElegido', 'indicadores', '$uibModal'];

    function FiltrosTableroController($http, $uibModalInstance, filtros, fechas, proyectoId, canalElegido, indicadores, $uibModal) {
        var vm = this;
        vm.fechas = fechas;
        vm.proyectoId = proyectoId;
        vm.canalElegido = canalElegido;
        vm.filtrosSelected = {};
        vm.filtros = filtros;
        vm.filtrosList = {};
        vm.loaded = false;
        loadFiltros();
        vm.aceptar = function (indicePadre) {
            // console.log(vm.filtros);
            $uibModalInstance.close({filtros:vm.filtros, fechas:vm.fechas});
        }

        vm.abrirGeografia = function () {
            var objeto = { filtros: vm.filtrosList['Geografía'], select: vm.filtros.Geografia };
            $uibModal.open({
                templateUrl: 'app/components/geografia/geografia.html',
                controller: 'GeografiaController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    filterList: objeto
                }
            }).result.then(function (result) {
                vm.filtros.Geografia = result;
            });
        }

        vm.abrirDistribucion = function () {
            var objeto = { filtros: vm.filtrosList['Distribución'], select: vm.filtros.Distribucion };
            $uibModal.open({
                templateUrl: 'app/components/cadena/cadena.html',
                controller: 'CadenaController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    filterList: objeto
                }
            }).result.then(function (result) {
                if (!vm.filtros.Distribucion) vm.filtros.Distribucion = {}
                var resultado = result;
                angular.forEach(resultado, function (obj) {
                    obj.tipo = vm.filtrosList['Distribución'].SelectFilter;
                });
                if (vm.filtros.Distribucion === '' || vm.filtros.Distribucion.length === 0) {
                    vm.filtros.Distribucion = [];
                }
                else {
                    var arregloFix = [];
                    angular.forEach(vm.filtros.Distribucion, function (value) {
                        if (value.tipo !== vm.filtrosList['Distribución'].SelectFilter) {
                            arregloFix.push(value);
                        }
                    });
                    vm.filtros.Distribucion = arregloFix;
                }
                vm.filtros.Distribucion = vm.filtros.Distribucion.concat(resultado);
            });
        }

        vm.abrirModal = function (categoria) {
            var filtro = vm.filtrosList[categoria];
            var objeto = { filtros: filtro, select: vm.filtros.Distribucion };
            $uibModal.open({
                templateUrl: 'app/components/cadena/cadena.html',
                controller: 'CadenaController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    filterList: objeto
                }
            }).result.then(function (result) {
                var resultado = result;
                angular.forEach(resultado, function (obj) {
                    obj.tipo = filtro.SelectFilter;
                });
                if (vm.filtros.Distribucion === '' || vm.filtros.Distribucion.length === 0) {
                    vm.filtros.Distribucion = [];
                } else {
                    var arregloFix = [];
                    angular.forEach(vm.filtros.Distribucion, function (value) {
                        if (value.tipo !== filtro.SelectFilter) {
                            arregloFix.push(value);
                        }
                    });
                    vm.filtros.Distribucion = arregloFix;
                }
                vm.filtros.Distribucion = vm.filtros.Distribucion.concat(resultado);
            });
        }

        vm.filtroValido = function (categoria) {
            var filtro = vm.filtrosList[categoria];
            if (filtro != undefined){
                return true;
            }
            return false;
        }

        vm.abrirFecha = function () {
            $uibModal.open({
                templateUrl: 'app/components/fecha/fecha.html',
                controller: 'FechaController',
                controllerAs: 'vm',
                size: 'md'
            }).result.then(function (result) {
                vm.fechas.fechadesde = result.fechaIni;
                vm.fechas.fechahasta = result.fechaFin;
            });
        }

        function loadFiltros() {
            var filtrosList = [];
            var count = 0;
            var listaIndicadores = [];
            angular.forEach(indicadores, function(indi, key){ 
                angular.forEach(indi, function(i, key){
                    if (i.info.IdMedidaIndicador !== 1068) listaIndicadores.push(i);             
                });
            });
            angular.forEach(Object.values(listaIndicadores), function (indicador, index) {
                $http.get('api/filtros-visiones/' + vm.proyectoId + '/' + indicador.info.IdIndicador + '/' + vm.canalElegido).then(function (response) {
                    filtrosList.push(response.data.m_Item1);
                    count++;
                    if (count == Object.values(listaIndicadores).length) {
                        vm.filtrosList = intersect();
                        vm.loaded = true;
                    }
                });
            });
            function intersect() {
                var filtros = filtrosList[0];
                if (filtrosList.length > 1) {
                    angular.forEach(filtrosList, function (filtro, indexFiltro) {
                        if (indexFiltro != 0) {
                            angular.forEach(filtro, function (group, indexGroup) {
                                angular.forEach(group.Group, function (subgroup, indexSubgroup) {
                                    if (filtros[indexGroup] && filtros[indexGroup].Group[indexSubgroup]) {
                                        var values = {};
                                        angular.forEach(subgroup.ValueFilter, function (valueFilter) {
                                            values[valueFilter.OptionText] = true;
                                        })
                                        var newArr = [];
                                        angular.forEach(filtros[indexGroup].Group[indexSubgroup].ValueFilter,function(value){
                                            if(values[value.OptionText]) newArr.push(value);
                                        });
                                        filtros[indexGroup].Group[indexSubgroup].ValueFilter = newArr;
                                    }
                                })
                            })
                        }
                    })
                }
                var filtrosFinal = {};
                angular.forEach(filtros, function (filtro) {
                    filtrosFinal[filtro.SelectFilter] = filtro;
                })
                return filtrosFinal;
            }
        }

        vm.removeFilter = function (group, filtro) {
            // console.log({filtros:vm.filtros[group],filtro:filtro});
            var newArr = [];
            angular.forEach(vm.filtros[group],function(value){
                if(value.table != filtro.table || value.valor != filtro.valor)
                newArr.push(value)
            })
            vm.filtros[group] = newArr;
            // console.log(filtros[group])
        }
        vm.removeFecha = function(){
            vm.fechas = {fechadesde:'null', fechahasta:'null'};
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('tabla', {
            templateUrl: 'app/components/tabla/tabla.html',
            controller: 'TablaController',
            controllerAs: 'vm',
            bindings: {
                resultadoTablaIndicador: '=',
                mostrarTablas: '='
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('TablaController', TablaController);

    TablaController.$inject = ['$http','$sessionStorage','Principal'];

    function TablaController ($http,$sessionStorage,Principal) {
        var vm = this;
        vm.filtro = '';
        vm.pagina = 1;
        vm.paginas = 1;
        vm.datosTabla = [];
        vm.regex = regex;
        vm.cargaTabla = cargaTabla;
        vm.sumarPagina = sumarPagina;
        vm.restarPagina = restarPagina;
        vm.adelantarColumna = adelantarColumna;
        vm.retrocederColumna = retrocederColumna;
        vm.buscarCodigoProducto = buscarCodigoProducto;
        vm.buscarCodigoTienda = buscarCodigoTienda;
        vm.proyectColombia = proyectColombia;
        vm.nCol = nCol;
        vm.visiones = [];
        vm.secundarias = [];
        vm.tVal = tVal;
        vm.ExportToXLSX = ExportToXLSX;

        function cargaTabla() {
            vm.mostrarTablas = !vm.mostrarTablas;
            if (vm.mostrarTablas){
                var indicadorTabla = vm.resultadoTablaIndicador[0],
                    codTie = false,
                    codPro = false,
                    numMax = 0,
                    numMin = 0;
                const isPStore = indicadorTabla.indicador == 'Perfect Store';
                vm.filtro = '';
                vm.actualizandoData = false;
                vm.descargando = false;
                vm.proyectoId = angular.copy($sessionStorage.proyectoId);
                vm.usuarioId = Principal.identity().$$state.value.Id;;
                vm.visiones = vm.resultadoTablaIndicador[0].vision;
                vm.secundarias = vm.resultadoTablaIndicador[0].medidasSecundarias;
                vm.paginas = Math.ceil(vm.resultadoTablaIndicador.length / 10);
                vm.pagina = 1;
                vm.datosTabla = [];
                vm.paginas = vm.paginas > 100 ? 100 : vm.paginas;
                numMax = vm.pagina * 10;
                numMin = numMax - 9;
                for (numMin; numMin <= numMax; numMin++) {
                    if(vm.resultadoTablaIndicador.length >= numMin) {
                        vm.datosTabla.push(vm.resultadoTablaIndicador[numMin - 1]);
                    }
                }
                if (isPStore){
                    angular.forEach(indicadorTabla.vision, function (vision){
                        if (vision.OptionText === "CodigoTienda"){
                            codTie = true;
                        }
                        else if (vision.OptionText === "CodigoProducto"){
                            codPro = true;
                        }
                    });
                    if (!codTie && !codPro){
                        angular.forEach(indicadorTabla.vision, function (vision, i){
                            if (vision.OptionText === "NombreNegocio"){
                                buscarCodigoTienda(i);
                            }
                            else if (vision.OptionText === "DescripcionProducto"){
                                buscarCodigoProducto(i);
                            }
                        });
                    }
                }
            }
        }

        function nCol() {
            return vm.resultadoTablaIndicador[0].nombresColumnas.length > 0 ? true : false;
        }

        function tVal(t) {
            if (t !== undefined){
                return t.valor != -1 ? true : false;
            }
        }

        function sumarPagina() {
            var numMax = 0,
            numMin = 0,
            cantIndicadores = 0;
            if(vm.pagina < vm.paginas) {
                vm.pagina = vm.pagina + 1;
                numMax = vm.pagina * 10;
                numMin = numMax - 9;
                vm.datosTabla = [];
                cantIndicadores = vm.resultadoTablaIndicador.length;
                for (numMin; numMin <= numMax; numMin++) {
                    if (cantIndicadores >= numMin) {
                        vm.datosTabla.push(vm.resultadoTablaIndicador[numMin - 1]);
                    }
                }
            }
        }

        function restarPagina() {
            var numMax = 0,
            numMin = 0,
            cantIndicadores = 0;
            if(vm.pagina > 1) {
                vm.pagina = vm.pagina - 1;
                numMax = vm.pagina * 10;
                numMin = numMax - 9;
                vm.datosTabla = [];
                cantIndicadores = vm.resultadoTablaIndicador.length;
                for (numMin; numMin <= numMax; numMin++) {
                    if (cantIndicadores >= numMin) {
                        vm.datosTabla.push(vm.resultadoTablaIndicador[numMin - 1]);
                    }
                }
            }
        }

        function adelantarColumna(indice) {
            var tempVision = [],
                tempNombresColumnas = [];
            if(indice !== vm.resultadoTablaIndicador[0].vision.length - 1) {
                angular.forEach(vm.datosTabla, function (datos) {
                    tempVision = datos.vision[indice];
                    tempNombresColumnas = datos.nombresColumnas[indice];
                    datos.vision[indice] = datos.vision[indice + 1];
                    datos.vision[indice + 1] = tempVision;
                    datos.nombresColumnas[indice] = datos.nombresColumnas[indice + 1];
                    datos.nombresColumnas[indice + 1] = tempNombresColumnas;
                })
            }
        }

        function retrocederColumna(indice) {
            var tempVision = [],
                tempNombresColumnas = [];
            if(indice !== 0) {
                angular.forEach(vm.datosTabla, function (datos) {
                    tempVision = datos.vision[indice];
                    tempNombresColumnas = datos.nombresColumnas[indice];
                    datos.vision[indice] = datos.vision[indice - 1];
                    datos.vision[indice - 1] = tempVision;
                    datos.nombresColumnas[indice] = datos.nombresColumnas[indice - 1];
                    datos.nombresColumnas[indice - 1] = tempNombresColumnas;
                })
            }
        }

        function buscarCodigoTienda(i) {
            vm.actualizandoData = true;
            var listaId = [],
                codigos = {},
                IdsNegocios = {};
            const objTienda = {
                OptionValue : 'Codigo Tienda',
                OptionText: 'CodigoTienda',
                Table: ''
            };
            const objNegocio = {
                OptionValue : 'Id Negocio',
                OptionText: 'IdNegocio',
                Table: 'Negocio'
            };

            const objMarcelo = {
                OptionValue : 'Marcelo',
                OptionText: 'Marcelo',
                Table: ''
            };
            angular.forEach(vm.resultadoTablaIndicador, function (resultado) {
                var id = regex(resultado.nombresColumnasGenerales[i]);
                listaId.push(id);
            });
            $http.post('api/resultado/buscarCodigosNegocios', listaId).then(function (response) {
                angular.forEach(response.data,function(codigo){
                    codigos[codigo.Nombre] = (codigo.Codigo == "" || codigo.Codigo == null) ? " " : codigo.Codigo;
                })

                angular.forEach(response.data,function(codigo){
                    IdsNegocios[codigo.Nombre] = codigo.Id;
                })

                angular.forEach(vm.resultadoTablaIndicador, function (resultado) {

                     resultado.nombresColumnas.push(codigos[resultado.nombresColumnasGenerales[i]]);
                     resultado.vision.push(objTienda);
                });

                angular.forEach(vm.resultadoTablaIndicador, function (resultado) {

                    resultado.nombresColumnas.push(IdsNegocios[resultado.nombresColumnasGenerales[i]]);
                    resultado.vision.push(objNegocio);
               });

                vm.actualizandoData = false;
            });
        }

        function buscarCodigoProducto(i) {
            vm.actualizandoData = true;
            var listaId = [],
                codigos = {};
            const objProducto = {
                OptionValue : 'Codigo Producto',
                OptionText: 'CodigoProducto',
                Table: ''
            };
            angular.forEach(vm.resultadoTablaIndicador, function (resultado) {
                var id = regex(resultado.nombresColumnasGenerales[i]);
                listaId.push(id);
            });
            $http.post('api/resultado/buscarCodigosProductos', listaId).then(function (response) {
                angular.forEach(response.data,function(codigo){
                    codigos[codigo.Nombre] = (codigo.Codigo == "" || codigo.Codigo == null) ? " " : codigo.Codigo;
                })
                angular.forEach(vm.resultadoTablaIndicador, function (resultado) {
                    resultado.nombresColumnas.push(codigos[resultado.nombresColumnasGenerales[i]]);
                    resultado.vision.push(objProducto);
                });
                vm.actualizandoData = false;
            });
        }

        function ExportToXLSX() {
            vm.descargando = true;
            var arrayRespuestas = [],
                objRespuesta = {},
                dataExcel = {},
                jsonTablePS = '',
                visiones = [],
                tabla = '',
                valor = '',
                col = 0,
                indicadorTabla = vm.resultadoTablaIndicador[0];
            const isPStore = indicadorTabla.indicador.match('Perfect Store');
            if (isPStore){
                if (indicadorTabla.vision.length === 0){
                    angular.forEach(vm.resultadoTablaIndicador, function(e){
                        objRespuesta = {};
                        objRespuesta.Indicador = (e.nombresColumnas[0] ? e.nombresColumnas[0] : '');
                        objRespuesta.Puntaje = (e.valor ? e.valor : '') + (e.mascara ? e.mascara : '');
                        arrayRespuestas.push(objRespuesta);
                    });
                }
                else{
                    angular.forEach(vm.resultadoTablaIndicador, function(e){
                        col = 0;
                        objRespuesta = {};
                        angular.forEach(e.vision, function(v){
                            objRespuesta[v.OptionValue] = e.nombresColumnas[col];
                            col++;
                        });
                        objRespuesta.Resultado = (e.preMascara ? e.preMascara : '') + (e.valor ? e.valor : '') + (e.mascara ? e.mascara : '');
                        angular.forEach(e.medidasSecundarias, function(s){
                            objRespuesta[s.PreMascara] = (s.resultado ? s.resultado : '') + (s.mascara ? s.mascara : '');
                        });
                        arrayRespuestas.push(objRespuesta);
                    });
                }
                jsonTablePS = JSON.stringify(arrayRespuestas);
                dataExcel = {
                    "jsonTablePS": "" + jsonTablePS
                };
            }
            else{
                if (indicadorTabla.vision.length !== 0){
                    angular.forEach(indicadorTabla.vision, function (vision) {
                        tabla = vision.Table;
                        valor = vision.OptionText;
                        if(tabla == null){
                            visiones.push(valor);
                        }
                        else if(tabla === "Negocio"){
                            visiones.push("Ne.Id" + valor.replace("Nombre",""));
                            if (valor === "NombreNegocio"){ visiones.push("Ne.CodigoExterno") }
                            visiones.push("Ne." + valor + "Reportes");
                        }
                        else if(tabla === "RespuestaEncuesta"){
                            visiones.push("Re." + valor);
                        }
                        else if(tabla === "PreguntasEncuesta"){
                            visiones.push("Pe.Id" + valor);
                            visiones.push("Pe." + valor + "Reportes");
                        }
                        else if(tabla === "Producto"){
                            if (valor === "DescripcionProducto"){
                                visiones.push("P.CodigoProducto")
                                visiones.push("Re.IdProducto")
                            }
                            else{
                                visiones.push("P.Id" + valor)
                            }
                            visiones.push("P." + valor + "Reportes");
                        }
                        else if(tabla === "RutaOperativa"){
                            visiones.push("Ro.IdRutaOperativa");
                            visiones.push("Ro." + valor);
                        }
                        else if(tabla === "OpcionesSeleccionMultiple"){
                            visiones.push("Op.IdOpcionSeleccionMultiple")
                            visiones.push("Op." + valor);
                        }
                        else if(tabla === "ItemPromocional"){
                            visiones.push("Ip.IdItemPromocional")
                            visiones.push("Ip." + valor);
                        }
                        else if(tabla === "Marcas"){
                            if (valor === 'Empresa'){
                                visiones.push('M.IdEmpresa')
                            }
                            else{
                                visiones.push("M.IdMarca");
                            }
                            visiones.push("M." + valor);
                        }
                        else if(tabla === "Empresas"){
                            visiones.push("E.IdEmpresa");
                            visiones.push("E." + valor);
                        }
                        else if(tabla === "CategoriasProducto"){
                            visiones.push("Cp.IdCategoriaProducto");
                            visiones.push("Cp." + valor);
                        }
                        else if(tabla === "UbicacionesEnTienda"){
                            visiones.push("Ut.IdUbicacionEnTienda");
                            visiones.push("Ut." + valor);
                        }
                        else if(tabla === "TiposDeItemsPromocionales"){
                            visiones.push("Tip.IdTipoItemPromocional");
                            visiones.push("Tip." + valor);
                        }
                        else if(tabla === "TipoTiendaProyecto"){
                            visiones.push("Ttp.IdTipoTiendaProyecto");
                            visiones.push("Ttp." + valor);
                        }
                        else if(tabla === "CapacidadProductos"){
                            visiones.push("Re." + valor);
                        }
                    });
                    dataExcel = {
                        "idProyecto": "" + vm.proyectoId,
                        "idUsuario": "" + vm.usuarioId,
                        "nombrecanal": "" + indicadorTabla.canal,
                        "indicador": "" + indicadorTabla.indicador,
                        "fil": indicadorTabla.filtros,
                        "fechadesde": "" + indicadorTabla.fechas.FechaInicio,
                        "fechahasta": "" + indicadorTabla.fechas.FechaFin,
                        "vision": visiones
                    };
                }
                else {
                    objRespuesta.Resultado = (indicadorTabla.preMascara && indicadorTabla.valor !== -1 ? indicadorTabla.preMascara : '') + (indicadorTabla.valor !== -1 ? indicadorTabla.valor : 'NA') + (indicadorTabla.mascara && indicadorTabla.valor !== -1 ? indicadorTabla.mascara : '');
                    angular.forEach(indicadorTabla.medidasSecundarias, function(s){
                        if (!vm.proyectColombia(indicadorTabla,s)){
                            objRespuesta[s.Medida.Nombre] = (s.Medida.PreMascara ? s.Medida.PreMascara : '') + Intl.NumberFormat().format(s.resultado) + (s.Medida.Mascara ? s.Medida.Mascara : '');
                        }
                        else{
                            objRespuesta[s.Medida.Nombre] = (s.Medida.PreMascara ? s.Medida.PreMascara : '') + (vm.valor) + (s.Medida.Mascara ? s.Medida.Mascara : '');
                        }
                    });
                    jsonTablePS = JSON.stringify(objRespuesta);
                    dataExcel = {
                        "idUsuario": "" + vm.usuarioId,
                        "jsonTablePS": "" + jsonTablePS
                    };
                }
            }


            $http.post('api/tabla/descarga', dataExcel, { responseType: 'arraybuffer' }).then(function (response) {
                var nombreCanal = indicadorTabla.canal.toLowerCase();
                nombreCanal = nombreCanal.charAt(0).toUpperCase() + nombreCanal.slice(1);
                var nombreIndicador = indicadorTabla.indicador.replaceAll(' ','-');
                const newDate = new Date();
                const date = newDate.getDate()+ "-" + (newDate.getMonth() + 1) + "-" + newDate.getFullYear();
                const file = new Blob([response.data], { type: 'text/xlsx' });
                saveAs(file, nombreCanal + '_' + nombreIndicador + '_' + date + '.xlsx');
                vm.descargando = false;
            });
        }

        //Formato pesos para Colombia Precios
        function proyectColombia(indi, secu) {
            vm.valor = null;
            if (vm.proyectoId == 25 || vm.proyectoId == 60){
                if (indi.indicador == "Precios" && secu.Medida.IdMedidaSecundaria == 36){
                    vm.valor = parseFloat(secu.resultado).format(2, 3, '.', ',');
                    return true;
                }
            }
            return false;
        }

        Number.prototype.format = function(n, x, s, c) {
            var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
                num = this.toFixed(Math.max(0, ~~n));
            return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
        }

        function regex(datos) {
            var myRe = /.*##([0-9]+)##/,
                match = datos.match(myRe);
            if(match == null){
                return "";
            }
            else{
                return parseInt(match[1]);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('sidebar', {
            templateUrl: 'app/components/sidebar/sidebar.html',
            controller: 'SidebarController',
            controllerAs: 'vm',
            bindings: {
                mostrarSidebar: '=',
                canalElegido: '=',
                indicadorElegido: '=',
                idIndicadorElegido: '=',
                resultado: '=',
                resultadoTotales: '=',
                resultadoTendencias: '=',
                mostrarTendencia: '=',
                mostrarMapa: '=',
                mostrarTabla: '=',
                mostrarEvidencia: '=',
                mostrar: '=',
                cargandoTendencia: '=',
                cargandoMapa: '=',
                cargandoEvidencia: '=',
                resultadoMapas: '=',
                resultadoEvidencia: '=',
                filtros: '=',
                fechas: '=',
                proyectoId: '=',
                openModalProjects: '&',
                visionSeleccionada: '=',
                cargando: '=',
                showdashboard: '=',
                showmainevidencias: '=',
                imagenbase64: '=',
                nombreProyecto: '=',
                showMessageError: '=',
                soloEvidencias: '=',
                proyectoCanalIndicadores: '=',
                unicoProyecto: '=',
                indicadorCanalEntrante: '=',
                menuPadreIndicador: '=',
                menuEntrante : '='
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('SidebarController', SidebarController);

    SidebarController.$inject = ['$q', '$rootScope', '$state', '$uibModal', '$http', 'showResult', '$sessionStorage', 'Principal','$timeout', '$scope'];

    function SidebarController ($q, $rootScope, $state, $uibModal, $http, showResult,$sessionStorage, Principal,$timeout, $scope) {
        var vm = this;

        $rootScope.isMenuLoaded = false;

        vm.isMenuLoaded = isMenuLoaded;
        function isMenuLoaded(){
            return $rootScope.isMenuLoaded;
        }

        showResult.sendMessage("");
        vm.mostrarPerfil = false;
        vm.showdashboard = false;
        vm.closeSidebar = false;
        vm.showmainevidencias = false;
        vm.indicadores = '';
        vm.canales = '';
        vm.filtrosvisiones = '';
        vm.razonSocial = '';
        vm.indicadorPerfectStore = null;
        vm.mostrarNegocio = false;
        vm.mostrarSegmentacion = false;
        vm.mostrarMainEvidencias = false;
        vm.disabledButtonSegmentacion = true;
        vm.mostrarCanales = false;
        vm.mostrarIndicadores = false;
        vm.mostrarMenu = false;
        vm.mostrarSubMenu = false;
        vm.menuElegido = [];
        vm.mostrarFiltros = false;
        vm.mostrarVision = '';
        vm.mostrarValorVision = '';
        vm.mostrarGeografia = false;
        vm.mostrarListaArea = false;
        vm.mostrarListaEstado = false;
        vm.mostrarListaUbicacion = false;
        vm.mostrarListaRegion = false;
        vm.mostrarValorVisionDate = false;
        vm.mostrarFecha = false;
        vm.disabledButtonMostrarResultados = true;
        vm.medidaSecundariaSeleccionada = [];
        vm.soloEvidencias = false;
        vm.haveMenu = false;
        vm.menuPadreArr = [];
        vm.usuarioId = Principal.identity().$$state.value.Id;

        function regex(datos) {
            var myRe = new RegExp('##[0-9]*##','g');
            return datos.replace(myRe,'');
        }

        if ($sessionStorage) {
            if ($sessionStorage.cliente) {
                vm.cliente = $sessionStorage.cliente;
                vm.razonSocial = $sessionStorage.cliente.RazonSocial;
                vm.imagenbase64 = $sessionStorage.cliente.Imagen;
                vm.nombreProyecto = $sessionStorage.nombreProyecto;
            } else {
                $http.get('api/clientes/user/' + vm.usuarioId).then(function (response) {
                    vm.cliente = response.data;
                    vm.razonSocial = vm.cliente.RazonSocial;
                    vm.imagenbase64 = vm.cliente.Imagen;
                });
            }
        }

        vm.Pais = '';
        // vm.perfil = perfil;
        vm.limpiarFiltroVision = limpiarFiltroVision;
        vm.abrirNegocio = abrirNegocio;
        vm.abrirSegmentacion = abrirSegmentacion;
        vm.abrirMainEvidencias = abrirMainEvidencias;
        vm.abrirCanales = abrirCanales;
        vm.abrirMenu = abrirMenu;
        vm.abrirSubMenu = abrirSubMenu;
        vm.abrirIndicadores = abrirIndicadores;
        vm.abrirFiltros = abrirFiltros;
        vm.abrirVision = abrirVision;
        vm.abrirFecha = abrirFecha;
        vm.cambioCanal = cambioCanal;
        vm.cambioIndicador = cambioIndicador;
        vm.elegirMenu = elegirMenu;
        vm.buscarFiltrosVisiones = buscarFiltrosVisiones;
        vm.openVisionValue = openVisionValue;
        vm.mostrarResultados = mostrarResultados;
        vm.changeProject = changeProject;
        vm.logOut = logOut;
        vm.btnCloseSidebar = btnCloseSidebar;
        vm.asignarVision = asignarVision;
        vm.resetOptions = resetOptions;
        vm.validarFiltros = validarFiltros;
        vm.openModalSecundarias = openModalSecundarias;
        vm.volverDashboard = volverDashboard;
        vm.darMostrar = darMostrar;
        vm.openVisionDate = openVisionDate;
        vm.asignarVisionPredefinida = asignarVisionPredefinida;
        vm.opcionesOpen = false;
        vm.sendEventEvidencias = sendEventEvidencias;
        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = (panel.scrollHeight + 14) + "px";
                }
            });
        }

        var showResultSubscribe = showResult.subscribe(function (x) {
            if (x === true) {
                mostrarResultados();
            }
            else if( x === "cargarTendencias"){
                    if(vm.indicadorPerfectStore) {
                            cargarTendenciasPS();
                        }
                    else{
                            cargarTendencias();
                        }
                }
            else if( x === "cargarMapa"){
                    if(vm.indicadorPerfectStore) {
                            cargarMapaPS();
                        }
                    else{
                            cargarMapa();
                        }
                }
            else if( x === "cargarEvidencias"){
                    if(vm.indicadorPerfectStore) {
                        }
                    else{
                            cargarEvidencias();
                        }
                }
            else{
                angular.forEach(vm.indicadores, function (indicador){
                    if(x === indicador.NombreIndicador){
                        cambioIndicador(indicador);
                    }
                })

            }
        });

        function cargarTendenciasPS(){
                vm.cargandoTendencia = true;
                vm.resultadoTendencias = [];
                var resultadotendencia = [];
                var dataPerfectStore = {
                        "idProyecto": "" + vm.proyectoId,
                        "idUsuario": "" + vm.usuarioId,
                        "nombrecanal": "" + vm.canalElegido,
                        "idIndicador": "" + vm.indicadorPerfectStore,
                        "idMenuPadre": "" + vm.idMenuPadreIndicador,
                        "fil": vm.arregloFiltros,
                        "fechadesde": "" + vm.fechas.FechaInicio,
                        "fechahasta": "" + vm.fechas.FechaFin,
                        "vision": null
                };
                $http.post('api/resultado/tendencias/perfectStore', dataPerfectStore).then(function (response) {
                        resultadotendencia = response.data;
                        angular.forEach(resultadotendencia, function (item) {
                                var obj = {
                                        valor: item.resultado,
                                        mes: item.mes,
                                        anio: item.anio,
                                        fechas: angular.copy(vm.fechas)
                                };
                                vm.resultadoTendencias.push(obj);
                            });
                        sortByMonth(vm.resultadoTendencias);
                        vm.cargandoTendencia = false;
                        vm.resultadoEvidencia.Content = [];
                        vm.progresoDeCarga = false;
                        var msg = "cargaChartTendencia";
                        showResult.sendMessage(msg);
                        vm.mostrarTendencia = true;
                    }, function errorCallback() {
                        vm.resultadoTendencias = [];
                        vm.resultadoEvidencia.Content = [];
                        vm.resultadoMapas = [];
                        vm.showdashboard = true;
                        vm.showmainevidencias = false;
                        vm.progresoDeCarga = false;
                        vm.cargando = false;
                        vm.showMessageError = true;
                    });
        }

        function cargarMapaPS(){
                    vm.cargandoMapa = true;
                    vm.resultadoMapas = [];
                    var dataPerfectStore3 = {
                            "idProyecto": "" + vm.proyectoId,
                            "idUsuario": "" + vm.usuarioId,
                            "nombrecanal": "" + vm.canalElegido,
                            "idIndicador": "" + vm.idIndicadorElegido,
                            "idMenuPadre": "" + vm.idMenuPadreIndicador,
                            "fil": vm.arregloFiltros,
                            "fechadesde": "" + vm.fechas.FechaInicio,
                            "fechahasta": "" + vm.fechas.FechaFin,
                            "resultadoBase": "" + vm.resultadoTotales.valor,
                            "vision": []
                    };
                    $http.post('api/mapa/perfectStore', dataPerfectStore3).then(function (response) {
                            vm.resultadoMapas = response.data;
                            var msg = "cargaMapaDatos";
                            showResult.sendMessage(msg);
                        }, function errorCallback() {
                            vm.resultadoMapas = [];
                            vm.cargando = false;
                            vm.cargandoMapa = true;
                            vm.executingQueryResultado = false;
                            vm.showMessageError = true;
                        });
        }

        function cargarEvidencias(){
            vm.cargandoEvidencia = true;
            var dataEvidencias = {
                "page": 1,
                "idProyecto": "" + vm.proyectoId,
                "idUsuario": "" + vm.usuarioId,
                "nombrecanal": "" + vm.canalElegido,
                "idIndicador": "" + vm.idIndicadorElegido,
                "idMenuPadre": "" + vm.idMenuPadreIndicador,
                "fil": vm.arregloFiltros,
                "fechadesde": "" + vm.fechas.FechaInicio,
                "fechahasta": "" + vm.fechas.FechaFin,
                "vision": []
            };

            $http.post('api/evidencias', dataEvidencias).then(function (response) {
                    vm.resultadoEvidencia = response.data;
                    if(vm.resultadoEvidencia.Content.length > 0){
                            sendEventEvidencias();
                            vm.mostrarEvidencia = true;
                        }
                    else{
                            vm.mostrarEvidencia = false;
                    }
                    vm.cargandoEvidencia = false;
                }, function errorCallback(){
                    vm.cargando = false;
                    vm.cargandoEvidencia = true;
                    vm.executingQueryResultado = false;
                    vm.showMessageError = true;
                });
        }

        function cargarTendencias() {
            vm.resultadoTendencias = [];
            vm.cargandoTendencia = true;
            var data2 = {
                    "idProyecto": "" + vm.proyectoId,
                    "idUsuario": "" + vm.usuarioId,
                    "nombrecanal": "" + vm.canalElegido,
                    "idIndicador": "" + vm.idIndicadorElegido,
                    "idMenuPadre": "" + vm.idMenuPadreIndicador,
                    "fil": vm.arregloFiltros,
                    "fechadesde": "" + vm.fechas.FechaInicio,
                    "fechahasta": "" + vm.fechas.FechaFin,
                    "vision": []
            };

            var resultadotendencia = [];
            if (vm.resultado.length > 0 && vm.resultado[0].valor !== 0) {
                    $http.post('api/resultado/tendencias', data2).then(function (response) {
                            resultadotendencia = response.data;
                            vm.progresoDeCarga = false;
                            angular.forEach(resultadotendencia, function (item) {
                                    var obj = {
                                            valor: (item.resultado).toFixed(2),
                                            mes: item.mes,
                                            anio: item.anio,
                                            fechas: angular.copy(vm.fechas)
                                    };
                                    vm.resultadoTendencias.push(obj);
                                });
                            sortByMonth(vm.resultadoTendencias);
                            vm.cargandoTendencia = false;
                            var msg = "cargaChartTendencia";
                            showResult.sendMessage(msg);
                        }, function errorCallback(){
                            vm.cargando = false;
                            vm.cargandoTendencia = true;
                            vm.executingQueryResultado = false;
                            vm.showMessageError = true;
                        });
                }
            else {
                    vm.resultadoTendencias = [];
                }
        }

        function cargarMapa() {
                vm.cargandoMapa = true;
                vm.resultadoMapas = [];
                var data = {
                        "idProyecto": "" + vm.proyectoId,
                        "idUsuario": "" + vm.usuarioId,
                        "nombrecanal": "" + vm.canalElegido,
                        "idIndicador": "" + vm.idIndicadorElegido,
                        "idMenuPadre": "" + vm.idMenuPadreIndicador,
                        "fil": vm.arregloFiltros,
                        "fechadesde": "" + vm.fechas.FechaInicio,
                        "fechahasta": "" + vm.fechas.FechaFin,
                        "vision": null
                };

               $http.post('api/mapa', data).then(function (response) {
                        vm.resultadoMapas = response.data;
                        var msg = "cargaMapaDatos";
                        showResult.sendMessage(msg);
                    }, function errorCallback(){
                        vm.cargando = false;
                        vm.cargandoMapa = true;
                        vm.executingQueryResultado = false;
                        vm.showMessageError = true;
                    });
        }

        function logOut() {
            showResult.desubscribe();
            vm.proyectoId = null;
            $rootScope.proyectoId = null;
            $state.go('home');
        }

        function darMostrar(showResult) {
            vm.data = function () {
                return showResult.getMessage();
            }
        }

        function openVisionDate() {
            vm.mostrarValorVisionDate = !vm.mostrarValorVisionDate;
        }

        function volverDashboard() {
            vm.showdashboardResultado = !vm.showdashboardResultado;
        }

        function changeProject() {
            vm.openModalProjects();
            vm.indicadores = '';
            vm.perfectStores = '';
            vm.canales = '';
            vm.filtrosvisiones = '';
            vm.idIndicadorElegido = '';
            vm.canalElegido = '';
            vm.indicadorElegido = '';
            vm.idMenuPadreIndicador = '';
            vm.visionSeleccionada = "null";
            vm.filtros = {Geografia: '', Distribucion: '', Adicionales: ''};
            vm.fechas = {FechaInicio: "null", FechaFin: "null"};
            vm.visionSeleccionada = [];
            resetOptions();
            vm.showdashboard = false;
            vm.showmainevidencias = false;
        }

        function resetOptions() {
            vm.mostrarNegocio = false;
            vm.mostrarSegmentacion = false;
            vm.mostrarMainEvidencias = false;
            vm.disabledButtonSegmentacion = true;
            vm.mostrarCanales = false;
            vm.mostrarIndicadores = false;
            vm.mostrarMenu = false;
            vm.mostrarSubMenu = false;
            vm.mostrarSegmentacion = false;
            vm.mostrarFiltros = false;
            vm.mostrarVision = '';
            vm.mostrarValorVision = '';
            vm.menuPadreArr = [];
        }

        function limpiarGraficasSecundarias() {
            var msg = "limpiar";
            showResult.sendMessage(msg);
        }

        function btnCloseSidebar() {
            vm.closeSidebar = !vm.closeSidebar;
        }

        vm.openModal = function (filtro) {
            //var objeto = {filtros: filtro, select: vm.filtros.Geografia};
            var objeto = {filtros: filtro,
                select: vm.filtros.Geografia,
                proyectoId: "" + vm.proyectoId,
                nombreCanal: "" + vm.canalElegido,
                idIndicador: "" + vm.idIndicadorElegido,
                idUsuario: "" + vm.usuarioId,
                fechaDesde: "null",
                fechaHasta: "null",
                arregloFiltros: vm.arregloFiltros
            };
            $uibModal.open({
                templateUrl: 'app/components/geografia/geografia.html',
                controller: 'GeografiaController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    filterList: objeto
                }
            }).result.then(function (result) {
                vm.filtros.Geografia = result;
                mostrarResultados();
            });
        };

        vm.openModalPerfil = function () {
            var nombre = {nombre: vm.nombreProyecto};
            $uibModal.open({
                templateUrl: 'app/components/perfil/perfil.html',
                controller: 'PerfilController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    proyectoSeleccionado: nombre
                }
            }).result.then(function (result) {
                vm.razonSocial = result.razonSocial;
            });
        };

        vm.openModalCadena = function (filtro) {
            var objeto = {filtros: filtro,
                select: vm.filtros.Distribucion,
                proyectoId: "" + vm.proyectoId,
                nombreCanal: "" + vm.canalElegido,
                idIndicador: "" + vm.idIndicadorElegido,
                idUsuario: "" + vm.usuarioId,
                fechaDesde: "null",
                fechaHasta: "null",
                arregloFiltros: vm.arregloFiltros
            };


            /* Parche para ocultar filtro de Tiendas en el login Genomma y DuracellArg*/

			var indiceTienda = filtro.Group.map(function (e) { return e.GroupFilter; }).indexOf('NombreNegocio');
            if (indiceTienda >= 0 && vm.usuarioId == "05" || (vm.usuarioId == "04" && vm.nombreProyecto == "DURACELLARG" ) ) {
                filtro.Group.splice(indiceTienda, 1);
            }

            /* -------------------------------------------------- */

            $uibModal.open({
                templateUrl: 'app/components/cadena/cadena.html',
                controller: 'CadenaController',
                controllerAs: 'vm',
                size: 'md',
                bindings: {
                    eviShown: '=',
                    proyectoId: '=',
                    canalElegido: '=',
                    usuarioId: '='
                },
                resolve: {
                    filterList: objeto
                }
            }).result.then(function (result) {
                var resultado = result;
                angular.forEach(resultado, function (obj) {
                    obj.tipo = filtro.SelectFilter;
                });
                if (vm.filtros.Distribucion === '' || vm.filtros.Distribucion.length === 0) {
                    vm.filtros.Distribucion = [];
                } else {
                    var arregloFix = [];
                    angular.forEach(vm.filtros.Distribucion, function (value) {
                        if (value.tipo !== filtro.SelectFilter) {
                            arregloFix.push(value);
                        }
                    });
                    vm.filtros.Distribucion = arregloFix;
                }
                vm.filtros.Distribucion = vm.filtros.Distribucion.concat(resultado);
                mostrarResultados();
            });

        };

        function openVisionValue(indice) {
            if (vm.mostrarValorVision === indice) {
                vm.mostrarValorVision = '';
            } else {
                vm.mostrarValorVision = indice;
            }
        }

        vm.openModalFecha = function () {
            $uibModal.open({
                templateUrl: 'app/components/fecha/fecha.html',
                controller: 'FechaController',
                controllerAs: 'vm',
                size: 'md'
            }).result.then(function (result) {
                vm.fechas.FechaInicio = result.fechaIni;
                vm.fechas.FechaFin = result.fechaFin;
                mostrarResultados();
            });
        };

        function openModalSecundarias() {
            var objeto = {filtros: vm.medidasSecundarias, select: vm.medidaSecundariaSeleccionada};
            $uibModal.open({
                templateUrl: 'app/components/medidaSecundaria/medidaSecundaria.html',
                controller: 'MedidaSecundariaController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    filterList: objeto
                }
            }).result.then(function (result) {
                vm.medidaSecundariaSeleccionada = result;
                cargarMedidasSecundarias();
            });
        }

        /**
         * Carga los indicadores de un kpi y modifica el estado del menu *sidebar
         * @param {*} opcion
         * @param {*} onlyLoadKpis para poder cargar los kpi sin afectar el menu
         */
        function cambioCanal(opcion, onlyLoadKpis) {
            if(!onlyLoadKpis){
                vm.canalElegido = opcion.Nombre;
                vm.idIndicadorElegido = null;
                vm.indicadorElegido = null;
                vm.idMenuPadreIndicador = null;
                vm.haveMenu = false;

                vm.showmainevidencias = false;
                vm.mostrarCanales = !vm.mostrarCanales;
                vm.mostrarIndicadores = !vm.mostrarIndicadores;
                vm.mostrarMenu = !vm.mostrarMenu;
                vm.mostrarSubMenu = false;
                vm.menuPadreArr = [];
            }

            angular.forEach(vm.canales, function (canal){
                if(canal.Nombre === vm.canalElegido){
                    vm.indicadores = canal.Indicadores;
                    // checkIndicadorMenu(canal);
                }
            });

        }


        function checkIndicadorMenu(canal) {
            angular.forEach(vm.indicadores, function (indicador){
                if(canal.IdIndicador === indicador.IdIndicador){
                    cambioIndicador(indicador);
                }
            })
        }


        //CARGA DE MENU
        //busco canales e indicadores al inicio, luego de la selección del proyecto
        var watch = $rootScope.$watch('proyectId', function (proyectId) {
            //proyect change!
            //notify => the menu is loading
            $rootScope.isMenuLoaded = false;
            LoadMenu(proyectId);
        }, true);

        function LoadMenu(proyectId){
            console.log('load menu... [proyectId] =>', proyectId);//sidebarModel.projectId);

            //si proyectId es null, puede significar que el proyecto ya fue seleccionado y se refresco el browser
            //por lo que le asingo el valor vm.proyectoId que es el que deberia tener el proyecto guardado en session.storage
            if(!proyectId) {
                proyectId = vm.proyectoId;
            }

            if(proyectId){
                $http.get('api/canales/' + proyectId + '/with-kpis').then(function (response) {
                        vm.canales = response.data;
                        //notify => the menu is loaded!
                        $rootScope.isMenuLoaded = true;
                });
            }
        }

        function buscarFiltrosVisiones() {
            if(vm.idIndicadorElegido !== '') {
                vm.cargando = true;
                $http.get('api/filtros-visiones/' + vm.proyectoId + '/' + vm.idIndicadorElegido + '/' + vm.canalElegido).then(function (response) {
                    vm.filtrosvisiones = null;
                    vm.filtrosvisiones = response.data;

                    /* Parche para ocultar visión de Tiendas en el login Genomma */

                    if (vm.usuarioId == "05") {
                        vm.filtrosvisiones.m_Item2[2].VisionValues.splice(2, 1);
                    }

                    /* -------------------------------------------------- */

                    vm.validarFiltros();
                    abrirSegmentacion();
                });
            }
        }

        function limpiarFiltroVision() {
            vm.visionSeleccionada = [];
            vm.filtros = {Geografia: [], Distribucion: [], Adicionales: []};
            vm.fechas = {FechaInicio: "null", FechaFin: "null"};
        }

        function cambioIndicador(opcion) {
            vm.limpiarFiltroVision();
            vm.cargando = true;
            vm.indicadorElegido = opcion.NombreIndicador;
            vm.idIndicadorElegido = opcion.IdIndicador;
            vm.indicadorPerfectStore = opcion.IdPerfectStore;
            vm.idMenuPadreIndicador = opcion.IdMenuPadre;
            vm.menuPadreIndicador = opcion.MenuPadre;
            vm.mostrarIndicadores = false;
            vm.mostrarMenu = false;
            vm.mostrarSubMenu = false;
            vm.disabledButtonSegmentacion = false;
            vm.showmainevidencias = false;
            vm.buscarFiltrosVisiones();
        }

        function elegirMenu(menu){
            var cierreMenu = false;
            //console.log(vm.menuEntrante[vm.canalElegido]);
            angular.forEach(vm.menuElegido, function(m, index){
                if (m === menu.IdMenu){
                    vm.menuElegido.splice(index);
                    vm.menuPadreArr.splice(index);
                    cierreMenu = true;
                }
            });
            if (menu.IdMenuPadre === null){
                vm.menuElegido = [];
                vm.menuPadreArr = [];
            }
            if (menu.IdIndicador !== null && !cierreMenu){
                vm.cargando = true;
                vm.indicadorElegido = menu.NombreMenu;
                if (menu.NombreMenu === 'Perfect Store'){
                    vm.indicadorPerfectStore = menu.IdPerfectStore;
                }
                else{
                    vm.idIndicadorElegido = menu.IdIndicador;
                }
                vm.idMenuPadreIndicador = menu.IdMenuPadre;
                vm.menuPadreIndicador = vm.menuPadreArr;
                vm.mostrarIndicadores = false;
                vm.mostrarMenu = false;
                vm.mostrarSubMenu = false;
                vm.disabledButtonSegmentacion = false;
                vm.showmainevidencias = false;
                vm.buscarFiltrosVisiones();
            }
            if (menu.IdIndicador === null && !cierreMenu){
                if (menu.IdMenu !== vm.menuElegido[vm.menuElegido.length - 1]){
                    vm.menuPadreArr.push(menu.NombreMenu);
                    vm.menuElegido.push(menu.IdMenu);
                }
            }
            //console.log(vm.menuElegido)
        }

        function buscarMedidasSecundarias(id) {
            $http.get('api/medidas/secundarias/'+ id).then(function(response) {
                vm.medidaSecundariaSeleccionada = response.data;
                mostrarResultados();
            });
        }

        function validarFiltros() {
            if(vm.filtros.Adicionales !== "" || vm.filtros.Distribucion !== "" || vm.filtros.Geografia !== ""){
                var encontrado = false;
                if(vm.filtros.Adicionales !== "")
                {
                    var adicionalesEncontrados = [];
                    angular.forEach(vm.filtros.Adicionales, function (seleccionado) {
                        encontrado = false;
                        angular.forEach(vm.filtrosvisiones.m_Item1, function (filtros) {
                            if (!encontrado) {
                                filtros.Group.find(function (value) {
                                    if (value.GroupFilter === seleccionado.columna) {
                                        value.ValueFilter.find(function (value2) {
                                            if (value2.OptionText === seleccionado.valor) {
                                                adicionalesEncontrados.push(seleccionado);
                                                encontrado = true;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    });
                    if(adicionalesEncontrados.length === 0){
                        vm.filtros.Adicionales = "";
                    }
                    else {
                        vm.filtros.Adicionales = adicionalesEncontrados;
                    }
                }
                if(vm.filtros.Geografia !== "") {
                    var geografiaEncontrados = [];
                    angular.forEach(vm.filtros.Geografia, function (seleccionado) {
                        encontrado = false;
                        angular.forEach(vm.filtrosvisiones.m_Item1, function (filtros) {
                            if (!encontrado) {
                                filtros.Group.find(function (value) {
                                    if (value.GroupFilter === seleccionado.columna) {
                                        value.ValueFilter.find(function (value2) {
                                            if (value2.OptionText === seleccionado.valor) {
                                                geografiaEncontrados.push(seleccionado);
                                                encontrado = true;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    });
                    if(geografiaEncontrados.length === 0){
                        vm.filtros.Geografia = "";
                    }
                    else{
                        vm.filtros.Geografia = geografiaEncontrados;
                    }
                }
                if(vm.filtros.Distribucion !== "") {
                    var distribucionEncontrados = [];
                    angular.forEach(vm.filtros.Distribucion, function (seleccionado) {
                        encontrado = false;
                        angular.forEach(vm.filtrosvisiones.m_Item1, function (filtros) {
                            if (!encontrado) {
                                filtros.Group.find(function (value) {
                                    if (value.GroupFilter === seleccionado.columna) {
                                        value.ValueFilter.find(function (value2) {
                                            if (value2.OptionText === seleccionado.valor) {
                                                distribucionEncontrados.push(seleccionado);
                                                encontrado = true;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    });
                    if(distribucionEncontrados.length === 0){
                        vm.filtros.Distribucion = "";
                    }
                    else{
                        vm.filtros.Distribucion = distribucionEncontrados;
                    }
                }
            }
            buscarMedidasSecundarias(vm.idIndicadorElegido);
        }

        function abrirNegocio(){
            vm.showmainevidencias = false;
            vm.mostrarNegocio = !vm.mostrarNegocio;
            vm.mostrarSegmentacion = false;
            vm.mostrarMainEvidencias = false;
        }

        function abrirSegmentacion(){
            vm.showmainevidencias = false;
            vm.mostrarSegmentacion = !vm.mostrarSegmentacion;
            vm.mostrarNegocio = false;
            vm.mostrarMainEvidencias = false;
        }

        function abrirMainEvidencias(){
            vm.mostrarSegmentacion = false;
            vm.mostrarNegocio = false;
            vm.mostrarCanales = false;
            vm.mostrarIndicadores = false;
            vm.mostrarMenu = false;
            vm.mostrarSubMenu = false;
            vm.indicadorElegido = null;
            vm.idMenuPadreIndicador = null;
            vm.showdashboard = false;
            vm.showmainevidencias = !vm.showmainevidencias;
            vm.mostrarMainEvidencias = !vm.mostrarMainEvidencias;
            vm.menuPadreArr = [];
            if(vm.mostrarMainEvidencias){
                vm.closeSidebar = true;
                vm.mostrarSidebar = false;
            }
        }

        function abrirCanales(){
            vm.mostrarCanales = !vm.mostrarCanales;
            vm.mostrarIndicadores = !vm.mostrarIndicadores;
            vm.mostrarMenu = !vm.mostrarMenu;
            vm.mostrarFiltros = false;
            vm.mostrarIndicadores = false;
            vm.mostrarMenu = false;
            vm.mostrarSubMenu = false;
            vm.menuPadreArr = [];
        }

        function abrirIndicadores(){
            vm.mostrarIndicadores = !vm.mostrarIndicadores;
            vm.mostrarCanales = false;
            vm.mostrarFiltros = false;
        }

        function abrirMenu(){
            vm.menuElegido = [];
            vm.mostrarMenu = !vm.mostrarMenu;
            vm.mostrarCanales = false;
            vm.mostrarFiltros = false;
            vm.menuPadreArr = [];
        }

        function abrirSubMenu(){
            vm.mostrarSubMenu = !vm.mostrarSubMenu;
            vm.mostrarCanales = false;
            vm.mostrarFiltros = false;
        }

        function abrirFiltros(){
            vm.mostrarFiltros = !vm.mostrarFiltros;
            vm.mostrarVision = false;
        }

        function abrirVision(){
            vm.mostrarVision = !vm.mostrarVision;
            vm.mostrarFiltros = false;
        }

        function cargarMedidasSecundarias() {
            if(vm.medidaSecundariaSeleccionada.length > 0){
                var visiones = visionesSeleccionadas(vm.visionSeleccionada);

                vm.arregloFiltros = [];
                cargarFiltros();
                vm.resultadoSecundario = [];

                angular.forEach(vm.resultado,function (resultado){
                    resultado.medidasSecundarias = [];
                });

                angular.forEach(vm.medidaSecundariaSeleccionada, function (medidaSecundaria) {
                    const dataSecundaria = {
                        "medidaSecundariaId": medidaSecundaria.IdMedidaSecundaria,
                        "idProyecto": "" + vm.proyectoId,
                        "idUsuario": "" + vm.usuarioId,
                        "nombrecanal": "" + vm.canalElegido,
                        "idIndicador": "" + vm.idIndicadorElegido,
                        "idMenuPadre": "" + vm.idMenuPadreIndicador,
                        "fil": vm.arregloFiltros,
                        "fechadesde": "" + vm.fechas.FechaInicio,
                        "fechahasta": "" + vm.fechas.FechaFin,
                        "vision": visiones
                    };
                    $http.post('api/resultado/secundario', dataSecundaria).then(function (response) {
                        const cantRes = vm.resultado.length,
                            resSecundarios = response.data;
                        var contIgualdad = 0,
                            y = 0,
                            z = 0;

                        if(cantRes === 1) {
                            angular.forEach(resSecundarios, function (obj) {
                                obj.Medida = angular.copy(medidaSecundaria);
                                vm.resultado[0].medidasSecundarias.push(obj);
                            });
                        }
                        else {
                            angular.forEach(resSecundarios, function (obj, index) {
                                obj.Medida = angular.copy(medidaSecundaria);
                                for (y = 0; y < cantRes; y++){
                                    contIgualdad = 0;
                                    for (z = 0; z < resSecundarios[index].nombresFiltros.length; z++){
                                        if (vm.resultado[y].nombresColumnasGenerales[z] === resSecundarios[index].nombresFiltros[z]){
                                            contIgualdad++;
                                        }
                                        else {
                                            break;
                                        }
                                    }
                                    if (contIgualdad === resSecundarios[index].nombresFiltros.length) {
                                        vm.resultado[y].medidasSecundarias.push(obj);
                                        break;
                                    }
                                }
                            });
                        }
                    });
                });
            }
        }

        function regex(datos) {
            var myRe = new RegExp('##[0-9]*##','g');
            return datos.replace(myRe,'');
        }
        function regexProd(datos) {
            var fields = datos.split('##');
            return fields[0] + ' ID:' + fields[1];
        }

        function cargarMedidasRendimiento(visiones) {
            var fechaHasta = new Date(),
                fechaDesde = new Date();

            fechaDesde.setDate(fechaHasta.getDate() - 90);
            fechaHasta = fechaHasta.getFullYear() + '-' + (1 + fechaHasta.getMonth()) + '-' + fechaHasta.getDate();
            fechaDesde = fechaDesde.getFullYear() + '-' + (1 + fechaDesde.getMonth()) + '-' + fechaDesde.getDate();

            const dataRendimiento = {
                "idProyecto": "" + vm.proyectoId,
                "idUsuario": "" + vm.usuarioId,
                "nombrecanal": "" + vm.canalElegido,
                "idIndicador": "" + vm.idIndicadorElegido,
                "idMenuPadre": "" + vm.idMenuPadreIndicador,
                "fil": vm.arregloFiltros,
                "fechadesde": "" + fechaDesde,
                "fechahasta": "" + fechaHasta,
                "vision": visiones,
                "top1000" : 1
            };
            $http.post('api/resultado/indicadores', dataRendimiento).then(function (response) {
                const resRendimiento = response.data;
                var contIgualdad = 0,
                    y = 0,
                    z = 0;

                if(vm.resultado.length === 1) {
                    angular.forEach(resRendimiento, function (obj) {
                        vm.resultado[0].medidaRendimiento = obj.resultado;
                    });
                }
                else {
                    angular.forEach(resRendimiento, function (obj, index) {
                        for (y = 0; y < vm.resultado.length; y++){
                            contIgualdad = 0;
                            for (z = 0; z < resRendimiento[index].nombresFiltros.length; z++){
                                if (vm.resultado[y].nombresColumnasGenerales[z] === resRendimiento[index].nombresFiltros[z]){
                                    contIgualdad++;
                                }
                                else {
                                    break;
                                }
                            }
                            if (contIgualdad === resRendimiento[index].nombresFiltros.length) {
                                vm.resultado[y].medidaRendimiento = obj.resultado;
                                break;
                            }
                        }
                    });
                }
            });
        }

        function cargarMedidasRendimientoPerfectStore(visiones) {
            var fechaHasta = new Date();
            var fechaDesde = new Date();
            fechaDesde.setDate(fechaHasta.getDate() - 90);
            fechaHasta = fechaHasta.getFullYear() + '-' + (1 + fechaHasta.getMonth()) + '-' + fechaHasta.getDate();
            fechaDesde = fechaDesde.getFullYear() + '-' + (1 + fechaDesde.getMonth()) + '-' + fechaDesde.getDate();

            const dataRendimientoPS = {
                "idProyecto": "" + vm.proyectoId,
                "idUsuario": "" + vm.usuarioId,
                "nombrecanal": "" + vm.canalElegido,
                "idIndicador": "" + vm.indicadorPerfectStore,
                "idMenuPadre": "" + vm.idMenuPadreIndicador,
                "fil": vm.arregloFiltros,
                "fechadesde": "" + fechaDesde,
                "fechahasta": "" + fechaHasta,
                "vision": visiones
            };
            $http.post('api/resultado/perfectStore/multipleKpi', dataRendimientoPS).then(function (response) {
                const resRendimientoPS = response.data;
                var band = true;
                angular.forEach(resRendimientoPS, function (obj) {
                    if (band) {
                        band = false;
                        vm.resultadoTotales.medidaRendimiento = obj.resultado;
                    }
                    else{
                        vm.resultado.find(function (value) {
                            if (obj.nombresFiltros.every(function (value1) {return value.nombresColumnas.includes(value1);})) {
                                value.medidaRendimiento = obj.resultado;
                            }
                        });
                    }
                });
            });
        }

        function asignarVisionPredefinida(vision) {
            var visionPredefinida = {
                OptionText: vision,
                OptionValue: vision
            };
            asignarVision(visionPredefinida);
        }

        function asignarVision(vision) {
            var elimino = false;
            vm.visionSeleccionada.find(function(value, index) {
                if (value.OptionText === vision.OptionText) {
                    vm.visionSeleccionada.splice(index,1);
                    elimino = true;
                }
            });
            if(!elimino){
                vm.visionSeleccionada.push(vision);
                mostrarResultados();
            }
            vm.mostrarValorVision = '';
        }

        function abrirFecha(){
            vm.mostrarFecha = !vm.mostrarFecha;
        }

        vm.executingQueryResultado = false;

        function cargarFiltros() {
            var valueFilterGeo = vm.filtros.Geografia;
            var colFilterGeo = vm.filtros.ColumnaGeografia;
            var valueFilterDis = vm.filtros.Distribucion;
            var colFilterDis = vm.filtros.ColumnaDistribucion;
            var valueAdicional = vm.filtros.Adicionales;

            if (vm.filtros.Geografia === '') {
                valueFilterGeo = "null";
                colFilterGeo = "null";
            }
            if (vm.filtros.Distribucion === '') {
                valueFilterDis = "null";
                colFilterDis = "null";
            }
            if (vm.filtros.Adicionales === '') {
                valueAdicional = "null";
            }

            if (valueFilterGeo !== "null") {
                angular.forEach(valueFilterGeo, function (item) {
                    vm.arregloFiltros.push({
                        valorFiltroGeografia: item.valor.toString(),
                        columnaFiltroGeografia: item.columna.toString(),
                        valorFiltroDistribucion: "null",
                        columnaFiltroDistribucion: "null",
                        table: item.table.toString()
                    })
                });
            }
            if (valueFilterDis !== "null") {
                angular.forEach(valueFilterDis, function (item) {
                    vm.arregloFiltros.push({
                        valorFiltroDistribucion: item.valor.toString(),
                        columnaFiltroDistribucion: item.columna.toString(),
                        valorFiltroGeografia: "null",
                        columnaFiltroGeografia: "null",
                        table: item.table.toString()
                    })
                });
            }
            if (valueAdicional !== "null") {
                angular.forEach(valueAdicional, function (item) {
                    var geografia = false;
                    angular.forEach(vm.filtrosvisiones.m_Item2[0].VisionValues, function (filtro){
                        if(filtro.OptionValue === item.columna){
                            geografia = true;
                        }
                    });
                    if(geografia){
                        vm.arregloFiltros.push({
                            valorFiltroGeografia: item.valor.toString(),
                            columnaFiltroGeografia: item.columna.toString(),
                            valorFiltroDistribucion: "null",
                            columnaFiltroDistribucion: "null",
                            table: item.table.toString()
                        })
                    }
                    else if (item.columna.toString() === "Año" || item.columna.toString() === "Mes"
                        || item.columna.toString() === "Quarter" || item.columna.toString() === "Dia"){
                        vm.arregloFiltros.push({
                            valorFiltroGeografia: "null",
                            columnaFiltroGeografia: "null",
                            valorFiltroDistribucion: item.valor.toString(),
                            columnaFiltroDistribucion: item.columna.toString(),
                            table: "RespuestaEncuesta"
                        })
                    }
                    else{
                        vm.arregloFiltros.push({
                            valorFiltroGeografia: "null",
                            columnaFiltroGeografia: "null",
                            valorFiltroDistribucion: item.valor.toString(),
                            columnaFiltroDistribucion: item.columna.toString(),
                            table: item.table.toString()
                        })
                    }
                });
            }
            return vm.arregloFiltros;
        }

        function sortByMonth(arr) {
            arr.sort(function(a,b){
                    if( a.anio < b.anio ){
                        return -1;
                    }
                    if( a.anio > b.anio){
                        return 1;
                    }
                    if( a.anio === b.anio){
                        if(a.mes < b.mes ) {
                            return -1;
                        }
                        else{
                            return 1;
                        }
                    }
                    return 0;
                }
            );
        }

        function sendEventEvidencias() {
            var msg = "cargaEvidencias";
            showResult.sendMessage(msg);
        }

        function mostrarResultados() {
            if(!(vm.indicadorElegido === '' || vm.canalElegido === '' || vm.executingQueryResultado)) {
                vm.cargando = true;
                vm.showMessageError = false;
                vm.arregloFiltros = [];
                cargarFiltros();
                vm.soloEvidencias = false;

                if (vm.arregloFiltros.length === 0) {
                    vm.arregloFiltros = [{
                        valorFiltroGeografia: "null",
                        columnaFiltroGeografia: "null",
                        valorFiltroDistribucion: "null",
                        columnaFiltroDistribucion: "null"
                    }]
                }

                if(vm.indicadorElegido === 'Evidencias'){
                    vm.cargandoEvidencia = true;
                    vm.showdashboard = true;
                    vm.showmainevidencias = false;
                    vm.soloEvidencias = true;

                    const dataEvidencias = {
                        "page": 1,
                        "idProyecto": "" + vm.proyectoId,
                        "idUsuario": "" + vm.usuarioId,
                        "nombrecanal": "" + vm.canalElegido,
                        "idIndicador": "" + vm.idIndicadorElegido,
                        "idMenuPadre": "" + vm.idMenuPadreIndicador,
                        "fil": vm.arregloFiltros,
                        "fechadesde": "" + vm.fechas.FechaInicio,
                        "fechahasta": "" + vm.fechas.FechaFin,
                        "vision": []
                    };

                    $http.post('api/evidencias', dataEvidencias).then(function (response) {
                        vm.resultado = [];
                        vm.resultadoTotales = null;
                        vm.resultadoTendencias = [];
                        vm.resultadoMapas = [];
                        vm.resultadoEvidencia.Content = [];
                        vm.resultadoEvidencia = response.data;
                        vm.cargandoEvidencia = false;
                        $timeout(function () {
                            vm.mostrarEvidencia = true;
                        }, 100);
                        vm.cargando = false;
                        vm.mostrarMapa = false;
                        vm.mostrarTabla = false;
                        vm.mostrarTendencia = false;
                        vm.mostrar = false;
                        sendEventEvidencias();
                    });
                }
                else if(vm.indicadorPerfectStore){
                    var visiones = visionesSeleccionadas(vm.visionSeleccionada);
                    vm.mostrarMapa = false;
                    vm.mostrarTabla = false;
                    vm.mostrarTendencia = false;
                    vm.mostrarEvidencia = false;

                    const dataPerfectStore = {
                        "idProyecto": "" + vm.proyectoId,
                        "idUsuario": "" + vm.usuarioId,
                        "nombrecanal": "" + vm.canalElegido,
                        "idIndicador": "" + vm.indicadorPerfectStore,
                        "idMenuPadre": "" + vm.idMenuPadreIndicador,
                        "fil": vm.arregloFiltros,
                        "fechadesde": "" + vm.fechas.FechaInicio,
                        "fechahasta": "" + vm.fechas.FechaFin,
                        "vision": visiones
                    };

                    if(visiones.length === 0){
                        //Calculo del PS y los KPIs que lo componen
                        $http.post('api/resultado/perfectStore/multipleKpi', dataPerfectStore).then(function (response) {
                            vm.resultado = [];
                            vm.resultadoTotales = [];
                            vm.resultadoTendencias = [];
                            vm.resultadoMapas = [];
                            vm.resultadoEvidencia.Content = [];
                            const resMultipleKpi = response.data;
                            var nombre = '',
                                nombreGeneral = '',
                                difFechas = null,
                                fecha1 = 0,
                                fecha2 = 0,
                                obj = {};

                            angular.forEach(resMultipleKpi, function (item) {
                                nombre = '';
                                nombreGeneral = '';

                                if (item.nombresFiltros !== null) {
                                    nombre = [];
                                    nombreGeneral = [];
                                    angular.forEach(item.nombresFiltros, function (filtro){
                                        nombre.push(regex(filtro));
                                        nombreGeneral.push(filtro);
                                    });
                                }

                                difFechas = null;
                                if(vm.fechas.FechaFin !== "null" && vm.fechas.FechaInicio !== "null"){
                                    fecha1 = new Date(vm.fechas.FechaFin).getTime();
                                    fecha2 = new Date(vm.fechas.FechaInicio).getTime();
                                    difFechas = (fecha1 - fecha2)/(1000*60*60*24);
                                }

                                obj = {};
                                if(item.resultado < 0){
                                    obj = {
                                        valor: -1,
                                        nombresColumnas: nombre,
                                        nombresColumnasGenerales: nombreGeneral,
                                        vision: angular.copy(vm.visionSeleccionada),
                                        canal: angular.copy(vm.canalElegido),
                                        indicador: angular.copy(vm.indicadorElegido),
                                        filtros: angular.copy(vm.arregloFiltros),
                                        fechas: angular.copy(vm.fechas),
                                        difFechas: angular.copy(difFechas),
                                        multipleKpi: true,
                                        mascara: item.Mascara,
                                        preMascara: item.PreMascara,
                                        mostrarTooltip: false,
                                        medidasSecundarias: [],
                                        medidaRendimiento: 0
                                    };
                                }
                                else{
                                    obj = {
                                        valor: (item.resultado * 100).toFixed(2),
                                        nombresColumnas: nombre,
                                        vision: angular.copy(vm.visionSeleccionada),
                                        canal: angular.copy(vm.canalElegido),
                                        indicador: angular.copy(vm.indicadorElegido),
                                        filtros: angular.copy( vm.arregloFiltros),
                                        fechas: angular.copy(vm.fechas),
                                        difFechas: angular.copy(difFechas),
                                        multipleKpi: true,
                                        mascara: item.Mascara,
                                        preMascara: item.PreMascara,
                                        mostrarTooltip: false,
                                        medidasSecundarias: [],
                                        medidaRendimiento: 0
                                    };
                                }

                                if(vm.resultadoTotales.length === 0){
                                    vm.resultadoTotales = obj;
                                }
                                else{
                                    vm.resultado.push(obj);
                                }
                            });

                            vm.showdashboard = true;
                            vm.showmainevidencias = false;
                            cargarMedidasRendimientoPerfectStore(visiones);

                            $http.post('api/resultado/perfectStore/secundario', dataPerfectStore).then(function (secundariasResponse) {
                                vm.resultadoTotales.medidasSecundarias = secundariasResponse.data;
                            });

                            vm.cargando = false;
                        }, function errorCallback() {
                            vm.resultado = [];
                            vm.resultadoTendencias = [];
                            vm.resultadoEvidencia.Content = [];
                            vm.resultadoMapas = [];
                            vm.showdashboard = true;
                            vm.showmainevidencias = false;
                            vm.progresoDeCarga = false;
                            vm.cargando = false;
                            vm.showMessageError = true;
                        })
                    }
                    else{
                        //Sin vision para el calculo total del PS
                        const dataPerfectStore2 = {
                            "idProyecto": "" + vm.proyectoId,
                            "idUsuario": "" + vm.usuarioId,
                            "nombrecanal": "" + vm.canalElegido,
                            "idIndicador": "" + vm.indicadorPerfectStore,
                            "idMenuPadre": "" + vm.idMenuPadreIndicador,
                            "fil": vm.arregloFiltros,
                            "fechadesde": "" + vm.fechas.FechaInicio,
                            "fechahasta": "" + vm.fechas.FechaFin,
                            "vision": []
                        };
                        $http.post('api/resultado/perfectStore', dataPerfectStore2).then(function (response) {
                            vm.resultadoTendencias = [];
                            vm.resultadoMapas = [];
                            vm.resultadoEvidencia.Content = [];
                            vm.resultadoTotales = null;
                            vm.progresoDeCarga = false;
                            const resPerfectStore2 = response.data;
                            angular.forEach(resPerfectStore2, function (item) {
                                if(item.resultado < 0){
                                    var obj = {
                                        valor: -1
                                    };
                                }
                                else{
                                    var obj = {
                                        valor: (item.resultado * 100).toFixed(2)
                                    };
                                }
                                vm.resultadoTotales = obj;
                            });

                            $http.post('api/resultado/perfectStore/secundario', dataPerfectStore2).then(function (secundariasResponse) {
                                vm.resultadoTotales.medidasSecundarias = secundariasResponse.data;
                            });

                        }, function errorCallback(){
                            vm.cargando = false;
                            vm.executingQueryResultado = false;
                            vm.showMessageError = true;
                        });

                        //Con vision para el calculo del ps por vision
                        $http.post('api/resultado/perfectStore', dataPerfectStore).then(function (response) {
                            vm.resultado = [];
                            var nombre = '',
                                nombreGeneral = '',
                                difFechas = null,
                                obj = {},
                                fecha1 = 0,
                                fecha2 = 0;
                            const resPerfectStore = response.data;
                            angular.forEach(resPerfectStore, function (item) {
                                nombre = '';
                                nombreGeneral = '';
                                difFechas = null;
                                obj = {};

                                if (item.nombresFiltros !== null) {
                                    nombre = [];
                                    nombreGeneral = [];
                                    angular.forEach(item.nombresFiltros, function (filtro){
                                        nombre.push(regex(filtro));
                                        nombreGeneral.push(filtro);
                                    });
                                }

                                if (vm.fechas.FechaFin !== "null" && vm.fechas.FechaInicio !== "null") {
                                    fecha1 = new Date(vm.fechas.FechaFin).getTime();
                                    fecha2 = new Date(vm.fechas.FechaInicio).getTime();
                                    difFechas = (fecha1 - fecha2) / (1000 * 60 * 60 * 24);
                                }

                                if (item.resultado < 0) {
                                    obj = {
                                        valor: -1,
                                        nombresColumnas: nombre,
                                        nombresColumnasGenerales: nombreGeneral,
                                        vision: angular.copy(vm.visionSeleccionada),
                                        canal: angular.copy(vm.canalElegido),
                                        indicador: angular.copy(vm.indicadorElegido),
                                        filtros: angular.copy( vm.arregloFiltros),
                                        fechas: angular.copy(vm.fechas),
                                        difFechas: angular.copy(difFechas),
                                        multipleKpi: true,
                                        mascara: item.Mascara,
                                        preMascara: item.PreMascara,
                                        medidasSecundarias: [],
                                        medidaRendimiento: 0
                                    };
                                }
                                else {
                                    obj = {
                                        valor: (item.resultado * 100).toFixed(2),
                                        nombresColumnas: nombre,
                                        nombresColumnasGenerales: nombreGeneral,
                                        vision: angular.copy(vm.visionSeleccionada),
                                        canal: angular.copy(vm.canalElegido),
                                        indicador: angular.copy(vm.indicadorElegido),
                                        filtros: angular.copy( vm.arregloFiltros),
                                        fechas: angular.copy(vm.fechas),
                                        difFechas: angular.copy(difFechas),
                                        multipleKpi: true,
                                        mascara: item.Mascara,
                                        preMascara: item.PreMascara,
                                        medidasSecundarias: [],
                                        medidaRendimiento: 0
                                    };
                                }

                                vm.resultado.push(obj);
                            });

                            $http.post('api/resultado/perfectStore/secundario', dataPerfectStore).then(function (secundariasResponse) {
                                for (var i = 0; i < secundariasResponse.data.length; i=i+2 ) {
                                    var secundarias = [secundariasResponse.data[i], secundariasResponse.data[i+1]];
                                    for (var y=0; y < vm.resultado.length; y++){
                                        var contIgualdad = 0;
                                        for (var z=0; z < secundariasResponse.data[i].nombresFiltros.length; z++){
                                            if (vm.resultado[y].nombresColumnasGenerales[z] === secundariasResponse.data[i].nombresFiltros[z]){
                                                contIgualdad++;
                                            }
                                            else {
                                                break;
                                            }
                                        }
                                        if (contIgualdad === secundariasResponse.data[i].nombresFiltros.length) {
                                            vm.resultado[y].medidasSecundarias = secundarias;
                                            break;
                                        }
                                    }
                                }
                            });

                            vm.showdashboard = true;
                            vm.showmainevidencias = false;
                            vm.executingQueryResultado = false;
                            vm.cargando = false;

                        }, function errorCallback() {
                            vm.resultado = [];
                            vm.resultadoTendencias = [];
                            vm.resultadoEvidencia.Content = [];
                            vm.resultadoMapas = [];
                            vm.showdashboard = true;
                            vm.showmainevidencias = false;
                            vm.executingQueryResultado = false;
                            vm.progresoDeCarga = false;
                            vm.cargando = false;
                            vm.showMessageError = true;
                        });
                    }
                }
                else{
                    vm.progresoDeCarga = false;
                    vm.executingQueryResultado = true;
                    vm.resultadoTendencias = [];
                    vm.resultadoMapas = [];
                    vm.resultadoEvidencia.Content = [];
                    vm.mostrarMapa = false;
                    vm.mostrarTabla = false;
                    vm.mostrarTendencia = false;
                    vm.mostrarEvidencia = false;
                    var visiones = visionesSeleccionadas(vm.visionSeleccionada);

                    const dataCantKPI = {
                        "idProyecto": "" + vm.proyectoId,
                        "idUsuario": "" + vm.usuarioId,
                        "nombrecanal": "" + vm.canalElegido,
                        "idIndicador": "" + vm.idIndicadorElegido,
                        "idMenuPadre": "" + vm.idMenuPadreIndicador,
                        "fil": vm.arregloFiltros,
                        "fechadesde": "" + vm.fechas.FechaInicio,
                        "fechahasta": "" + vm.fechas.FechaFin,
                        "vision": visiones,
                        "cantTotal" : 1
                    };
                    //Se utiliza para calcular la cantidad total de tarjetas
                    $http.post('api/resultado/indicadores', dataCantKPI).then(function (response) {
                        const res = response.data;
                        const cantidadTotal = res[0].resultado;

                        const dataTop1000 = {
                            "idProyecto": "" + vm.proyectoId,
                            "idUsuario": "" + vm.usuarioId,
                            "nombrecanal": "" + vm.canalElegido,
                            "idIndicador": "" + vm.idIndicadorElegido,
                            "idMenuPadre": "" + vm.idMenuPadreIndicador,
                            "fil": vm.arregloFiltros,
                            "fechadesde": "" + vm.fechas.FechaInicio,
                            "fechahasta": "" + vm.fechas.FechaFin,
                            "vision": visiones,
                            "top1000" : 1
                        };
                        //Se utiliza para calcular los valores de las visiones del kpi
                        $http.post('api/resultado/indicadores', dataTop1000).then(function (response) {
                            const resTop1000 = response.data;
                            vm.resultado = [];
                            var difFechas = null,
                                fecha1 = 0,
                                fecha2 = 0,
                                nombre = '',
                                nombreGeneral = '',
                                obj = {},
                                val = -1;

                            if(vm.fechas.FechaFin !== "null" && vm.fechas.FechaInicio !== "null"){
                                fecha1 = new Date(vm.fechas.FechaFin).getTime();
                                fecha2 = new Date(vm.fechas.FechaInicio).getTime();
                                difFechas = (fecha1 - fecha2)/(1000*60*60*24);
                            }

                            angular.forEach(resTop1000, function (item) {
                                nombre = '';
                                nombreGeneral = '';
                                obj = {};
                                val = -1;

                                if (item.nombresFiltros !== null) {
                                    nombre = [];
                                    nombreGeneral = [];
                                    angular.forEach(item.nombresFiltros, function (filtro){
                                        if (filtro.includes("ProdFilter")){
                                            nombre.push(regexProd(filtro));
                                            nombreGeneral.push(filtro.replace(/ProdFilter/g, '').trim());
                                        }
                                        else{
                                            nombre.push(regex(filtro));
                                            nombreGeneral.push(filtro);
                                        }
                                    });
                                }

                                if (item.resultado >= 0) {
                                    val = (item.resultado * 100).toFixed(2);
                                }

                                obj = {
                                    cantidadTotal: cantidadTotal,
                                    valor: val,
                                    nombresColumnas: nombre,
                                    nombresColumnasGenerales: nombreGeneral,
                                    vision: angular.copy(vm.visionSeleccionada),
                                    canal: angular.copy(vm.canalElegido),
                                    indicador: angular.copy(vm.indicadorElegido),
                                    filtros: angular.copy( vm.arregloFiltros),
                                    fechas: angular.copy(vm.fechas),
                                    difFechas: angular.copy(difFechas),
                                    mascara: item.Mascara,
                                    preMascara: item.PreMascara,
                                    medidasSecundarias: [],
                                    medidaRendimiento: 0
                                };

                                vm.resultado.push(obj);
                            });
                            vm.resultadoTotales = null;
                            if (vm.visionSeleccionada.length === 0) {
                                vm.cargando = false;
                                vm.showdashboard = true;
                                vm.showmainevidencias = false;
                            }
                            else{
                                const dataTotalKpi = {
                                    "idProyecto": "" + vm.proyectoId,
                                    "idUsuario": "" + vm.usuarioId,
                                    "nombrecanal": "" + vm.canalElegido,
                                    "idIndicador": "" + vm.idIndicadorElegido,
                                    "idMenuPadre": "" + vm.idMenuPadreIndicador,
                                    "fil": vm.arregloFiltros,
                                    "fechadesde": "" + vm.fechas.FechaInicio,
                                    "fechahasta": "" + vm.fechas.FechaFin,
                                    "vision": []
                                };
                                //Se utiliza para calcular el total del kpi cuando se aplican visiones
                                $http.post('api/resultado/indicadores', dataTotalKpi).then(function (response) {
                                    vm.progresoDeCarga = false;
                                    vm.resultadoTotales = null;
                                    const resTotalKpi = response.data;
                                    angular.forEach(resTotalKpi, function (item) {
                                        if(item.resultado < 0){
                                            var obj = {
                                                preMascara: item.PreMascara,
                                                mascara: item.Mascara,
                                                valor: -1
                                            };
                                        }
                                        else{
                                            var obj = {
                                                preMascara: item.PreMascara,
                                                mascara: item.Mascara,
                                                valor: (item.resultado * 100).toFixed(2)
                                            };
                                        }
                                        vm.resultadoTotales = obj;
                                    });
                                    vm.cargando = false;
                                    vm.showdashboard = true;
                                    vm.showmainevidencias = false;
                                }, function errorCallback(){
                                    vm.cargando = false;
                                    vm.showdashboard = true;
                                    vm.showmainevidencias = false;
                                    vm.executingQueryResultado = false;
                                    vm.showMessageError = true;
                                });
                            }
                            cargarMedidasSecundarias();
                            cargarMedidasRendimiento(visiones);
                            vm.executingQueryResultado = false;
                            vm.progresoDeCarga = true;
                        });
                    }, function errorCallback(){
                        vm.showdashboard = true;
                        vm.showmainevidencias = false;
                        vm.cargando = false;
                        vm.cargandoTendencia = false;
                        vm.cargandoMapa = false;
                        vm.cargandoEvidencia = false;
                        vm.executingQueryResultado = false;
                        vm.showMessageError = true;
                    });
                }
            }
            else {
                vm.cargando = false;
            }
        }

        function visionesSeleccionadas(visiones){
            var arr = [];
            angular.forEach(visiones, function (vision) {
                if(vision.Table == null){
                    arr.push(vision.OptionText);
                }
                else if(vision.Table === "Negocio"){
                    arr.push("Ne." + vision.OptionText);
                }
                else if(vision.Table === "RespuestaEncuesta"){
                    arr.push("Re." + vision.OptionText);
                }
                else if(vision.Table === "PreguntasEncuesta"){
                    arr.push("Pe." + vision.OptionText);
                }
                else if(vision.Table === "Producto"){
                    arr.push("P." + vision.OptionText);
                }
                else if(vision.Table === "RutaOperativa"){
                    arr.push("Ro." + vision.OptionText);
                }
                else if(vision.Table === "OpcionesSeleccionMultiple"){
                    arr.push("Op." + vision.OptionText);
                }
                else if(vision.Table === "ItemPromocional"){
                    arr.push("Ip." + vision.OptionText);
                }
                else if(vision.Table === "Marcas"){
                    arr.push("M." + vision.OptionText);
                }
                else if(vision.Table === "Empresas"){
                    arr.push("E." + vision.OptionText);
                }
                else if(vision.Table === "CategoriasProducto"){
                    arr.push("Cp." + vision.OptionText);
                }
                else if(vision.Table === "UbicacionesEnTienda"){
                    arr.push("Ut." + vision.OptionText);
                }
                else if(vision.Table === "TiposDeItemsPromocionales"){
                    arr.push("Tip." + vision.OptionText);
                }
                else if(vision.Table === "TipoTiendaProyecto"){
                    arr.push("Ttp." + vision.OptionText);
                }
                else if(vision.Table === "CapacidadProductos"){
                    arr.push("Re." + vision.OptionText);
                }
            });
            return arr;
        }

        $scope.$watch("vm.indicadorCanalEntrante",function(){
            if(vm.indicadorCanalEntrante != undefined){
                cambioCanal(vm.indicadorCanalEntrante.canal);
                cambioIndicador(vm.indicadorCanalEntrante.indicador);
            }
        },true);
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('row', {
            templateUrl: 'app/components/resultado/row.html',
            controller: 'RowController',
            controllerAs: 'vm',
            bindings: {
                rows: '=',
                filtroSelected: '='
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('RowController', RowController);
        RowController.$inject = ['$scope'];

    function RowController ($scope) {
        var vm = this;
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('resultado', {
            templateUrl: 'app/components/resultado/resultado.html',
            controller: 'ResultadoController',
            controllerAs: 'vm',
            bindings: {
                resultadoIndicador: '=',
                showdashboardResultado: '=',
                filtrosResultado: '=',
                resultadoTotal: '=',
                mostrar: '='
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('ResultadoController', ResultadoController);

    ResultadoController.$inject = ['showResult', '$scope','$compile', '$timeout'];

    function ResultadoController (showResult, $scope, $compile, $timeout) {
        var vm = this;
        vm.mostrar = true;
        vm.mostrarmenu = false;
        vm.mostrarFiltros = false;
        vm.mostrarVision = false;
        vm.tooltip = false;
        vm.volverDashboard = volverDashboard;
        vm.agregarFiltro = agregarFiltro;
        vm.cambiarIndicador = cambiarIndicador;
        vm.quitarFiltro = quitarFiltro;
        vm.mostrarMenu = mostrarMenu;
        vm.pedirMostrar = pedirMostrar;
        vm.sendEvent = sendEvent;
        vm.showHover = {};
        vm.positive = positive;
        vm.negative = negative;
        vm.positiveTotal = positiveTotal;
        vm.negativeTotal = negativeTotal;
        vm.rotateCard = rotateCard;
        vm.sumarPagina = sumarPagina;
        vm.restarPagina = restarPagina;
        vm.pagina = 1;
        vm.paginas = 1;
        vm.rotate = false;
        vm.total = 1;

        function rotateCard(obj) {
            obj.isRotated = !obj.isRotated;
        }

        function positive(index) {
            vm.showHover[index] = true;
        }

        function negative(index) {
            vm.showHover[index] = false;
        }

        function positiveTotal() {
            vm.resultadoTotal.mostrarTooltip = true;
        }

        function negativeTotal() {
            vm.resultadoTotal.mostrarTooltip = false;
        }

        function volverDashboard() {
            vm.showdashboardResultado = !vm.showdashboardResultado;
        }

        function sendEvent() {
            showResult.sendMessage(true);
        }

        function pedirMostrar(){
            sendEvent();
        }

        $scope.$watch("vm.resultadoFiltroSelected",function(value){
            if(vm.resultadoFiltroSelected) agregarFiltro(value.filtro, value.filtroGenerales, value.indice);
        })

        function agregarFiltro(filtro, filtroGenerales, indice) {
            var filtroGeneral = '',
                filtroEspecifico = '',
                columna = '',
                valorMostrar = '',
                table = '',
                encontrado = false,
                i = 0;
            if (filtro != null && filtroGenerales != null & indice != null){
                filtroGeneral = filtroGenerales[indice];
                columna = vm.resultadoIndicador[0].vision[indice].OptionText;
                valorMostrar = vm.resultadoIndicador[0].vision[indice].OptionValue;
                table = vm.resultadoIndicador[0].vision[indice].Table;
                encontrado = false;
                if(vm.filtrosResultado.Geografia !== ''){
                    vm.filtrosResultado.Geografia.find(function(value) {
                        if (value.valorA === filtro && value.columna === columna) {
                            encontrado = true;
                        }
                    });
                }
                if(vm.filtrosResultado.Distribucion !== ''){
                    vm.filtrosResultado.Distribucion.find(function(value) {
                        if (value.valorA === filtro && value.columna === columna) {
                            encontrado = true;
                        }
                    });
                }
                if(!encontrado) {
                    if (vm.filtrosResultado.Adicionales === '') {
                        vm.filtrosResultado.Adicionales = [];
                    }
                    vm.filtrosResultado.Adicionales.push({valor: filtroGeneral, valorA: filtro, columna: columna, table: table, valorMostrar: valorMostrar});
                    pedirMostrar();
                }
            } 
            else {
                for (i = 0; i < filtroGenerales.length; i++) {
                    filtroGeneral = filtroGenerales[i];
                    filtroEspecifico = filtro[i];
                    columna = vm.resultadoIndicador[0].vision[i].OptionText;
                    valorMostrar = vm.resultadoIndicador[0].vision[i].OptionValue;
                    table = vm.resultadoIndicador[0].vision[i].Table;
                    encontrado = false;
                    if (vm.filtrosResultado.Geografia !== '') {
                        vm.filtrosResultado.Geografia.find(function (value) {
                            if (value.valorA === filtroEspecifico && value.columna === columna) {
                                encontrado = true;
                            }
                        });
                    }
                    if (vm.filtrosResultado.Distribucion !== '') {
                        vm.filtrosResultado.Distribucion.find(function (value) {
                            if (value.valorA === filtroEspecifico && value.columna === columna) {
                                encontrado = true;
                            }
                        });
                    }
                    if (!encontrado) {
                        if (vm.filtrosResultado.Adicionales === '') {
                            vm.filtrosResultado.Adicionales = [];
                        }
                        vm.filtrosResultado.Adicionales.push({ valor: filtroGeneral, valorA: filtroEspecifico, columna: columna, table: table, valorMostrar: valorMostrar });
                    }
                }
                pedirMostrar();
            }          
        }

        function cambiarIndicador(nombreIndicador) {
            showResult.sendMessage(nombreIndicador);
        }

        function quitarFiltro(filtro, indice) {
            if(vm.filtrosResultado.Adicionales !== '' || vm.filtrosResultado.Adicionales !== []){
                vm.filtrosResultado.Adicionales.find(function(value, index) {
                    if (value.valor === filtro && value.columna === vm.resultadoIndicador[0].vision[indice]) {
                        vm.filtrosResultado.Adicionales.splice(index,1);
                    }
                });
            }
        }

        function mostrarMenu() {
            vm.mostrarmenu = !vm.mostrarmenu;
        }
        
        function sumarPagina(){
            if(vm.pagina < vm.paginas) {
                vm.pagina = vm.pagina + 1;
                vm.rows = [];
                var numMax = vm.pagina * 51,
                    numMin = numMax - 50,
                    columnas = 3,
                    filas = 0,
                    res = [],
                    orderedResultados = [],
                    z = 0,
                    i = 0,
                    j = 0;
                if (vm.pagina == vm.paginas){                                                 
                    for (numMin; numMin <= numMax; numMin++) {
                        if (vm.resultadoIndicador[numMin] !== undefined){
                        res[z] = vm.resultadoIndicador[numMin];
                        z++;
                        }
                    }
                }
                else {                              
                    for (numMin; numMin <= numMax; numMin++) {
                        res[z] = vm.resultadoIndicador[numMin];
                        z++;                      
                    }
                }
                orderedResultados = angular.copy(res);
                filas = Math.ceil(orderedResultados.length / 3);    
                filas = filas > 17 ? 17 : filas;
                for(i = 0; i < filas; i++){
                    vm.rows[i] = [];
                    for(j = 0; j < columnas; j++){
                        vm.rows[i][j] = {
                            resultado: orderedResultados[i*columnas+j],
                            rotate:false
                        };
                    }
                }              
                window.scrollTo(0, 225);
            }
        }

        function restarPagina(){
            if(vm.pagina > 1) {
                vm.pagina = vm.pagina - 1;
                vm.rows = [];
                var numMax = vm.pagina * 51,
                    numMin = numMax - 50,
                    columnas = 3,
                    filas = 17,      
                    res = [],
                    orderedResultados,
                    z = 0,
                    i = 0,
                    j = 0;
                for (numMin; numMin <= numMax; numMin++) {
                    res[z] = vm.resultadoIndicador[numMin];
                    z++;
                }
                orderedResultados = angular.copy(res);
                for(i = 0; i < filas; i++){
                    vm.rows[i] = [];
                    for(j = 0; j < columnas; j++){
                        vm.rows[i][j] = {
                            resultado: orderedResultados[i*columnas+j],
                            rotate: false
                        };
                    }
                }
                window.scrollTo(0, 225);
            }
        }

        $scope.$watch("vm.resultadoIndicador", function (value) {
            vm.total = 0;
            var cantRes = vm.resultadoIndicador.length,
                columnas = 3,
                res = [],
                orderedResultados = [],
                cantTarjetas = 0,
                filas = 0,
                i = 0,
                j = 0;
            if (cantRes > 0){
                vm.total = vm.resultadoIndicador[0].cantidadTotal;
                vm.rows = [];
                if (cantRes > 1){
                    vm.paginas = Math.ceil(cantRes / 51);
                    vm.paginas = vm.paginas > 20 ? 20 : vm.paginas;
                    vm.pagina = 1;          
                }        
                vm.resultadoIndicador.sort(function(a,b){
                    return b.valor-a.valor;
                });
                cantTarjetas = cantRes < 51 ? cantRes : 51;
                for (i = 0; i < cantTarjetas; i++){
                    res[i] = vm.resultadoIndicador[i];
                }
                orderedResultados = angular.copy(res);      
                filas = Math.ceil(orderedResultados.length / 3);
                filas = filas > 17 ? 17 : filas;
                for(i = 0; i < filas; i++){
                    vm.rows[i] = [];
                    for(j = 0; j < columnas; j++){
                        vm.rows[i][j] = {
                            resultado: orderedResultados[i*columnas+j],
                            rotate: false
                        };
                    }
                }
            }
            $timeout(function () {
                $compile( document.getElementById('contentArea') )( $scope)
              });
        }, true);
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('infobox', {
            templateUrl: 'app/components/resultado/infobox.html',
            controller: 'InfoboxController',
            controllerAs: 'vm',
            bindings: {
                objResultado: '=',
                rotate: '=',
                filtroSelected: '=',
                isTotal: '='
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('InfoboxController', InfoboxController);
    InfoboxController.$inject = ['$sessionStorage'];

    function InfoboxController ($sessionStorage) {
        var vm = this;
        if ($sessionStorage.proyectoId == null){
            $sessionStorage.proyectoId = 0;
        }
        if (vm.proyectoId != $sessionStorage.proyectoId){
            vm.proyectoId = angular.copy($sessionStorage.proyectoId);
        }

        vm.rotateCard = function(){
            vm.rotate = !vm.rotate;
        }
        vm.agregarFiltro = function (obj, nombresColumnasGenerales, index){
            vm.filtroSelected = {
                filtro:obj,
                filtroGenerales: nombresColumnasGenerales,
                indice: index
            };
        }
        vm.impreciso = function(){
            if ((vm.objResultado.valor < 0) || 7 >= vm.objResultado.difFechas && vm.objResultado.difFechas){
                return true;
            }
            return false;
        }
        vm.sube = function(){
            if ((vm.objResultado.valor >= 0) && ((vm.objResultado.valor/100).toFixed(3) >= vm.objResultado.medidaRendimiento) && !vm.objResultado.difFechas < 7){
                return true;
            }
            return false;
        }
        vm.baja = function(){
            if ((vm.objResultado.valor >= 0) && (vm.objResultado.medidaRendimiento > (vm.objResultado.valor/100).toFixed(3)) && !vm.objResultado.difFechas < 7){
                return true;
            }
            return false;
        }

        //Formato pesos para Colombia Precios
        vm.proyectColombia = function proyectColombia(indi, secu) {
            if (vm.proyectoId == 25 || vm.proyectoId == 60){
                if (indi.indicador == "Precios" && secu.Medida.IdMedidaSecundaria == 36){
                    vm.valor = parseFloat(secu.resultado).format(2, 3, '.', ',');
                    return true;
                }
            }
            return false;
        }

        Number.prototype.format = function(n, x, s, c) {
            var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
                num = this.toFixed(Math.max(0, ~~n));
            return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('ProyectoController', ProyectoController);

    ProyectoController.$inject = ['$rootScope', '$http', '$uibModalInstance', '$state', 'Principal','showResult'];

    function ProyectoController ($rootScope, $http, $uibModalInstance, $state, Principal,showResult) {
        var vm = this;

        vm.proyectoUnico = false;

        vm.aceptarProyecto = aceptarProyecto;
        vm.volver = volver;

        vm.proyectos = [];
        vm.disableProyectos = true;
        vm.usuarioId = Principal.identity().$$state.value.Id;
        vm.cliente = '';
        vm.ProyectoSeleccionado = {IdProyecto: 0, nombre: ""};

        function limpiarGraficasSecundarias() {
            var msg = "limpiar";
            showResult.sendMessage(msg);
        }

        $http.get('api/clientes/user/' + vm.usuarioId).then(function(response) {
            vm.cliente = response.data;
            $http.get('api/usuarioProyecto/' + vm.usuarioId).then(function(response) {
                const usuarioProyectosResponse = response.data;
                if (usuarioProyectosResponse.length > 0){
                    var idProyecto;
                    vm.disableProyectos = false;
                    if(usuarioProyectosResponse.length == 1){
                        idProyecto = usuarioProyectosResponse[0].IdProyecto;
                        $http.get('api/proyectos/get/' + idProyecto).then(function(response) {
                            vm.proyectoUnico = true;
                            vm.ProyectoSeleccionado = response.data;
                            aceptarProyecto();
                        });
                    }
                    else{
                        angular.forEach(usuarioProyectosResponse, function(items) {
                            idProyecto = items.IdProyecto;
                            $http.get('api/proyectos/get/' + idProyecto).then(function(response) {
                                vm.proyectos.push(response.data);
                            });
                        });
                    }
                }
                else{
                    $http.get('api/proyectos/' + vm.cliente.IdCliente).then(function(response) {
                        vm.proyectos = response.data;
                        if(vm.proyectos.length > 0){
                            vm.disableProyectos = false;
                        }
                        if(vm.proyectos.length === 1){
                            vm.proyectoUnico = true;
                            vm.ProyectoSeleccionado = vm.proyectos[0];
                            aceptarProyecto();
                        }
                    });
                }
            });
        });

        function volver() {
            showResult.desubscribe();
            $uibModalInstance.dismiss('cancel');
            $state.go('home');
        }

        function aceptarProyecto() {
            if(vm.ProyectoSeleccionado.IdProyecto){
                limpiarGraficasSecundarias();
                //seteo la variable global
                $rootScope.proyectId = vm.ProyectoSeleccionado.IdProyecto;
                $uibModalInstance.close({proyecto: vm.ProyectoSeleccionado.IdProyecto, cliente: vm.cliente,
                nombreProyecto: vm.ProyectoSeleccionado.NombreProyecto, proyectoUnico: vm.proyectoUnico});
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('perfil', {
            parent: 'app',
            url: '/perfil',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/perfil/perfil.html',
                    controller: 'PerfilController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('PerfilController', PerfilController);

    PerfilController.$inject = ['$http', '$uibModalInstance', '$state', 'Principal', 'Auth', 'proyectoSeleccionado'];

    function PerfilController ($http, $uibModalInstance, $state, Principal, Auth, proyectoSeleccionado) {
        var vm = this;
        window.scrollTo(0, 0);
        vm.cliente = '';
        vm.nuevoPassword = '';
        vm.proyectoNombre = proyectoSeleccionado.nombre;
        vm.usuarioId = Principal.identity().$$state.value.Id;
        $http.get('api/clientes/user/' + vm.usuarioId).then(function(response) {
            vm.cliente = response.data;
            vm.contacto = vm.cliente.Contacto;
            vm.correo = vm.cliente.Correo;
            vm.direccion = vm.cliente.Direccion;
            vm.rfc = vm.cliente.RFC;
            vm.razonSocial = vm.cliente.RazonSocial;
            vm.telefono = vm.cliente.Telefono;
            vm.idCliente = vm.cliente.IdCliente;
            vm.base64Imagen = vm.cliente.Imagen;
        });

        vm.mostrar = false;
        vm.guardarysalir = guardarysalir;
        vm.cambiarfoto = cambiarfoto;
        vm.descartarcambios = descartarcambios;
        vm.cerrarModal = cerrarModal;
        vm.cambiarImagen = cambiarImagen;
        vm.buscarImagen = buscarImagen;
        vm.cambiarPassword = cambiarPassword;
        var modal = document.getElementById('myModal');

        function buscarImagen($file) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function (e) {
                    vm.base64Imagen = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                };
            }
        }

        function cerrarModal() {
            modal.style.display = "none";
        }

        function cambiarfoto() {
            modal.style.display = "block";
        }

        function cambiarPassword() {
            var data = {
                "NewPassword": vm.nuevoPassword
            };
            $http.post('api/account/change-password', data).then(function(response) {
            });
            $uibModalInstance.close();
        }


        function cambiarImagen() {
            vm.base64Imagen = vm.nuevaImagen;
            modal.style.display = "none";
        }

        function guardarysalir () {
            var data = {
                "Contacto": "" + vm.contacto,
                "Correo": "" + vm.correo,
                "Direccion": "" + vm.direccion,
                "IdCliente": "" + vm.idCliente,
                "RFC": "" + vm.rfc,
                "RazonSocial": vm.razonSocial,
                "Telefono": vm.telefono,
                "Imagen": vm.base64Imagen
            };
            $http.put('api/clientes/', data).then(function(response) {
            });
            $uibModalInstance.close({razonSocial: vm.razonSocial});
        }

        function descartarcambios() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('navbar', {
            templateUrl: 'app/components/navbar/navbar.html',
            controller: 'NavbarController',
            controllerAs: 'vm'
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = [];

    function NavbarController () {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('MedidaSecundariaController', MedidaSecundariaController);

    MedidaSecundariaController.$inject = ['$http', '$uibModalInstance', 'DASHBOARD_API_URL', 'filterList', '$timeout'];

    function MedidaSecundariaController ($http, $uibModalInstance, DASHBOARD_API_URL, filterList, $timeout) {
        var vm = this;

        vm.cadena = {};
        vm.cadenaSeleccionada = '';
        vm.distribucionSeleccionada = {valor: '', columna: ''};
        vm.disabledButtonCadena = true;
        vm.filtro = '';
        vm.medidaSecundariaElegida = [];
        vm.filterList = filterList.filtros;
        vm.seleccionado = filterList.select;
        vm.datosTabla = angular.copy(filterList.filtros);

        vm.seleccionoValor = seleccionoValor;
        vm.aceptarCadena = aceptarCadena;
        vm.busqueda = busqueda;
        vm.cargarSeleccionados = cargarSeleccionados;

        $timeout(function () {
            cargarSeleccionados();
        }, 5);

        function aceptarCadena() {
            $uibModalInstance.close(vm.medidaSecundariaElegida);
        }

        function cargarSeleccionados() {
            vm.medidaSecundariaElegida = [];

            angular.forEach(vm.seleccionado, function (seleccionado) {
                vm.medidaSecundariaElegida.push(seleccionado);
                angular.forEach(vm.datosTabla, function (filtro,index) {
                     if(seleccionado.IdMedidaSecundaria === filtro.IdMedidaSecundaria){
                         document.getElementById('radioB'+ index +'').checked = true;
                    }
                 });
             });
        }

        function seleccionoValor(indiceHijo) {
            var valor = vm.datosTabla[indiceHijo];
            var elimino = false;

            vm.medidaSecundariaElegida.find(function (value, index) {
                if (value && value.IdMedidaSecundaria && valor && valor.IdMedidaSecundaria) {
                    if (value.IdMedidaSecundaria === valor.IdMedidaSecundaria) {
                        vm.medidaSecundariaElegida.splice(index, 1);
                        elimino = true;
                    }
                }
            });
            if (!elimino) {
                vm.medidaSecundariaElegida.push(valor);
            }

            if(vm.medidaSecundariaSeleccionada === []) {
                vm.disabledButtonCadena = true;
            }
            else {
                vm.disabledButtonCadena = false;
            }
        }

        function busqueda() {
            vm.datosTabla = [];
            angular.forEach(filterList.filtros, function (elem) {
                if(elem.Nombre.toLowerCase().indexOf(vm.filtro.toLowerCase().trim()) > -1){
                    vm.datosTabla.push(elem);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('MapaModalController', MapaModalController);

    MapaModalController.$inject = ['$http', '$uibModalInstance','$state', 'datosTienda'];

    function MapaModalController ($http, $uibModalInstance,$state, datosTienda) {
        var vm = this;

        vm.aceptarProyecto = aceptarProyecto;
        vm.volver = volver;
        vm.datosTienda = datosTienda;
        vm.mostrarDatos = true;
        vm.tiempoImagen = '-';
        vm.buscarTienda = buscarTienda;
        vm.ampliarImagen = ampliarImagen;

        function volver() {
            $uibModalInstance.dismiss('cancel');
            $state.go('home');
        }

        function aceptarProyecto() {
            $uibModalInstance.close({ proyecto: vm.ProyectoSeleccionado, cliente: vm.cliente});
        }


        vm.filtrar = function(){
            $uibModalInstance.close({filtro:vm.datosTienda});
        }

        vm.base64Imagen = null;

        buscarTienda();
        function buscarTienda() {
            $http.get('api/mapa/' + vm.datosTienda.idNegocio).then(function(response) {
                vm.TiendaInfoPath = response.data;
                if(vm.TiendaInfoPath.PathEvidencia !== "") {
                    vm.base64Imagen = vm.TiendaInfoPath.PathEvidencia;
                }
                vm.tiempoImagen = vm.TiendaInfoPath.Fecha;
            });
        }

        function ampliarImagen() {
            vm.mostrarDatos = !vm.mostrarDatos;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('mapa', {
            templateUrl: 'app/components/mapa/mapa.html',
            controller: 'MapaController',
            controllerAs: 'vm',
            bindings: {
                resultadoMapaIndicador: '=',
                mostrarMapas: '=',
                cargandoMapas: '=',
                filtrosResultado: '=',
                fechasElegidas: '='
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('MapaController', MapaController);

    MapaController.$inject = ['$http','$scope', '$compile', '$uibModal', 'showResult', '$timeout'];

    function MapaController($http,$scope, $compile, $uibModal, showResult, $timeout) {
        var vm = this;
        vm.mostrar = false;
        vm.cargando = false;
        vm.initMap = initMap;
        vm.limpiarMapa = limpiarMapa;
        vm.openModal = openModal;
        vm.openTiendasModal = openTiendasModal;
        vm.cargarMapa = cargarMapa;
        vm.mostrarModal = false;
        vm.mostrarModalTiendas = false;
        vm.rutaOperativa = '';
        vm.resultadoFiltrado = [];
        vm.abrirModalTiendas = abrirModalTiendas;

        var showResultSubscribe = showResult.subscribe(function (x) {
            console.log('[MAPA] Mensaje recibido:', x);
            if (x === "cargaMapaDatos") {
                console.log('[MAPA] Iniciando carga de mapa. Total tiendas:', vm.resultadoMapaIndicador ? vm.resultadoMapaIndicador.length : 'undefined');
                if (vm.resultadoMapaIndicador && vm.resultadoMapaIndicador.length > 0) {
                    console.log('[MAPA] Llamando a initMap() inmediatamente');
                    vm.initMap();
                }
                else {
                    console.log('[MAPA] No hay datos, esperando 2 segundos...');
                    $timeout(function () {
                        console.log('[MAPA] Después de 2 segundos. Total tiendas:', vm.resultadoMapaIndicador ? vm.resultadoMapaIndicador.length : 'undefined');
                        if (vm.resultadoMapaIndicador && vm.resultadoMapaIndicador.length > 0) {
                            console.log('[MAPA] Llamando a initMap() después del timeout');
                            vm.initMap();
                        } else {
                            console.error('[MAPA] ERROR: No hay datos después del timeout');
                        }
                    }, 2000);
                }
                vm.cargandoMapas = false;
                vm.mostrarMapas = true;
            }
        });

        vm.pos = {
            lat: 23.7248607,
            lng: -103.4066612
        };

        function openModal(objeto) {
            $uibModal.open({
                templateUrl: 'app/components/mapa/mapa.modal.html',
                controller: 'MapaModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    datosTienda: objeto
                }
            }).result.then(function (result) {
                var found = false;
                if(!vm.filtrosResultado.Distribucion){
                    vm.filtrosResultado.Distribucion = [];
                } else{
                    angular.forEach(vm.filtrosResultado.Distribucion,function(filtro){
                        if(filtro.columna == "NombreNegocio" && filtro.valor == result.filtro.nombreCompleto){
                            found = true;
                        }
                    });
                }
                if(!found){
                    vm.filtrosResultado.Distribucion.push({
                        columna: "NombreNegocio",
                        table: "Negocio",
                        tipo: "Cadena",
                        valor: result.filtro.nombreCompleto,
                        valorA: result.filtro.nombreNegocio,
                        valorMostrar: "Tiendas"
                    })
                    showResult.sendMessage(true);
                }
            });
        }

        function openTiendasModal(objeto) {
            console.log('[MAPA] openTiendasModal() llamado');
            console.log('[MAPA] Objeto recibido:', objeto);
            console.log('[MAPA] fechasElegidas:', vm.fechasElegidas);
            
            var fechaInicio = vm.fechasElegidas.FechaInicio;
            var fechaFin = vm.fechasElegidas.FechaFin;
          
            console.log('[MAPA] Abriendo modal de UI Bootstrap...');
            $uibModal.open({
              templateUrl: 'app/components/mapa/mapa.tiendas.modal.html',
              controller: 'TiendasModalController',
              controllerAs: 'vm',
              size: 'lg',
              resolve: {
                datosTienda: function() {
                  return { 
                    tiendas: objeto,
                    fechasElegidas: vm.fechasElegidas
                 };
                }
              }
            }).result.then(function(result) {
              vm.resultadoFiltrado = [];
            });
          }
          

        function cargarMapa() {
            console.log('[MAPA] cargarMapa() llamado');
            var msg = "cargarMapa";
            showResult.sendMessage(msg);
            console.log('[MAPA] Mensaje "cargarMapa" enviado a showResult');
        }

        function limpiarMapa() {
            angular.element(document.getElementById("display")).children("div").remove();
        }

        function regex(datos) {
            var myRe = new RegExp('##[0-9]*##', 'g');
            return datos.replace(myRe, '');
        }

        /* function GetIdNegocio(datos){
            var myRe = new RegExp('##[0-9]*##', 'g');
            const regex = /\d+/g;
            return datos.match(regex)[0];//devuelve un solo valor
        } */

        function GetIdNegocio(datos){
            const regex = /##(\d+)##/;
            const match = datos.match(regex);
            
            var result = match ? parseInt(match[1]) : null;
            return result;
        }

        function initMap() {
            console.log('[MAPA] initMap() iniciado');
            console.log('[MAPA] Total de tiendas a cargar:', vm.resultadoMapaIndicador.length);
            console.log('[MAPA] Primeras 3 tiendas:', vm.resultadoMapaIndicador.slice(0, 3));
            
            // Mostrar mensaje si hay muchas tiendas
            if (vm.resultadoMapaIndicador.length > 5000) {
                console.log('[MAPA] Cargando ' + vm.resultadoMapaIndicador.length + ' tiendas en el mapa. Esto puede tomar unos momentos...');
            }

            console.log('[MAPA] Creando instancia de GMaps...');
            
            // Configuración base del mapa
            var mapConfig = {
                div: "#map",
                lat: vm.pos.lat,
                lng: vm.pos.lng
            };
            
            // Verificar si MarkerClusterer está disponible
            if (typeof MarkerClusterer !== 'undefined') {
                console.log('[MAPA] MarkerClusterer disponible - habilitando clustering');
                mapConfig.markerClusterer = function (map) {
                    var markerClusterer = new MarkerClusterer(map, [], { 
                        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                        minimumClusterSize: 10,
                        maxZoom: 15,
                        gridSize: 60,
                        averageCenter: true
                    });
                
                        // Agrega un escucha de eventos que se activará cuando se haga clic en un cluster
                        google.maps.event.addListener(markerClusterer, 'clusterclick', function(cluster) {
                            console.log('[MAPA] Click en cluster detectado');
                            
                            var markers = cluster.getMarkers();
                            console.log('[MAPA] Marcadores en el cluster:', markers.length);
                            
                            // Obtener el zoom máximo del mapa
                            var maxZoom = map.maxZoom;
                            // Obtener el zoom actual del mapa
                            var currentZoom = map.getZoom();
                            console.log('[MAPA] Zoom actual:', currentZoom, '/ Zoom máximo:', maxZoom);

                            var idNegociosGrupo = markers.map(function(objeto) {
                                return Number(GetIdNegocio(objeto.title)) 
                            });
                            console.log('[MAPA] IDs de negocios en el cluster:', idNegociosGrupo);

                            //obtengo los negocios del grupo
                            console.log('[MAPA] Filtrando tiendas del cluster...');
                            vm.resultadoFiltrado = vm.resultadoMapaIndicador.filter(function(indicador) {
                                return idNegociosGrupo.some(function(idNegocio) {
                                  return idNegocio === indicador.idNegocio;
                                });
                              }).map(function(indicador) {
                                return {
                                  idNegocio: indicador.idNegocio,
                                  negocio: regex(indicador.nombreNegocio),
                                  latitud: indicador.latitud,
                                  longitud: indicador.longitud,
                                  pathImage: "",
                                  direccionGoogle: ""
                                };
                              });  

                           
                            

                             console.log('[MAPA] Tiendas filtradas:', vm.resultadoFiltrado.length);
                             
                             //ordernar por latitud y longitud
                              vm.resultadoFiltrado.sort(function(a, b) {
                                if (a.latitud < b.latitud) {
                                  return -1;
                                } else if (a.latitud > b.latitud) {
                                  return 1;
                                } else {
                                  if (a.longitud < b.longitud) {
                                    return -1;
                                  } else if (a.longitud > b.longitud) {
                                    return 1;
                                  } else {
                                    return 0;
                                  }
                                }
                              });
                              
                            console.log('[MAPA] Tiendas ordenadas');

                            if(currentZoom >= 20){
                                  console.log('[MAPA] Zoom >= 20, abriendo modal de tiendas');
                                  abrirModalTiendas();
                            } else {
                                  console.log('[MAPA] Zoom < 20, no se abre modal automáticamente');
                            }
                            
                        });

                        // Agrega un escucha de eventos para capturar el clic derecho en un cluster
                        google.maps.event.addListener(markerClusterer, 'rightclick', function (cluster) {
                            console.log('Se hizo clic derecho en un cluster');
                            // Realiza las acciones que deseas realizar al capturar el evento de clic derecho en un cluster
                        });   

                        return markerClusterer;
                    };
            } else {
                console.warn('[MAPA] MarkerClusterer NO disponible - el mapa funcionará sin clustering');
                console.warn('[MAPA] Esto puede afectar el rendimiento con muchas tiendas');
            }
            
            vm.map = new GMaps(mapConfig);

            vm.styles = [{
                "featureType": "landscape", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "lightness": 65 }

                    ,

                    { "visibility": "on" }

                ]
            }, {
                "featureType": "poi", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "lightness": 51 }

                    ,

                    { "visibility": "simplified" }

                ]
            }, {
                "featureType": "road.highway", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "visibility": "simplified" }

                ]
            }, {
                "featureType": "road.arterial", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "lightness": 30 }

                    ,

                    { "visibility": "on" }

                ]
            }, {
                "featureType": "road.local", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "lightness": 40 }

                    ,

                    { "visibility": "on" }

                ]
            }, {
                "featureType": "transit", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "visibility": "simplified" }

                ]
            }, {
                "featureType": "administrative.province", "stylers": [

                    { "visibility": "off" }

                ]
            }, {
                "featureType": "water", "elementType": "labels", "stylers": [

                    { "visibility": "on" }

                    ,

                    { "lightness": -25 }

                    ,

                    { "saturation": -100 }

                ]
            }, {
                "featureType": "water", "elementType": "geometry", "stylers": [

                    { "hue": "#ffff00" }

                    ,

                    { "lightness": -25 }

                    ,

                    { "saturation": -97 }

                ]
            }];

            vm.map.addStyle({
                styledMapName: "Styled Map",
                styles: vm.styles,
                mapTypeId: "map_style"
            });

            vm.map.setStyle("map_style");

            var bounds = new google.maps.LatLngBounds();
            
            // Procesar marcadores en lotes para mejorar rendimiento con datasets grandes
            var batchSize = 500;
            var totalMarkers = vm.resultadoMapaIndicador.length;
            var currentBatch = 0;
            
            function processBatch() {
                var start = currentBatch * batchSize;
                var end = Math.min(start + batchSize, totalMarkers);
                
                console.log('[MAPA] Procesando lote', currentBatch + 1, '- Tiendas', start, 'a', end, 'de', totalMarkers);
                
                var marcadoresInvalidos = 0;
                for (var i = start; i < end; i++) {
                    var marcador = vm.resultadoMapaIndicador[i];
                    
                    // Validar que tenga coordenadas válidas
                    if (!marcador.latitud || !marcador.longitud || 
                        isNaN(parseFloat(marcador.latitud)) || isNaN(parseFloat(marcador.longitud))) {
                        marcadoresInvalidos++;
                        continue;
                    }
                    
                    var pt = new google.maps.LatLng(parseFloat(marcador.latitud), parseFloat(marcador.longitud));
                    bounds.extend(pt);
                    
                    var nombre = marcador.nombreNegocio;
                    var icon;
                    
                    if (marcador.objetivo === 0) {
                        icon = 'content/images/pinMapaAzul.png'
                    }
                    else if(marcador.resultado >= marcador.objetivo){
                        icon = 'content/images/pinMapaVerde.png'
                    }
                    else if(marcador.resultado < marcador.objetivo){
                        icon = 'content/images/pinMapaNaranja.png'
                    }
                    
                    // Usar closure para capturar el marcador correcto
                    (function(currentMarcador, currentNombre) {
                        vm.map.addMarker({
                            lat: parseFloat(currentMarcador.latitud),
                            lng: parseFloat(currentMarcador.longitud),
                            title: currentNombre,
                            icon: icon,
                            click: function (e) {
                                vm.cargando = true;
                                vm.idNegocio = currentMarcador.idNegocio;
                                vm.nombreNegocio = currentNombre;
                                vm.nombreCadena = regex(currentMarcador.nombreCadena);
                                vm.formato = regex(currentMarcador.formato);
                                vm.direccion = currentMarcador.direccion;
                                vm.latitud = currentMarcador.latitud;
                                vm.longitud = currentMarcador.longitud;
                                vm.mostrarModal = true;
                                //obtener rutaoperativa 
                                $http.get('api/mapa/rutaoperativa/' + vm.idNegocio).then(function(response) {
                                    vm.rutaOperativa = response.data;
                                    var objeto = {
                                        nombreCompleto: currentMarcador.nombreNegocio,
                                        idNegocio: vm.idNegocio, 
                                        nombreNegocio: vm.nombreNegocio, 
                                        nombreCadena: vm.nombreCadena,
                                        formato: vm.formato, 
                                        direccion: vm.direccion, 
                                        latitud: vm.latitud, 
                                        longitud: vm.longitud,
                                        rutaOperativa: vm.rutaOperativa
                                    };
                                    vm.cargando = false;
                                    vm.openModal(objeto);
                                });
                            }
                        });
                    })(marcador, nombre);
                }
                
                if (marcadoresInvalidos > 0) {
                    console.warn('[MAPA] Marcadores inválidos en este lote:', marcadoresInvalidos);
                }
                
                currentBatch++;
                
                // Si hay más lotes, procesarlos con un pequeño delay
                if (end < totalMarkers) {
                    $timeout(function() {
                        processBatch();
                    }, 10);
                } else {
                    // Cuando termine, ajustar bounds
                    console.log('[MAPA] Todos los lotes procesados. Ajustando bounds...');
                    vm.map.fitLatLngBounds(bounds);
                    vm.map.fitBounds(bounds);
                    console.log('[MAPA] ✓ Mapa cargado exitosamente con', totalMarkers, 'tiendas');
                    console.log('[MAPA] Total de marcadores en el mapa:', vm.map.markers ? vm.map.markers.length : 'undefined');
                }
            }
            
            // Iniciar procesamiento por lotes
            processBatch();
        }

        function abrirModalTiendas(){
            console.log('[MAPA] abrirModalTiendas() llamado');
            console.log('[MAPA] resultadoFiltrado:', vm.resultadoFiltrado);
            console.log('[MAPA] Total tiendas filtradas:', vm.resultadoFiltrado ? vm.resultadoFiltrado.length : 0);
            
            if (!vm.resultadoFiltrado || vm.resultadoFiltrado.length === 0) {
                console.warn('[MAPA] WARNING: No hay tiendas filtradas para mostrar');
                console.log('[MAPA] Total de tiendas en mapa:', vm.resultadoMapaIndicador ? vm.resultadoMapaIndicador.length : 0);
                
                // Si no hay filtrado, mostrar todas las tiendas
                if (vm.resultadoMapaIndicador && vm.resultadoMapaIndicador.length > 0) {
                    console.log('[MAPA] Usando todas las tiendas del mapa');
                    vm.resultadoFiltrado = vm.resultadoMapaIndicador.map(function(indicador) {
                        return {
                            idNegocio: indicador.idNegocio,
                            negocio: regex(indicador.nombreNegocio),
                            latitud: indicador.latitud,
                            longitud: indicador.longitud,
                            pathImage: "",
                            direccionGoogle: ""
                        };
                    });
                    console.log('[MAPA] resultadoFiltrado actualizado con', vm.resultadoFiltrado.length, 'tiendas');
                }
            }
            
            vm.mostrarModalTiendas = true;
            console.log('[MAPA] Abriendo modal con', vm.resultadoFiltrado.length, 'tiendas');
            vm.openTiendasModal(vm.resultadoFiltrado);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('TiendasModalController', TiendasModalController);

    TiendasModalController.$inject = ['$http','$uibModalInstance', '$state', 'datosTienda'];

    function TiendasModalController ($http, $uibModalInstance, $state, datosTienda) {
        console.log('[TIENDAS MODAL] Constructor iniciado');
        console.log('[TIENDAS MODAL] datosTienda recibido:', datosTienda);
        
        var vm = this;
        vm.cargando = false;
        vm.volver = volver;
        vm.ExportToXLSX = ExportToXLSX
        vm.markers = datosTienda;
        vm.mostrarDatos = false;
        vm.descargandoExcel = false;
        vm.fechasElegidas = datosTienda.fechasElegidas;
        vm.fotosfachada = [];

        console.log('[TIENDAS MODAL] vm.markers:', vm.markers);
        console.log('[TIENDAS MODAL] vm.markers.tiendas:', vm.markers.tiendas);
        console.log('[TIENDAS MODAL] Total tiendas:', vm.markers.tiendas ? vm.markers.tiendas.length : 0);
        
        getFotoFachada();
        function getFotoFachada(){
            console.log('[TIENDAS MODAL] getFotoFachada() iniciado');
            vm.mostrarDatos = false;
            vm.cargando = true;
            
            if (!vm.markers || !vm.markers.tiendas) {
                console.error('[TIENDAS MODAL] ERROR: No hay datos de tiendas');
                console.error('[TIENDAS MODAL] vm.markers:', vm.markers);
                vm.cargando = false;
                return;
            }
            
            var idNegocios = vm.markers.tiendas.map(function(objeto) {
                return Number(objeto.idNegocio) 
            });
            
            console.log('[TIENDAS MODAL] IDs de negocios:', idNegocios);
            console.log('[TIENDAS MODAL] Total IDs:', idNegocios.length);

            $http.post('api/mapa/negocios', idNegocios).then(function(response) {
                console.log('[TIENDAS MODAL] Respuesta de fotos recibida');
                console.log('[TIENDAS MODAL] Total fotos:', response.data ? response.data.length : 0);
                
                vm.fotosfachada = response.data;

                vm.markers.tiendas.forEach(function(tienda) {
                    vm.fotosfachada.forEach(function(foto) {
                      if (foto.IdNegocio === tienda.idNegocio) {
                        tienda.pathImage = foto.PathEvidencia;
                      }
                    });
                  });
                
                console.log('[TIENDAS MODAL] Fotos asignadas a tiendas');
                vm.cargando = false;
                vm.mostrarDatos = true;
                console.log('[TIENDAS MODAL] Datos listos para mostrar');
            }).catch(function(error) {
                console.error('[TIENDAS MODAL] ERROR al obtener fotos:', error);
                vm.cargando = false;
                vm.mostrarDatos = true; // Mostrar tiendas aunque falle las fotos
            });

            
        }


        function volver() {
            $uibModalInstance.dismiss('cancel');
            $state.go('home');
        }

        function ExportToXLSX() {
            vm.descargandoExcel = true;
            var fechas = vm.fechasElegidas;
            var idNegocios = vm.markers.tiendas.map(function(tienda) {
                return tienda.idNegocio;
              });
            
            var data = {
                "idnegocios": idNegocios,
                "fechadesde": "" + vm.fechasElegidas.FechaInicio,
                "fechahasta": "" + vm.fechasElegidas.FechaFin,
            }

            $http.post('api/mapa/descargarXLSX', data , { responseType: 'arraybuffer' })
                .then(function (response) {
                
                const newDate = new Date();
                const date = newDate.getDate()+ "-" + (newDate.getMonth() + 1) + "-" + newDate.getFullYear();
                const file = new Blob([response.data], { type: 'text/xlsx' });
                saveAs(file,'TiendasMapa_' + date + '.xlsx');
                vm.descargandoExcel = false;
            })
            .catch(function(error) {
                console.log('Error Server', error);
              });;
        }

        function aceptarProyecto() {
            $uibModalInstance.close();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('mainevidencias', {
            templateUrl: 'app/components/mainevidencias/mainevidencias.html',
            controller: 'MainEvidenciasController',
            controllerAs: 'vm',
            bindings: {
                eviShown: '=',
                proyectoId: '=',
                canalElegido: '=',
                usuarioId: '='
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('MainEvidenciasController', MainEvidenciasController);

    MainEvidenciasController.$inject = ['$q', '$scope', '$http', '$timeout', 'showResult',];

    function MainEvidenciasController($q, $scope, $http, $timeout, showResult) {
        var vm = this;
        vm.loaded = false;
        vm.loadedFotosFachada = false;
        function loadCanales() {
            $http.get('api/canales/' + vm.proyectoId).then(function (response) {
                vm.canales = response.data;
            });
        }
        function getFiltrosFinal() {
            var filtros = [];
            angular.forEach(vm.filtrosSelected, function (value, key) {
                if(key!="fecha"){
                filtros.push(value);
                }
            });
            return filtros;
        }
        vm.filtrosSelected = {};
        vm.filtrosLoaded = false;
        function loadEvidencias(page) {
            vm.loaded = false;
            vm.loadedFotosFachada = false;
            var dataEvidencias = {
                "page": page,
                "size": 54,
                "idProyecto": "" + vm.proyectoId,
                "nombrecanal": "" + vm.canalElegido,
                "idUsuario": "" + vm.usuarioId
            }

            if(vm.filtrosSelected.fecha){
                dataEvidencias.fechadesde = ""+vm.filtrosSelected.fecha.value.fechaIni;
                dataEvidencias.fechahasta = ""+vm.filtrosSelected.fecha.value.fechaFin;
                
            }
            dataEvidencias.fil = getFiltrosFinal();
            if (vm.filtrosSelected.geo) dataEvidencias.fil.push(vm.filtrosSelected.geo);
            if (vm.filtrosSelected.cadena) dataEvidencias.fil.push(vm.filtrosSelected.cadena);
            if (vm.filtrosSelected.distribucion) dataEvidencias.fil.push(vm.filtrosSelected.distribucion);
            if(vm.filtrosSelected.tipoTienda) dataEvidencias.fil.push(vm.filtrosSelected.tipoTienda);
            if(vm.filtrosSelected.pregunta) dataEvidencias.fil.push(vm.filtrosSelected.pregunta);
            if(vm.filtrosSelected.producto) dataEvidencias.fil.push(vm.filtrosSelected.producto);
            if(vm.filtrosSelected.indicador){
                dataEvidencias.nombreIndicador = vm.filtrosSelected.indicador.value;
                $http.post('api/evidencias/mainKpi', dataEvidencias).then(function (response) {
                    vm.paginationPage = page;
                    vm.paginationSize = response.data.TotalPages;
                    vm.evidencias = response.data.Content;
                    vm.loaded = true;

                    // Procesar fotos de fachada
                    //procesarFotosFachada(vm.evidencias);
                });
            } else {
                $http.post('api/evidencias/main', dataEvidencias).then(function (response) {
                    vm.paginationPage = page;
                    vm.paginationSize = response.data.TotalPages;
                    vm.evidencias = response.data.Content;
                    vm.loaded = true;
                });
            }

            
            var dataFotosFachada = {};
            for (var key in dataEvidencias) {
                if (dataEvidencias.hasOwnProperty(key) && key !== 'page' && key !== 'size') {
                    dataFotosFachada[key] = dataEvidencias[key];
                }
            }
            $http.post('api/evidencias/main/fotosfachada', dataFotosFachada).then(function (response) {
                var fotosUnicas = {};
                // vm.paginationPage = page;
                // vm.paginationSize = response.data.TotalPages;
                vm.fotosFachada = response.data;
                // vm.loaded = true;
                // Procesar fotos de fachada
                vm.fotosFachada.forEach(function(evidencia) {
                    if (evidencia.pathRelativoFachada && evidencia.nombreFotoFachada && evidencia.finEncuesta && evidencia.nombreNegocio) {
                        // Crear clave única combinando los tres campos
                        var claveUnica = evidencia.finEncuesta + '|' + evidencia.fotoFachada + '|' 
                            + evidencia.nombreFotoFachada + '|' + evidencia.nombreNegocio;  
                        
                        // Solo agregar si no existe
                        if (!fotosUnicas[claveUnica]) {
                            fotosUnicas[claveUnica] = {
                                // Adaptar a la estructura que espera el carrusel
                                pathEvidencia: evidencia.pathRelativoFachada,
                                nombreEvidencia: evidencia.nombreFotoFachada,
                                finEncuesta: evidencia.finEncuesta,
                                // Mantener también los datos originales si los necesitas
                                fotoFachada: evidencia.pathRelativoFachada,
                                nombreFotoFachada: evidencia.nombreFotoFachada
                            };
                        }
                    }
                });
                vm.fotosFachada = Object.values(fotosUnicas);
                vm.loadedFotosFachada = true;
                console.log('Fotos de fachada únicas:', vm.fotosFachada);
            });
            
        }

        // Función para procesar fotos de fachada
        function procesarFotosFachada(evidencias) {
            vm.fotosFachada = [];
            var fotosUnicas = {};
            
            if (evidencias && evidencias.length > 0) {
                evidencias.forEach(function(evidencia) {
                    if (evidencia.fotoFachada && evidencia.nombreFotoFachada && evidencia.finEncuesta && evidencia.nombreNegocio) {
                        // Crear clave única combinando los tres campos
                        var claveUnica = evidencia.finEncuesta + '|' + evidencia.fotoFachada + '|' 
                            + evidencia.nombreFotoFachada + '|' + evidencia.nombreNegocio;  
                        
                        // Solo agregar si no existe
                        if (!fotosUnicas[claveUnica]) {
                            fotosUnicas[claveUnica] = {
                                // Adaptar a la estructura que espera el carrusel
                                pathEvidencia: evidencia.fotoFachada,
                                nombreEvidencia: evidencia.nombreFotoFachada,
                                finEncuesta: evidencia.finEncuesta,
                                // Mantener también los datos originales si los necesitas
                                fotoFachada: evidencia.fotoFachada,
                                nombreFotoFachada: evidencia.nombreFotoFachada
                            };
                        }
                    }
                });
                
                // Convertir objeto a array
                vm.fotosFachada = Object.values(fotosUnicas);
            }
            
            
        }


        function loadFiltros() {
            vm.filtrosLoaded = false;
            vm.filtros = {
                geo: { elements: {}, cantEvidencias: { pais: {}, area: {}, estado: {}, municipio: {} } },
                cadena: { elements: {}, cantEvidencias: { cadena: {}, formato: {}, negocio: {} } },
                distribucion: { elements: {}, cantEvidencias: { region: {}, distribuidor: {}, supervisor: {}, rutaComercial: {}, rutaOperativa: {} } },
                tipoTienda: { elements: {}, cantEvidencias: { clusterTienda: {}, tipoTienda: {}, tamTienda: {} } },
                pregunta: { elements: {}, cantEvidencias: { pregunta: {}, marca: {}, categoriaItem: {}, tipoItempromocional: {} } },
                producto: { elements: {}, cantEvidencias: { marca: {} } },
                indicador: { elements: {}, cantEvidencias: { nombreIndicador: {} } }
            };
            var body = {
                "idProyecto": "" + vm.proyectoId,
                "nombrecanal": "" + vm.canalElegido,
            }
            if(vm.filtrosSelected.fecha){
                body.fechadesde = ""+vm.filtrosSelected.fecha.value.fechaIni;
                body.fechahasta = ""+vm.filtrosSelected.fecha.value.fechaFin;
            }
            body.fil = getFiltrosFinal();
            vm.filtrosPlain = {
                pais:{},
                area:{},
                estado:{},
                municipio:{},
                cadena:{},
                formato:{},
                negocio:{},
                region: {},
                distribuidor: {},
                supervisor: {},
                rutaComerciall: {},
                rutaOperativaa: {},
                clusterTienda: {},
                tipoTienda: {},
                tamTienda: {},
                pregunta:{},
                marcaPregunta:{},
                categoriaItemPregunta:{},
                tipoItempromocionalPregunta:{},
                marca: {},
                nombreIndicador: {}
            };
            $http.post('api/evidencias/filtros', body).then(function (response) {
                angular.forEach(response.data.geo, function (value) {

                    if(!vm.filtrosPlain.pais[value.pais]) vm.filtrosPlain.pais[value.pais] = {};
                    if(!vm.filtrosPlain.area[value.area]) vm.filtrosPlain.area[value.area] = {pais:value.pais};
                    if(!vm.filtrosPlain.estado[value.estado]) vm.filtrosPlain.estado[value.estado] = {pais:value.pais, area: value.area};
                    if(!vm.filtrosPlain.municipio[value.municipio]) vm.filtrosPlain.municipio[value.municipio] = {pais:value.pais, area: value.area, estado: value.estado};

                    // Acumular cantidad de evidencias
                    if (vm.filtros.geo.cantEvidencias.pais[value.pais] == undefined) {
                        vm.filtros.geo.cantEvidencias.pais[value.pais] = value.evidencias;
                    } else vm.filtros.geo.cantEvidencias.pais[value.pais] += value.evidencias;
                    if (vm.filtros.geo.cantEvidencias.area[value.area] == undefined) {
                        vm.filtros.geo.cantEvidencias.area[value.area] = value.evidencias;
                    } else vm.filtros.geo.cantEvidencias.area[value.area] += value.evidencias;
                    if (vm.filtros.geo.cantEvidencias.estado[value.estado] == undefined) {
                        vm.filtros.geo.cantEvidencias.estado[value.estado] = value.evidencias;
                    } else vm.filtros.geo.cantEvidencias.estado[value.estado] += value.evidencias;
                    if (vm.filtros.geo.cantEvidencias.municipio[value.municipio] == undefined) {
                        vm.filtros.geo.cantEvidencias.municipio[value.municipio] = value.evidencias;
                    } else vm.filtros.geo.cantEvidencias.municipio[value.municipio] += value.evidencias;

                    // Crear jerarquía
                    if (vm.filtros.geo.elements[value.pais] == undefined) vm.filtros.geo.elements[value.pais] = {};
                    if (vm.filtros.geo.elements[value.pais][value.area] == undefined) vm.filtros.geo.elements[value.pais][value.area] = {};
                    if (vm.filtros.geo.elements[value.pais][value.area][value.estado] == undefined) vm.filtros.geo.elements[value.pais][value.area][value.estado] = {};
                    if (vm.filtros.geo.elements[value.pais][value.area][value.estado][value.municipio] == undefined) vm.filtros.geo.elements[value.pais][value.area][value.estado][value.municipio] = {};

                });
                angular.forEach(response.data.cadena, function (value) {
                    if(!vm.filtrosPlain.cadena[value.cadena]) vm.filtrosPlain.cadena[value.cadena] = {};
                    if(!vm.filtrosPlain.formato[value.formato]) vm.filtrosPlain.formato[value.formato] = {cadena:value.cadena};
                    if(!vm.filtrosPlain.negocio[value.negocio]) vm.filtrosPlain.negocio[value.negocio] = {cadena:value.cadena, formato: value.formato};

                    // Acumular cantidad de evidencias
                    if (vm.filtros.cadena.cantEvidencias.cadena[value.cadena] == undefined) {
                        vm.filtros.cadena.cantEvidencias.cadena[value.cadena] = value.evidencias;
                    } else vm.filtros.cadena.cantEvidencias.cadena[value.cadena] += value.evidencias;
                    if (vm.filtros.cadena.cantEvidencias.formato[value.formato] == undefined) {
                        vm.filtros.cadena.cantEvidencias.formato[value.formato] = value.evidencias;
                    } else vm.filtros.cadena.cantEvidencias.formato[value.formato] += value.evidencias;
                    if (vm.filtros.cadena.cantEvidencias.negocio[value.negocio] == undefined) {
                        vm.filtros.cadena.cantEvidencias.negocio[value.negocio] = value.evidencias;
                    } else vm.filtros.cadena.cantEvidencias.negocio[value.negocio] += value.evidencias;

                    if (vm.filtros.cadena.elements[value.cadena] == undefined) vm.filtros.cadena.elements[value.cadena] = {};
                    if (vm.filtros.cadena.elements[value.cadena][value.formato] == undefined) vm.filtros.cadena.elements[value.cadena][value.formato] = {};
                    if (vm.filtros.cadena.elements[value.cadena][value.formato][value.negocio] == undefined) vm.filtros.cadena.elements[value.cadena][value.formato][value.negocio] = {};
                });
                 var count = 0;
                var distribucion = $q.resolve(
                    angular.forEach(response.data.distribucion, function (value) {
                        if(!vm.filtrosPlain.region[value.region]) vm.filtrosPlain.region[value.region] = {};
                        if(!vm.filtrosPlain.distribuidor[value.distribuidor]) vm.filtrosPlain.distribuidor[value.distribuidor] = {region:value.region};
                        if(!vm.filtrosPlain.supervisor[value.supervisor]) vm.filtrosPlain.supervisor[value.supervisor] = {region:value.region, distribuidor: value.distribuidor};
                        if(!vm.filtrosPlain.rutaComerciall[value.rutaComercial]) vm.filtrosPlain.rutaComerciall[value.rutaComercial] = {region:value.region, distribuidor: value.distribuidor, supervisor: value.supervisor};
                        if(!vm.filtrosPlain.rutaOperativaa[value.rutaOperativa]) vm.filtrosPlain.rutaOperativaa[value.rutaOperativa] = {region:value.region, distribuidor: value.distribuidor, supervisor: value.supervisor, rutaComercial:value.rutaComercial};

                        count++;
                        // Acumular cantidad de evidencias
                        if (vm.filtros.distribucion.cantEvidencias.region[value.region] == undefined) {
                            vm.filtros.distribucion.cantEvidencias.region[value.region] = value.evidencias;
                        } else vm.filtros.distribucion.cantEvidencias.region[value.region] += value.evidencias;
                        if (vm.filtros.distribucion.cantEvidencias.distribuidor[value.distribuidor] == undefined) {
                            vm.filtros.distribucion.cantEvidencias.distribuidor[value.distribuidor] = value.evidencias;
                        } else vm.filtros.distribucion.cantEvidencias.distribuidor[value.distribuidor] += value.evidencias
                        if (vm.filtros.distribucion.cantEvidencias.supervisor[value.supervisor] == undefined) {
                            vm.filtros.distribucion.cantEvidencias.supervisor[value.supervisor] = value.evidencias;
                        } else vm.filtros.distribucion.cantEvidencias.supervisor[value.supervisor] += value.evidencias;
                        if (vm.filtros.distribucion.cantEvidencias.rutaComercial[value.rutaComercial] == undefined) {
                            vm.filtros.distribucion.cantEvidencias.rutaComercial[value.rutaComercial] = value.evidencias;
                        } else vm.filtros.distribucion.cantEvidencias.rutaOperativa[value.rutaComercial] += value.evidencias;
                        if (vm.filtros.distribucion.cantEvidencias.rutaOperativa[value.rutaOperativa] == undefined) {
                            vm.filtros.distribucion.cantEvidencias.rutaOperativa[value.rutaOperativa] = value.evidencias;
                        } else vm.filtros.distribucion.cantEvidencias.rutaOperativa[value.rutaOperativa] += value.evidencias;

                        if (vm.filtros.distribucion.elements[value.region] == undefined) vm.filtros.distribucion.elements[value.region] = {};
                        if (vm.filtros.distribucion.elements[value.region][value.distribuidor] == undefined) vm.filtros.distribucion.elements[value.region][value.distribuidor] = {};
                        if (vm.filtros.distribucion.elements[value.region][value.distribuidor][value.supervisor] == undefined) vm.filtros.distribucion.elements[value.region][value.distribuidor][value.supervisor] = {};
                        if (vm.filtros.distribucion.elements[value.region][value.distribuidor][value.supervisor][value.rutaComercial] == undefined) vm.filtros.distribucion.elements[value.region][value.distribuidor][value.supervisor][value.rutaComercial] = {};
                        if (vm.filtros.distribucion.elements[value.region][value.distribuidor][value.supervisor][value.rutaComercial][value.rutaOperativa] == undefined) vm.filtros.distribucion.elements[value.region][value.distribuidor][value.supervisor][value.rutaComercial][value.rutaOperativa] = {};

                    })

                ).then(
                    //for debugging
                //    console.log('vm.filtrosPlain', vm.filtrosPlain, 'vm.filtros.distribucion', vm.filtros.distribucion)

                  );

                angular.forEach(response.data.tipoTienda, function (value) {
                    if(!vm.filtrosPlain.clusterTienda[value.clusterTienda]) vm.filtrosPlain.clusterTienda[value.clusterTienda] = {};
                    if(!vm.filtrosPlain.tipoTienda[value.tipoTienda]) vm.filtrosPlain.tipoTienda[value.tipoTienda] = {clusterTienda:value.clusterTienda};
                    if(!vm.filtrosPlain.tamTienda[value.tamTienda]) vm.filtrosPlain.tamTienda[value.tamTienda] = {clusterTienda:value.clusterTienda, tipoTienda: value.tipoTienda};

                    // Acumular cantidad de evidencias
                    if (vm.filtros.tipoTienda.cantEvidencias.clusterTienda[value.clusterTienda] == undefined) {
                        vm.filtros.tipoTienda.cantEvidencias.clusterTienda[value.clusterTienda] = value.evidencias;
                    } else vm.filtros.tipoTienda.cantEvidencias.clusterTienda[value.clusterTienda] += value.evidencias;
                    if (vm.filtros.tipoTienda.cantEvidencias.tipoTienda[value.tipoTienda] == undefined) {
                        vm.filtros.tipoTienda.cantEvidencias.tipoTienda[value.tipoTienda] = value.evidencias;
                    } else vm.filtros.tipoTienda.cantEvidencias.tipoTienda[value.tipoTienda] += value.evidencias;
                    if (vm.filtros.tipoTienda.cantEvidencias.tamTienda[value.tamTienda] == undefined) {
                        vm.filtros.tipoTienda.cantEvidencias.tamTienda[value.tamTienda] = value.evidencias;
                    } else vm.filtros.tipoTienda.cantEvidencias.tamTienda[value.tamTienda] += value.evidencias;

                    if (vm.filtros.tipoTienda.elements[value.clusterTienda] == undefined) vm.filtros.tipoTienda.elements[value.clusterTienda] = {};
                    if (vm.filtros.tipoTienda.elements[value.clusterTienda][value.tipoTienda] == undefined) vm.filtros.tipoTienda.elements[value.clusterTienda][value.tipoTienda] = {};
                    if (vm.filtros.tipoTienda.elements[value.clusterTienda][value.tipoTienda][value.tamTienda] == undefined) vm.filtros.tipoTienda.elements[value.clusterTienda][value.tipoTienda][value.tamTienda] = {};
                });
                angular.forEach(response.data.pregunta, function (value) {
                    if(!vm.filtrosPlain.pregunta[value.pregunta]) vm.filtrosPlain.pregunta[value.pregunta] = {};
                    if(!vm.filtrosPlain.marcaPregunta[value.marca]) vm.filtrosPlain.marcaPregunta[value.marca] = {pregunta: value.pregunta};
                    if(!vm.filtrosPlain.categoriaItemPregunta[value.categoriaItem]) vm.filtrosPlain.categoriaItemPregunta[value.categoriaItem] = {pregunta: value.pregunta};
                    if(!vm.filtrosPlain.tipoItempromocionalPregunta[value.tipoItemProm]) vm.filtrosPlain.tipoItempromocionalPregunta[value.tipoItemProm] = {pregunta: value.pregunta};
                    
                    // Acumular cantidad de evidencias
                    if (vm.filtros.pregunta.cantEvidencias.pregunta[value.pregunta] == undefined) {
                        vm.filtros.pregunta.cantEvidencias.pregunta[value.pregunta] = value.evidencias;
                    } else vm.filtros.pregunta.cantEvidencias.pregunta[value.pregunta] += value.evidencias;
                    if (vm.filtros.pregunta.cantEvidencias.marca[value.marca] == undefined) {
                        vm.filtros.pregunta.cantEvidencias.marca[value.marca] = value.evidencias;
                    } else vm.filtros.pregunta.cantEvidencias.marca[value.marca] += value.evidencias;
                    if (vm.filtros.pregunta.cantEvidencias.categoriaItem[value.categoriaItem] == undefined) {
                        vm.filtros.pregunta.cantEvidencias.categoriaItem[value.categoriaItem] = value.evidencias;
                    } else vm.filtros.pregunta.cantEvidencias.categoriaItem[value.categoriaItem] += value.evidencias;
                    if (vm.filtros.pregunta.cantEvidencias.tipoItempromocional[value.tipoItemProm] == undefined) {
                        vm.filtros.pregunta.cantEvidencias.tipoItempromocional[value.tipoItemProm] = value.evidencias;
                    } else vm.filtros.pregunta.cantEvidencias.tipoItempromocional[value.tipoItemProm] += value.evidencias;
                    
                    // Crear jerarquía
                    if (vm.filtros.pregunta.elements[value.pregunta] == undefined) vm.filtros.pregunta.elements[value.pregunta] = {};
                    if (vm.filtros.pregunta.elements[value.pregunta][value.marca] == undefined) vm.filtros.pregunta.elements[value.pregunta][value.marca] = {};
                    if (vm.filtros.pregunta.elements[value.pregunta][value.categoriaItem] == undefined) vm.filtros.pregunta.elements[value.pregunta][value.categoriaItem] = {};
                    if (vm.filtros.pregunta.elements[value.pregunta][value.tipoItemProm] == undefined) vm.filtros.pregunta.elements[value.pregunta][value.tipoItemProm] = {}; 
                });
                angular.forEach(response.data.producto, function (value) {
                    if(!vm.filtrosPlain.marca[value.marca]) vm.filtrosPlain.marca[value.marca] = {};
                    // Acumular cantidad de evidencias
                    if (vm.filtros.producto.cantEvidencias.marca[value.marca] == undefined) {
                        vm.filtros.producto.cantEvidencias.marca[value.marca] = value.evidencias;
                    } else vm.filtros.producto.cantEvidencias.marca[value.marca] += value.evidencias;
                    if (vm.filtros.producto.elements[value.marca] == undefined) vm.filtros.producto.elements[value.marca] = {};
                });
                angular.forEach(response.data.indicador, function (value) {
                    if(!vm.filtrosPlain.nombreIndicador[value.nombreIndicador]) vm.filtrosPlain.nombreIndicador[value.nombreIndicador] = {};
                    if (vm.filtros.indicador.cantEvidencias.nombreIndicador[value.nombreIndicador] == undefined){
                        vm.filtros.indicador.cantEvidencias.nombreIndicador[value.nombreIndicador] = value.evidencias;
                    } else vm.filtros.indicador.cantEvidencias.nombreIndicador[value.nombreIndicador] += value.evidencias;
                    if (vm.filtros.indicador.elements[value.nombreIndicador] == undefined) vm.filtros.indicador.elements[value.nombreIndicador] = {};
                });
                angular.forEach(response.data.genericos, function (values, key) {
                    vm.filtrosPlain[key] = {};

                    // Acumular cantidad de evidencias
                    if (vm.filtros[key] == undefined) {
                        vm.filtros[key] = { elements: {}, cantEvidencias: {} };
                    }

                    angular.forEach(values, function (value) {
                        vm.filtrosPlain[key][value.valor] = {};
                        if (vm.filtros[key].cantEvidencias[value.valor] == undefined) {
                            vm.filtros[key].cantEvidencias[value.valor] = value.evidencias;
                        } else vm.filtros[key].cantEvidencias[value.valor] += value.evidencias;
                        if (vm.filtros[key].elements[value.valor] == undefined) vm.filtros[key].elements[value.valor] = {};
                    })
                });
                vm.filtrosLoaded = true;
            });
        }
        vm.filtrosHidden = true;
        vm.mostrarFiltros = function () {
            vm.filtrosHidden = !vm.filtrosHidden;
        }
        vm.carHidden = true;
        vm.carHiddenFotosFachada = true;
        vm.evidenciasSet = false;
        vm.evidencias = [];
        vm.fotosFachada = [];
        vm.activeSlide = 0;
        vm.paginationPage = 0;
        vm.paginationSize = 0;
        vm.lastProyecto = null;
        vm.lastCanal = "";
        vm.showCanales = false;
        vm.mostrarCanal = function (value) {
            if (vm.canalElegido == value){
                vm.canalElegido = '';
            }
            else{
                vm.canalElegido = value;
            }
            vm.showCanales = !vm.showCanales;
        }
        vm.mostrarCanales = function () {
            vm.showCanales = !vm.showCanales;
        }
        $scope.$watch("vm.eviShown", function (shown) {
            initialize();
        }, true);
        $scope.$watch("vm.proyectoId", function (shown) {
            initialize();
        }, true);
        $scope.$watch("vm.canalElegido", function (shown) {
            initialize();
        }, true);
        function initialize() {
            if (vm.eviShown &&
                (vm.lastProyecto != vm.proyectoId ||
                vm.lastCanal != vm.canalElegido) &&
                vm.proyectoId != null) {
                loadCanales();
                if(vm.paginationPage!=0) {
                    vm.paginationPage = 0;
                }
                else loadEvidencias(0);
                loadFiltros();

                vm.lastProyecto = vm.proyectoId;
                vm.lastCanal = vm.canalElegido;
            }
        }
        $scope.$watch("vm.paginationPage", function (value) {
            if (vm.eviShown) {
            loadEvidencias(value);
            }
        }, true);
        $scope.$watch("vm.filtrosSelected", function (value) {
            if (vm.eviShown) {
                loadEvidencias(0);
                loadFiltros();
            }
        }, true);
        vm.download = function(){
            vm.loaded = false;
            var dataEvidencias = {
                "idProyecto": "" + vm.proyectoId,
                "nombrecanal": "" + vm.canalElegido,
                "idUsuario": "" + vm.usuarioId
            };
            if(vm.filtrosSelected.fecha){
                dataEvidencias.fechadesde = ""+vm.filtrosSelected.fecha.value.fechaIni;
                dataEvidencias.fechahasta = ""+vm.filtrosSelected.fecha.value.fechaFin;
            }
            dataEvidencias.fil = getFiltrosFinal();
            if (vm.filtrosSelected.geo) dataEvidencias.fil.push(vm.filtrosSelected.geo);
            if (vm.filtrosSelected.cadena) dataEvidencias.fil.push(vm.filtrosSelected.cadena);
            $http.post('api/evidencias/descargaMain', dataEvidencias, { responseType: 'arraybuffer' }).then(function (response) {
                var newDate = new Date();
                var date = "" + newDate.getDate()+ "-" + (newDate.getMonth() + 1) + "-" + newDate.getFullYear() + "-" + newDate.getHours() + "-" + newDate.getMinutes();
                var file = new Blob([response.data], { type: 'application/zip' });
                saveAs(file, 'evidencias-dashboard-'+date+'.zip');
                vm.loaded = true;
            });
        }

        // Inicializar las variables al inicio del controlado

        vm.mostrarFotosFachada = function() {
            if (vm.fotosFachada && vm.fotosFachada.length > 0) {
                vm.currentSlide = 0;
                vm.carHiddenFotosFachada = false; // Usar la variable correcta
            } else {
                console.log('No hay fotos de fachada disponibles');
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'app',
            url: '/login',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$state'];

    function LoginService ($state) {
        var service = {
            open: open
        };

        return service;

        function open () {
            $state.go('home');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope','Principal', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, Principal, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.grant_type = 'password';
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true,
                grant_type: 'password'
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            if(event != null) {
                event.preventDefault();
            }

            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe,
                grant_type: vm.grant_type
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                $state.go('home', {},{reload:true});

                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (resp) {
                if (resp.data.error === 'invalid_grant') {
                    vm.authenticationError = true;
                }

                if (resp.data.error === 'no_client') {
                    vm.noClientError = true;
                }
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('graficaPrincipal', {
            templateUrl: 'app/components/graficaPrincipal/graficaPrincipal.html',
            controller: 'GraficaPrincipalController',
            controllerAs: 'vm',
            bindings: {
                labelsDatos: '=',
                ultDatos: '=',
                listaCantidad: '=',
                labels: '=',
                cont: '='
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('GraficaPrincipalController', GraficaPrincipalController);

    GraficaPrincipalController.$inject = ['$scope'];

    function GraficaPrincipalController($scope) {
        var vm = this;
        var myChart;
        vm.cont = 0;

        var colorBorder = ["#F98866", "#FF420E", "#eb0058", "#9aeb59","#f100c5","#98DBC6","#5BC8AC","#E6D72A"];
        var colorBorderBack = ["#F98866", "#FF420E", "#eb0058", "#9aeb59","#f100c5","#98DBC6","#5BC8AC","#E6D72A"];
        var ctx = document.getElementById('trimestre-info-bar').getContext('2d');
        var whiteGradient = ctx.createLinearGradient(0, 0, 0, 300);
        whiteGradient.addColorStop(0, '#ffffff');
        whiteGradient.addColorStop(1, 'transparent');

        $scope.$watch('vm.ultDatos', function (newVal) {
            if(vm.cont >= 1){
                if(vm.cont === 1){
                    myChart.data.labels = [];
                    myChart.data.labels = vm.labelsDatos;
                    myChart.data.datasets = [];
                    myChart.options.legend.display = true;
                    /*
                    var option = myChart.options.legend.labels;
                    option.fontColor = 'FFF';
                    myChart.options.legend.labels = option;*/
                }
                var data = {
                    label: vm.labels[vm.cont - 1],
                    data: vm.ultDatos[vm.cont - 1],
                    backgroundColor: whiteGradient,
                    hoverBackgroundColor: whiteGradient,
                    borderColor: colorBorder[vm.cont - 1],
                    fill: false,
                    pointBackgroundColor: colorBorderBack[vm.cont - 1],
                    pointBorderWidth: 2,
                    pointRadius: 4,
                    pointHoverRadius: 4
                };
                myChart.data.datasets.push(data);
                myChart.update();
                vm.cont++;
            }
            else{
                if(myChart){
                    myChart.destroy();
                }
                cargaGrafico();
                vm.cont++;
            }
        }, true);

        function cargaGrafico() {
            myChart = new Chart(document.getElementById("trimestre-info-bar"), {
                /*plugins: [{
                    afterDatasetsDraw: function(chart, easing) {
                        // To only draw at the end of animation, check for easing === 1

                        var ctx = chart.ctx;
                        chart.data.datasets.forEach(function (dataset, i) {
                            if(i === 0){
                                var meta = chart.getDatasetMeta(i);
                                if (!meta.hidden) {
                                    meta.data.forEach(function(element, index) {
                                        // Draw the text in black, with the specified font
                                        ctx.fillStyle = 'rgb(255, 255, 255)';
                                        var fontSize = 12;
                                        var fontStyle = 'normal';
                                        var fontFamily = 'Roboto';
                                        ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

                                        // Just naively convert to string for now
                                        var dataString = chart.data.labels[index];
                                        // Make sure alignment settings are correct
                                        ctx.textAlign = 'center';
                                        ctx.textBaseline = 'middle';
                                        var padding = 10;
                                        var position = element.tooltipPosition();
                                        ctx.fillText(dataString, position.x, position.y - (fontSize / 2) - padding);
                                    });
                                }
                            }
                        });
                    }
                }],*/
                type: 'line',
                data: {
                    labels: vm.labelsDatos,
                    datasets: [{
                        label: '',
                        data: vm.ultDatos[0],
                        backgroundColor: whiteGradient,
                        hoverBackgroundColor: whiteGradient,
                        borderColor: "#FFFFFF",
                        fill: true,
                        pointBackgroundColor: "#0c2646",
                        pointBorderWidth: 3,
                        pointRadius: 5,
                        pointHoverRadius: 6
                    }]
                },
                options: {
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            left: 20,
                            right: 20,
                            top: 80,
                            bottom: 70
                        }
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: "#FFFFFF",
                                fontFamily: "Arial",
                                fontSize: 12
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontColor: "#FFFFFF",
                                fontFamily: "Arial",
                                fontSize: 12,
                                min: 0
                            }
                        }]
                    },
                    title: {
                        display: false,
                        text: 'Información general de encuestas contestadas en los últimos 3 meses'
                    },
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                var label = data.datasets[tooltipItem.datasetIndex].label || '';

                                if (label) {
                                    label += ': ';
                                }
                                label += Math.round(tooltipItem.yLabel * 100) / 100;
                                if(vm.listaCantidad && vm.listaCantidad[tooltipItem.datasetIndex] && vm.listaCantidad[tooltipItem.datasetIndex][tooltipItem.index]){
                                    label += " | Encuestas: " + vm.listaCantidad[tooltipItem.datasetIndex][tooltipItem.index];
                                }
                                return label;
                            }
                        },
                        backgroundColor: '#FFF',
                        titleFontSize: 16,
                        titleFontColor: '#000',
                        bodyFontColor: '#000',
                        bodyFontSize: 14,
                        displayColors: false,
                        caretSize: 5,
                        fontFamily: "Arial",
                        xPadding: 20,
                        yPadding: 10
                    }
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('GeografiaController', GeografiaController);

    GeografiaController.$inject = ['$http', '$uibModalInstance', 'DASHBOARD_API_URL', 'filterList', '$timeout'];

    function GeografiaController ($http, $uibModalInstance, DASHBOARD_API_URL, filterList, $timeout) {
        var vm = this;
        vm.cargando = false;
        vm.proyectoId = filterList.proyectoId;
        vm.usuarioId = filterList.idUsuario;
        vm.canalElegido = filterList.nombreCanal;
        vm.idIndicador = filterList.idIndicador;
        vm.arregloFiltros = [];//filterList.arregloFiltros;
        vm.fechasElegidas = {FechaInicio: 'null', FechaFin: 'null'};
        vm.geografia = {};
        vm.ultimoFiltroElegidoMunicipios = [];
        vm.ultimoFiltroElegidoEstados = [];
        vm.ultimoFiltroElegidoAreasNielsen = [];
        vm.ultimoFiltroElegidoPaises = [];
        vm.filtroElegido = [];
        vm.agregados = [];

        vm.disabledButtonGeografia = true;

        vm.disabledEstado = true;
        vm.disabledUbicacion = true;

        vm.tieneMunicipios = false;
        vm.tieneEstados = false;
        vm.tieneAreaNielsen = false;
        vm.tienePaises = false;

        vm.areas = '';
        vm.estados = '';
        vm.ubicaciones = '';

        vm.filterList = filterList.filtros;
        vm.datosTabla = angular.copy(filterList.filtros);
        vm.aplicarFiltro = aplicarFiltro;
        vm.aceptarGeografia = aceptarGeografia;
        vm.mostrarListaClic = mostrarListaClic;
        vm.seleccionoValor = seleccionoValor;
        vm.busqueda = busqueda;

        vm.seleccionarTodos = seleccionarTodos;
        vm.seleccionoTodos = false;
        vm.SeleccionarTodosText = "Seleccionar Todos";
        // vm.cargarSeleccionados = cargarSeleccionados;

        vm.mostrarLista = [];
        vm.disabledButtonGeografia = [];

        vm.filtro = '';
        vm.seleccionado = [];//filterList.select;

        $timeout(function () {
            cargarSeleccionados();
        }, 5);

        function regex(datos) {
            var myRe = new RegExp('##[0-9]*##','g');
            return datos.replace(myRe,'');
        }

        function aplicarFiltro(indice) {
            var indiceSiguiente = indice + 1;

            //obtener seleccionado y guardar en memoria
            vm.arregloFiltros = [];
            angular.forEach(vm.filtroElegido, function (item) {
                vm.arregloFiltros.push({
                    valorFiltroGeografia: item.valor.toString(),
                    columnaFiltroGeografia: item.columna.toString(),
                    valorFiltroDistribucion: "null",
                    columnaFiltroDistribucion: "null",
                    table: item.table.toString()
                })
            });

            if(indice == vm.mostrarLista.length - 1)
            {
                aceptarGeografia();
            }
            else{
                mostrarListaClic(indiceSiguiente);
            }
            

        }

        function cargarSeleccionados() {
            angular.forEach(vm.seleccionado, function (seleccionado) {
                vm.filtroElegido.push(seleccionado);
                angular.forEach(vm.datosTabla.Group, function (filtros, pindex) {
                    if(seleccionado.columna === filtros.GroupFilter){
                        vm.disabledButtonGeografia[pindex] = false;
                        angular.forEach(filtros.ValueFilter, function (filtro, index){
                            if(seleccionado.valor === filtro.OptionText){
                                document.getElementById('radioG' + pindex + index +'').checked = true;
                            }
                        });
                    }
                });
            })
        }

        angular.forEach(vm.filterList.Group, function (elem) {
            vm.mostrarLista.push(false);
            vm.disabledButtonGeografia.push(true);
        });

        function mostrarListaClic(indice) {
            vm.seleccionoTodos = true;
            vm.seleccionarTodos(indice);

            var descripcionFiltro = vm.datosTabla.Group[indice].GroupFilter;
            var dataFiltros = {
                "idProyecto": "" + vm.proyectoId,
                "idUsuario": "" + vm.usuarioId,
                "nombrecanal": "" + vm.canalElegido,
                "idIndicador": "" + vm.idIndicador,
                "fil": [],
                "fechadesde": "" + vm.fechasElegidas.FechaInicio,
                "fechahasta": "" + vm.fechasElegidas.FechaFin,
                "vision": [],
                "nombreMenuPadre": ""
            };

            vm.filterList.Group[indice].ValueFilter = [];
            vm.datosTabla.Group[indice].ValueFilter = [];

            //obtener datos
            vm.cargando = true;
            if (descripcionFiltro === "NombrePais") {
                dataFiltros.nombreMenuPadre = "Paises";
                angular.forEach(vm.arregloFiltros, function (obj) {
                    dataFiltros.fil.push(obj);
                });
            }

            if (descripcionFiltro === "AreaNielsen") {
                dataFiltros.nombreMenuPadre = "AreasNielsen";
                angular.forEach(vm.arregloFiltros, function (obj) {
                    // if(obj.columnaFiltroGeografia === 'NombrePais' ){
                    //     dataFiltros.fil.push(obj);
                    // }
                    dataFiltros.fil.push(obj);
                });
            }

            if (descripcionFiltro === "NombreEstado") {
                dataFiltros.nombreMenuPadre = "Estados";
                angular.forEach(vm.arregloFiltros, function (obj) {
                    dataFiltros.fil.push(obj);
                });
            }

            if (descripcionFiltro === "NombreUbicacion") {
                dataFiltros.nombreMenuPadre = "Municipios";
                angular.forEach(vm.arregloFiltros, function (obj) {
                    dataFiltros.fil.push(obj);
                });
            }

            if (vm.filterList.SelectFilter == "Geografía") {
                $http.post('api/filtros-visiones/cadenas', dataFiltros).then(function (response) {
                    vm.filterList.Group[indice].ValueFilter = response.data;
                    vm.datosTabla.Group[indice].ValueFilter = response.data;
                    vm.cargando = false;
                });

                
            } 

            //agrego el campo selected para poder vincularlo al checkbox y luego utilizar seleccionar/deselecccionar todos
            vm.filterList.Group[indice].ValueFilter = vm.filterList.Group[indice].ValueFilter.map(function(item) {
                item.selected = false;
                return item;
            });


            angular.forEach(vm.filterList.Group,function(item, index){
                if(index === indice){
                    vm.mostrarLista[index] = !(vm.mostrarLista[index]);
                }
                else{
                    vm.mostrarLista[index] = false;
                }
            });
        }

        function seleccionoValor(indicePadre, indiceHijo) {
            var row = vm.datosTabla.Group[indicePadre].ValueFilter[indiceHijo];
            var valor = vm.datosTabla.Group[indicePadre].ValueFilter[indiceHijo].OptionText;
            var columna = vm.datosTabla.Group[indicePadre].GroupFilter;
            var table = vm.datosTabla.Group[indicePadre].Table;
            var valorMostrar = vm.datosTabla.Group[indicePadre].valorMostar;
            var filtro = {valor: valor, columna: columna, table: table, valorA: regex(valor)};
            var elimino = false;

            vm.filtroElegido.find(function(value, index) {
                if (value && value.valor === filtro.valor && filtro && value.columna === filtro.columna) {
                    vm.filtroElegido.splice(index,1);
                    elimino = true;
                    row.selected = false;
                }
            });
            if(!elimino){
                row.selected = true;
                filtro.valorMostar = valorMostrar;
                vm.filtroElegido.push(filtro);
                angular.forEach(vm.filterList.Group,function(item, index){
                    if(index === indicePadre){
                        vm.disabledButtonGeografia[index] = false;
                    }
                    else{
                        vm.disabledButtonGeografia[index] = true;
                    }
                });
            }

        }


        // function aceptarGeografia(indicePadre){
        //     var filtrosElegidos = [];
        //     angular.forEach(vm.filtroElegido,function(item,index){
        //         if(item.columna === vm.datosTabla.Group[indicePadre].GroupFilter){
        //             item.valorMostar = item.columna.match(/[A-Z][a-z]+|[0-9]+/g).join(" ");
        //             filtrosElegidos.push(item);
        //         }
        //     });
        //     $uibModalInstance.close(filtrosElegidos);
        // }

        function aceptarGeografia(){
            var filtrosElegidos = [];

            //setea variables para despues dejar la ultima seleccion
            CargarListaMunicipios();
            CargarListaEstados();
            CargarListaAreasNielsen();
            CargarListaPaises();
            angular.forEach(vm.filtroElegido,function(item,index){
                
                if(vm.ultimoFiltroElegidoMunicipios.length > 0){
                    if(item.valorMostar == 'Municipios'){
                        filtrosElegidos.push(item);
                    }
                }
                else if(vm.ultimoFiltroElegidoEstados.length > 0){
                    if(item.valorMostar == 'Estados'){
                        filtrosElegidos.push(item);
                    }
                }
                else if(vm.ultimoFiltroElegidoAreasNielsen.length > 0){
                    if(item.valorMostar == 'Áreas Nielsen'){
                        filtrosElegidos.push(item);
                    }
                }
                else if(vm.ultimoFiltroElegidoPaises.length > 0){
                    if(item.valorMostar == 'Países'){
                        filtrosElegidos.push(item);
                    }
                }
                
            });
            $uibModalInstance.close(filtrosElegidos);
        }

        function busqueda(i) {
            vm.datosTabla.Group[i].ValueFilter = [];
            angular.forEach(vm.filterList.Group[i].ValueFilter, function (elem) {
                if(elem.OptionText.toLowerCase().indexOf(vm.filtro.toLowerCase().trim()) > -1){
                    vm.datosTabla.Group[i].ValueFilter.push(elem);
                }
            });
        }

        function CargarListaMunicipios() {
            angular.forEach(vm.filtroElegido,function(item,index){
                if(item.valorMostar == 'Municipios'){
                    vm.ultimoFiltroElegidoMunicipios.push(item);
                }
            });
        }

        function CargarListaEstados() {
            angular.forEach(vm.filtroElegido,function(item,index){
                if(item.valorMostar == 'Estados'){
                    vm.ultimoFiltroElegidoEstados.push(item);
                }
                
            });
        }

        function CargarListaAreasNielsen() {
            angular.forEach(vm.filtroElegido,function(item,index){
                if(item.valorMostar == 'Áreas Nielsen'){
                    vm.ultimoFiltroElegidoAreasNielsen.push(item);
                }
                
            });
        }

        function CargarListaPaises() {
            angular.forEach(vm.filtroElegido,function(item,index){
                if(item.valorMostar === 'Países'){
                    vm.ultimoFiltroElegidoPaises.push(item);
                }
                
            });
        }

        function seleccionarTodos(indice){
            vm.seleccionoTodos = !vm.seleccionoTodos;
            if(vm.seleccionoTodos){
                vm.SeleccionarTodosText = "Deseleccionar Todos";
                vm.disabledButtonGeografia[indice] = false;
                angular.forEach(vm.datosTabla.Group[indice].ValueFilter, function(item) {
                    item.selected = true;
                    var valor = item.OptionText;
                    var columna = vm.datosTabla.Group[indice].GroupFilter;
                    var table = vm.datosTabla.Group[indice].Table;
                    var valorMostrar = vm.datosTabla.Group[indice].valorMostar;
                    var filtro = {valor: valor, columna: columna, table: table, valorA: regex(valor)};
                    filtro.valorMostar = valorMostrar;
                    vm.filtroElegido.push(filtro);
                });

            }
            else{
                vm.SeleccionarTodosText = "Seleccionar Todos";
                vm.disabledButtonGeografia[indice] = true;
                angular.forEach(vm.datosTabla.Group[indice].ValueFilter, function(item) {
                    item.selected = false;

                    vm.filtroElegido.find(function(value, index) {
                        if (value && value.valor === item.OptionText && value.columna === vm.datosTabla.Group[indice].GroupFilter) {
                            vm.filtroElegido.splice(index,1);
                        }
                    });
                });

                

            }    
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('FechaController', FechaController);

    FechaController.$inject = ['$http', '$uibModalInstance'];

    function FechaController ($http, $uibModalInstance) {
        
        var vm = this;
        vm.disabledButtonFecha = false;
        vm.selectFecha = true;
        vm.anyo = false;
        vm.mes = false;
        vm.quarter = false;
        vm.dia = false;
        vm.aceptarFecha = aceptarFecha;
        vm.buscarFecha = buscarFecha;
        vm.buscarQuarter = buscarQuarter;
        vm.names = ["Año", "Quarter", "Mes", "Dia", "Fecha"];
        
        var date = new Date();
        var maxYear =  date.getFullYear();
        var minYear = 2019;
        var meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
        var ultMeses = [];
        var ultQuarter = [];
        var fechaQuarter = new Date();

        //Carga meses  
        for (var i = 12; i >= 0; i--) {
            var fecha = new Date();
            fecha.setDate(1);
            var mes = (date.getMonth()+i-12);
            fecha.setMonth(mes);
            ultMeses[i] = fecha;
        }
  
        //Carga quarters
        if (fechaQuarter.getMonth() + 1 == 3 || fechaQuarter.getMonth() + 1 == 6 || fechaQuarter.getMonth() + 1 == 9 || fechaQuarter.getMonth() + 1 == 12){
            fechaQuarter.setMonth(fechaQuarter.getMonth() + 0);
        }
        else if (fechaQuarter.getMonth() + 1 == 2 || fechaQuarter.getMonth() + 1 == 5 || fechaQuarter.getMonth() + 1 == 8 || fechaQuarter.getMonth() + 1 == 11){
            fechaQuarter.setMonth(fechaQuarter.getMonth() + 1);
        }
        else if (fechaQuarter.getMonth() + 1 == 1 || fechaQuarter.getMonth() + 1 == 4 || fechaQuarter.getMonth() + 1 == 7 || fechaQuarter.getMonth() + 1 == 10){
            fechaQuarter.setMonth(fechaQuarter.getMonth() + 2);
        }

        for (var i = 0; i < 8; i++) {
            var fecha;
            if ((fechaQuarter.getMonth() + 1) == 3){
                fecha = fechaQuarter.getFullYear() + "-Q1";
            }
            else if ((fechaQuarter.getMonth() + 1) == 6){
                fecha = fechaQuarter.getFullYear() + "-Q2";
            }
            else if ((fechaQuarter.getMonth() + 1) == 9){
                fecha = fechaQuarter.getFullYear() + "-Q3";
            }
            else if ((fechaQuarter.getMonth() + 1) == 12){
                fecha = fechaQuarter.getFullYear() + "-Q4";
            }
            ultQuarter.push(fecha);
            fechaQuarter.setMonth(fechaQuarter.getMonth() - 3);
        }
        ultQuarter = ultQuarter.reverse();

        function buscarFecha(mes){
            return meses[ultMeses[(mes - 1)].getMonth()] + '-' + ultMeses[(mes - 1)].getFullYear();
        }

        function buscarQuarter(quarter){
            return ultQuarter[quarter - 1];
        }

        vm.sliderMes = {
            minValue: 1,
            maxValue: 13,
            options: {
                floor: 1,
                ceil: 13,
                step: 1,
                showTicks: true,
                minRange: 0,
                translate: function(value) {
                    var mes = buscarFecha(value);
                    return mes;
                    }
            }
        };

        vm.sliderQuarter = {
            minValue: 1,
            maxValue: 8,
            options: {
                floor: 1,
                ceil: 8,
                step: 1,
                showTicks: true,
                minRange: 0,
                translate: function(value) {
                    var quarter = buscarQuarter(value);
                    return quarter;
                }
            }
        };

        vm.sliderAnyo = {
            minValue: minYear,
            maxValue: maxYear,
            options: {
                floor: minYear,
                ceil: maxYear,
                step: 1,
                showTicks: true,
                minRange: 0
            }
        };

        vm.today = function() {
            vm.dt = new Date();
            vm.dt.setDate(vm.dt.getDate());
            vm.dt2 = new Date();
        };
        vm.today();

        vm.clear = function() {
            vm.dt = new Date();
            vm.dt.setMonth(vm.dt.getMonth() - 1);
            vm.dt2 = new Date();
        };

        vm.inlineOptions = {
            customClass: getDayClass,
            minDate: new Date(),
            showWeeks: true
        };

        vm.dateOptions = {
            // dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(),
            minDate: new Date(2019,1,1),
            startingDay: 1
        };

        // Disable weekend selection
        // function disabled(data) {
        //     var date = data.date,
        //         mode = data.mode;
        //     return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        // }

        vm.toggleMin = function() {
            vm.inlineOptions.minDate = vm.inlineOptions.minDate ? null : new Date();
            vm.dateOptions.minDate = vm.inlineOptions.minDate;
        };

        vm.toggleMin();

        vm.open1 = function() {
            vm.popup1.opened = true;
        };

        vm.open2 = function() {
            vm.popup2.opened = true;
        };

        vm.setDate = function(year, month, day) {
            vm.dt = new Date(year, month, day);
        };
        vm.setDate2 = function(year, month, day) {
            vm.dt2 = new Date(year, month, day);
        };

        vm.formats = ['dd-MMMM-yyyy', 'yyyy-MM-dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[1];
        vm.altInputFormats = ['M!/d!/yyyy'];

        vm.popup1 = {
            opened: false
        };

        vm.popup2 = {
            opened: false
        };

        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        var afterTomorrow = new Date();
        afterTomorrow.setDate(tomorrow.getDate() + 1);
        vm.events = [
            {
                date: tomorrow,
                status: 'full'
            },
            {
                date: afterTomorrow,
                status: 'partially'
            }
        ];

        function getDayClass(data) {
            var date = data.date,
                mode = data.mode;
            if (mode === 'day') {
                var dayToCheck = new Date(date).setHours(0,0,0,0);

                for (var i = 0; i < vm.events.length; i++) {
                    var currentDay = new Date(vm.events[i].date).setHours(0,0,0,0);

                    if (dayToCheck === currentDay) {
                        return vm.events[i].status;
                    }
                }
            }
            return '';
        }

        var lastday = function(y,m){
            return  new Date(y, m +1, 0).getDate();
        }

        function aceptarFecha() {
            var fecha = {fechaIni: '', fechaFin: ''};
            if(vm.selectFecha){
                fecha.fechaIni = vm.dt.getFullYear() + '-' + (1 + vm.dt.getMonth()) + '-' + vm.dt.getDate();
                fecha.fechaFin = vm.dt2.getFullYear() + '-' + (1 + vm.dt2.getMonth()) + '-' + vm.dt2.getDate();
                var fI = new Date(fecha.fechaIni).setMilliseconds(0);
                var fF = new Date(fecha.fechaFin).setMilliseconds(0);
                if (fI > fF) {
                    fecha.fechaFin = new Date();
                    fecha.fechaFin = fecha.fechaFin.getFullYear() + "-" + (1 + fecha.fechaFin.getMonth()) + "-" + fecha.fechaFin.getDate();
                }
            }
            else if (vm.dia){
                fecha.fechaIni = vm.dt.getFullYear() + '-' + (1 + vm.dt.getMonth()) + '-' + vm.dt.getDate();
                fecha.fechaFin = vm.dt.getFullYear() + '-' + (1 + vm.dt.getMonth()) + '-' + vm.dt.getDate();
            }
            else if(vm.anyo){
                fecha.fechaIni = vm.sliderAnyo.minValue + '-1-1';
                fecha.fechaFin = vm.sliderAnyo.maxValue + '-12-31';
            }
            else if(vm.mes){
                if(ultMeses[vm.sliderMes.maxValue-1].getMonth() === 11){
                    fecha.fechaIni = ultMeses[vm.sliderMes.minValue-1].getFullYear() + '-' + ((ultMeses[vm.sliderMes.minValue-1].getMonth())+1) + '-1';
                    fecha.fechaFin = (ultMeses[vm.sliderMes.maxValue-1].getFullYear()) + '-12-31';
                }
                else{
                    var anioFin = ultMeses[vm.sliderMes.maxValue-1].getFullYear();
                    var mesFin = ultMeses[vm.sliderMes.maxValue-1].getMonth()+1;
                    fecha.fechaIni = ultMeses[vm.sliderMes.minValue-1].getFullYear() + '-' + ((ultMeses[vm.sliderMes.minValue-1].getMonth())+1) + '-1';
                    fecha.fechaFin = anioFin + '-' + mesFin + '-' + lastday(anioFin, mesFin-1);
                }
            }
            else if(vm.quarter){
                var indice = vm.sliderQuarter.minValue - 1;
                var anio = ultQuarter[indice].slice(0,4);
                var q = ultQuarter[indice].slice(ultQuarter[indice].length-1,ultQuarter[indice].length);
                if (q == 1){
                    fecha.fechaIni = anio + '-' + 1 + '-' + 1;    
                    fecha.fechaFin = anio + '-' + 3 + '-' + lastday(anio, 2);
                }
                else if (q == 2){
                    fecha.fechaIni = anio + '-' + 4 + '-' + 1;    
                    fecha.fechaFin = anio + '-' + 6 + '-' + lastday(anio, 5);
                }
                else if (q == 3){
                    fecha.fechaIni = anio + '-' + 7 + '-' + 1;    
                    fecha.fechaFin = anio + '-' + 9 + '-' + lastday(anio, 8);
                }
                else {
                    fecha.fechaIni = anio + '-' + 10 + '-' + 1;    
                    fecha.fechaFin = anio + '-' + 12 + '-' + lastday(anio, 11);
                }
            }
            $uibModalInstance.close(fecha);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('eviPagination', {
            templateUrl: 'app/components/eviPagination/eviPagination.html',
            controller: 'EviPaginationController',
            controllerAs: 'vm',
            bindings: {
                size: '=',
                page: '=',
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('EviPaginationController', EviPaginationController);

    EviPaginationController.$inject = ['$scope', '$http', '$timeout', 'showResult'];

    function EviPaginationController($scope, $http, $timeout, showResult) {
        var vm = this;
        vm.min = 0;
        vm.max = 4;
        vm.numbers = [0,1,2,3,4];
        function resetPages(){
            if(vm.page > 3){
                vm.min = vm.page-2;
                vm.max = vm.page+2;
            }
            else{
                vm.min = 0;
                vm.max = 4;
            }
            if(vm.max > vm.size-1){
                vm.max = vm.size;
            }
            vm.numbers = [];
            for(var i = vm.min; i<= vm.max;i++){
                vm.numbers.push(i);
            }
        }
        $scope.$watch("vm.page",resetPages,true);
        $scope.$watch("vm.size",resetPages,true);
        vm.setPage = function(number){
            vm.page = number;
        }
        vm.next = function(){
            if(vm.page+1 <= vm.size) vm.page++;
            //console.log(vm.size);
        }
        vm.prev = function(){
            if(vm.page-1 >= 0) vm.page--;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('eviGallery', {
            templateUrl: 'app/components/eviGallery/eviGallery.html',
            controller: 'EviGalleryController',
            controllerAs: 'vm',
            bindings: {
                items: '=',
                selection:'=',
                carHidden:'='
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('EviGalleryController', EviGalleryController);

    EviGalleryController.$inject = ['$scope', '$http', '$timeout', 'showResult', '$element'];

    function EviGalleryController($scope, $http, $timeout, showResult,$element) {
        var vm = this;
        vm.selection = 0;
        vm.select = function(index){
            vm.selection = index;
            vm.carHidden = !vm.carHidden;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('eviFiltros', {
            templateUrl: 'app/components/eviFiltros/eviFiltros.html',
            controller: 'EviFiltrosController',
            controllerAs: 'vm',
            bindings: {
                filtros: '=',
                filtrosSelected: '=',
                filtrosHidden: '=',
                filtrosPlain: '=',
                loaded: '='
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('EviFiltrosController', EviFiltrosController);

    EviFiltrosController.$inject = ['$scope', '$http', '$timeout', 'showResult','$uibModal' ];

    function EviFiltrosController($scope, $http, $timeout, showResult, $uibModal) {
        var vm = this;
        vm.formatFiltro = function(value){
            if(typeof value === 'string'){
            return value.replace(/##.*##/, '');
            }
            else{
                return value.fechaIni+" - "+value.fechaFin;
            }
        }
        vm.close = function(){
            vm.filtrosHidden = true;
        }
        vm.clean = true;
        vm.geoSelected = {table:undefined,value:undefined};
        $scope.$watch("vm.filtrosSelected",function(){
            if(Object.keys(vm.filtrosSelected).length > 0) {
                vm.clean = false;
            }
            else vm.clean = true;

        },true);
        /*$scope.$watch("vm.filtrosPlain",function(){
            console.log({filtrosPlain:vm.filtrosPlain});

        },true);*/
        vm.removeFiltro = function(filtro){
            delete vm.filtrosSelected[filtro];
        };
        vm.selectFiltro = function(type,table,value, catText){
            if((vm.filtrosSelected[type] == undefined) || vm.filtrosSelected[type].table != table || vm.filtrosSelected[type].value != value){
                vm.filtrosSelected[type] = {table: table, value: value, catText: catText};
            }
            else{
                delete vm.filtrosSelected[type];
            }
            vm.busqueda = '';
        };
        vm.selectFecha = function(){
            $uibModal.open({
                templateUrl: 'app/components/fecha/fecha.html',
                controller: 'FechaController',
                controllerAs: 'vm',
                size: 'md'
            }).result.then(function (result) {
                vm.filtrosSelected.fecha = {table: "fecha", value: {fechaIni:result.fechaIni, fechaFin:result.fechaFin}, catText: "Fecha"};
            });
        };
        vm.collapse = function($event, collapse){
            $event.stopPropagation();
            $event.preventDefault();
            return !collapse;
        };
        vm.clearSearch = function(){
            vm.busqueda = '';
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('evidencias', {
            templateUrl: 'app/components/evidencias/evidencias.html',
            controller: 'EvidenciasController',
            controllerAs: 'vm',
            bindings: {
                resultadoEvidenciasIndicador: '=',
                proyectoId: '=',
                mostrarEvidencias: '=',
                cargandoEvidencias: '=',
                canalElegido: '=',
                idIndicadorElegido: '=',
                filtrosElegidos: '=',
                fechasElegidas: '=',
                filtrosvisiones: '=',
                nombreMenuPadre: '='
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('EvidenciasController', EvidenciasController);

    EvidenciasController.$inject = ['$http', '$timeout', 'showResult', 'Principal'];

    function EvidenciasController($http, $timeout, showResult, Principal) {
        var vm = this;
        vm.pagina = 1;
        vm.arrayPrev = [];
        vm.arrayRes = [];
        vm.descargando = false;
        vm.sumarPagina = sumarPagina;
        vm.changeValue = changeValue;
        vm.onCarouselAfterChange = onCarouselAfterChange;
        vm.movementCarousel = movementCarousel;
        vm.cargarEvidencias = cargarEvidencias;
        vm.descargarImagenes = descargarImagenes;
        vm.currentSlide = 1;
        vm.moveDisabled = true;
        vm.finEvidencias = false;
        vm.usuarioId = Principal.identity().$$state.value.Id; 

        (function() {
            var listEl = document.querySelector('.home-grid.products-grid.products-grid--max-4');
            var btnLeftEl = document.querySelector('#left-btn');
            var btnRightEl = document.querySelector('#right-btn');
            vm.count = 0;
        
            function slideImages(dir) {
                var totalChildren = listEl.querySelectorAll(".item").length;
                var widthClassItem = document.getElementsByClassName('item-container')[0].offsetWidth;
                dir === "left" ? ++vm.count : --vm.count;
                listEl.style.left = vm.count * widthClassItem + 'px';
                btnLeftEl.style.display = vm.count < 0 ? "block" : "none";
                // Here, 4 is the number displayed at any given time
                btnRightEl.style.display = vm.count > 4-totalChildren ? "block" : "none";
            }

            btnLeftEl.addEventListener("click", function(e) {
                slideImages("left");
            });
            btnRightEl.addEventListener("click", function(e) {
                slideImages("right");
            });
        })();

        function movementCarousel(mov) {
            document.getElementById(vm.currentSlide).classList.remove('active');
            if(mov == true) {
                vm.currentSlide = vm.currentSlide + 1;
                document.getElementById('right-btn').disabled = true;
                $timeout(function () {
                    document.getElementById('right-btn').disabled = false;
                    onCarouselAfterChange(vm.currentSlide);
                }, 650);              
            }
            else {
                vm.currentSlide = vm.currentSlide - 1;
                document.getElementById('left-btn').disabled = true;
                $timeout(function () {
                    document.getElementById('left-btn').disabled = false;
                }, 650);
            }
            document.getElementById(vm.currentSlide).classList.add('active');
            return vm.currentSlide;          
        }

        showResult.subscribe(function(x) {
            if (x == "cargaEvidencias") {
                changeValue();
            }
        });
        
        function changeValue() {
            vm.currentSlide = 1;
            vm.pagina = 1;
            vm.arrayPrev = [];
            vm.arrayRes = [];
            vm.finEvidencias = false;
            disableRightBtn();
            $timeout(function () {
                document.getElementById(vm.currentSlide).classList.remove('active');
            }, 600);
            primeraCarga();
            sumarPagina();
            $timeout(function () {
                document.getElementById(1).classList.add('active');
            }, 600);
            recargaEvidenciasElementosHtml();
        }

        function descargarImagenes(){
            vm.descargando = true;
            var dataEvidencias = {
                "idProyecto": "" + vm.proyectoId,
                "idUsuario": "" + vm.usuarioId,
                "nombrecanal": "" + vm.canalElegido,
                "idIndicador": "" + vm.idIndicadorElegido,
                "fil": vm.arregloFiltros,
                "fechadesde": "" + vm.fechasElegidas.FechaInicio,
                "fechahasta": "" + vm.fechasElegidas.FechaFin,
                "vision": [],
                "nombreMenuPadre": "" + vm.nombreMenuPadre
            };
            $http.post('api/evidencias/descarga', dataEvidencias, { responseType: 'arraybuffer' }).then(function (response) {
                var newDate = new Date();
                var date = "" + newDate.getDate()+ "-" + (newDate.getMonth() + 1) + "-" + newDate.getFullYear() + "-" + newDate.getHours() + "-" + newDate.getMinutes();
                var file = new Blob([response.data], { type: 'application/zip' });
                saveAs(file, 'imagenes-dashboard-'+date+'.zip');
                vm.descargando = false;
            });
        }

        function recargaEvidenciasElementosHtml() {
            vm.count = 0;
            var btnLeftEl = document.querySelector('#left-btn');
            var btnRightEl = document.querySelector('#right-btn');
            var listEl = document.querySelector('.home-grid.products-grid.products-grid--max-4');
            listEl.style.left = vm.count + 'px';
            btnLeftEl.style.display = vm.count < 0 ? "block" : "none";
        }

        function onCarouselAfterChange(indexAfter) {
            if (vm.arrayPrev.length === 0 && vm.finEvidencias == false){
                disableRightBtn();       
                sumarPagina();    
                vm.arrayPrev = vm.arrayRes;                   
            }
            if (vm.arrayPrev[0] != undefined){             
                vm.resultadoEvidenciasIndicador.Content.push(vm.arrayPrev[0]);
                vm.arrayPrev.splice(0, 1);
            }
            else{
                vm.finEvidencias = true;
            }           
        }

        function cargarEvidencias(){
            var msg = "cargarEvidencias";
            showResult.sendMessage(msg);
        }

        function primeraCarga() {
            vm.pagina++;
            vm.arregloFiltros = [];
            cargarFiltros();
            var dataEvidencias = {
                "page": vm.pagina,
                "idProyecto": "" + vm.proyectoId,
                "idUsuario": "" + vm.usuarioId,
                "nombrecanal": "" + vm.canalElegido,
                "idIndicador": "" + vm.idIndicadorElegido,
                "fil": vm.arregloFiltros,
                "fechadesde": "" + vm.fechasElegidas.FechaInicio,
                "fechahasta": "" + vm.fechasElegidas.FechaFin,
                "vision": [],
                "idMenuPadre": "" + 0,
                "nombreMenuPadre": "" + vm.nombreMenuPadre
            };
            $http.post('api/evidencias', dataEvidencias).then(function (response) {
                vm.arrayPrev = response.data.Content;
            });
        }

        function sumarPagina(){
            vm.pagina++;
            var dataEvidencias = {
                    "page": vm.pagina,
                    "idProyecto": "" + vm.proyectoId,
                    "idUsuario": "" + vm.usuarioId,
                    "nombrecanal": "" + vm.canalElegido,
                    "idIndicador": "" + vm.idIndicadorElegido,
                    "fil": vm.arregloFiltros,
                    "fechadesde": "" + vm.fechasElegidas.FechaInicio,
                    "fechahasta": "" + vm.fechasElegidas.FechaFin,
                    "vision": [],
                    "idMenuPadre": "" + 0,
                    "nombreMenuPadre": "" + vm.nombreMenuPadre
            };
            $http.post('api/evidencias', dataEvidencias).then(function (response) {
                vm.arrayRes = response.data.Content;
                enableRightBtn();            
            });
        }

        function enableRightBtn(){
            document.getElementById('right-btn').disabled = false;
            document.getElementById('right-btn').style.color= "#000000";
        }

        function disableRightBtn(){
            document.getElementById('right-btn').disabled = true;
            document.getElementById('right-btn').style.color= "#c5c2c2";  
        }

        function cargarFiltros() {
            var valueFilterGeo = vm.filtrosElegidos.Geografia;
            var colFilterGeo = vm.filtrosElegidos.ColumnaGeografia;
            var valueFilterDis = vm.filtrosElegidos.Distribucion;
            var colFilterDis = vm.filtrosElegidos.ColumnaDistribucion;
            var valueAdicional = vm.filtrosElegidos.Adicionales;

            if (vm.filtrosElegidos.Geografia === '') {
                valueFilterGeo = "null";
                colFilterGeo = "null";
            }
            if (vm.filtrosElegidos.Distribucion === '') {
                valueFilterDis = "null";
                colFilterDis = "null";
            }
            if (vm.filtrosElegidos.Adicionales === '') {
                valueAdicional = "null";
            }

            if (valueFilterGeo !== "null") {
                angular.forEach(valueFilterGeo, function (item) {
                    vm.arregloFiltros.push({
                        valorFiltroGeografia: item.valor.toString(),
                        columnaFiltroGeografia: item.columna.toString(),
                        valorFiltroDistribucion: "null",
                        columnaFiltroDistribucion: "null",
                        table: item.table.toString()
                    })
                });
            }
            if (valueFilterDis !== "null") {
                angular.forEach(valueFilterDis, function (item) {
                    vm.arregloFiltros.push({
                        valorFiltroDistribucion: item.valor.toString(),
                        columnaFiltroDistribucion: item.columna.toString(),
                        valorFiltroGeografia: "null",
                        columnaFiltroGeografia: "null",
                        table: item.table.toString()
                    })
                });
            }
            if (valueAdicional !== "null") {     
                var listaGeo = ["NombrePais","AreaNielsen","NombreEstado","NombreUbicacion"]; 
                var listaFecha = ["Año","Mes","Quarter","Dia"];    
                angular.forEach(valueAdicional, function (item) {
                    if (listaFecha.indexOf(item.columna.toString()) > -1 ){
                        vm.arregloFiltros.push({
                            valorFiltroGeografia: "null",
                            columnaFiltroGeografia: "null",
                            valorFiltroDistribucion: item.valor.toString(),
                            columnaFiltroDistribucion: item.columna.toString(),
                            table: "RespuestaEncuesta"
                        })
                    }
                    else if (listaGeo.indexOf(item.columna.toString()) > -1 ){
                        vm.arregloFiltros.push({
                            valorFiltroGeografia: item.valor.toString(),
                            columnaFiltroGeografia: item.columna.toString(),
                            valorFiltroDistribucion: "null",
                            columnaFiltroDistribucion: "null",
                            table: item.table.toString()
                        })
                    }
                    else{
                        vm.arregloFiltros.push({
                            valorFiltroGeografia: "null",
                            columnaFiltroGeografia: "null",
                            valorFiltroDistribucion: item.valor.toString(),
                            columnaFiltroDistribucion: item.columna.toString(),
                            table: item.table.toString()
                        })
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('eviCarousel', {
            templateUrl: 'app/components/eviCarousel/eviCarousel.html',
            controller: 'EviCarouselController',
            controllerAs: 'vm',
            bindings: {
                items: '=',
                slide:'=',
                carHidden:'='
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('EviCarouselController', EviCarouselController);

    EviCarouselController.$inject = ['$scope', '$http', '$timeout', 'showResult', '$element'];

    function EviCarouselController($scope, $http, $timeout, showResult,$element) {
        var vm = this;
        vm.slide = 0;
        vm.nextSlide = function(){
            vm.slide++;
            if(vm.slide == vm.items.length) vm.slide = 0;
        }
        vm.prevSlide = function(){
            vm.slide--;
            if(vm.slide == -1) vm.slide = vm.items.length-1;
        }
        vm.close = function(){
            vm.info = false;
            vm.carHidden = true;
        }
        vm.timeout;
        vm.hoverTimeout = 2000;
        vm.hideHideables = false;
        vm.mouseOver = true;
        vm.showHidables = function(){
            vm.hideHideables = false;
            $timeout.cancel(vm.timeout);
            vm.timeout = $timeout(function(){
                if(vm.mouseOver) vm.hideHideables = true;
            },vm.hoverTimeout);
        }
        $timeout(function(){
            if(vm.mouseOver) vm.hideHideables = true;
        },vm.hoverTimeout)
        vm.enableMouseOver = function(){
            vm.mouseOver = true;
        }        
        vm.disableMouseOver = function(){
            vm.mouseOver = false;
        }
        vm.keypress = function(event){
            if(event.key == "ArrowLeft") vm.prevSlide();
            if(event.key == "ArrowRight") vm.nextSlide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .component('dropdown', {
            templateUrl: 'app/components/dropdown/dropdown.html',
            controller: 'DropdownController',
            controllerAs: 'vm'
        });
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('DropdownController', DropdownController);

    DropdownController.$inject = [];

    function DropdownController () {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('dashboard', {
            parent: 'app',
            url: '/dashboard',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/dashboard/dashboard.html',
                    controller: 'DashboardController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['$rootScope', '$state','Principal','$uibModal','$http', '$sessionStorage', 'showResult', '$scope', 'IS_DEV'];

    function DashboardController ($rootScope, $state, Principal, $uibModal, $http, $sessionStorage, showResult, $scope, IS_DEV) {
        var vm = this;
        vm.isDev = IS_DEV;
        //load data only after menu is loaded
        var watch = $rootScope.$watch('isMenuLoaded', function (ìsMenuLoaded) {
            if(ìsMenuLoaded){
                loadData();
            }
        }, true);

        vm.imagenbase64 = null;
        vm.eliminarFiltros = eliminarFiltros;
        vm.showdashboard = false;
        vm.showmainevidencias = false;
        vm.mostrarSidebar = true;
        vm.canalElegido = '';
        vm.indicadorElegido = '';
        vm.idIndicadorElegido = '';
        vm.idMenuPadreIndicador = '';
        vm.cargando = false;
        vm.mostrarTendencias = false;
        vm.mostrarMapas = false;
        vm.mostrarEvidencias = false;
        vm.mostrarTablas = false;
        vm.mostrarResultado = true;
        vm.cargandoTendencias = false;
        vm.cargandoMapa = false;
        vm.cargandoEvidencias = false;
        vm.graficaNoConfigurada = [true,true,true];
        vm.cargandoGraficaSecundarias = [true,true,true];
        vm.resultado = [];
        vm.resultadoTotal = null;
        vm.resultadoTendencias = [];
        vm.resultadoMapa = [];
        vm.resultadoEvidencia = [];
        vm.resultadoGraficaSecundaria = [];
        vm.proyectoId = '';
        vm.nombreProyecto = '';
        vm.visionSeleccionada = [];
        vm.showMessageError = false;
        vm.inicio = true;
        vm.labelsDatos = ['','','','','','','','','','','',''];
        vm.labels = [];
        vm.ultDatos = [[0,0,0,0,0,0,0,0,0,0,0,0]];
        vm.listaCantidad = [[0,0,0,0,0,0,0,0,0,0,0,0]];
        vm.cont = 0;
        vm.filtros = {Geografia: '', Distribucion: '', Adicionales: ''};
        vm.fechas = {FechaInicio: "null", FechaFin: "null"};

        vm.soloEvidencias = false;

        vm.collapseToggle = collapseToggle;
        vm.borrarFiltros = borrarFiltros;
        vm.borrarFiltroCanalIndicador = borrarFiltroCanalIndicador;
        vm.borrarFiltroGeografia = borrarFiltroGeografia;
        vm.borrarFiltroDistribucion = borrarFiltroDistribucion;
        vm.borrarFiltroAdicionales = borrarFiltroAdicionales;
        vm.borrarFecha = borrarFecha;
        vm.borrarVision = borrarVision;
        vm.init = init;
        vm.openModalProyecto = openModalProyecto;
        vm.reload = reload;

        vm.pedirMostrar = pedirMostrar;
        vm.sendEvent = sendEvent;
        vm.sendEventGraficaSecundaria = sendEventGraficaSecundaria;

        vm.usuarioId = Principal.identity().$$state.value.Id;

        function init() {
            vm.proyectoId = $sessionStorage.proyectoId;
            if($sessionStorage.nombreProyecto){
                vm.nombreProyecto = $sessionStorage.nombreProyecto;
            }
            vm.cliente = $sessionStorage.cliente;
            if(vm.cliente){
                vm.razonSocial = $sessionStorage.cliente.RazonSocial;
            }
            if($sessionStorage.Imagen != null) {
                vm.imagenbase64 = $sessionStorage.Imagen;
            }
            if (!vm.proyectoId) {
                openModalProyecto();
            } else {
                $http.get('api/proyectoCanalIndicadores/' + vm.proyectoId).then(function(response) {
                    vm.proyectoCanalIndicador = response.data;
                });
                $http.get('api/proyectos/get/' + vm.proyectoId).then(function(response) {
                    vm.proyecto = response.data;
                    vm.nombreProyecto = $sessionStorage.nombreProyecto = vm.proyecto.NombreProyecto;
                });
            }
        }

        function sendEvent() {
            showResult.sendMessage(true);
        }

        function limpiarGraficasSecundarias() {
            var msg = "limpiar";
            showResult.sendMessage(msg);
        }

        function sendEventGraficaSecundaria(i) {
            var msg = "cargaGrafico" + i;
            showResult.sendMessage(msg);
        }

        function pedirMostrar(){
            sendEvent();
        }

        function reload() {
            sendEvent();
        }

        showResult.subscribe(function(x) {
            if (x == "cargarGraficas") {
                cargarGraficasSecundarias();
            }
        });

        function openModalProyecto() {
            $uibModal.open({
                templateUrl: 'app/components/proyecto/proyecto.html',
                controller: 'ProyectoController',
                controllerAs: 'vm',
                size: 'md',
                backdrop  : 'static',
                keyboard  : false
            }).result.then(function (result) {
                vm.proyectoId = $sessionStorage.proyectoId = result.proyecto;
                vm.cliente = $sessionStorage.cliente = result.cliente;
                vm.proyectoUnico = $sessionStorage.proyectoUnico = result.proyectoUnico;
                vm.imagenbase64 = $sessionStorage.Imagen = vm.cliente.Imagen;
                vm.nombreProyecto = $sessionStorage.nombreProyecto = result.nombreProyecto;
                $http.get('api/proyectoCanalIndicadores/' + vm.proyectoId).then(function(response) {
                    vm.proyectoCanalIndicador = response.data.Content;
                });
                limpiarGraficaPrincipal();

                //actualizo la variable global para cargar los canales e indicadores del menu
                $rootScope.proyectId = vm.proyectoId;
            });
        }

        function limpiarGraficaPrincipal() {
            vm.cont = 0;
            vm.labelsDatos = [];
            vm.labels = [];
            vm.ultDatos = [];
            vm.listaCantidad = [];
        }


        function loadData() {
            if(vm.isDev == false){
                $http.get('api/resultado/graficaPrincipal/' + vm.proyectoId + '/' + vm.usuarioId).then(function (response) {
                    var responseFecha = new Date(response.data);
                    responseFecha.setDate(responseFecha.getDate() + 2);
                    var hasta = responseFecha.getFullYear() + "-" + (responseFecha.getMonth() + 1) + "-" + responseFecha.getDate();
                    var desde = '';
                    if ( (responseFecha.getMonth() + 1) != 12){
                        desde = (responseFecha.getFullYear() - 1) + "-" + (responseFecha.getMonth() + 2) + "-01";
                    }
                    else{
                        desde = responseFecha.getFullYear() + "-01" + "-01";
                    }
                    $http.get('api/indicadores/perfect/' + vm.proyectoId).then(function (response) {
                        var listaPerfect = response.data;
                        vm.labelsDatos = [];
                        var fechaDesde = new Date(desde);
                        var label = '';
                        fechaDesde.setMonth(fechaDesde.getMonth() + 1);
                        for(var i = 0; i < 12; i++){
                            if (i == 0 && fechaDesde.getMonth() == 0){
                                label = "1 - " + fechaDesde.getFullYear();
                                vm.labelsDatos.push(label);
                            }
                            else{
                                if (fechaDesde.getMonth() == 0){
                                    label = "12 - " + (fechaDesde.getFullYear() - 1);
                                    vm.labelsDatos.push(label);
                                    if ( i != 11){
                                        label = "1 - " + fechaDesde.getFullYear();
                                        vm.labelsDatos.push(label);
                                        fechaDesde.setMonth(fechaDesde.getMonth() + 1);
                                        i++;
                                    }
                                }
                                else{
                                    label = fechaDesde.getMonth() + " - " + fechaDesde.getFullYear();
                                    vm.labelsDatos.push(label);
                                }
                            }
                            fechaDesde.setMonth(fechaDesde.getMonth() + 1);
                        }
                        angular.forEach(listaPerfect, function (item) {
                            var dataPerfectStore = {
                                "idProyecto": "" + item.IdProyecto,
                                "idUsuario": "" + vm.usuarioId,
                                "nombrecanal": "" + item.NombreCanal,
                                "idIndicador": "" + item.IdPerfectStore,
                                "fil": [],
                                "fechadesde": "" + desde,
                                "fechahasta": "" + hasta,
                                "vision": ["Mes"]
                            };
    
                            $http.post('api/resultado/perfectStore', dataPerfectStore).then(function (response) {
                                var resultados = [];
                                angular.forEach(response.data, function (resultado){
                                resultado.anio = parseInt(resultado.nombresFiltros[0].substring(0,4));
                                resultado.mes = parseInt(resultado.nombresFiltros[0].substring(5,7));
                                resultados.push(resultado);
                                });
                                resultados.sort(function(a,b){
                                        if( a.anio < b.anio ){
                                            return -1;
                                        }
                                        if( a.anio > b.anio){
                                            return 1;
                                        }
                                        if( a.anio === b.anio){
                                            if(a.mes < b.mes ) {
                                                return -1;
                                            }
                                            else{
                                                return 1;
                                            }
                                        }
                                        return 0;
                                });
                                if(resultados.length === 13){
                                    resultados.splice(0, 1);
                                }
                                else if (resultados.length < 13 && resultados.length > 0){
                                    while (resultados.length < 12) {
                                        resultados.unshift(null);
                                    }
                                    var fechaHasta = new Date(hasta);
                                    var mesMax = (fechaHasta.getMonth() +1);
                                    var anioMax = (fechaHasta.getFullYear());
                                    if (resultados[11].anio != anioMax || resultados[11].mes != mesMax){
                                        var cant = 0;
                                        if (resultados[11].anio != anioMax){
                                            cant = 12 + mesMax - resultados[11].mes;
                                            for (var j=0; j<cant; j++){
                                                resultados.shift();
                                                resultados.splice(11+j,0,null);
                                            }
                                        }
                                        else if (resultados[11].mes != mesMax){
                                            cant = cant + (mesMax - resultados[11].mes);
                                            for (var j=0; j<cant; j++){
                                                resultados.shift();
                                                resultados.splice(11+j,0,null);
                                            }
                                        }
                                    }
                                    for(var i = 11; i > 0; i--){
                                        if (resultados[i] == null || resultados[i-1] == null){
                                            continue;
                                        }
                                        if(resultados[i].mes == 1){
                                            if ( ( resultados[i].mes + 11 != resultados[i-1].mes ) && ( resultados[i].anio - 1 != resultados[i-1].anio ) ){
                                                var cant = (resultados[i].mes + 11) - (resultados[i-1].mes);
                                                for (var j=0; j<cant; j++){
                                                    resultados.shift();
                                                    resultados.splice(i+j-1,0,null);
                                                }
                                            }
                                        }
                                        else if( (resultados[i].mes - 1) != (resultados[i-1].mes) ){
                                            var cant = (resultados[i].mes - 1) - (resultados[i-1].mes);
                                            for (var j=0; j<cant; j++){
                                                resultados.shift();
                                                resultados.splice(i+j-1,0,null);
                                            }
                                        }
                                    }
                                }
    
                                if(resultados.length !== 0){
                                    $http.post('api/resultado/perfectStore/cantidadEncuestas', dataPerfectStore).then(function (responseCantidad) {
                                        var resultadosCantidad = [];
                                        angular.forEach(responseCantidad.data, function (resultadoCantidad) {
                                            resultadoCantidad.anio = parseInt(resultadoCantidad.nombresFiltros[0].substring(0, 4));
                                            resultadoCantidad.mes = parseInt(resultadoCantidad.nombresFiltros[0].substring(5, 7));
                                            resultadosCantidad.push(resultadoCantidad);
                                        });
                                        resultadosCantidad.sort(function (a, b) {
                                                if (a.anio < b.anio) {
                                                    return -1;
                                                }
                                                if (a.anio > b.anio) {
                                                    return 1;
                                                }
                                                if (a.anio === b.anio) {
                                                    if (a.mes < b.mes) {
                                                        return -1;
                                                    } else {
                                                        return 1;
                                                    }
                                                }
                                                return 0;
                                            }
                                        );
                                        if(resultadosCantidad.length === 13){
                                            resultadosCantidad.splice(0, 1);
                                        }
                                        if(resultadosCantidad.length !== 0) {
                                            var lista = [];
                                            var i = 0;
                                            angular.forEach(resultadosCantidad, function (resultado) {
                                                if (i >= 12){
                                                    return;
                                                }
                                                if (resultados[i] != null){
                                                    lista.push(resultado.resultado);
                                                }
                                                else{
                                                    do{
                                                        lista.push(null);
                                                        i = i + 1;
                                                    } while(resultados[i] == null && i <= 11)
                                                    if (i <= 11){
                                                        lista.push(resultado.resultado);
                                                    }
                                                }
                                                i = i + 1;
                                            });
                                            while ( i <= 11 ){
                                                lista.push(null);
                                                i = i + 1;
                                            }
                                        }
                                        vm.listaCantidad.push(lista);
                                    });
                                    if(vm.inicio){
                                        vm.inicio = false;
                                        vm.ultDatos = [];
                                        vm.listaCantidad.splice(0,1);
                                    }
                                    var ultimos = [];
                                    if(resultados.length !== 0) {
                                        angular.forEach(resultados, function (item) {
                                            if(item){
                                                ultimos.push((item.resultado * 100).toFixed(2));
                                            }
                                            else{
                                                ultimos.push(null);
                                            }
                                        });
                                    }
                                    vm.labels.push(" "+ item.NombreCanal + " - " + item.NombreIndicador);
                                    vm.ultDatos.push(ultimos);
                                }
                            });
                        });
                        cargarGraficasSecundarias();
                    });
                });
            }
            
        }


        function cargarGraficasSecundarias() {
            limpiarGraficasSecundarias();
            vm.graficaNoConfigurada = [true,true,true];
            vm.cargandoGraficaSecundarias = [true,true,true];
            $http.get('api/grafica/' + vm.proyectoId).then(function(graficasProyecto) {
                vm.graficasSecundarias = graficasProyecto.data;
                vm.resultadoGraficaSecundaria = [];
                vm.cargandoGraficaSecundarias = [false,false,false];
                angular.forEach(vm.graficasSecundarias, function (obj) {
                    vm.graficaNoConfigurada[obj.Pos - 1] = false;
                    vm.cargandoGraficaSecundarias[obj.Pos - 1] = true;
                });
                var cont = 0;
                if(vm.graficasSecundarias.length !== 0) {
                    angular.forEach(vm.graficasSecundarias, function (obj) {
                        $http.get('api/resultado/graficaSecundaria/' + obj.IdGrafica + "/" + vm.proyectoId + "/" + vm.usuarioId).then(function (response) {
                            var resultado = response.data;
                            angular.forEach(resultado.resultados, function (res) {
                                angular.forEach(res.nombresFiltros, function (filtro, i) {
                                    filtro = regex(filtro);
                                    res.nombresFiltros[i] = filtro;
                                });
                            });
                            vm.cargandoGraficaSecundarias[obj.Pos - 1] = false;
                            resultado.Pos = obj.Pos;
                            cont = cont + 1;
                            vm.resultadoGraficaSecundaria.push(resultado);
                            sendEventGraficaSecundaria(cont);
                        });
                    });
                }
            });
        }

        function regex(datos) {
            var myRe = new RegExp('##[0-9]*##','g');
            return datos.replace(myRe,'');
        }

        function collapseToggle(){
            vm.mostrarSidebar = !vm.mostrarSidebar;
        }

        function borrarFiltroCanalIndicador(){
            vm.canalElegido = '';
            vm.indicadorElegido = '';
            vm.idMenuPadreIndicador = '';
            vm.showdashboard = false;
            vm.showmainevidencias = false;
        }

        function eliminarFiltros(){
            if(vm.visionSeleccionada.length !== 0 || vm.filtros.Geografia.length !== 0 || vm.filtros.Distribucion.length !== 0 || vm.filtros.Adicionales.length !== 0 || vm.fechas.FechaFin !== "null" && vm.fechas.FechaInicio !== "null") {
                return true;
            }
            return false;
        }


        function borrarFiltros(){
            vm.visionSeleccionada = [];
            vm.filtros = {Geografia: [], Distribucion: [], Adicionales: []};
            vm.fechas = {FechaInicio: "null", FechaFin: "null"};
            $scope.$watch('vm.visionSeleccionada', function(){
                if(vm.visionSeleccionada.length === 0){
                    pedirMostrar();
                }
            });
        }

        function borrarVision(indice){
            if (indice > -1) {
                vm.visionSeleccionada.splice(indice, 1);
                pedirMostrar();
            }
        }

        function borrarFiltroGeografia(indice){
            if (indice > -1) {
                vm.filtros.Geografia.splice(indice, 1);
                pedirMostrar();
            }
        }

        function borrarFiltroDistribucion(indice){
            if (indice > -1) {
                vm.filtros.Distribucion.splice(indice, 1);
                pedirMostrar();
            }
        }

        function borrarFiltroAdicionales(indice){
            if (indice > -1) {
                vm.filtros.Adicionales.splice(indice, 1);
                pedirMostrar();
            }
        }

        function borrarFecha(){
            vm.fechas.FechaInicio = "null";
            vm.fechas.FechaFin = "null";
            pedirMostrar();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('CadenaController', CadenaController);

    CadenaController.$inject = ['$http', '$scope','$filter','$uibModalInstance', 'filterList', '$timeout'];

    function CadenaController ($http, $scope, $filter,$uibModalInstance, filterList, $timeout) {
        var vm = this;
        vm.proyectoId = filterList.proyectoId;
        vm.usuarioId = filterList.idUsuario;
        vm.canalElegido = filterList.nombreCanal;
        vm.idIndicador = filterList.idIndicador;
        vm.arregloFiltros = [];//filterList.arregloFiltros;
        vm.fechasElegidas = {FechaInicio: 'null', FechaFin: 'null'};
        vm.cadena = {};
        vm.cadenaSeleccionada = '';
        vm.distribucionSeleccionada = {valor: '', columna: ''};
        vm.disabledButtonCadena = true;
        vm.mostrarAdvertencia = false;
        vm.cargando = false;
        vm.mostrarLista = [];
        vm.disabledButtonGeografia = [];

        vm.filtro = '';
        vm.filtroElegido = [];
        vm.filterList = filterList.filtros;
        vm.seleccionado = [];//filterList.select;
        vm.datosTabla = angular.copy(filterList.filtros);
        vm.seleccionoValor = seleccionoValor;
        vm.mostrarListaClic = mostrarListaClic;
        vm.aceptarCadena = aceptarCadena;
        vm.aplicarFiltro = aplicarFiltro;
        vm.busqueda = busqueda;
        vm.cargarSeleccionados = cargarSeleccionados;

        vm.seleccionarTodos = seleccionarTodos;
        vm.seleccionoTodos = false;
        vm.SeleccionarTodosText = "Seleccionar Todos";

        function regex(datos) {
            var myRe = new RegExp('##[0-9]*##','g');
            return datos.replace(myRe,'');
        }

        $timeout(function () {
            cargarSeleccionados();
            validarArreglo();
        }, 5);

        function aceptarCadena() {
            $uibModalInstance.close(vm.filtroElegido);
        }

        function aplicarFiltro(indice) {
            var indiceSiguiente = indice + 1;

            //obtener seleccionado y guardar en memoria
            vm.arregloFiltros = [];
            angular.forEach(vm.filtroElegido, function (item) {
                vm.arregloFiltros.push({
                    valorFiltroDistribucion: item.valor.toString(),
                    columnaFiltroDistribucion: item.columna.toString(),
                    valorFiltroGeografia: "null",
                    columnaFiltroGeografia: "null",
                    table: item.table.toString()
                })
            });

            if(indice == vm.mostrarLista.length - 1)
            {
                aceptarCadena();
            }
            else{
                mostrarListaClic(indiceSiguiente);
            }
            

        }
        

        function validarArreglo() {
            var vacio = true;
            angular.forEach(vm.filterList.Group, function (obj) {
                if(vacio){
                    if(obj.ValueFilter.length > 0){
                        vacio = false;
                    }
                }
            });
            vm.mostrarAdvertencia = vacio;
        }

        function cargarSeleccionados() {
            angular.forEach(vm.seleccionado, function (seleccionado) {
                if(seleccionado.tipo === vm.filterList.SelectFilter){
                    vm.filtroElegido.push(seleccionado);
                    angular.forEach(vm.datosTabla.Group, function (filtros,pindex) {
                        if(seleccionado.columna === filtros.GroupFilter){
                            angular.forEach(filtros.ValueFilter, function (filtro,index){
                                if(seleccionado.valor === filtro.OptionText){
                                    document.getElementById('radioB'+ pindex + '-' +  index ).checked = true;
                                }
                            });
                        }
                    });
                }
            })
        }

        angular.forEach(vm.filterList.Group, function () {
            vm.mostrarLista.push(false);
            vm.disabledButtonGeografia.push(true);
        });

        function mostrarListaClic(indice) {
            vm.seleccionoTodos = true;
            vm.seleccionarTodos(indice);

            var descripcionFiltro = vm.datosTabla.Group[indice].GroupFilter;
            //variable que se envia a la api
            var dataFiltros = {
                "idProyecto": "" + vm.proyectoId,
                "idUsuario": "" + vm.usuarioId,
                "nombrecanal": "" + vm.canalElegido,
                "idIndicador": "" + vm.idIndicador,
                "fil": [],
                "fechadesde": "" + vm.fechasElegidas.FechaInicio,
                "fechahasta": "" + vm.fechasElegidas.FechaFin,
                "vision": [],
                "nombreMenuPadre": ""
            };

            
            
            if (vm.filterList.SelectFilter == "Cadena" || vm.filterList.SelectFilter == "Productos" ||
                vm.filterList.SelectFilter == "Distribución" ||  
                vm.filterList.SelectFilter == "Marcas" ){
                vm.cargando =  true;

                //limpia filtros: en algunos casos no se deben limpiar para mantener los que ya vienen
                if(vm.filterList.SelectFilter == "Distribución"){

                    if(descripcionFiltro == "RutaOperativa"){

                    }
                    else{
                        vm.filterList.Group[indice].ValueFilter = [];
                        vm.datosTabla.Group[indice].ValueFilter = [];
                    }
                    
                    
                }
                else{
                    vm.filterList.Group[indice].ValueFilter = [];
                    vm.datosTabla.Group[indice].ValueFilter = [];
                }
                

                //obtener Cadenas
                if (vm.filterList.SelectFilter == "Cadena") {
                    if (descripcionFiltro === "NombreCadena") {
                        dataFiltros.nombreMenuPadre = "Cadena";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'NombreCadena');

                        angular.forEach(vm.arregloFiltros, function (obj) {
                            dataFiltros.fil.push(obj);
                        });
                    }

                    if (descripcionFiltro === "FormatoNegocio") {
                        dataFiltros.nombreMenuPadre = "FormatoCadena";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'NombreCadena');

                        angular.forEach(vm.arregloFiltros, function (obj) {
                            if(obj.columnaFiltroDistribucion === 'NombreCadena' ){
                                dataFiltros.fil.push(obj);
                            }
                        });
                    }

                    if (descripcionFiltro === "NombreNegocio") {
                        dataFiltros.nombreMenuPadre = "Tienda";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'FormatoNegocio');
                        angular.forEach(vm.arregloFiltros, function (obj) {
                            if(obj.columnaFiltroDistribucion === 'NombreCadena' ||  obj.columnaFiltroDistribucion === 'FormatoNegocio'){
                                dataFiltros.fil.push(obj);
                            }
                        });
                    }

                    if (vm.filterList.SelectFilter == "Cadena") {
                        $http.post('api/filtros-visiones/cadenas', dataFiltros).then(function (response) {
                            vm.filterList.Group[indice].ValueFilter = response.data;
                            vm.datosTabla.Group[indice].ValueFilter = response.data;
                            vm.cargando = false;
                        });

                        
                    }
                } 
                
                //obtener Productos
                if (vm.filterList.SelectFilter == "Productos") {
                    //obtener cadenas
                    if (descripcionFiltro == "Empresa") {
                        dataFiltros.nombreMenuPadre = "Empresa";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'NombreCadena');

                        angular.forEach(vm.arregloFiltros, function (obj) {
                            dataFiltros.fil.push(obj);
                        });
                    }

                    if (descripcionFiltro == "Marca") {
                        dataFiltros.nombreMenuPadre = "Marca";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'NombreCadena');

                        angular.forEach(vm.arregloFiltros, function (obj) {
                            dataFiltros.fil.push(obj);
                        });
                    }

                    if (descripcionFiltro == "DescripcionProducto") {
                        dataFiltros.nombreMenuPadre = "Producto";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'FormatoNegocio');
                        angular.forEach(vm.arregloFiltros, function (obj) {
                            dataFiltros.fil.push(obj);
                        });
                    }

                    if (descripcionFiltro === "PresentacionProducto") {
                        dataFiltros.nombreMenuPadre = "PresentacionProducto";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'FormatoNegocio');
                        angular.forEach(vm.arregloFiltros, function (obj) {
                            dataFiltros.fil.push(obj);
                        });
                    }

                    if (descripcionFiltro === "CapacidadProducto") {
                        dataFiltros.nombreMenuPadre = "CapacidadProducto";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'FormatoNegocio');
                        angular.forEach(vm.arregloFiltros, function (obj) {
                            dataFiltros.fil.push(obj);
                        });
                    }


                    $http.post('api/filtros-visiones/cadenas', dataFiltros).then(function (response) {
                        vm.filterList.Group[indice].ValueFilter = response.data;
                        vm.datosTabla.Group[indice].ValueFilter = response.data;
                        vm.cargando = false;
                    });
                }

                //obtener Distibuidores
                if (vm.filterList.SelectFilter == "Distribución"){

                    if (descripcionFiltro === "NombreCadena") {
                        dataFiltros.nombreMenuPadre = "Cadena";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'NombreCadena');

                    }

                    if (descripcionFiltro === "NombreDistribuidor") {
                        dataFiltros.nombreMenuPadre = "Distribuidor";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'NombreCadena');

                    }

                    if (descripcionFiltro === "NombreSupervisor") {
                        dataFiltros.nombreMenuPadre = "Supervisor";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'NombreCadena');

                    }

                    if (descripcionFiltro === "RutaComercial") {
                        dataFiltros.nombreMenuPadre = "RutaComercial";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'NombreCadena');
                    }

                    if (descripcionFiltro === "Region") {
                        dataFiltros.nombreMenuPadre = "Region";
                        //dataFiltros.fil = vm.arregloFiltros.filter((a)=> a.columnaFiltroDistribucion === 'NombreCadena');
                    }
                    

                    angular.forEach(vm.arregloFiltros, function (obj) {
                        dataFiltros.fil.push(obj);
                    });

                    //no recargar ruta operativa
                    if(descripcionFiltro != "RutaOperativa"){
                        $http.post('api/filtros-visiones/cadenas', dataFiltros).then(function (response) {
                            vm.filterList.Group[indice].ValueFilter = response.data;
                            vm.datosTabla.Group[indice].ValueFilter = response.data;
                            vm.cargando = false;
                        });
                    }
                    else{
                        vm.cargando = false;
                    }
                    
                }

                //obtener Tipo
                // if (vm.filterList.SelectFilter == "Tipo"){

                //     if (descripcionFiltro === "ClusterNegocio") {
                //         dataFiltros.nombreMenuPadre = "ClusterTienda";
                //     }

                //     if (descripcionFiltro === "DepositoNegocio") {
                //         dataFiltros.nombreMenuPadre = "DepositoTienda";
                //     }

                //     if (descripcionFiltro === "TipoNegocio") {
                //         dataFiltros.nombreMenuPadre = "TipoTienda";
                //     }

                //     angular.forEach(vm.arregloFiltros, function (obj) {
                //         dataFiltros.fil.push(obj);
                //     });

                //     $http.post('api/filtros-visiones/cadenas', dataFiltros).then(function (response) {
                //         vm.filterList.Group[indice].ValueFilter = response.data;
                //         vm.datosTabla.Group[indice].ValueFilter = response.data;
                //         vm.cargando = false;
                //     });
                    
                // }

                if(vm.filterList.SelectFilter == "Tamaño"){
                    if (descripcionFiltro === "TamanoNegocio") {
                        dataFiltros.nombreMenuPadre = "TamanoNegocio";
                    }

                    $http.post('api/filtros-visiones/cadenas', dataFiltros).then(function (response) {
                        vm.filterList.Group[indice].ValueFilter = response.data;
                        vm.datosTabla.Group[indice].ValueFilter = response.data;
                        vm.cargando = false;
                    });
                }

                if(vm.filterList.SelectFilter == "Categorías de Producto"){
                    if (descripcionFiltro === "CategoriaProducto" || descripcionFiltro === "Descripcion") {
                        dataFiltros.nombreMenuPadre = "CategoriaProducto";
                    }

                    $http.post('api/filtros-visiones/cadenas', dataFiltros).then(function (response) {
                        vm.filterList.Group[indice].ValueFilter = response.data;
                        vm.datosTabla.Group[indice].ValueFilter = response.data;
                        vm.cargando = false;
                    });
                }

                if(vm.filterList.SelectFilter == "Marcas"){
                    if (descripcionFiltro === "Empresa") {
                        dataFiltros.nombreMenuPadre = "Empresa";
                    }

                    if (descripcionFiltro === "Marca" || descripcionFiltro === "Descripcion") {
                        dataFiltros.nombreMenuPadre = "Marca";
                    }

                    angular.forEach(vm.arregloFiltros, function (obj) {
                        dataFiltros.fil.push(obj);
                    });

                    $http.post('api/filtros-visiones/cadenas', dataFiltros).then(function (response) {
                        vm.filterList.Group[indice].ValueFilter = response.data;
                        vm.datosTabla.Group[indice].ValueFilter = response.data;
                        vm.cargando = false;
                    });
                }
            }
            
            //agrego el campo selected para poder vincularlo al checkbox y luego utilizar seleccionar/deselecccionar todos
            vm.filterList.Group[indice].ValueFilter = vm.filterList.Group[indice].ValueFilter.map(function(item) {
                item.selected = false;
                return item;
            });

            angular.forEach(vm.filterList.Group,function(item, index){
                if(index === indice){
                    vm.mostrarLista[index] = !(vm.mostrarLista[index]);
                }
                else{
                    vm.mostrarLista[index] = false;
                }
            });
        }

        function seleccionoValor(indicePadre, indiceHijo) {
            var row = vm.datosTabla.Group[indicePadre].ValueFilter[indiceHijo];
            var valor = vm.datosTabla.Group[indicePadre].ValueFilter[indiceHijo].OptionText;
            var columna = vm.datosTabla.Group[indicePadre].GroupFilter;
            var valorMostrar = vm.datosTabla.Group[indicePadre].valorMostar;
            var table = vm.datosTabla.Group[indicePadre].Table;
            var filtro = {valor: valor, columna: columna, table: table, valorA: regex(valor)};
            var elimino = false;

            if (vm.filtroElegido === []) {
                vm.disabledButtonCadena = true;
                vm.filtroElegido.push(filtro);
            }
            else {
                vm.filtroElegido.find(function (value, index) {
                    if (value && filtro && value.valor === filtro.valor && value.columna === filtro.columna) {
                        vm.filtroElegido.splice(index, 1);
                        elimino = true;
                        row.selected = false;
                    }
                });
                if (!elimino) {
                    row.selected = true;
                    filtro.valorMostar = valorMostrar;
                    vm.filtroElegido.push(filtro);
                    angular.forEach(vm.filterList.Group,function(item, index){
                        if(index === indicePadre){
                            vm.disabledButtonGeografia[index] = false;
                        }
                        else{
                            vm.disabledButtonGeografia[index] = true;
                        }
                    });
                }
            }
        }

        function busqueda(i) {
            vm.datosTabla.Group[i].ValueFilter = [];
            angular.forEach(vm.filterList.Group[i].ValueFilter, function (elem) {
                if(elem.OptionText.toLowerCase().indexOf(vm.filtro.toLowerCase().trim()) > -1){
                    vm.datosTabla.Group[i].ValueFilter.push(elem);
                }
            });
        }

        function seleccionarTodos(indice){
            vm.seleccionoTodos = !vm.seleccionoTodos;
            if(vm.seleccionoTodos){
                vm.SeleccionarTodosText = "Deseleccionar Todos";
                vm.disabledButtonGeografia[indice] = false;
                angular.forEach(vm.datosTabla.Group[indice].ValueFilter, function(item) {
                    item.selected = true;
                    var valor = item.OptionText;
                    var columna = vm.datosTabla.Group[indice].GroupFilter;
                    var table = vm.datosTabla.Group[indice].Table;
                    var valorMostrar = vm.datosTabla.Group[indice].valorMostar;
                    var filtro = {valor: valor, columna: columna, table: table, valorA: regex(valor)};
                    filtro.valorMostar = valorMostrar;
                    vm.filtroElegido.push(filtro);
                });

            }
            else{
                vm.SeleccionarTodosText = "Seleccionar Todos";
                vm.disabledButtonGeografia[indice] = true;
                angular.forEach(vm.datosTabla.Group[indice].ValueFilter, function(item) {
                    item.selected = false;

                    vm.filtroElegido.find(function(value, index) {
                        if (value && value.valor === item.OptionText && value.columna === vm.datosTabla.Group[indice].GroupFilter) {
                            vm.filtroElegido.splice(index,1);
                        }
                    });
                });

                

            }    
        }
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('perfectStoreDashboardApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('perfectStoreDashboardApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('perfectStoreDashboardApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('perfectStoreDashboardApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('apiInterceptor', apiInterceptor);

    apiInterceptor.$inject = ['DASHBOARD_API_URL'];

    function apiInterceptor (DASHBOARD_API_URL) {
        var service = {
            request: request
        };
        return service;

        function request (config) {
            if (config && config.url && (/^api/.test(config.url) || /^token/.test(config.url))) {
                config.url = DASHBOARD_API_URL + config.url;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'PerfectStoreDashboard' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('apiInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('perfectStoreDashboardApp')
        .constant('VERSION', 1)
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1773931941114)
        .constant('DASHBOARD_API_URL', "")
        .constant('IS_DEV', false)
;
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'PerfectStoreDashboard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('perfectStoreDashboardApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants','$state'];

    function RequestResetController ($timeout, Auth, errorConstants,$state) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
                $timeout(function () {
                    $state.go('home');
                }, 10000);
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?mail?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$state', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $state, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;
        vm.key = $stateParams.key;
        vm.user = $state.params.mail;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({Username: vm.user, Token: vm.key, NewPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                    $timeout(function () {
                        $state.go('home');
                    }, 7000);
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService', 'errorConstants'];

    function RegisterController ($timeout, Auth, LoginService, errorConstants) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();

/*
* FileSaver.js
* A saveAs() FileSaver implementation.
*
* By Eli Grey, http://eligrey.com
*
* License : https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md (MIT)
* source  : http://purl.eligrey.com/github/FileSaver.js
*/

// The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
var _global = typeof window === 'object' && window.window === window
  ? window : typeof self === 'object' && self.self === self
  ? self : typeof global === 'object' && global.global === global
  ? global
  : this

function bom (blob, opts) {
  if (typeof opts === 'undefined') opts = { autoBom: false }
  else if (typeof opts !== 'object') {
    console.warn('Deprecated: Expected third argument to be a object')
    opts = { autoBom: !opts }
  }

  // prepend BOM for UTF-8 XML and text/* types (including HTML)
  // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
  if (opts.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
    return new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type })
  }
  return blob
}

function download (url, name, opts) {
  var xhr = new XMLHttpRequest()
  xhr.open('GET', url)
  xhr.responseType = 'blob'
  xhr.onload = function () {
    saveAs(xhr.response, name, opts)
  }
  xhr.onerror = function () {
    console.error('could not download file')
  }
  xhr.send()
}

function corsEnabled (url) {
  var xhr = new XMLHttpRequest()
  // use sync to avoid popup blocker
  xhr.open('HEAD', url, false)
  try {
    xhr.send()
  } catch (e) {}
  return xhr.status >= 200 && xhr.status <= 299
}

// `a.click()` doesn't work for all browsers (#465)
function click (node) {
  try {
    node.dispatchEvent(new MouseEvent('click'))
  } catch (e) {
    var evt = document.createEvent('MouseEvents')
    evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80,
                          20, false, false, false, false, 0, null)
    node.dispatchEvent(evt)
  }
}

var saveAs = _global.saveAs || (
  // probably in some web worker
  (typeof window !== 'object' || window !== _global)
    ? function saveAs () { /* noop */ }

  // Use download attribute first if possible (#193 Lumia mobile)
  : 'download' in HTMLAnchorElement.prototype
  ? function saveAs (blob, name, opts) {
    var URL = _global.URL || _global.webkitURL
    var a = document.createElement('a')
    name = name || blob.name || 'download'

    a.download = name
    a.rel = 'noopener' // tabnabbing

    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'

    if (typeof blob === 'string') {
      // Support regular links
      a.href = blob
      if (a.origin !== location.origin) {
        corsEnabled(a.href)
          ? download(blob, name, opts)
          : click(a, a.target = '_blank')
      } else {
        click(a)
      }
    } else {
      // Support blobs
      a.href = URL.createObjectURL(blob)
      setTimeout(function () { URL.revokeObjectURL(a.href) }, 4E4) // 40s
      setTimeout(function () { click(a) }, 0)
    }
  }

  // Use msSaveOrOpenBlob as a second approach
  : 'msSaveOrOpenBlob' in navigator
  ? function saveAs (blob, name, opts) {
    name = name || blob.name || 'download'

    if (typeof blob === 'string') {
      if (corsEnabled(blob)) {
        download(blob, name, opts)
      } else {
        var a = document.createElement('a')
        a.href = blob
        a.target = '_blank'
        setTimeout(function () { click(a) })
      }
    } else {
      navigator.msSaveOrOpenBlob(bom(blob, opts), name)
    }
  }

  // Fallback to using FileReader and a popup
  : function saveAs (blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open('', '_blank')
    if (popup) {
      popup.document.title =
      popup.document.body.innerText = 'downloading...'
    }

    if (typeof blob === 'string') return download(blob, name, opts)

    var force = blob.type === 'application/octet-stream'
    var isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari
    var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent)

    if ((isChromeIOS || (force && isSafari)) && typeof FileReader !== 'undefined') {
      // Safari doesn't allow downloading of blob URLs
      var reader = new FileReader()
      reader.onloadend = function () {
        var url = reader.result
        url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;')
        if (popup) popup.location.href = url
        else location = url
        popup = null // reverse-tabnabbing #460
      }
      reader.readAsDataURL(blob)
    } else {
      var URL = _global.URL || _global.webkitURL
      var url = URL.createObjectURL(blob)
      if (popup) popup.location = url
      else location.href = url
      popup = null // reverse-tabnabbing #460
      setTimeout(function () { URL.revokeObjectURL(url) }, 4E4) // 40s
    }
  }
)

_global.saveAs = saveAs.saveAs = saveAs

if (typeof module !== 'undefined') {
  module.exports = saveAs;
}
(function(){angular.module('perfectStoreDashboardApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<section id="login" class="home"><div class="boxLog"><form role="form" ng-submit="vm.login($event)"><div class="inputBox"><input type="text" id="username" required value="" onkeyup="this.setAttribute(\'value\', this.value);" ng-model="vm.username"><label>Username</label></div><div class="inputBox"><input type="password" id="password" required value="" onkeyup="this.setAttribute(\'value\', this.value);" ng-model="vm.password"><label>Password</label></div><div style="white-space: nowrap"><label style="width: 50%" for="rememberMe" class="labelLogin"><input style="margin-left: 0px !important" class="form-check-input" type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span style="margin-left: 1.25em !important; color: black; font-weight: bold !important">Recordarme</span></label><button style="width: 50%" class="btnLogin btnLogin-primary login" type="submit"><div><span>Iniciar sesi\xF3n</span></div></button></div><a style="margin-top: 10px;width: 100%; display: block; text-align: right; color: black; font-weight: bold" href="" ng-click="vm.requestResetPassword()" class="labelLogin alert-link">\xBFHa olvidado su contrase\xF1a?</a></form></div></section><footer class="site-footer"><div class="container"><div class="row"><div class="col-xs-6 col-md-3" style="border-spacing: 10px"><div style="width: 32px; display: table-cell; line-height: 0"><span class="et_pb_image_wrap"><img style="max-width: 100%; height: auto" loading="lazy" src="https://healthcheck.com.mx/wp-content/uploads/2021/02/bandera-mexico-1-150x150.png" alt=""></span></div><div style="display: table-cell"><h6>Mexico</h6><ul class="footer-links"><li><p>Direcci\xF3n: Av. Santa Fe 170, Of 5-4-1, Santa Fe, \xC1lvaro Obreg\xF3n, 01210, Ciudad de M\xE9xico</p></li><li><p>+52 55 2623 0591</p></li></ul></div></div><div class="col-xs-6 col-md-3" style="border-spacing: 10px"><div style="width: 32px; display: table-cell; line-height: 0"><span class="et_pb_image_wrap"><img style="max-width: 100%; height: auto" loading="lazy" src="https://healthcheck.com.mx/wp-content/uploads/2021/02/bandera-argentina-1-150x150.png" alt=""></span></div><div style="display: table-cell"><h6>Argentina</h6><ul class="footer-links"><li><p>Direcci\xF3n: Av. C\xF3rdoba 1111 Piso 6, Ciudad de Buenos Aires</p></li><li><p>+54 9 11 3663 3774</p></li></ul></div></div><div class="col-xs-6 col-md-3" style="border-spacing: 10px"><div style="width: 32px; display: table-cell; line-height: 0"><span class="et_pb_image_wrap"><img style="max-width: 100%; height: auto" loading="lazy" src="https://healthcheck.com.mx/wp-content/uploads/2021/02/bandera-colombia-1-150x150.png" alt=""></span></div><div style="display: table-cell"><h6>Colombia</h6><ul class="footer-links"><li><p>Direcci\xF3n: Calle 96 N 71 - 37 Torre 5 Apto 1001, Barranquilla</p></li><li><p>+57 5 312 4373</p></li></ul></div></div><div class="col-xs-6 col-md-3" style="border-spacing: 10px"><div style="width: 32px; display: table-cell; line-height: 0"><span class="et_pb_image_wrap"></span></div><div style="display: table-cell"><h6>Contacto</h6><ul class="footer-links"><li><a target="_blank" href="https://wa.me/525545058572?text=Hola, me interesa conocer m\xE1s acerca de">WhatsApp</a></li><li><a href="mailto:contacto@healthcheck.com" target="_blank" rel="noopener noreferrer">contacto@healthcheck.com.mx</a></li></ul></div></div></div><hr></div></footer>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/components/cadena/cadena.html','<div class="cadena"><div class="container-menu"><h4 class="titulo-cadena">{{vm.filterList.SelectFilter}}</h4><div id="cadena" class="well container-cadena" ng-repeat="cadena in vm.datosTabla.Group track by $index"><div class="titulo-submenu-cadena"><div class="col-xs-5" ng-click="vm.mostrarListaClic($index)">{{cadena.valorMostar}}</div><i class="fa fa-search" aria-hidden="true" ng-show="vm.mostrarLista[$index]"></i><div class="col-xs-6 form-inline"><input ng-change="vm.busqueda($index)" ng-value="vm.filtro" ng-model="vm.filtro" type="search" class="form-control" placeholder="Search" ng-show="vm.mostrarLista[$index]"></div><hr ng-show="vm.mostrarLista[$index]"></div><div ng-show="vm.mostrarLista[$index] && vm.cargando"><p>Cargando...</p></div><div class=""><div ng-show="vm.mostrarLista[$index] && !vm.cargando" style="margin-left: 15px"><div class="col-xs-7"><input type="checkbox" class="custom-control-input" id="radioSel{{$index}}" name="radioSel{{$index}}" value="{{$index}}" ng-show="false" ng-checked="vm.seleccionoTodos" ng-click="vm.seleccionarTodos($index)"><label class="custom-control-label" for="radioSel{{$index}}">{{vm.SeleccionarTodosText}}</label></div><div class="col-xs-5"></div></div></div><div ng-show="vm.mostrarLista[$index]" class="cadena-lista container-scroll" style="margin-bottom: 2rem"><div class="custom-control custom-radio" ng-repeat="opc in cadena.ValueFilter track by $index"><input type="checkbox" class="custom-control-input" id="radioB{{$parent.$index + \'-\' + $index}}" name="radioB{{$parent.$index + \'-\' + $index}}" ng-show="false" value="{{$index}}" ng-checked="{{opc.selected}}" ng-model="opc.selected" ng-click="vm.seleccionoValor($parent.$index, $index)"><label class="custom-control-label" for="radioB{{$parent.$index + \'-\' + $index}}">{{opc.OptionValue}}</label></div><div style="text-align: left" ng-show="vm.mostrarAdvertencia"><label>Sin selecci\xF3n</label></div></div><div class="container-button" ng-show="vm.mostrarLista[$index]"><button class="btn btn-primary" ng-class="{\'disabled-button\': vm.disabledButtonGeografia[$index]}" ng-click="vm.aplicarFiltro($index)">APLICAR</button></div></div></div><div class="container-button"><button class="btn btn-success" ng-class="{\'disabled-button\': vm.disabledButtonGeografia[$index]}" ng-click="vm.aceptarCadena()">ACEPTAR</button></div></div>');
$templateCache.put('app/components/dashboard/dashboard.html','<div style="height: 100%" class="dashboard" data-ng-init="vm.init()" ng-class="{\'dashboard-showdashboard\':vm.showdashboard}"><div class="pantalla-carga-ocultada" ng-class="{\'pantalla-carga\': vm.cargando}"><div class="pantalla-carga-content"><div class="loader" id="loader">Loading...</div></div></div><div class="dashc" style="height: 100%" ng-class="{\'no-overflow\':vm.showmainevidencias}"><div class="container-sidebar sin-espacios" style="width: 250px"><div class="circle-close" ng-class="{\'opacity-zero\' : !vm.mostrarSidebar}"></div><i class="fas fa-chevron-circle-left arrow-close-sidebar" ng-class="{\'opacity-zero\' : !vm.mostrarSidebar}" ng-click="vm.collapseToggle()"></i><div class="circle-open" ng-class="{\'opacity-zero\' : vm.mostrarSidebar}"></div><i class="fas fa-chevron-circle-right arrow-open-sidebar" ng-class="{\'opacity-zero\' : vm.mostrarSidebar}" ng-click="vm.collapseToggle()"></i><sidebar open-modal-projects="vm.openModalProyecto()" mostrar-sidebar="vm.mostrarSidebar" proyecto-id="vm.proyectoId" canal-elegido="vm.canalElegido" indicador-elegido="vm.indicadorElegido" fechas="vm.fechas" mostrar="vm.mostrarResultado" filtros="vm.filtros" resultado="vm.resultado" resultado-tendencias="vm.resultadoTendencias" id-indicador-elegido="vm.idIndicadorElegido" vision-seleccionada="vm.visionSeleccionada" cargando="vm.cargando" nombre-proyecto="vm.nombreProyecto" unico-proyecto="vm.proyectoUnico" mostrar-tendencia="vm.mostrarTendencias" mostrar-mapa="vm.mostrarMapas" cargando-mapa="vm.cargandoMapa" cargando-tendencia="vm.cargandoTendencias" showdashboard="vm.showdashboard" showmainevidencias="vm.showmainevidencias" resultado-totales="vm.resultadoTotal" imagenbase64="vm.imagenbase64" resultado-mapas="vm.resultadoMapa" mostrar-tabla="vm.mostrarTablas" resultado-evidencia="vm.resultadoEvidencia" mostrar-evidencia="vm.mostrarEvidencias" proyecto-canal-indicadores="vm.proyectoCanalIndicador" solo-evidencias="vm.soloEvidencias" cargando-evidencia="vm.cargandoEvidencias" show-message-error="vm.showMessageError" indicador-canal-entrante="vm.indicadorCanalEntrante" menu-padre-indicador="vm.menuPadreIndicador" menu-entrante="vm.menuEntrante"></sidebar></div><div class="espaciomenu" ng-class="{sinsidebar2: !vm.mostrarSidebar}"><div class="container-filters filter well" ng-show="(vm.canalElegido || vm.indicadorElegido) && !vm.showmainevidencias"><div class="container-canal-variable col-xs-12"><div class="container-chip" ng-show="vm.canalElegido"><span class="titulo">CANAL:</span><div class="chip"><span style="display: inline-block">{{vm.canalElegido}}</span> <i class="fas fa-times icon-cruz" ng-click="vm.borrarFiltroCanalIndicador()"></i></div></div><div class="container-chip" ng-if="vm.menuPadreIndicador" ng-repeat="(index,menu) in vm.menuPadreIndicador track by $index"><span class="titulo">MENU({{index + 1}}):</span><div class="chip"><span style="display: inline-block">{{menu}}</span> <i class="fas fa-times icon-cruz" ng-click="vm.borrarFiltroCanalIndicador()"></i></div></div><div class="container-chip" ng-show="vm.indicadorElegido"><span class="titulo">KPI:</span><div class="chip"><span style="display: inline-block">{{vm.indicadorElegido}}</span> <i class="fas fa-times icon-cruz" ng-click="vm.borrarFiltroCanalIndicador()"></i></div></div></div><div class="container-filtros-vision"><div class="col-xs-6 container-filtros" ng-class="{\'border\': vm.visionSeleccionada.length > 0}" ng-show="((vm.filtros.Geografia || vm.filtros.Distribucion || vm.filtros.Adicionales)&&(vm.filtros.Geografia.length > 0 || vm.filtros.Distribucion.length > 0 || vm.filtros.Adicionales.length > 0)) ||\r\n                    vm.fechas.FechaInicio && (vm.fechas.FechaInicio !== \'null\')  || vm.fechas.FechaFin && (vm.fechas.FechaFin !== \'null\')"><span class="titulo">Filtros:</span><div class="container-chip" ng-show="vm.filtros.Geografia" ng-repeat="geo in vm.filtros.Geografia track by $index"><span>{{geo.valorMostar}}:</span><div class="chip"><span style="display: inline-block">{{geo.valorA}}</span> <i class="fas fa-times icon-cruz" ng-click="vm.borrarFiltroGeografia($index)"></i></div></div><div class="container-chip" ng-show="vm.filtros.Distribucion" ng-repeat="dis in vm.filtros.Distribucion track by $index"><span>{{dis.valorMostar}}:</span><div class="chip"><span style="display: inline-block">{{dis.valorA}}</span> <i class="fas fa-times icon-cruz" ng-click="vm.borrarFiltroDistribucion($index)"></i></div></div><div class="container-chip" ng-show="vm.filtros.Adicionales" ng-repeat="add in vm.filtros.Adicionales track by $index"><span>{{add.valorMostrar}}:</span><div class="chip"><span style="display: inline-block">{{add.valorA}}</span> <i class="fas fa-times icon-cruz" ng-click="vm.borrarFiltroAdicionales($index)"></i></div></div><div class="container-chip" ng-show="vm.fechas.FechaInicio && (vm.fechas.FechaInicio !== \'null\')"><span>FECHA INICIO:</span><div class="chip"><span style="display: inline-block">{{vm.fechas.FechaInicio}}</span> <i class="fas fa-times icon-cruz" ng-click="vm.borrarFecha()"></i></div></div><div class="container-chip" ng-show="vm.fechas.FechaFin && (vm.fechas.FechaFin !== \'null\')"><span>FECHA FIN:</span><div class="chip"><span style="display: inline-block">{{vm.fechas.FechaFin}}</span> <i class="fas fa-times icon-cruz" ng-click="vm.borrarFecha()"></i></div></div></div><div class="col-xs-6 container-vision"><div ng-show="vm.visionSeleccionada[0]"><span class="titulo">Visiones:</span><div class="container-chip" ng-repeat="vis in vm.visionSeleccionada track by $index"><div class="chip"><span style="display: inline-block">{{vis.OptionValue}}</span> <i class="fas fa-times icon-cruz" ng-click="vm.borrarVision($index)"></i></div></div></div></div></div><div class="col-xs-12 container-button-borrar"><button ng-if="vm.eliminarFiltros()" type="button" ng-click="vm.borrarFiltros()" class="btn btn-danger button-aling"><i class="glyphicon glyphicon-remove"></i> Eliminar Filtros</button> <button ng-if="vm.canalElegido && vm.indicadorElegido" style="margin-left: 1rem" type="button" ng-click="vm.reload()" class="btn button-green"><i class="glyphicon glyphicon-refresh refresh"></i> Mostrar Resultados</button></div></div><div class="slider" ng-class="{\'sliderClose\':vm.showdashboard||vm.showmainevidencias}"><grafica-principal cont="vm.cont" lista-cantidad="vm.listaCantidad" ult-datos="vm.ultDatos" labels-datos="vm.labelsDatos" labels="vm.labels"></grafica-principal><div><div class="bloque-tarjetas well col-xs-12" ng-show="!vm.isDev"><tarjetas resultado-grafica-secundaria="vm.resultadoGraficaSecundaria" graficas-secundarias="vm.graficasSecundarias" grafica-no-configurada="vm.graficaNoConfigurada" cargando-grafica-secundarias="vm.cargandoGraficaSecundarias"></tarjetas><tablero proyecto-id="vm.proyectoId" cliente="vm.cliente" indicador-canal="vm.indicadorCanalEntrante" menu-principal="vm.menuEntrante"></tablero></div></div></div><div style="min-height: 100%" ng-show="vm.showdashboard"><div class="col-xs-12"><div class="col-xs-12" ng-if="vm.showMessageError"><div class="alert alert-danger" style="margin-top: 40px; text-align: center; font-size: 20px">No se ha podido obtener algunos de los datos. Por favor, vuelva a intentar.</div></div><div ng-if="!vm.soloEvidencias" class="col-xs-12"><resultado class="fixResultado bloque well col-xs-12" filtros-resultado="vm.filtros" mostrar="vm.mostrarResultado" showdashboard-resultado="vm.showdashboard" resultado-total="vm.resultadoTotal" resultado-indicador="vm.resultado"></resultado></div><div ng-if="!vm.soloEvidencias" class="col-xs-12"><tabla class="bloque well col-xs-12" mostrar-tablas="vm.mostrarTablas" resultado-tabla-indicador="vm.resultado"></tabla></div><div ng-if="!vm.soloEvidencias" class="col-xs-12"><tendencias class="bloque well col-xs-12" cargando-tendencias="vm.cargandoTendencias" mostrar-tendencias="vm.mostrarTendencias" resultado-tendencias-indicador="vm.resultadoTendencias"></tendencias></div><div ng-if="!vm.soloEvidencias" class="col-xs-12"><mapa class="bloque well col-xs-12" cargando-mapas="vm.cargandoMapa" mostrar-mapas="vm.mostrarMapas" resultado-mapa-indicador="vm.resultadoMapa" filtros-resultado="vm.filtros" fechas-elegidas="vm.fechas"></mapa></div><div class="col-xs-12" ng-class="{\'margin-top-1-rem\': vm.soloEvidencias, \'padding-25px\': vm.soloEvidencias}"><evidencias class="bloque well col-xs-12" proyecto-id="vm.proyectoId" cargando-evidencias="vm.cargandoEvidencias" mostrar-evidencias="vm.mostrarEvidencias" resultado-evidencias-indicador="vm.resultadoEvidencia" filtrosvisiones="vm.filtrosvisiones" canal-elegido="vm.canalElegido" id-indicador-elegido="vm.idIndicadorElegido" filtros-elegidos="vm.filtros" fechas-elegidas="vm.fechas" nombre-menu-padre="vm.menuPadreIndicador"></evidencias></div></div></div><mainevidencias style="min-height:100%" ng-class="{\'hidden\':!vm.showmainevidencias}" evi-shown="vm.showmainevidencias" proyecto-id="vm.proyectoId" canal-elegido="vm.canalElegido" usuario-id="vm.usuarioId"></div></div></div>');
$templateCache.put('app/components/dropdown/dropdown.html','<div class="dropdown"><!--<div class="" ng-show="vm.mostrarListaArea" style="margin-bottom: 2rem">--><!--<hr>--><!--<div class="custom-control custom-radio" ng-repeat="areas in vm.areas track by $index">--><!--<input type="radio" class="custom-control-input" id="defaultGroupExample1" name="groupOfDefaultRadios"--><!--value="{{$index}}" ng-click="vm.areaSeleccionada = $index">--><!--<label class="custom-control-label" for="defaultGroupExample1">{{areas}}</label>--><!--</div>--><!--<button class="btn btn-primary" ng-click="vm.aceptarArea()">ACEPTAR</button>--><!--</div>--></div>');
$templateCache.put('app/components/eviCarousel/eviCarousel.html','<div class="evi-carousel" ng-mousemove="vm.showHidables()" tabindex="0" ng-keydown="vm.keypress($event)"><div class="car-container"><div class="item" ng-repeat="item in vm.items" ng-class="{\'active\': $index == vm.slide}"><div class="card-container" ng-class="{\'info\': vm.info}"><div class="card" ng-mouseenter="vm.disableMouseOver()" ng-mouseleave="vm.enableMouseOver()"><div class="front"><img ng-src="{{item.pathEvidencia}}"></div><div class="box"><div class="data-content"><div class="nombre">{{item.nombreEvidencia}}</div><div class="moreInfo"><span ng-if="item.nombreNegocio"><strong>Nombre de Negocio:</strong> {{item.nombreNegocio}}</span> <span ng-if="item.idNegocio"><strong>ID de Negocio:</strong> {{item.idNegocio}}</span> <span ng-if="item.direccion"><strong>Pa\xEDs:</strong> {{item.nombrePais}}</span> <span ng-if="item.direccion"><strong>Area Nielsen:</strong> {{item.areaNielsen}}</span> <span ng-if="item.direccion"><strong>Estado:</strong> {{item.nombreEstado}}</span> <span ng-if="item.direccion"><strong>Localidad:</strong> {{item.nombreUbicacion}}</span> <span ng-if="item.direccion"><strong>Direcci\xF3n:</strong> {{item.direccion}}</span> <span ng-if="item.codigoExterno"><strong>C\xF3digo Externo:</strong> {{item.codigoExterno}}</span> <span ng-if="item.nombreCadena"><strong>Nombre de Cadena:</strong> {{item.nombreCadena}}</span> <span ng-if="item.marca"><strong>Marca:</strong> {{item.marca}}</span> <span ng-if="item.descripcionProducto"><strong>Producto:</strong> {{item.descripcionProducto}}</span> <span ng-if="item.marca"><strong>Fecha:</strong> {{item.finEncuesta.slice(0, 10)}}</span></div></div></div></div></div></div><i class="fas fa-chevron-circle-left car-float left car-btn hideable" ng-click="vm.prevSlide()" role="button" ng-mouseenter="vm.disableMouseOver()" ng-mouseleave="vm.enableMouseOver()"></i> <i class="fas fa-chevron-circle-right car-float right car-btn hideable" ng-click="vm.nextSlide()" role="button" ng-mouseenter="vm.disableMouseOver()" ng-mouseleave="vm.enableMouseOver()"></i><div class="car-float car-menu"><i class="fas fa-times-circle car-btn hideable" ng-click="vm.close()" role="button" ng-mouseenter="vm.disableMouseOver()" ng-mouseleave="vm.enableMouseOver()"></i></div></div></div>');
$templateCache.put('app/components/evidencias/evidencias.html','<div class="evidencias"><div class="row"><div class="col-xs-12 header-container"><div class="col-xs-11"><h3 class="col-xs-5 title">Evidencias</h3></div><div class="col-xs-1 container-btn"><button class="btn btn-primary width-fix cargandoIcon" ng-show="vm.cargandoEvidencias"><i class="fa-li fa fa-spinner fa-spin fa-2x" style="horiz-align: center; vertical-align: middle"></i></button> <button class="btn btn-primary width-fix" ng-if="vm.resultadoEvidenciasIndicador.Content.length !== 0" ng-show="!vm.cargandoEvidencias" ng-click="(vm.mostrarEvidencias)=!(vm.mostrarEvidencias);"><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': !vm.mostrarEvidencias,\r\n                    \'glyphicon-chevron-up\': vm.mostrarEvidencias }" style="horiz-align: center; vertical-align: middle"></i></button></div><div class="col-xs-1 container-btn" ng-if="vm.resultadoEvidenciasIndicador.Content.length === 0" ng-show="!vm.cargandoEvidencias"><button class="btn btn-primary width-fix"><i ng-click="vm.cargarEvidencias()" class="glyphicon glyphicon-chevron-down" style="horiz-align: center; vertical-align: middle"></i></button></div></div><div class="container-carousel" style="margin-top: 50px" ng-show="vm.mostrarEvidencias"><div class="contenedor"><button ng-if="!vm.descargando" class="btn button-export" ng-click="vm.descargarImagenes()"><i class="glyphicon glyphicon-download"></i> DESCARGAR EVIDENCIAS</button> <button ng-if="vm.descargando" class="btn button-export-load"><i class="glyphicon glyphicon-repeat glyphicon-animate"></i> DESCARGANDO EVIDENCIAS</button></div><div class="home-product-new-hldr" ng-show="!vm.cargandoEvidencias"><div class="slider-btn-hldr slider-btn-hldr-left"><button id="left-btn" class="slider-btn" ng-click="vm.movementCarousel(false)" style="display: none"><i class="fas fa-chevron-circle-left"></i></button></div><div class="home-product-new"><div class="home-grid products-grid products-grid--max-4" style="left: 0px"><div class="item-container" ng-repeat="item in vm.resultadoEvidenciasIndicador.Content track by $index"><div id="{{$index}}" class="item {{$index}} item-{{$index}}"><img ng-src="{{item.pathEvidencia}}" class="image-carousel" alt="Image"><div class="text-box"><label>{{item.nombreEvidencia}}</label></div></div></div></div></div><div class="slider-btn-hldr slider-btn-hldr-right"><button id="right-btn" class="slider-btn" ng-click="vm.movementCarousel(true)" style="display: block"><i class="fas fa-chevron-circle-right"></i></button></div></div></div></div></div>');
$templateCache.put('app/components/eviFiltros/eviFiltros.html','<div class="evi-filtros"><div class="loading" ng-show="!vm.loaded"><i class="fa fa-spinner fa-spin fa-2x"></i></div><div class="filtros-title" ng-hide="vm.clean"><h3>Filtrando por</h3></div><div class="filtros-list"><span ng-repeat="(filtro, filtroValue) in vm.filtrosSelected"><span class="badge badge-pill badge-primary" ng-click="vm.removeFiltro(filtro)"><strong>{{filtroValue.catText}}</strong> {{vm.formatFiltro(filtroValue.value)}} <i class="fas fa-times-circle close-icon"></i></span></span></div><div class="filtros-title"><h3>Filtros</h3></div><div class="filtros-disponibles-list"><div class="search-container" ng-class="{\'empty\':!!vm.busqueda}"><input type="text" ng-model="vm.busqueda" placeholder="Buscar..." class="search"> <span class="buttons"><i class="fas fa-search button search-button"></i> <i class="fas fa-times button clear-button" ng-click="vm.clearSearch()"></i></span></div><div class="filtros-list" ng-show="vm.busqueda"><span ng-repeat="(pais, paisValue) in vm.filtrosPlain.pais" ng-show="pais.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'geo\',\'pais\',pais, \'Pa\xEDs\')" ng-class="{\'active\':vm.filtrosSelected.geo.table==\'pais\'&&vm.filtrosSelected.geo.value==pais}"><strong>{{vm.formatFiltro(pais)}}</strong> (Pa\xEDs, {{vm.filtros.geo.cantEvidencias.pais[pais]}} resultados) </span></span><span ng-repeat="(area, areaValue) in vm.filtrosPlain.area" ng-show="area.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'geo\',\'area\',area, \'\xC1rea Nielsen\')" ng-class="{\'active\':vm.filtrosSelected.geo.table==\'area\'&&vm.filtrosSelected.geo.value==area}"><strong>{{vm.formatFiltro(area)}}</strong> (\xC1rea Nielsen, {{vm.filtros.geo.cantEvidencias.area[area]}} resultados) </span></span><span ng-repeat="(estado, estadoValue) in vm.filtrosPlain.estado" ng-show="estado.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'geo\',\'estado\',estado, \'Estado\')" ng-class="{\'active\':vm.filtrosSelected.geo.table==\'estado\'&&vm.filtrosSelected.geo.value==estado}"><strong>{{vm.formatFiltro(estado)}}, {{vm.formatFiltro(estadoValue.pais)}}</strong> (Estado, {{vm.filtros.geo.cantEvidencias.estado[estado]}} resultados) </span></span><span ng-repeat="(formato, formatoValue) in vm.filtrosPlain.formato" ng-show="formato.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'cadena\',\'formato\',formato, \'Formato de Tienda\')" ng-class="{\'active\':vm.filtrosSelected.formato.table==\'formato\'&&vm.filtrosSelected.formato.value==formato}"><strong>{{vm.formatFiltro(formato)}} - {{vm.formatFiltro(formatoValue.cadena)}}</strong> (Formato de tienda, {{vm.filtros.cadena.cantEvidencias.formato[formato]}} resultados) </span></span><span ng-repeat="(negocio, negocioValue) in vm.filtrosPlain.negocio" ng-show="negocio.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'cadena\',\'negocio\',negocio, \'Tienda\')" ng-class="{\'active\':vm.filtrosSelected.negocio.table==\'negocio\'&&vm.filtrosSelected.negocio.value==negocio}"><strong>{{vm.formatFiltro(negocio)}}, {{vm.formatFiltro(negocioValue.cadena)}} {{vm.formatFiltro(negocioValue.formato)}}</strong> (Tienda, {{vm.filtros.cadena.cantEvidencias.negocio[negocio]}} resultados) </span></span><span ng-repeat="(region, regionValue) in vm.filtrosPlain.region" ng-show="region.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'region\',\'region\',region, \'Regi\xF3n\')" ng-class="{\'active\':vm.filtrosSelected.region.table==\'region\'&&vm.filtrosSelected.region.value==region}"><strong>{{vm.formatFiltro(region)}}</strong> (Regi\xF3n, {{vm.filtros.region.cantEvidencias[region]}} resultados) </span></span><span ng-repeat="(nombreDistribuidor, nombreDistribuidorValue) in vm.filtrosPlain.nombreDistribuidor" ng-show="nombreDistribuidor.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'nombreDistribuidor\',\'nombreDistribuidor\',nombreDistribuidor, \'Distribuidor\')" ng-class="{\'active\':vm.filtrosSelected.nombreDistribuidor.table==\'nombreDistribuidor\'&&vm.filtrosSelected.nombreDistribuidor.value==nombreDistribuidor}"><strong>{{vm.formatFiltro(nombreDistribuidor)}}</strong> (Distribuidor, {{vm.filtros.nombreDistribuidor.cantEvidencias[nombreDistribuidor]}} resultados) </span></span><span ng-repeat="(nombreSupervisor, nombreSupervisorValue) in vm.filtrosPlain.nombreSupervisor" ng-show="nombreSupervisor.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'nombreSupervisor\',\'nombreSupervisor\',nombreSupervisor, \'Supervisor\')" ng-class="{\'active\':vm.filtrosSelected.nombreSupervisor.table==\'nombreSupervisor\'&&vm.filtrosSelected.nombreSupervisor.value==nombreSupervisor}"><strong>{{vm.formatFiltro(nombreSupervisor)}}</strong> (Supervisor, {{vm.filtros.nombreSupervisor.cantEvidencias[nombreSupervisor]}} resultados) </span></span><span ng-repeat="(rutaOperativa, rutaOperativaValue) in vm.filtrosPlain.rutaOperativa" ng-show="rutaOperativa.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'rutaOperativa\',\'rutaOperativa\',rutaOperativa, \'Ruta Operativa\')" ng-class="{\'active\':vm.filtrosSelected.rutaOperativa.table==\'nombreRutaOperativa\'&&vm.filtrosSelected.rutaOperativa.value==rutaOperativa}"><strong>{{vm.formatFiltro(rutaOperativa)}}</strong> (Ruta Operativa, {{vm.filtros.rutaOperativa.cantEvidencias[rutaOperativa]}} resultados) </span></span><span ng-repeat="(rutaComercial, rutaComercialValue) in vm.filtrosPlain.rutaComercial" ng-show="rutaComercial.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'rutaComercial\',\'rutaComercial\',rutaComercial, \'Ruta Comercial\')" ng-class="{\'active\':vm.filtrosSelected.rutaComercial.table==\'rutaComercial\'&&vm.filtrosSelected.rutaComercial.value==rutaComercial}"><strong>{{vm.formatFiltro(rutaComercial)}}</strong> (Ruta Comercial, {{vm.filtros.rutaComercial.cantEvidencias[rutaComercial]}} resultados) </span></span><span ng-repeat="(clusterNegocio, clusterNegocioValue) in vm.filtrosPlain.clusterNegocio" ng-show="clusterNegocio.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'clusterNegocio\',\'clusterNegocio\',clusterNegocio, \'Cluster de Negocios\')" ng-class="{\'active\':vm.filtrosSelected.clusterNegocio.table==\'clusterNegocio\'&&vm.filtrosSelected.clusterNegocio.value==clusterNegocio}"><strong>{{vm.formatFiltro(clusterNegocio)}}</strong> (Cluster de Negocios, {{vm.filtros.clusterNegocio.cantEvidencias[clusterNegocio]}} resultados) </span></span><span ng-repeat="(tipoNegocio, tipoNegocioValue) in vm.filtrosPlain.tipoNegocio" ng-show="tipoNegocio.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'tipoNegocio\',\'tipoNegocio\',tipoNegocio, \'Tipo de Negocio\')" ng-class="{\'active\':vm.filtrosSelected.tipoNegocio.table==\'tipoNegocio\'&&vm.filtrosSelected.tipoNegocio.value==tipoNegocio}"><strong>{{vm.formatFiltro(tipoNegocio)}}</strong> (Tipo de Negocio, {{vm.filtros.tipoNegocio.cantEvidencias[tipoNegocio]}} resultados) </span></span><span ng-repeat="(tamanoNegocio, tamanoNegocioValue) in vm.filtrosPlain.tamanoNegocio" ng-show="tamanoNegocio.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'tamanoNegocio\',\'tamanoNegocio\',tamanoNegocio, \'Tama\xF1o de Negocio\')" ng-class="{\'active\':vm.filtrosSelected.tamanoNegocio.table==\'tamanoNegocio\'&&vm.filtrosSelected.tamanoNegocio.value==tamanoNegocio}"><strong>{{vm.formatFiltro(tamanoNegocio)}}</strong> (Tama\xF1o de Negocio, {{vm.filtros.tamanoNegocio.cantEvidencias[tamanoNegocio]}} resultados) </span></span><span ng-repeat="(marcaPregunta, marcaPreguntaValue) in vm.filtrosPlain.marcaPregunta" ng-show="marcaPregunta.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'pregunta\',\'marcaPregunta\',marcaPregunta, \'Marca de Pregunta\')" ng-class="{\'active\':vm.filtrosSelected.pregunta.table==\'marcaPregunta\'&&vm.filtrosSelected.pregunta.value==marcaPregunta}"><strong>{{vm.formatFiltro(marcaPregunta)}}</strong> (Marca de Pregunta, {{vm.filtros.pregunta.cantEvidencias.marca[marcaPregunta]}} resultados) </span></span><span ng-repeat="(categoriaItemPregunta, categoriaItemPreguntaValue) in vm.filtrosPlain.categoriaItemPregunta" ng-show="categoriaItemPregunta.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'pregunta\',\'categoriaItemPregunta\',categoriaItemPregunta, \'Categor\xEDa Producto\')" ng-class="{\'active\':vm.filtrosSelected.pregunta.table==\'categoriaItemPregunta\'&&vm.filtrosSelected.pregunta.value==categoriaItemPregunta}"><strong>{{vm.formatFiltro(categoriaItemPregunta)}}</strong> (Categor\xEDa Producto, {{vm.filtros.pregunta.cantEvidencias.categoriaItem[categoriaItemPregunta]}} resultados) </span></span><span ng-repeat="(tipoItempromocionalPregunta, tipoItempromocionalPreguntaValue) in vm.filtrosPlain.tipoItempromocionalPregunta" ng-show="tipoItempromocionalPregunta.toUpperCase().includes(vm.busqueda.toUpperCase())"><span class="option" ng-click="vm.selectFiltro(\'pregunta\',\'tipoItempromocionalPregunta\',tipoItempromocionalPregunta, \'Tipo Item Promocional\')" ng-class="{\'active\':vm.filtrosSelected.pregunta.table==\'tipoItempromocionalPregunta\'&&vm.filtrosSelected.pregunta.value==tipoItempromocionalPregunta}"><strong>{{vm.formatFiltro(tipoItempromocionalPregunta)}}</strong> (Tipo Item Promocional, {{vm.filtros.pregunta.cantEvidencias.tipoItempromocional[tipoItempromocionalPregunta]}} resultados)</span></span></div><div class="filtros-hierarchy" ng-show="!vm.busqueda"><div class="filtroPrincipal" ng-init="geografiaPrincipalCollapsed = true"><span class="tituloPrincipal">Geograf\xEDa</span> <i class="fas btn-collapse" ng-class="[geografiaPrincipalCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="geografiaPrincipalCollapsed = vm.collapse($event,geografiaPrincipalCollapsed)" role="button"></i><div class="filtro" ng-init="paisCollapsed = true" ng-class="{\'collapse\':geografiaPrincipalCollapsed}"><div class="sub-category">Pa\xEDs <i class="fas btn-collapse" ng-class="[paisCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="paisCollapsed = vm.collapse($event,paisCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':paisCollapsed}"><div class="filtro" ng-repeat="(pais,paisValue) in vm.filtros.geo.elements" ng-init="collapsed = true"><span class="option" ng-click="vm.selectFiltro(\'geo\',\'pais\',pais, \'Pa\xEDs\')" ng-class="{\'active\':vm.filtrosSelected.geo.table==\'pais\'&& vm.filtrosSelected.geo.value==pais}">{{vm.formatFiltro(pais)}} ({{vm.filtros.geo.cantEvidencias.pais[pais]}})</span></div></div></div><div class="filtro" ng-init="areaCollapsed = true" ng-class="{\'collapse\':geografiaPrincipalCollapsed}"><div class="sub-category">\xC1rea Nielsen <i class="fas btn-collapse" ng-class="[areaCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="areaCollapsed = vm.collapse($event,areaCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':areaCollapsed}"><div class="filtro" ng-repeat="(area,areaValue) in vm.filtrosPlain.area" ng-init="collapsed = true"><span class="option" ng-click="vm.selectFiltro(\'geo\',\'area\',area, \'\xC1rea Nielsen\')" ng-class="{\'active\':vm.filtrosSelected.geo.table==\'area\'&& vm.filtrosSelected.geo.value==area}">{{vm.formatFiltro(area)}} ({{vm.filtros.geo.cantEvidencias.area[area]}})</span></div></div></div><div class="filtro" ng-init="estadoCollapsed = true" ng-class="{\'collapse\':geografiaPrincipalCollapsed}"><div class="sub-category">Estado <i class="fas btn-collapse" ng-class="[estadoCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="estadoCollapsed = vm.collapse($event,estadoCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':estadoCollapsed}"><div class="filtro" ng-repeat="(estado,estadoValue) in vm.filtrosPlain.estado" ng-init="collapsed = true"><span class="option" ng-click="vm.selectFiltro(\'geo\',\'estado\',estado, \'Estado\')" ng-class="{\'active\':vm.filtrosSelected.geo.table==\'estado\'&&vm.filtrosSelected.geo.value==estado}">{{vm.formatFiltro(estado)}} ({{vm.filtros.geo.cantEvidencias.estado[estado]}})</span></div></div></div><div class="filtro" ng-init="localidadCollapsed = true" ng-class="{\'collapse\':geografiaPrincipalCollapsed}"><div class="sub-category">Localidad <i class="fas btn-collapse" ng-class="[localidadCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="localidadCollapsed = vm.collapse($event,localidadCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':localidadCollapsed}"><div class="filtro" ng-repeat="(municipio,municipioValue) in vm.filtrosPlain.municipio"><span class="option" ng-click="vm.selectFiltro(\'geo\',\'municipio\',municipio, \'Localidad\')" ng-class="{\'active\':vm.filtrosSelected.geo.table==\'municipio\'&&vm.filtrosSelected.geo.value==municipio}">{{vm.formatFiltro(municipio)}} ({{vm.filtros.geo.cantEvidencias.municipio[municipio]}})</span></div></div></div></div><div class="filtroPrincipal" ng-init="cadenaPrincipalCollapsed = true"><span class="tituloPrincipal">Cadena</span> <i class="fas btn-collapse" ng-class="[cadenaPrincipalCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="cadenaPrincipalCollapsed = vm.collapse($event,cadenaPrincipalCollapsed)" role="button"></i><div class="filtro" ng-init="cadenaCollapsed = true" ng-class="{\'collapse\':cadenaPrincipalCollapsed}"><div class="sub-category">Cadena <i class="fas btn-collapse" ng-class="[cadenaCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="cadenaCollapsed = vm.collapse($event,cadenaCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':cadenaCollapsed}"><div class="filtro" ng-repeat="(cadena,cadenaValue) in vm.filtros.cadena.elements" ng-init="collapsed = true"><span class="option" ng-click="vm.selectFiltro(\'cadena\',\'cadena\',cadena, \'Cadena\')" ng-class="{\'active\':vm.filtrosSelected.cadena.table==\'cadena\'&&vm.filtrosSelected.cadena.value==cadena}">{{vm.formatFiltro(cadena)}} ({{vm.filtros.cadena.cantEvidencias.cadena[cadena]}})</span></div></div></div><div class="filtro" ng-init="formatoCollapsed = true" ng-class="{\'collapse\':cadenaPrincipalCollapsed}"><div class="sub-category">Formato de Tienda <i class="fas btn-collapse" ng-class="[formatoCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="formatoCollapsed = vm.collapse($event,formatoCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':formatoCollapsed}"><div class="filtro" ng-repeat="(formato,formatoValue) in vm.filtrosPlain.formato" ng-init="collapsed = true"><span class="option" ng-click="vm.selectFiltro(\'cadena\',\'formato\',formato, \'Formato de Tienda\')" ng-class="{\'active\':vm.filtrosSelected.cadena.table==\'area\'&&vm.filtrosSelected.cadena.value==formato}">{{vm.formatFiltro(formato)}} ({{vm.filtros.cadena.cantEvidencias.formato[formato]}})</span></div></div></div><div class="filtro" ng-init="tiendaCollapsed = true" ng-class="{\'collapse\':cadenaPrincipalCollapsed}"><div class="sub-category">Tienda <i class="fas btn-collapse" ng-class="[tiendaCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="tiendaCollapsed = vm.collapse($event,tiendaCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':tiendaCollapsed}"><div class="filtro" ng-repeat="(negocio,negocioValue) in vm.filtrosPlain.negocio" ng-init="collapsed = true"><span class="option" ng-click="vm.selectFiltro(\'cadena\',\'negocio\',negocio, \'Tienda\')" ng-class="{\'active\':vm.filtrosSelected.cadena.table==\'negocio\'&&vm.filtrosSelected.cadena.value==negocio}">{{vm.formatFiltro(negocio)}} ({{vm.filtros.cadena.cantEvidencias.negocio[negocio]}})</span></div></div></div></div><div class="filtroPrincipal" ng-init="distribucionPrincipalCollapsed = true"><span class="tituloPrincipal">Distribuci\xF3n</span> <i class="fas btn-collapse" ng-class="[distribucionPrincipalCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="distribucionPrincipalCollapsed = vm.collapse($event,distribucionPrincipalCollapsed)" role="button"></i><div class="filtro" ng-init="regionCollapsed = true" ng-class="{\'collapse\':distribucionPrincipalCollapsed}"><div class="sub-category">Regi\xF3n <i class="fas btn-collapse" ng-class="[regionCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="regionCollapsed = vm.collapse($event,regionCollapsed)" role="button"></i><div class="filtro-container" ng-class="{\'collapse\':regionCollapsed}"><div class="filtro" ng-repeat="(region,regionValue) in vm.filtros.distribucion.elements" ng-init="regionCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'distribucion\',\'region\',region, \'Regi\xF3n\')" ng-class="{\'active\':vm.filtrosSelected.distribucion.table==\'region\'&&vm.filtrosSelected.distribucion.value==region}">{{vm.formatFiltro(region)}} ({{vm.filtros.distribucion.cantEvidencias.region[region]}})</span></div></div></div></div><div class="filtro" ng-init="nombreDistribuidorCollapsed = true" ng-class="{\'collapse\':distribucionPrincipalCollapsed}"><div class="sub-category">Distribuidor <i class="fas btn-collapse" ng-class="[nombreDistribuidorCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="nombreDistribuidorCollapsed = vm.collapse($event,nombreDistribuidorCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':nombreDistribuidorCollapsed}"><div class="filtro" ng-repeat="(nombreDistribuidor,nombreDistribuidorValue) in vm.filtrosPlain.distribuidor" ng-init="nombreDistribuidorCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'distribucion\',\'nombreDistribuidor\',nombreDistribuidor, \'Distribuidor\')" ng-class="{\'active\':vm.filtrosSelected.distribucion.table==\'distribuidor\'&&vm.filtrosSelected.distribucion.value==nombreDistribuidor}">{{vm.formatFiltro(nombreDistribuidor)}} ({{vm.filtros.distribucion.cantEvidencias.distribuidor[nombreDistribuidor]}})</span></div></div></div><div class="filtro" ng-init="nombreSupervisorCollapsed = true" ng-class="{\'collapse\':distribucionPrincipalCollapsed}"><div class="sub-category">Supervisor <i class="fas btn-collapse" ng-class="[nombreSupervisorCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="nombreSupervisorCollapsed = vm.collapse($event,nombreSupervisorCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':nombreSupervisorCollapsed}"><div class="filtro" ng-repeat="(nombreSupervisor,nombreSupervisorValue) in vm.filtrosPlain.supervisor" ng-init="nombreSupervisorCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'distribucion\',\'nombreSupervisor\',nombreSupervisor, \'Supervisor\')" ng-class="{\'active\':vm.filtrosSelected.distribucion.table==\'supervisor\'&&vm.filtrosSelected.distribucion.value==nombreSupervisor}">{{vm.formatFiltro(nombreSupervisor)}} ({{vm.filtros.distribucion.cantEvidencias.supervisor[nombreSupervisor]}})</span></div></div></div><div class="filtro" ng-init="rutaComercialCollapsed = true" ng-class="{\'collapse\':distribucionPrincipalCollapsed}"><div class="sub-category">Ruta Comercial <i class="fas btn-collapse" ng-class="[rutaComercialCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="rutaComercialCollapsed = vm.collapse($event,rutaComercialCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':rutaComercialCollapsed}"><div class="filtro" ng-repeat="(rutaComercial,rutaComercialValue) in vm.filtrosPlain.rutaComerciall" ng-init="rutaComercialCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'distribucion\',\'rutaComercial\',rutaComercial, \'Ruta Comercial\')" ng-class="{\'active\':vm.filtrosSelected.distribucion.table==\'rutaComercial\'&&vm.filtrosSelected.distribucion.value==rutaComercial}">{{vm.formatFiltro(rutaComercial)}} ({{vm.filtros.distribucion.cantEvidencias.rutaComercial[rutaComercial]}})</span></div></div></div></div><div class="filtro" ng-init="rutaOperativaCollapsed = true" ng-class="{\'collapse\':distribucionPrincipalCollapsed}"><div class="sub-category">Ruta Operativa <i class="fas btn-collapse" ng-class="[rutaOperativaCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="rutaOperativaCollapsed = vm.collapse($event,rutaOperativaCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':rutaOperativaCollapsed}"><div class="filtro" ng-repeat="(rutaOperativa,rutaOperativaValue) in vm.filtrosPlain.rutaOperativaa" ng-init="rutaOperativaCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'distribucion\',\'rutaOperativa\',rutaOperativa, \'Ruta Operativa\')" ng-class="{\'active\':vm.filtrosSelected.distribucion.table==\'rutaOperativa\'&&vm.filtrosSelected.distribucion.value==rutaOperativa}">{{vm.formatFiltro(rutaOperativa)}} ({{vm.filtros.distribucion.cantEvidencias.rutaOperativa[rutaOperativa]}})</span></div></div></div></div><div class="filtroPrincipal" ng-init="tiendaPrincipalCollapsed = true"><span class="tituloPrincipal">Tipo de Tienda</span> <i class="fas btn-collapse" ng-class="[tiendaPrincipalCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="tiendaPrincipalCollapsed = vm.collapse($event,tiendaPrincipalCollapsed)" role="button"></i><div class="filtro" ng-init="clusterNegocioCollapsed = true" ng-class="{\'collapse\':tiendaPrincipalCollapsed}"><div class="sub-category">Cluster de Tiendas <i class="fas btn-collapse" ng-class="[clusterNegocioCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="clusterNegocioCollapsed = vm.collapse($event,clusterNegocioCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':clusterNegocioCollapsed}"><div class="filtro" ng-repeat="(clusterTienda,clusterTiendaValue) in vm.filtros.tipoTienda.elements" ng-init="clusterNegocioCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'tipoTienda\',\'clusterNegocio\',clusterTienda, \'Cluster de Tiendas\')" ng-class="{\'active\':vm.filtrosSelected.tipoTienda.table==\'clusterNegocio\'&&vm.filtrosSelected.tipoTienda.value==clusterTienda}">{{vm.formatFiltro(clusterTienda)}} ({{vm.filtros.tipoTienda.cantEvidencias.clusterTienda[clusterTienda]}})</span></div></div></div><div class="filtro" ng-init="tipoNegocioCollapsed = true" ng-class="{\'collapse\':tiendaPrincipalCollapsed}"><div class="sub-category">Tipo de Tienda <i class="fas btn-collapse" ng-class="[tipoNegocioCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="tipoNegocioCollapsed = vm.collapse($event,tipoNegocioCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':tipoNegocioCollapsed}"><div class="filtro" ng-repeat="(tipoTienda,tipoTiendaValue) in vm.filtrosPlain.tipoTienda" ng-init="tipoNegocioCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'tipoTienda\',\'tipoNegocio\',tipoTienda, \'Tipo de Tienda\')" ng-class="{\'active\':vm.filtrosSelected.tipoTienda.table==\'tipoNegocio\'&&vm.filtrosSelected.tipoTienda.value==tipoTienda}">{{vm.formatFiltro(tipoTienda)}} ({{vm.filtros.tipoTienda.cantEvidencias.tipoTienda[tipoTienda]}})</span></div></div></div><div class="filtro" ng-init="tamanoNegocioCollapsed = true" ng-class="{\'collapse\':tiendaPrincipalCollapsed}"><div class="sub-category">Tama\xF1o de Tienda <i class="fas btn-collapse" ng-class="[tamanoNegocioCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="tamanoNegocioCollapsed = vm.collapse($event,tamanoNegocioCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':tamanoNegocioCollapsed}"><div class="filtro" ng-repeat="(tamTienda,tamTiendaValue) in vm.filtrosPlain.tamTienda" ng-init="tamanoNegocioCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'tipoTienda\',\'tamanoNegocio\',tamTienda, \'Tama\xF1o de Tienda\')" ng-class="{\'active\':vm.filtrosSelected.tipoTienda.table==\'tamanoNegocio\'&&vm.filtrosSelected.tipoTienda.value==tamTienda}">{{vm.formatFiltro(tamTienda)}} ({{vm.filtros.tipoTienda.cantEvidencias.tamTienda[tamTienda]}})</span></div></div></div></div><div class="filtroPrincipal" ng-init="preguntasPrincipalCollapsed = true"><span class="tituloPrincipal">Preguntas Encuestas</span> <i class="fas btn-collapse" ng-class="[preguntasPrincipalCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="preguntasPrincipalCollapsed = vm.collapse($event,preguntasPrincipalCollapsed)" role="button"></i><div class="filtro" ng-init="preguntasCollapsed = true" ng-class="{\'collapse\':preguntasPrincipalCollapsed}"><div class="sub-category">Preguntas <i class="fas btn-collapse" ng-class="[preguntasCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="preguntasCollapsed = vm.collapse($event,preguntasCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':preguntasCollapsed}"><div class="filtro" ng-repeat="(preguntaEncuesta,preguntaEncuestaValue) in vm.filtros.pregunta.elements" ng-init="preguntasCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'pregunta\',\'preguntaEncuesta\',preguntaEncuesta, \'Preguntas\')" ng-class="{\'active\':vm.filtrosSelected.pregunta.table==\'preguntaEncuesta\'&&vm.filtrosSelected.pregunta.value==preguntaEncuesta}">{{vm.formatFiltro(preguntaEncuesta)}} ({{vm.filtros.pregunta.cantEvidencias.pregunta[preguntaEncuesta]}})</span></div></div></div><div class="filtro" ng-init="marcasPreguntaCollapsed = true" ng-class="{\'collapse\':preguntasPrincipalCollapsed}"><div class="sub-category">Marcas <i class="fas btn-collapse" ng-class="[marcasPreguntaCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="marcasPreguntaCollapsed = vm.collapse($event,marcasPreguntaCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':marcasPreguntaCollapsed}"><div class="filtro" ng-repeat="(marcaPregunta,marcaPreguntaValue) in vm.filtrosPlain.marcaPregunta" ng-init="marcasPreguntaCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'pregunta\',\'marcaPregunta\',marcaPregunta, \'Marca de Pregunta\')" ng-class="{\'active\':vm.filtrosSelected.pregunta.table==\'marcaPregunta\'&&vm.filtrosSelected.pregunta.value==marcaPregunta}">{{vm.formatFiltro(marcaPregunta)}} ({{vm.filtros.pregunta.cantEvidencias.marca[marcaPregunta]}})</span></div></div></div><div class="filtro" ng-init="categoriaItemPreguntaCollapsed = true" ng-class="{\'collapse\':preguntasPrincipalCollapsed}"><div class="sub-category">Categor\xEDa Producto <i class="fas btn-collapse" ng-class="[categoriaItemPreguntaCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="categoriaItemPreguntaCollapsed = vm.collapse($event,categoriaItemPreguntaCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':categoriaItemPreguntaCollapsed}"><div class="filtro" ng-repeat="(categoriaItemPregunta,categoriaItemPreguntaValue) in vm.filtrosPlain.categoriaItemPregunta" ng-init="categoriaItemPreguntaCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'pregunta\',\'categoriaItemPregunta\',categoriaItemPregunta, \'Categor\xEDa Producto\')" ng-class="{\'active\':vm.filtrosSelected.pregunta.table==\'categoriaItemPregunta\'&&vm.filtrosSelected.pregunta.value==categoriaItemPregunta}">{{vm.formatFiltro(categoriaItemPregunta)}} ({{vm.filtros.pregunta.cantEvidencias.categoriaItem[categoriaItemPregunta]}})</span></div></div></div><div class="filtro" ng-init="tipoItempromocionalPreguntaCollapsed = true" ng-class="{\'collapse\':preguntasPrincipalCollapsed}"><div class="sub-category">Tipo Item Promocional <i class="fas btn-collapse" ng-class="[tipoItempromocionalPreguntaCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="tipoItempromocionalPreguntaCollapsed = vm.collapse($event,tipoItempromocionalPreguntaCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':tipoItempromocionalPreguntaCollapsed}"><div class="filtro" ng-repeat="(tipoItempromocionalPregunta,tipoItempromocionalPreguntaValue) in vm.filtrosPlain.tipoItempromocionalPregunta" ng-init="tipoItempromocionalPreguntaCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'pregunta\',\'tipoItempromocionalPregunta\',tipoItempromocionalPregunta, \'Tipo Item Promocional\')" ng-class="{\'active\':vm.filtrosSelected.pregunta.table==\'tipoItempromocionalPregunta\'&&vm.filtrosSelected.pregunta.value==tipoItempromocionalPregunta}">{{vm.formatFiltro(tipoItempromocionalPregunta)}} ({{vm.filtros.pregunta.cantEvidencias.tipoItempromocional[tipoItempromocionalPregunta]}})</span></div></div></div></div><div class="filtroPrincipal" ng-init="productosPrincipalCollapsed = true"><span class="tituloPrincipal">Productos</span> <i class="fas btn-collapse" ng-class="[productosPrincipalCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="productosPrincipalCollapsed = vm.collapse($event,productosPrincipalCollapsed)" role="button"></i><div class="filtro" ng-init="productosCollapsed = true" ng-class="{\'collapse\':productosPrincipalCollapsed}"><div class="sub-category">Marcas <i class="fas btn-collapse" ng-class="[productosCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="productosCollapsed = vm.collapse($event,productosCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':productosCollapsed}"><div class="filtro" ng-repeat="(marca,marcaValue) in vm.filtros.producto.elements" ng-init="productosCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'producto\',\'marca\',marca, \'Marca producto\')" ng-class="{\'active\':vm.filtrosSelected.producto.table==\'marca\'&&vm.filtrosSelected.producto.value==marca}">{{vm.formatFiltro(marca)}} ({{vm.filtros.producto.cantEvidencias.marca[marca]}})</span></div></div></div></div><div class="filtroPrincipal" ng-init="indicadoresPrincipalCollapsed = true"><span class="tituloPrincipal">Indicadores</span> <i class="fas btn-collapse" ng-class="[indicadoresPrincipalCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="indicadoresPrincipalCollapsed = vm.collapse($event,indicadoresPrincipalCollapsed)" role="button"></i><div class="filtro" ng-init="indicadoresCollapsed = true" ng-class="{\'collapse\':indicadoresPrincipalCollapsed}"><div class="sub-category">KPI <i class="fas btn-collapse" ng-class="[indicadoresCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="indicadoresCollapsed = vm.collapse($event,indicadoresCollapsed)" role="button"></i></div><div class="filtro-container" ng-class="{\'collapse\':indicadoresCollapsed}"><div class="filtro" ng-repeat="(indicador, indicadoresValue) in vm.filtros.indicador.elements" ng-init="indicadoresCollapsed = true"><span class="option" ng-click="vm.selectFiltro(\'indicador\',\'kpi\',indicador, \'indicadores\')" ng-class="{\'active\':vm.filtrosSelected.indicador.table==\'kpi\'&&vm.filtrosSelected.indicador.value==indicador}">{{vm.formatFiltro(indicador)}} ({{vm.filtros.indicador.cantEvidencias.nombreIndicador[indicador]}})</span></div><div class="filtro" ng-show="!vm.canalElegido" ng-init="indicadoresCollapsed = true"><span class="option">Seleccione un canal para visualizar los kpis</span></div></div></div></div><div class="filtroPrincipal" ng-init="fechaPrincipalCollapsed = true"><span class="tituloPrincipal">Fecha</span> <i class="fas btn-collapse" ng-class="[fechaPrincipalCollapsed?\'fa-plus-circle\':\'fa-minus-circle\']" ng-click="fechaPrincipalCollapsed = vm.collapse($event,fechaPrincipalCollapsed)" role="button"></i><div class="filtro" ng-init="indicadoresCollapsed = true" ng-class="{\'collapse\':fechaPrincipalCollapsed}"><span class="sub-category" ng-click="vm.selectFecha()" ng-class="{\'active\':vm.filtrosSelected.fecha}">Seleccionar Fecha</span></div></div><div class="btn-close"><i class="fas fa-times-circle" ng-click="vm.close()" role="button"></i></div></div></div>');
$templateCache.put('app/components/fecha/fecha.html','<div class="fecha"><h4 class="titulo-fecha">FECHA</h4><div class="container-menu well"><div class="row"><div class="col-xs-12"><div class="fecha-lista" style="margin-bottom: 2rem"><h4>Selecciona una opci\xF3n:</h4><hr><div class="container container-options"><div class="custom-control custom-radio"><input type="radio" class="custom-control-input radiobutton" id="year" name="groupOfDefaultRadios" ng-click="vm.selectFecha = false; vm.anyo = true; vm.mes = false; vm.quarter = false; vm.dia = false;"><label class="custom-control-label">A\xD1O</label><input type="radio" class="custom-control-input radiobutton" id="quarter" name="groupOfDefaultRadios" ng-click="vm.selectFecha = false; vm.anyo = false; vm.mes = false; vm.quarter = true; vm.dia = false;"><label class="custom-control-label">QUARTER</label><input type="radio" class="custom-control-input radiobutton" id="month" name="groupOfDefaultRadios" ng-click="vm.selectFecha = false; vm.anyo = false; vm.mes = true; vm.quarter = false; vm.dia = false;"><label class="custom-control-label">MES</label><input type="radio" class="custom-control-input radiobutton" id="month" name="groupOfDefaultRadios" ng-click="vm.selectFecha = false; vm.anyo = false; vm.mes = false; vm.quarter = false; vm.dia = true;"><label class="custom-control-label">D\xCDA</label><input type="radio" class="custom-control-input radiobutton" id="date" name="groupOfDefaultRadios" checked="checked" ng-click="vm.selectFecha = true; vm.anyo = false; vm.mes = false; vm.quarter = false; vm.dia = false;"><label class="custom-control-label">FECHA</label></div></div></div></div><div class="container-slider" ng-if="vm.anyo"><rzslider rz-slider-model="vm.sliderAnyo.minValue" rz-slider-high="vm.sliderAnyo.maxValue" rz-slider-options="vm.sliderAnyo.options"></rzslider></div><div class="container-slider" ng-if="vm.mes"><rzslider rz-slider-model="vm.sliderMes.minValue" rz-slider-high="vm.sliderMes.maxValue" rz-slider-options="vm.sliderMes.options"></rzslider></div><div class="container-slider" ng-if="vm.quarter"><rzslider rz-slider-model="vm.sliderQuarter.minValue" rz-slider-options="vm.sliderQuarter.options"></rzslider></div><div class="container-datepicker" ng-if="vm.dia"><div class="opt-dia"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.dt" is-open="vm.popup1.opened" datepicker-options="vm.dateOptions" ng-required="true" close-text="Close" alt-input-formats="vm.altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open1()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="container-datepicker" ng-if="vm.selectFecha"><div class="col-xs-6"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.dt" is-open="vm.popup1.opened" datepicker-options="vm.dateOptions" ng-required="true" close-text="Close" alt-input-formats="vm.altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open1()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-xs-6"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.dt2" is-open="vm.popup2.opened" datepicker-options="vm.dateOptions" ng-required="true" close-text="Close" alt-input-formats="vm.altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><hr><div class="container-buttons"><button type="button" class="btn btn-sm btn-info" ng-click="vm.today()">Hoy</button> <button type="button" class="btn btn-sm btn-danger" ng-click="vm.clear()">Ultimos Mes</button></div></div><div class="container-button"><button class="btn btn-primary" ng-class="{\'disabled-button\': vm.disabledButtonFecha}" ng-click="vm.aceptarFecha()">ACEPTAR</button></div></div></div></div>');
$templateCache.put('app/components/geografia/geografia.html','<div class="geografia"><h4 class="titulo-geografia">{{vm.filterList.SelectFilter}}</h4><div class="container-menu"><div id="algo" class="well container-option" ng-repeat="filtro in vm.datosTabla.Group track by $index"><div class="titulo-submenu-geografia"><div class="col-xs-5" ng-click="vm.mostrarListaClic($index)">{{filtro.valorMostar}}</div><i class="fa fa-search" aria-hidden="true" ng-show="vm.mostrarLista[$index]"></i><div class="col-xs-6 form-inline"><input ng-change="vm.busqueda($index)" ng-value="vm.filtro" ng-model="vm.filtro" type="search" class="form-control" placeholder="Search" ng-show="vm.mostrarLista[$index]"></div><hr ng-show="vm.mostrarLista[$index]"></div><div ng-show="vm.mostrarLista[$index] && vm.cargando"><p>Cargando...</p></div><div class=""><div ng-show="vm.mostrarLista[$index] && !vm.cargando" style="margin-left: 15px"><div class="col-xs-7"><input type="checkbox" class="custom-control-input" id="radioSel{{$index}}" name="radioSel{{$index}}" value="{{$index}}" ng-show="false" ng-checked="vm.seleccionoTodos" ng-click="vm.seleccionarTodos($index)"><label class="custom-control-label" for="radioSel{{$index}}">{{vm.SeleccionarTodosText}}</label></div><div class="col-xs-5"></div></div></div><div class="geografia-lista container-scroll" ng-show="vm.mostrarLista[$index]" style="margin-bottom: 2rem"><div class="custom-control custom-radio" ng-repeat="values in filtro.ValueFilter track by $index"><input type="checkbox" class="custom-control-input" id="radioG{{$parent.$index}}{{$index}}" name="radioG{{$parent.$index}}{{$index}}" value="{{$index}}" ng-show="false" ng-checked="{{values.selected}}" ng-model="values.selected" ng-click="vm.seleccionoValor($parent.$index, $index)"><label class="custom-control-label" for="radioG{{$parent.$index}}{{$index}}">{{values.OptionValue}}</label></div></div><div class="container-button" ng-show="vm.mostrarLista[$index]"><button class="btn btn-primary" ng-class="{\'disabled-button\': vm.disabledButtonGeografia[$index]}" ng-click="vm.aplicarFiltro($index)">APLICAR</button></div></div></div><div class="container-button"><button class="btn btn-success" ng-click="vm.aceptarGeografia($index)">ACEPTAR</button></div></div>');
$templateCache.put('app/components/graficaPrincipal/graficaPrincipal.html','<div class="graficaPrincipal"><section id="info-boxs"><img class="image-logo" src="/content/images/perfectstore-logo.png" alt="logo"><div style="width: 100%"><div><canvas class="graficoPrincipal" id="trimestre-info-bar" width="1000"></canvas></div></div></section></div>');
$templateCache.put('app/components/login/login.html','<!--<section id="login">--><!--<div class="mobile-header">--><!--<div class="logo">--><!--<a>--><!--<span class="icon">--><!--<img src="/content/images/logo.png" alt="logo" />--><!--</span>--><!--<span class="icon-text animated">--><!--<img src="/content/images/logo-text.png" alt="icon-text" />--><!--</span>--><!--</a>--><!--</div>--><!--</div>--><!--<div class="modal-body">--><!--<div class="row justify-content-md-center">--><!--<div class="col-md-4">--><!--<div class="alert alert-danger" ng-if="vm.authenticationError">--><!--<strong>Failed to sign in!</strong> Please check your credentials and try again.--><!--</div>--><!--</div>--><!--<div class="col-md-4">--><!--<form class="form" role="form" ng-submit="vm.login($event)">--><!--<div class="form-group">--><!--<label for="username">Usuario</label>--><!--<input type="text" class="form-control" id="username"--><!--placeholder="Ingresar usuario" ng-model="vm.username">--><!--</div>--><!--<div class="form-group">--><!--<label for="password">Contrase\xF1a</label>--><!--<input type="password" class="form-control" id="password" placeholder="Ingres\xE1 tu contrase\xF1a"--><!--ng-model="vm.password">--><!--</div>--><!--<div class="form-group">--><!--<label for="rememberMe">--><!--<input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked>--><!--<span>Recuerdame</span>--><!--</label>--><!--</div>--><!--<button type="submit" class="btn btn-primary login">Iniciar sesi\xF3n</button>--><!--</form>--><!--</div>--><!--<div class="col-md-12">--><!--<hr>--><!--</div>--><!--<div class="col-md-4">--><!--<div class="alert alert-warning">--><!--<a class="alert-link" href="" ng-click="vm.requestResetPassword()">--><!--\xBFOlvidaste la contrase\xF1a?--><!--</a>--><!--</div>--><!--<div class="alert alert-warning">--><!--\xBFA\xFAn no tienes cuenta?--><!--<a class="alert-link" href="" ng-click="vm.register()">--><!--Registrarme--><!--</a>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</section>-->');
$templateCache.put('app/components/mainevidencias/mainevidencias.html','<div class="main-evidencias" ng-mouseover="vm.show()" ng-class="{\'loading\':!vm.loaded}"><div class="gallery" ng-class="{\'gal-hidden\': !vm.carHidden, \'filtros-hidden\': vm.filtrosHidden}"><div class="loading-spinner" ng-show="!vm.loaded"><i class="fa fa-spinner fa-spin fa-2x"></i></div><div class="gallery-content"><div class="shadow-top"></div><div class="evi-header"><div class="title col-xs-6"><h3>Evidencias</h3></div><div class="toolbar col-xs-6"><div ng-if="vm.loadedFotosFachada"><i class="fas fa-eye toolbar-btn" ng-click="vm.mostrarFotosFachada()" role="button"></i><div class="evi-tooltip-container"><div class="evi-tooltip-inner">Ver Fotos Fachada</div></div></div><!-- Spinner mientras carga --><div ng-if="!vm.loadedFotosFachada"><i class="fas fa-spinner fa-spin toolbar-btn" role="button"></i><div class="evi-tooltip-container"><div class="evi-tooltip-inner">Cargando Fotos Fachada...</div></div></div><i class="fas fa-download toolbar-btn" ng-click="vm.download()" role="button"></i><div class="evi-tooltip-container"><div class="evi-tooltip-inner">Descargar Evidencias</div></div><i class="fas fa-indent toolbar-btn" ng-click="vm.mostrarCanales()" role="button"></i><div class="evi-tooltip-container"><div class="evi-tooltip-inner">Seleccionar Canal</div></div><div class="evi-canales" ng-class="{\'active\':vm.showCanales}"><div class="tip"></div><div class="inner"><div class="option" ng-repeat="canal in vm.canales" ng-click="vm.mostrarCanal(canal.Nombre)" ng-class="{\'active\':vm.canalElegido == canal.Nombre}">{{canal.Nombre}}</div></div></div><i class="fas fa-filter toolbar-btn" ng-click="vm.mostrarFiltros()" role="button"></i><div class="evi-tooltip-container"><div class="evi-tooltip-inner">Seleccionar Filtros</div></div></div><evi-pagination class="col-xs-12" size="vm.paginationSize" page="vm.paginationPage"></evi-pagination></div><evi-gallery items="vm.evidencias" selection="vm.currentSlide" car-hidden="vm.carHidden"></evi-gallery><evi-filtros filtros="vm.filtros" filtros-plain="vm.filtrosPlain" filtros-selected="vm.filtrosSelected" filtros-hidden="vm.filtrosHidden" loaded="vm.filtrosLoaded"></evi-filtros></div></div><evi-carousel items="vm.evidencias" slide="vm.currentSlide" car-hidden="vm.carHidden" ng-class="{\'car-hidden\': vm.carHidden}"></evi-carousel><evi-carousel items="vm.fotosFachada" slide="vm.currentSlide" car-hidden="vm.carHiddenFotosFachada" ng-class="{\'car-hidden\': vm.carHiddenFotosFachada}"></evi-carousel></div><style>.main-evidencias evi-carousel.car-hidden-fotos {\r\n    top: 100vh;\r\n    opacity: 0; \r\n}\r\n\r\n.main-evidencias evi-carousel:not(.car-hidden) {\r\n    background: #333;\r\n}</style>');
$templateCache.put('app/components/mapa/mapa.html','<div class="mapa"><div class="row"><div class="pantalla-carga-ocultada" ng-class="{\'pantalla-carga\': vm.cargando}"><div class="pantalla-carga-content"><div class="loader" id="loader">Loading...</div></div></div><div class="col-xs-12"><div><div class="col-xs-11"><h3 class="col-xs-12 title">Mapa</h3><a style="margin-left: 15px" ng-click="vm.abrirModalTiendas()" ng-show="vm.mostrarMapas && !vm.cargandoMapas">Listado de tiendas</a></div><div class="col-xs-1 container-btn"><button class="btn btn-primary width-fix cargandoIcon" ng-show="vm.cargandoMapas"><i class="fa-li fa fa-spinner fa-spin fa-2x" style="horiz-align: center; vertical-align: middle"></i></button> <button class="btn btn-primary width-fix" ng-if="vm.resultadoMapaIndicador.length !== 0" ng-show="!vm.mostrarMapas && !vm.cargandoMapas" ng-click="(vm.mostrarMapas)=!(vm.mostrarMapas);"><i class="glyphicon glyphicon-chevron-down" style="horiz-align: center; vertical-align: middle"></i></button> <button class="btn btn-primary width-fix" ng-show="vm.mostrarMapas && !vm.cargandoMapas" ng-click="(vm.mostrarMapas)=!(vm.mostrarMapas); vm.limpiarMapa()"><i class="glyphicon glyphicon-chevron-up" style="horiz-align: center; vertical-align: middle"></i></button></div><div class="col-xs-1 container-btn" ng-if="vm.resultadoMapaIndicador.length == 0" ng-show="!vm.cargandoMapas"><button class="btn btn-primary width-fix"><i ng-click="vm.cargarMapa()" class="glyphicon glyphicon-chevron-down" style="horiz-align: center; vertical-align: middle"></i></button></div><div style="text-align: center" id="display" ng-show="vm.mostrarMapas && !vm.cargandoMapas"></div><!--<div class="button-mapa" ng-show="vm.mostrar" ng-disabled="vm.disableTodos"--><!--ng-click="vm.cambioTodos()" ng-class="{\'button-mapa-active\':vm.disableTodos}">--><!--<i class="fas fa-dot-circle"></i>--><!--<span>TODOS</span>--><!--</div>--><!--<div class="button-mapa" ng-show="vm.mostrar" ng-disabled="vm.disableHab"--><!--ng-click="vm.cambioHab()" ng-class="{\'button-mapa-active\':vm.disableHabilitados}">--><!--<i class="fas fa-dot-circle"></i>--><!--<span>HABILITADOS</span>--><!--</div>--><!--<div class="button-mapa" ng-show="vm.mostrar" ng-disabled="vm.disableInhab"--><!--ng-click="vm.cambioInhab()" ng-class="{\'button-mapa-active\':vm.disableInhabilitados}">--><!--<i class="fas fa-dot-circle"></i>--><!--<span>INHABILITADOS</span>--><!--</div>--><!--</div>--></div><div id="contentmap" class="container-fluid" ng-show="vm.mostrarMapas"><div id="map" class="map col-xs-12" style="height: 530px; margin: 7px"></div></div></div></div></div>');
$templateCache.put('app/components/mapa/mapa.modal.html','<div class="mapa" ng-class="{\'fondo-pic\': !vm.mostrarDatos}"><div class="row container-fluid"><div class="col-md-12 container-card"><div class="card"><div class="card-body"><form ng-show="vm.mostrarDatos"><div class="container-fluid"><div class="col-xs-12 col-sm-6 col-md-8"><div ng-click="vm.ampliarImagen()" class="profile-pic" ng-style="{\'background-image\':(vm.base64Imagen?(\'url(data:image/jpeg;base64,\'+vm.base64Imagen+\')\'):\'url(/content/images/image-not-found.jpg)\')}"><span class="glyphicon glyphicon-camera"></span> <span>Ampliar imagen</span></div><div class="texto-imagen-tomada" style="text-align: center"><div class="title" style="font-size: 10px; color: #797979">Imagen tomada: {{vm.tiempoImagen}}</div></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group" style="margin-top: 3rem"><div class="tienda-name">{{vm.datosTienda.nombreNegocio}}</div></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group"><div class="title">Nombre Cadena</div><div class="data">{{vm.datosTienda.nombreCadena}}</div></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group"><div class="title">Formato</div><div class="data">{{vm.datosTienda.formato}}</div></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group"><div class="title">Direccion</div><div class="data">{{vm.datosTienda.direccion}}</div></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group"><div class="title">Ruta Operativa</div><div class="data">{{vm.datosTienda.rutaOperativa}}</div></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group"><div class="title">Latitud</div><div class="data">{{vm.datosTienda.latitud}}</div></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group"><div class="title">Longitud</div><div class="data">{{vm.datosTienda.longitud}}</div></div></div><div class="button-container col-xs-12 col-sm-6 col-md-4"><div class="filtrar-button btn btn-primary" ng-click="vm.filtrar()">Filtrar por este negocio</div></div></div></form><form ng-show="!vm.mostrarDatos" class="fondo-pic"><div class="container-fluid"><div ng-click="vm.ampliarImagen()" class="expand-pic" ng-style="{\'background-image\':\'url(data:image/jpeg;base64,\'+vm.base64Imagen+\')\'}"></div><h4 ng-click="vm.ampliarImagen()" style="display: block;right: 50px;top: 43px; position: absolute">X</h4></div></form></div></div></div></div></div>');
$templateCache.put('app/components/mapa/mapa.tiendas.modal.html','<div class="tabla"><div class="row"><div class="col-xs-12"><div class="col-xs-11"><h3 class="col-xs-7 title">{{vm.markers.tiendas.length }} Tiendas en la misma ubicacion</h3><!-- <form class="form-inline">\r\n                    <i class="fa fa-search" aria-hidden="true" ng-if="vm.mostrarDatos"></i>\r\n                    <input class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search"\r\n                           aria-label="Search" ng-change="vm.busqueda()" ng-if="vm.mostrarTablas"\r\n                           ng-value="vm.filtro" ng-model="vm.filtro">\r\n                </form> --></div><div class="col-xs-1 container-btn"><button class="btn btn-primary width-fix" ng-click="vm.cargaTabla()"><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': !vm.mostrarDatos,\r\n                    \'glyphicon-chevron-up\': vm.mostrarTablas }" style="horiz-align: center; vertical-align: middle"></i></button></div></div><div id="contenttable" class="container-fluid cuerpoTabla row" ng-if="vm.mostrarDatos"><iframe id="txtArea1" ng-if="false"></iframe><div class="table-responsive col-xs-12"><div class="contenedor"><button ng-if="!vm.descargandoExcel" class="btn button-export" ng-click="vm.ExportToXLSX()"><i class="glyphicon glyphicon-export"></i> EXPORTAR EXCEL</button><!-- <button ng-if="!vm.descargandoExcel" class="btn button-export-load">\r\n                        <i class="glyphicon glyphicon-repeat glyphicon-animate"></i>\r\n                        ACTUALIZANDO EXCEL\r\n                    </button> --> <button ng-if="vm.descargandoExcel" class="btn button-export-load"><i class="glyphicon glyphicon-repeat glyphicon-animate"></i> EXPORTANDO EXCEL</button></div><table id="tablaToExcel" class="table table-sm table-hover col-xs-12"><thead><tr><th><div><h5 style="text-align: center" class="titulo-tabla">Latitud</h5></div></th><th><div><h5 style="text-align: center" class="titulo-tabla">Longitud</h5></div></th><th><h5 style="text-align: center" class="titulo-tabla">Tienda</h5></th><th><h5 style="text-align: center" class="titulo-tabla">Foto Fachada</h5></th></tr></thead><tbody><tr ng-repeat="tienda in vm.markers.tiendas | orderBy:[\'latitud\', \'longitud\', \'negocio\']"><td><a href="https://www.google.com/maps?q={{tienda.latitud.replace(\',\', \'.\')}},{{tienda.longitud.replace(\',\', \'.\')}}" target="_blank">{{tienda.latitud}}</a></td><td><a href="https://www.google.com/maps?q={{tienda.latitud.replace(\',\', \'.\')}},{{tienda.longitud.replace(\',\', \'.\')}}" target="_blank">{{tienda.longitud}}</a></td><td><a href="https://www.google.com/maps?q={{tienda.latitud.replace(\',\', \'.\')}},{{tienda.longitud.replace(\',\', \'.\')}}" target="_blank">{{tienda.negocio}}</a></td><td><a href="{{tienda.pathImage}}" target="_blank">Ver</a></td></tr></tbody></table></div></div></div></div><style>.cuarta-columna {\r\n        width: 50%;\r\n        word-wrap: break-word;\r\n        white-space: normal;\r\n    }</style>');
$templateCache.put('app/components/navbar/navbar.html','<nav class="navbar navbar-default"><div class="container-fluid"><ul class="nav navbar-nav"></ul></div></nav>');
$templateCache.put('app/components/perfil/perfil.html','<div class="perfil login content"><div class="container-fluid"><div class="container-card"><div class="card"><div class="card-body"><form><div class="row container-fluid"><div class="col-md-3"><a class="profile-pic" ngf-select ngf-change="vm.buscarImagen($file)" accept="image/*"><div class="profile-pic" ng-style="{\'background-image\':\'url(data:image/jpeg;base64,\'+vm.base64Imagen+\')\'}"><span class="glyphicon glyphicon-camera"></span> <span>Cambiar imagen</span></div></a></div><div class="col-xs-1"></div><div class="col-md-8 container-info"><div class="col-md-12 pl-1" style="margin-top: 2rem"><div class="form-group"><label style="margin-top: 1rem">Proyecto</label><input type="text" class="form-control" placeholder="Proyecto" disabled="disabled" ng-value="vm.proyectoNombre" ng-model="vm.proyectoNombre"></div></div><div class="col-md-12 pr-1"><div class="form-group"><label>Nombre y Apellido</label><input type="text" class="form-control" placeholder="Nombre de Usuario" ng-value="vm.razonSocial" ng-model="vm.razonSocial"></div></div></div><div class="col-md-12 container-info"><div class="col-md-8 pr-1"><div class="form-group"><label>Cambia tu contrase\xF1a</label><input type="text" class="form-control" placeholder="Contrase\xF1a" ng-value="vm.nuevoPassword" ng-model="vm.nuevoPassword"></div></div><div class="col-md-4"><button class="btn btn-success botones" style="margin-top: 2.5rem; line-height: 1.25rem" ng-click="vm.cambiarPassword()">Cambiar Contrase\xF1a</button></div></div><div ng-if="vm.error" class="alert alert-danger col-xs-12">No hemos podido enviar el mail de recuperaci\xF3n de contrase\xF1a, por favor intente mas tarde...</div><div ng-if="vm.errorEmailNotExists" class="alert alert-danger col-xs-12">El correo ingresado no es valido</div><div ng-if="vm.success" class="alert alert-success col-xs-12">Enviamos un correo de confirmaci\xF3n para el cambio de contrase\xF1a</div></div><div class="card-body" style="text-align: center"><button class="btn btn-primary botones" ng-click="vm.guardarysalir()">Guardar y salir</button> <button class="btn botones" ng-click="vm.descartarcambios()">Descartar cambios y salir</button></div></form></div></div></div></div></div>');
$templateCache.put('app/components/proyecto/proyecto.html','<div class="proyecto" data-backdrop="static" data-keyboard="false"><div class="container-menu"><div id="proyecto" class="container-proyecto"><p class="titulo-proyecto">Proyectos</p><div class="row"><div class="col-xs-12"><select ng-disabled="vm.disableProyectos" class="form-control select-style" ng-options="proyecto.NombreProyecto for proyecto in\r\n                    vm.proyectos track by proyecto.IdProyecto" name="singleSelect" ng-model="vm.ProyectoSeleccionado"></select></div></div><div class="row"><div class="col-xs-6"></div><div class="col-xs-6 container-button"><button class="btn btn-secondary" ng-click="vm.volver()">Volver al Inicio</button> <button class="btn btn-primary" ng-class="{\'disabled-button\': !(vm.ProyectoSeleccionado)}" ng-click="vm.aceptarProyecto()">ACEPTAR</button></div></div></div></div></div>');
$templateCache.put('app/components/resultado/infobox.html','<section id="info-boxs" class="container-fluid info-box-quarter"><div class="flip-card"><div class="flip-card-inner" ng-class="{\'flip-card-rotate\': vm.rotate}"><div class="info-box principal-box flip-card-front"><div ng-if="vm.objResultado.canal" class="grafico-rendimiento"><!--  --><div class="container-grafico-impreciso" ng-if="vm.impreciso() "><div class="tooltip-grafico"><!-- ng-if="vm.showHover" --><div class="tooltip-arrow"></div><div class="tooltip-inner">No existe suficiente informaci\xF3n para comparar contra periodos anteriores.</div></div><img class="imprecise-icon" src="/content/images/question-icon.png"></div><!--  --><div class="container-grafico-sube" ng-if="vm.sube()"><div class="tooltip-grafico"><div class="tooltip-arrow"></div><div class="tooltip-inner">Tendencia con respecto a los \xFAltimos 3 meses.</div></div><img class="chart-line-up" src="/content/images/line-chart-up.png"></div><!--  --><div class="container-grafico-baja" ng-if="vm.baja()"><div class="tooltip-grafico"><div class="tooltip-arrow"></div><div class="tooltip-inner">Tendencia con respecto a los \xFAltimos 3 meses.</div></div><img class="chart-line-down" src="/content/images/line-chart-down.png"></div></div><div class="wrapper-content"><div class="info-content"><span class="claseTextoColumna" ng-if="!(vm.objResultado.nombresColumnas.length > 0) && !vm.isTotal">SIN VISI\xD3N</span> <span class="claseTextoColumna" ng-if="vm.isTotal" style="margin-right: 20px">TOTAL</span><div ng-repeat="obj in vm.objResultado.nombresColumnas | limitTo:51 track by $index " uib-dropdown><div ng-if="!vm.objResultado.multipleKpi && vm.objResultado.nombresColumnas && (vm.objResultado.nombresColumnas.length > 0)" class="claseTextoColumna2" ng-click="vm.agregarFiltro(obj, vm.objResultado.nombresColumnasGenerales, $index)" uib-dropdown-toggle>{{obj}}&nbsp;</div><div ng-if="vm.objResultado.multipleKpi && vm.objResultado.nombresColumnas && (vm.objResultado.nombresColumnas.length > 0)" ng-click="vm.cambiarIndicador(obj)" class="claseTextoColumna" uib-dropdown-toggle>{{obj}}</div></div><i ng-if="!vm.objResultado.multipleKpi && vm.objResultado.nombresColumnas.length > 0" class="fas fa-filter toolbar-btn" ng-click="vm.agregarFiltro(vm.objResultado.nombresColumnas, vm.objResultado.nombresColumnasGenerales, null)"></i> <i ng-if="vm.objResultado.medidasSecundarias.length > 0" style="color: #337ab7" class="glyphicon glyphicon-plus arrow-front" ng-click="vm.rotateCard()"></i></div><div class="number-content"><div class="container-progress col-xs-12" ng-if="vm.objResultado.valor >= 0"><div class="progress"><div class="progress-bar progress-bar-blue" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="50" style="width:{{vm.objResultado.valor}}%"></div></div><div ng-if="vm.objResultado.mascara && vm.objResultado.mascara === \'SIN MASCARA\' " class="porcentaje">{{vm.objResultado.preMascara}} {{vm.objResultado.valor}}</div><div ng-if="vm.objResultado.mascara && vm.objResultado.mascara !== \'SIN MASCARA\'" class="porcentaje">{{vm.objResultado.preMascara}} {{vm.objResultado.valor}} {{vm.objResultado.mascara}}</div><div ng-if="!vm.objResultado.mascara" class="porcentaje">{{vm.objResultado.preMascara}} {{vm.objResultado.valor}} %</div></div><div class="container-progress col-xs-12" ng-if="vm.objResultado.valor < 0"><div class="progress"><div class="progress-bar progress-bar-important" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="50" style="width:0%"></div></div><div class="porcentaje">NA</div></div></div></div></div><div class="flip-card-back"><div class="info-content"><div ng-repeat="obj in vm.objResultado.nombresColumnas | limitTo:51 track by $index " uib-dropdown><span class="claseTextoColumna" ng-if="!(vm.objResultado.nombresColumnas.length > 0) && !vm.isTotal">SIN VISI\xD3N</span> <span class="claseTextoColumna" ng-if="vm.isTotal">TOTAL</span><div style="margin-left: 1rem" class="claseTextoColumna" ng-click="vm.agregarFiltro(obj, vm.objResultado.nombresColumnasGenerales, $index)" ng-if="vm.objResultado.nombresColumnas && (vm.objResultado.nombresColumnas.length > 0)" uib-dropdown-toggle>{{obj}}</div></div><i class="glyphicon glyphicon-minus arrow-back" style="color: #337ab7" ng-click="vm.rotateCard()"></i><div class="scroller"><div ng-repeat="obj in vm.objResultado.medidasSecundarias | limitTo:51"><h5 class="claseTextoColumna"><span ng-if="!vm.proyectColombia(vm.objResultado, obj)">{{obj.Medida.Nombre}}{{obj.PreMascara}}: {{obj.Medida.PreMascara}} {{obj.resultado | number}} {{obj.Medida.Mascara}} </span><span ng-if="vm.proyectColombia(vm.objResultado, obj)">{{obj.Medida.Nombre}}{{obj.PreMascara}}: {{obj.Medida.PreMascara}} {{vm.valor}} {{obj.Medida.Mascara}}</span></h5></div></div></div></div></div></div></section>');
$templateCache.put('app/components/resultado/resultado.html','<div class="resultado"><div class="row"><div class="col-xs-12"><div class="col-xs-11"><h3 class="title">Resultado <span class="title-indicador">{{vm.resultadoIndicador[0].indicador}}</span> <span ng-if="vm.total > 1000">1,000 de {{vm.total | number}}</span></h3></div><div class="col-xs-1 container-btn"><button class="btn btn-primary width-fix" ng-if="!vm.mostrar" ng-click="(vm.mostrar)=!(vm.mostrar)"><i class="glyphicon glyphicon-chevron-down" style="horiz-align: center; vertical-align: middle"></i></button> <button class="btn btn-primary width-fix" ng-if="vm.mostrar" ng-click="(vm.mostrar)=!(vm.mostrar)"><i class="glyphicon glyphicon-chevron-up" style="horiz-align: center; vertical-align: middle"></i></button></div><div class="col-xs-12"></div></div><div class="col-xs-12 marcontainer" ng-if="vm.mostrar"><div ng-if="vm.resultadoIndicador.length === 0" class="texto-sin-resultado"><h4>No se ha encontrado resultado para los datos ingresados.</h4><h4>Por favor revise canal, indicador y filtros seleccionados.</h4></div><infobox ng-hide="!vm.resultadoTotal" is-total="true" filtro-selected="vm.filtroSelected" class="col-xs-4" obj-resultado="vm.resultadoTotal" rotate="vm.rotate"></infobox></div><div class="repeater-container" ng-if="vm.mostrar"><row filtro-selected="vm.resultadoFiltroSelected" ng-repeat="row in vm.rows | limitTo:17 | orderBy:\'valor\'" class="col-xs-12" rows="row"></div><div class="col-xs-12" ng-if="vm.mostrar && vm.resultadoIndicador.length > 1 && vm.paginas > 1" style="text-align: center"><button class="btn button-blue" ng-if="vm.pagina !== 1" ng-click="vm.restarPagina()" style="margin: 2rem"><i class="glyphicon glyphicon-chevron-left" style="color: blue"></i></button><label>PAGINA {{vm.pagina}} DE {{vm.paginas}}</label><button class="btn button-blue" ng-if="vm.pagina !== vm.paginas" ng-click="vm.sumarPagina()" style="margin: 2rem"><i class="glyphicon glyphicon-chevron-right" style="color: blue"></i></button></div><div class="container-buttons" ng-if="vm.mostrar"><button type="button" ng-click="vm.volverDashboard()" class="btn button-green" ng-class="{\'button-disabled\':vm.disabledButtonMostrarResultados}"><span>VOLVER AL DASHBOARD</span></button></div></div></div>');
$templateCache.put('app/components/resultado/row.html','<infobox filtro-selected="vm.filtroSelected" class="col-xs-4" ng-repeat="row in vm.rows" obj-resultado="row.resultado" rotate="row.rotate" ng-if="row.resultado!=undefined"></infobox>');
$templateCache.put('app/components/sidebar/sidebar.html','<div class="sidebar" id="sidebar" ng-class="{\'close-sidebar\': !vm.mostrarSidebar}"><div class="nav-side-menu"><div class="container-perfil"><div class="container-opciones-perfil"><div class="col-xs-12 container-proyecto" ng-class="{\'containers-sidebar-close\': !vm.mostrarSidebar}"><div class="col-xs-2 container-icon"><img class="image-icon" src="/content/images/perfectstore-icon.png" ng-class="{\'image-icon-sidebar-close\': !vm.mostrarSidebar}" alt="icon"></div><div class="col-xs-9 container-nombre-proyecto" ng-if="vm.mostrarSidebar"><span class="nombre-proyecto" ng-if="vm.nombreProyecto">{{vm.nombreProyecto}}</span> <span class="nombre-proyecto" ng-if="!vm.nombreProyecto"><b>-</b></span></div><a class="col-xs-1 change-project" ng-show="vm.mostrarSidebar"><!-- <i class="fas fa-archive fa-2x icon-change-project" ng-class="{\'icon-change-project-sidebar-close\': !vm.mostrarSidebar}" ng-click="vm.changeProject()"\r\n                        data-toggle="tooltip" data-placement="bottom" title="Cambiar proyecto"></i> --> <i ng-if="!vm.unicoProyecto" class="fas fa-file-export icon-change-project" ng-class="{\'icon-change-project-sidebar-close\': !vm.mostrarSidebar}" ng-click="vm.changeProject()" data-toggle="tooltip" data-placement="bottom" title="Cambiar proyecto"></i></a></div><div class="col-xs-12 container-usuario" ng-class="{\'containers-sidebar-close\': !vm.mostrarSidebar}"><div class="col-xs-2 avatar" ng-class="{\'avatar-sidebar-close\': !vm.mostrarSidebar}"><img src=\'{{vm.imagenbase64?("data:image/jpeg;base64, "+vm.imagenbase64):"/content/images/default-avatar.png"}}\' ng-class="{\'avatar-img-sidebar-close\': !vm.mostrarSidebar}" ng-click="vm.openModalPerfil()" alt="photo"></div><div class="col-xs-9 container-nombre-usuario"><span class="nombre-usuario" ng-if="vm.mostrarSidebar">{{vm.razonSocial}} </span><span class="glyphicon glyph-arrow accordion" ng-class="{\'glyphicon-chevron-down\' : !vm.opcionesOpen, \'glyphicon-chevron-up\' : vm.opcionesOpen}" ng-click="vm.opcionesOpen = !vm.opcionesOpen"></span><div class="panel"><ul class="opciones" ng-class="{\'opciones-open\' : vm.opcionesOpen}"><!-- <li>Proyecto:</li> --><li ng-click="vm.openModalPerfil()">Editar Perfil</li><li ng-click="vm.logOut()">Cerrar sesi\xF3n</li></ul></div></div></div></div></div><div class="menu-list"><ul class="menu-content collapse out" id="menu-content" ng-class="{\'menu-content-sidebar-close\': !vm.mostrarSidebar}"><div ng-if="vm.isMenuLoaded()"><!----><!--Negocio--><li data-toggle="collapse" ng-click="vm.abrirNegocio()" class="collapsed" ng-class="{\'button-active\': vm.mostrarNegocio}" ng-show="vm.mostrarSidebar"><i class="fas fa-cube"></i> <span>NEGOCIO</span></li><ul class="container-negocio" ng-show="vm.mostrarNegocio"><!--Canales--><li data-toggle="collapse" ng-click="vm.abrirCanales()" class="collapsed negocio-option" ng-show="vm.mostrarSidebar" ng-class="{\'button-active\': vm.mostrarCanales}"><i class="fas fa-indent"></i> <span>CANALES</span> <i ng-class="{\'fas fa-sort-down ps-arrow-down\': !vm.mostrarCanales}"></i> <i ng-class="{\'fas fa-sort-up ps-arrow-up\': vm.mostrarCanales}"></i></li><ul class="sub-menu" ng-show="vm.mostrarCanales && vm.mostrarSidebar"><div class="container-submenu-canales"><li ng-repeat="canal in vm.canales" ng-click="vm.cambioCanal(canal)"><span>{{canal.Nombre}}</span></li></div></ul><!----><!--Indicadores--><div ng-if="!vm.haveMenu"><li data-toggle="collapse" ng-click="vm.abrirIndicadores()" class="collapsed negocio-option" ng-class="{\'button-active\': vm.mostrarIndicadores}" ng-show="vm.mostrarSidebar"><i class="fab fa-connectdevelop"></i> <span>KPI</span> <i ng-class="{\'fas fa-sort-down ps-arrow-down\': !vm.mostrarIndicadores}"></i> <i ng-class="{\'fas fa-sort-up ps-arrow-up\': vm.mostrarIndicadores}"></i></li><ul class="sub-menu" ng-show="vm.mostrarIndicadores && vm.mostrarSidebar"><div class="container-submenu-indicadores"><li ng-repeat="indicador in vm.indicadores" ng-click="vm.cambioIndicador(indicador)"><span>{{indicador.NombreIndicador}}</span></li><li ng-show="vm.indicadores == \'\' && vm.perfectStores == \'\'" class="container-submenu-indicadores"><span>Sin KPI</span></li></div></ul></div><!--MENU--><div ng-if="vm.haveMenu"><li data-toggle="collapse" ng-click="vm.abrirMenu()" class="collapsed negocio-option" ng-class="{\'button-active\': vm.mostrarMenu}" ng-if="vm.mostrarSidebar"><i class="fab fa-connectdevelop"></i> <span>MENU</span> <i ng-class="{\'fas fa-sort-down ps-arrow-down\': !vm.mostrarMenu, \'fas fa-sort-up ps-arrow-up\': vm.mostrarMenu}"></i></li><ul class="sub-menu" ng-if="vm.mostrarMenu && vm.mostrarSidebar"><div class="container-submenu-indicadores" ng-repeat="menuOpc in vm.menuEntrante[vm.canalElegido][0] track by $index"><li ng-click="vm.elegirMenu(menuOpc)" ng-init="menuPadre1 = menuOpc.IdMenu"><span style="font-size: 14px">{{menuOpc.NombreMenu}}</span> <i class="arrowMenu" ng-if="menuOpc.IdIndicador === null" ng-class="{\'fas fa-sort-down ps-arrow-down\': vm.menuElegido[0] !== menuPadre1, \'fas fa-sort-up ps-arrow-up\': vm.menuElegido[0] === menuPadre1}"></i></li><div ng-if="vm.menuElegido[0] === menuPadre1" ng-repeat="menuOpc in vm.menuEntrante[vm.canalElegido][vm.menuElegido[0]] track by $index"><li ng-click="vm.elegirMenu(menuOpc)" ng-init="menuPadre2 = menuOpc.IdMenu"><span style="font-size: 12px; padding-left: 5px">{{menuOpc.NombreMenu}}</span> <i class="arrowMenu" ng-if="menuOpc.IdIndicador === null" ng-class="{\'fas fa-sort-down ps-arrow-down\': vm.menuElegido[1] !== menuPadre2, \'fas fa-sort-up ps-arrow-up\': vm.menuElegido[1] === menuPadre2}"></i></li><div ng-if="vm.menuElegido[0] === menuPadre1 && vm.menuElegido[1] === menuPadre2" ng-repeat="menuOpc in vm.menuEntrante[vm.canalElegido][vm.menuElegido[1]] track by $index"><li ng-click="vm.elegirMenu(menuOpc)" ng-init="menuPadre3 = menuOpc.IdMenu"><span style="font-size: 10px; padding-left: 10px">{{menuOpc.NombreMenu}}</span> <i class="arrowMenu" ng-if="menuOpc.IdIndicador === null" ng-class="{\'fas fa-sort-down ps-arrow-down\': vm.menuElegido[2] !== menuPadre3, \'fas fa-sort-up ps-arrow-up\': vm.menuElegido[2] === menuPadre3}"></i></li><div ng-if="vm.menuElegido[0] === menuPadre1 && vm.menuElegido[1] === menuPadre2 && vm.menuElegido[2] === menuPadre3" ng-repeat="menuOpc in vm.menuEntrante[vm.canalElegido][vm.menuElegido[2]] track by $index"><li ng-click="vm.elegirMenu(menuOpc)" ng-init="menuPadre4 = menuOpc.IdMenu"><span style="font-size: 8px; padding-left: 15px">{{menuOpc.NombreMenu}}</span> <i class="arrowMenu" ng-if="menuOpc.IdIndicador === null" ng-class="{\'fas fa-sort-down ps-arrow-down\': vm.menuElegido[3] !== menuPadre4, \'fas fa-sort-up ps-arrow-up\': vm.menuElegido[3] === menuPadre4}"></i></li><div ng-if="vm.menuElegido[0] === menuPadre1 && vm.menuElegido[1] === menuPadre2 && vm.menuElegido[2] === menuPadre3 && vm.menuElegido[3] === menuPadre4" ng-repeat="menuOpc in vm.menuEntrante[vm.canalElegido][vm.menuElegido[3]] track by $index"><li ng-click="vm.elegirMenu(menuOpc)" ng-init="menuPadre5 = menuOpc.IdMenu"><span style="font-size: 8px; padding-left: 20px">{{menuOpc.NombreMenu}}</span> <i class="arrowMenu" ng-if="menuOpc.IdIndicador === null" ng-class="{\'fas fa-sort-down ps-arrow-down\': vm.menuElegido[4] !== menuPadre5, \'fas fa-sort-up ps-arrow-up\': vm.menuElegido[4] === menuPadre5}"></i></li></div></div></div></div></div></ul></div></ul><!----><!--Segmentaci\xF3n--><li data-toggle="collapse" class="collapsed button-disabled" ng-show="vm.disabledButtonSegmentacion && vm.mostrarSidebar"><i class="fas fa-cube"></i> <span>SEGMENTACI\xD3N</span></li><li data-toggle="collapse" ng-show="!vm.disabledButtonSegmentacion && vm.mostrarSidebar" ng-click="vm.abrirSegmentacion()" class="collapsed" ng-class="{\'button-active\': vm.mostrarSegmentacion}"><i class="fas fa-cube"></i> <span>SEGMENTACI\xD3N</span></li><ul ng-show="vm.mostrarSegmentacion"><!----><!--Filtros--><!--[{"SelectFilter":"Geograf\xEDa","Group":[{"GroupFilter":"NombrePais","ValueFilter":[{"OptionValue":"NombrePais = \'MEXICO\'","OptionText":"MEXICO"}]} --><li data-toggle="collapse" ng-click="vm.abrirFiltros()" class="collapsed segmentacion-option" ng-show="vm.mostrarSidebar" ng-class="{\'button-active\': vm.mostrarFiltros}"><i class="fas fa-filter"></i> <span>FILTROS</span> <i ng-class="{\'fas fa-sort-down ps-arrow-down\': !vm.mostrarFiltros}"></i> <i ng-class="{\'fas fa-sort-up ps-arrow-up\': vm.mostrarFiltros}"></i></li><ul class="sub-menu" ng-show="vm.mostrarFiltros && vm.mostrarSidebar"><div class="container-submenu-filtros"><li ng-if="filtro.SelectFilter == \'Geograf\xEDa\'" ng-repeat="filtro in vm.filtrosvisiones.m_Item1" ng-click="vm.openModal(filtro)"><span>GEOGRAF\xCDA</span></li><li ng-show="filtro.SelectFilter != \'Geograf\xEDa\'" ng-repeat="filtro in vm.filtrosvisiones.m_Item1" ng-click="vm.openModalCadena(filtro)"><span>{{filtro.SelectFilter}}</span></li><li ng-click="vm.openModalFecha()"><span>FECHA</span></li></div></ul><!----><!--Visi\xF3n--><li data-toggle="collapse" ng-click="vm.abrirVision()" class="collapsed segmentacion-option" ng-class="{\'button-active\': vm.mostrarVision}" ng-show="vm.mostrarSidebar"><i class="far fa-map"></i> <span>VISI\xD3N</span> <i ng-class="{\'fas fa-sort-down ps-arrow-down\': !vm.mostrarVision}"></i> <i ng-class="{\'fas fa-sort-up ps-arrow-up\': vm.mostrarVision}"></i></li><ul class="sub-menu" ng-show="vm.mostrarVision && vm.mostrarSidebar"><div class="container-submenu-filtros" ng-repeat="vision in vm.filtrosvisiones.m_Item2 track by $index"><li ng-click="vm.openVisionValue($index)" data-toggle="collapse" class="collapsed segmentacion-option" ng-class="{\'button-active\': vm.mostrarValorVision === $index }"><span>{{vision.SelectVision}}</span></li><li ng-show="vm.mostrarValorVision === $parent.$index" ng-repeat="valoresVisiones in vision.VisionValues" ng-click="vm.asignarVision(valoresVisiones)"><span style="font-size: 10px">{{valoresVisiones.OptionValue}}</span></li></div><div class="container-submenu-filtros" style="margin-bottom: 100px"><li ng-click="vm.openVisionDate()" data-toggle="collapse" class="collapsed segmentacion-option" ng-class="{\'button-active\': vm.mostrarValorVisionDate}"><span>FECHA</span></li><li ng-show="vm.mostrarValorVisionDate" class="collapsed segmentacion-option" ng-click="vm.asignarVisionPredefinida(\'A\xF1o\')"><span>A\xF1o</span></li><li ng-show="vm.mostrarValorVisionDate" class="collapsed segmentacion-option" ng-click="vm.asignarVisionPredefinida(\'Quarter\')"><span>Quarter</span></li><li ng-show="vm.mostrarValorVisionDate" class="collapsed segmentacion-option" ng-click="vm.asignarVisionPredefinida(\'Mes\')"><span>Mes</span></li><li ng-show="vm.mostrarValorVisionDate" style="margin-bottom: 60px" class="collapsed segmentacion-option" ng-click="vm.asignarVisionPredefinida(\'Dia\')"><span>D\xEDa</span></li></div></ul><!--<li data-toggle="collapse"  ng-click="vm.openModalSecundarias()" class="collapsed segmentacion-option"\r\n                            ng-show="vm.mostrarSidebar">\r\n                                <i class="fas fa-plus"></i>\r\n                                <span>Medidas Secundarias</span>\r\n                            </li>\r\n                            --></ul><!----><!--Evidencias--><li data-toggle="collapse" ng-click="vm.abrirMainEvidencias()" class="collapsed" ng-class="{\'button-active\': vm.mostrarMainEvidencias}" ng-show="vm.mostrarSidebar"><i class="fas fa-image"></i> <span>EVIDENCIAS</span></li><!----></div><div ng-if="!vm.isMenuLoaded()"><li data-toggle="collapse" ng-show="vm.mostrarSidebar" class="collapsed" style="font-size: 17px"><i class="fas fa-clock"></i> <span>CARGANDO ...</span></li></div></ul></div></div></div>');
$templateCache.put('app/components/tabla/tabla.html','<div class="tabla"><div class="row"><div class="col-xs-12"><div class="col-xs-11"><h3 class="col-xs-7 title">Tabla</h3><form class="form-inline"><i class="fa fa-search" aria-hidden="true" ng-if="vm.mostrarTablas"></i> <input class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search" ng-change="vm.busqueda()" ng-if="vm.mostrarTablas" ng-value="vm.filtro" ng-model="vm.filtro"></form></div><div class="col-xs-1 container-btn"><button class="btn btn-primary width-fix" ng-click="vm.cargaTabla()"><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': !vm.mostrarTablas,\r\n                    \'glyphicon-chevron-up\': vm.mostrarTablas }" style="horiz-align: center; vertical-align: middle"></i></button></div></div><div id="contenttable" class="container-fluid cuerpoTabla row" ng-if="vm.mostrarTablas"><iframe id="txtArea1" ng-if="false"></iframe><div class="table-responsive col-xs-12"><div class="contenedor"><button ng-if="!vm.descargando && !vm.actualizandoData" class="btn button-export" ng-click="vm.ExportToXLSX()"><i class="glyphicon glyphicon-export"></i> EXPORTAR EXCEL</button> <button ng-if="!vm.descargando && vm.actualizandoData" class="btn button-export-load"><i class="glyphicon glyphicon-repeat glyphicon-animate"></i> ACTUALIZANDO EXCEL</button> <button ng-if="vm.descargando" class="btn button-export-load"><i class="glyphicon glyphicon-repeat glyphicon-animate"></i> EXPORTANDO EXCEL</button></div><table id="tablaToExcel" class="table-historial listado col-xs-12"><thead><tr><th ng-if="vm.nCol()" ng-repeat="vision in vm.visiones track by $index"><div class="container-header-tabla"><div class="container-button" ng-if="$index !== 0"><button class="btn boton-mover boton-retroceder" ng-click="vm.retrocederColumna($index)"><i class="glyphicon glyphicon-chevron-left"></i></button></div><div class="container-titulo-tabla"><h5 class="titulo-tabla">{{vision.OptionValue}}</h5></div><div class="container-button" ng-if="$index !== vm.resultadoTablaIndicador[0].vision.length - 1"><button class="btn boton-mover boton-adelantar" ng-click="vm.adelantarColumna($index)"><i class="glyphicon glyphicon-chevron-right"></i></button></div></div></th><th><div ng-if="!(vm.resultadoTablaIndicador[0].indicador == \'Perfect Store\' && vm.resultadoTablaIndicador[0].vision.length == 0)"><h5 class="titulo-tabla">Resultado</h5></div><div ng-if="vm.resultadoTablaIndicador[0].indicador == \'Perfect Store\' && vm.resultadoTablaIndicador[0].vision.length == 0"><h5 class="titulo-tabla">Indicador</h5></div></th><th ng-if="vm.resultadoTablaIndicador[0].indicador != \'Perfect Store\'" ng-repeat="secundaria in vm.resultadoTablaIndicador[0].medidasSecundarias track by $index"><h5 class="titulo-tabla">{{secundaria.Medida.Nombre}}</h5></th><th ng-if="vm.resultadoTablaIndicador[0].indicador == \'Perfect Store\' && vm.resultadoTablaIndicador[0].vision.length > 0" ng-repeat="secundaria in vm.resultadoTablaIndicador[0].medidasSecundarias track by $index"><h5 class="titulo-tabla">{{secundaria.PreMascara}}</h5></th><th ng-if="vm.resultadoTablaIndicador[0].indicador == \'Perfect Store\' && vm.resultadoTablaIndicador[0].vision.length == 0"><h5 class="titulo-tabla">Puntaje</h5></th></tr></thead><tbody><tr ng-repeat="tienda in vm.datosTabla | filter: vm.filtro"><td ng-if="tienda.nombresColumnas.length > 0" ng-repeat="col in tienda.nombresColumnas track by $index"><a>{{col}}</a></td><td><a ng-if="vm.tVal(tienda)">{{tienda.preMascara}} {{tienda.valor | number}} {{tienda.mascara}}</a> <a ng-if="!vm.tVal(tienda)">NA</a></td><td ng-repeat="secundaria in tienda.medidasSecundarias"><a ng-if="!vm.proyectColombia(tienda,secundaria)">{{secundaria.Medida.PreMascara}} {{secundaria.resultado | number}} {{secundaria.Medida.Mascara}} </a><a ng-if="vm.proyectColombia(tienda,secundaria)">{{secundaria.Medida.PreMascara}} {{vm.valor}} {{secundaria.Medida.Mascara}}</a></td></tr></tbody></table><div class="col-xs-12"><button ng-if="vm.pagina !== 1" class="btn button-blue" ng-click="vm.restarPagina()" style="margin: 2rem"><i class="glyphicon glyphicon-chevron-left" style="color: white; horiz-align: center"></i></button><label ng-if="vm.paginas !== 1">PAGINA {{vm.pagina}} DE {{vm.paginas}}</label><button ng-if="vm.pagina !== vm.paginas" class="btn button-blue" ng-click="vm.sumarPagina()" style="margin: 2rem"><i class="glyphicon glyphicon-chevron-right" style="color: white; horiz-align: center"></i></button></div></div></div></div></div>');
$templateCache.put('app/components/eviGallery/eviGallery.html','<div class="evi-gallery"><div class="gal-container row"><div class="item col-xs-6 col-sm-4 col-md-3 col-lg-2" ng-repeat="item in vm.items" ng-class="{\'active\': $index == vm.selection}"><div class="item-container" ng-click="vm.select($index)"><div class="glow"></div><img class="d-block w-100" ng-src="{{item.pathEvidencia}}"></div><div class="nombre"><div class="inner">{{item.nombreEvidencia}}</div></div></div></div></div>');
$templateCache.put('app/components/tarjetas/tarjetas-modal.html','<div class="modal-tarjetas"><div class="container-menu"><div class="well container-cadena" style="text-align: center"><h4 class="titulo-cadena">Configuraci\xF3n Gr\xE1ficas</h4><div class="row"><div class="form-group col-xs-2"><label>Posici\xF3n</label><select class="form-control" ng-options="posicion for posicion in vm.posiciones" ng-change="vm.cambioPos()" ng-model="vm.posicionElegida"></select></div><div class="form-group col-xs-8"><label>Gr\xE1fica</label><select class="form-control" ng-options="grafica.SubTituloGrafica + \' - \' + grafica.TituloGrafica for grafica in vm.graficas" ng-model="vm.graficaElegida"></select></div><div class="form-group col-xs-2"><button ng-show="!vm.mostrarGuardar" style="margin-top: 25px" ng-disabled="!vm.posicionElegida && !vm.graficaElegida && vm.posicionElegida == \'\'" ng-click="vm.agregarGrafica()" class="btn btn-primary"><i class="fas fa-plus"></i></button> <button ng-show="vm.mostrarGuardar" style="margin-top: 25px" ng-disabled="!vm.posicionElegida && !vm.graficaElegida && vm.posicionElegida == \'\'" ng-click="vm.agregarGrafica()" class="btn btn-primary"><i class="fas fa-save"></i></button></div></div><div class="row"><div class="form-group col-xs-12"><table class="table table-bordered table-historial listado col-xs-12"><thead><tr><td>Posici\xF3n</td><td>Gr\xE1fica</td><td></td></tr></thead><tbody><tr ng-repeat="x in vm.graficasElegidas | orderBy : \'Pos\'"><td>{{ x.Pos }}</td><td>{{ x.NombreGrafica }}</td><td><button style="width: auto;height: auto;padding: 5px;line-height: 1;margin-bottom: 2px;margin-right: -10px" ng-click="vm.deleteGrafica(x.Pos)" class="btn btn-danger"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody></table></div></div><div class="form-group"><button ng-click="vm.save()" class="btn btn-primary"><i class="glyphicon glyphicon-save"></i> Guardar Cambios</button></div></div></div></div>');
$templateCache.put('app/components/tarjetas/tarjetas.html','<div class="tarjetas"><section id="info-boxs" class="row"><div class="col-sm-4"><div class="info-box card-tarjeta"><div class="wrapper-content"><div ng-show="!vm.graficaNoConfigurada[0] && !vm.cargandoGraficaSecundarias[0]"><h5 class="card-category">{{vm.titulo[0]}}</h5><h3>{{vm.subTitulo[0]}}</h3><div class="container-title" uib-dropdown><div class="card-header"><button class="btn btn-primary iconoOpcions" uib-dropdown-toggle><i class="fas fa-cog" style="horiz-align: center; vertical-align: middle"></i></button></div><ul class="dropdown-menu modalOpcions" role="menu" aria-labelledby="single-button" uib-dropdown-menu><li role="menuitem" ng-click="vm.configurarGraficos()"><a>Configurar gr\xE1fico</a></li><li role="menuitem" ng-if="vm.tipo[0] == \'line\'" ng-click="vm.cambiarTipo(0)"><a>Barras</a></li><li role="menuitem" ng-if="vm.tipo[0] == \'bar\'" ng-click="vm.cambiarTipo(0)"><a>Linea</a></li><li role="menuitem" ng-if="vm.mostrarlabel[0] == false" ng-click="vm.cambiarLabel(0)"><a>Mostrar Label</a></li><li role="menuitem" ng-if="vm.mostrarlabel[0] == true" ng-click="vm.cambiarLabel(0)"><a>Ocultar Label</a></li><li role="menuitem"><a>Cerrar</a></li></ul></div><canvas class="graficos" id="chart-pos-1" width="480" height="270"></canvas><div class="card-footer"><div class="stats"><i class="now-ui-icons arrows-1_refresh-69"></i></div></div></div><div ng-show="vm.cargandoGraficaSecundarias[0]" style="height: 437px; position: relative; text-align: center"><div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%)"><i class="fa fa-spinner fa-spin fa-4x" style="color: #4ab9f2 !important"></i></div></div><div style="height: 437px; text-align: center" ng-if="!vm.cargandoGraficaSecundarias[0]" ng-show="vm.graficaNoConfigurada[0]"><label style="text-align: center;margin-top: 18rem; color: #0f005a">Esta gr\xE1fica no se encuentra configurada.<br>Para realizar esta configuraci\xF3n,<br>haga clic en <a style="color: #0f005a" ng-click="vm.configurarGraficos()"><u>CONFIGURAR GRAFICAS</u></a></label></div></div></div></div><div class="col-sm-4"><div class="info-box card-tarjeta"><div class="wrapper-content"><div ng-show="!vm.graficaNoConfigurada[1] && !vm.cargandoGraficaSecundarias[1]"><h5 class="card-category">{{vm.titulo[1]}}</h5><h3>{{vm.subTitulo[1]}}</h3><div class="container-title" uib-dropdown><div class="card-header"><button class="btn btn-primary iconoOpcions" uib-dropdown-toggle><i class="fas fa-cog" style="horiz-align: center; vertical-align: middle"></i></button></div><ul class="dropdown-menu modalOpcions" role="menu" aria-labelledby="single-button" uib-dropdown-menu><li role="menuitem" ng-click="vm.configurarGraficos()"><a>Configurar gr\xE1fico</a></li><li role="menuitem" ng-if="vm.tipo[1] == \'line\'" ng-click="vm.cambiarTipo(1)"><a>Barras</a></li><li role="menuitem" ng-if="vm.tipo[1] == \'bar\'" ng-click="vm.cambiarTipo(1)"><a>Linea</a></li><li role="menuitem" ng-if="vm.mostrarlabel[1] == false" ng-click="vm.cambiarLabel(1)"><a>Mostrar Label</a></li><li role="menuitem" ng-if="vm.mostrarlabel[1] == true" ng-click="vm.cambiarLabel(1)"><a>Ocultar Label</a></li><li role="menuitem"><a>Cerrar</a></li></ul></div><canvas class="graficos" id="chart-pos-2" width="480" height="270"></canvas><div class="card-footer"><div class="stats"><i class="now-ui-icons arrows-1_refresh-69"></i></div></div></div><div ng-show="vm.cargandoGraficaSecundarias[1]" style="height: 437px; position: relative; text-align: center"><div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%)"><i class="fa fa-spinner fa-spin fa-4x" style="color: #4ab9f2 !important"></i></div></div><div style="height: 437px; text-align: center" ng-if="!vm.cargandoGraficaSecundarias[1]" ng-show="vm.graficaNoConfigurada[1]"><label style="text-align: center;margin-top: 18rem; color: #0f005a">Esta gr\xE1fica no se encuentra configurada.<br>Para realizar esta configuraci\xF3n,<br>haga clic en <a style="color: #0f005a" ng-click="vm.configurarGraficos()"><u>CONFIGURAR GRAFICAS</u></a></label></div></div></div></div><div class="col-sm-4"><div class="info-box card-tarjeta"><div class="wrapper-content"><div ng-show="!vm.graficaNoConfigurada[2] && !vm.cargandoGraficaSecundarias[2]"><h5 class="card-category">{{vm.titulo[2]}}</h5><h3>{{vm.subTitulo[2]}}</h3><div class="container-title" uib-dropdown><div class="card-header"><button class="btn btn-primary iconoOpcions" uib-dropdown-toggle><i class="fas fa-cog" style="horiz-align: center; vertical-align: middle"></i></button></div><ul class="dropdown-menu modalOpcions" role="menu" aria-labelledby="single-button" uib-dropdown-menu><li role="menuitem" ng-click="vm.configurarGraficos()"><a>Configurar gr\xE1fico</a></li><li role="menuitem" ng-if="vm.tipo[2] == \'line\'" ng-click="vm.cambiarTipo(2)"><a>Barras</a></li><li role="menuitem" ng-if="vm.tipo[2] == \'bar\'" ng-click="vm.cambiarTipo(2)"><a>Linea</a></li><li role="menuitem" ng-if="vm.mostrarlabel[2] == false" ng-click="vm.cambiarLabel(2)"><a>Mostar Label</a></li><li role="menuitem" ng-if="vm.mostrarlabel[2] == true" ng-click="vm.cambiarLabel(2)"><a>Ocultar Label</a></li><li role="menuitem"><a>Cerrar</a></li></ul></div><canvas class="graficos" id="chart-pos-3" width="480" height="270"></canvas><div class="card-footer"><div class="stats"><i class="now-ui-icons arrows-1_refresh-69"></i></div></div></div><div ng-show="vm.cargandoGraficaSecundarias[2]" style="height: 437px; position: relative; text-align: center"><div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%)"><i class="fa fa-spinner fa-spin fa-4x" style="color: #4ab9f2 !important"></i></div></div><div style="height: 437px;text-align: center" ng-if="!vm.cargandoGraficaSecundarias[2]" ng-show="vm.graficaNoConfigurada[2]"><label style="text-align: center;margin-top: 18rem; color: #0f005a">Esta gr\xE1fica no se encuentra configurada.<br>Para realizar esta configuraci\xF3n,<br>haga clic en <a style="color: #0f005a" ng-click="vm.configurarGraficos()"><u>CONFIGURAR GRAFICAS</u></a></label></div></div></div></div></section></div>');
$templateCache.put('app/components/tendencias/tendencias.html','<div class="tendencias"><div class="row"><div class="col-xs-12"><div class="col-xs-11"><h3 class="col-xs-5 title">Tendencias</h3></div><div class="col-xs-1 container-btn"><button class="btn btn-primary width-fix cargandoIcon" ng-show="vm.cargandoTendencias"><i class="fa-li fa fa-spinner fa-spin fa-2x" style="horiz-align: center; vertical-align: middle"></i></button> <button class="btn btn-primary width-fix" ng-if="vm.resultadoTendenciasIndicador.length !== 0" ng-show="!vm.cargandoTendencias" ng-click="(vm.mostrarTendencias)=!(vm.mostrarTendencias);"><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': !vm.mostrarTendencias,\r\n                    \'glyphicon-chevron-up\': vm.mostrarTendencias }" style="horiz-align: center; vertical-align: middle"></i></button></div><div class="col-xs-1 container-btn" ng-if="vm.resultadoTendenciasIndicador.length == 0" ng-show="!vm.cargandoTendencias"><button class="btn btn-primary width-fix"><i ng-click="vm.cargarTendencias();" class="glyphicon glyphicon-chevron-down" style="horiz-align: center; vertical-align: middle"></i></button></div></div><div id="concol-xs-12tentchart row" class="col-xs-12 container-fluid chart-wrapper" ng-show="vm.mostrarTendencias"><div class="container-buttons"><div class="row"><div class="button-tendencias" ng-show="vm.mostrarTendencias" ng-click="vm.cambioMes();" ng-class="{\'button-tendencias-active\':vm.disableMes}"><i class="fas fa-dot-circle"></i> <span>MES</span></div><div class="button-tendencias" ng-show="vm.mostrarTendencias" ng-click="vm.cambioTri();" ng-class="{\'button-tendencias-active\':vm.disableTri}"><i class="fas fa-dot-circle"></i> <span>TRIMESTRE</span></div><div class="button-tendencias" ng-show="vm.mostrarTendencias" ng-click="vm.cambioSe();" ng-class="{\'button-tendencias-active\':vm.disableSe}"><i class="fas fa-dot-circle"></i> <span>SEMESTRE</span></div><div class="button-tendencias" ng-show="vm.mostrarTendencias" ng-click="vm.cambioAnio();" ng-class="{\'button-tendencias-active\':vm.disableAnio}"><i class="fas fa-dot-circle"></i> <span>A&Ntilde;O</span></div></div></div><div class="chart-container"><canvas id="myChart" height="385" class="chartjs-render-monitor" width="770" style="display: block; width: 770px; height: 385px"></canvas></div></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Registration</h1><div class="alert alert-success" ng-show="vm.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="Your username" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Your username can only contain letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button></form><p></p><div class="alert alert-warning">If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/components/eviPagination/eviPagination.html','<div class="evi-pagination"><span class="pag-prev" ng-click="vm.prev()">Anterior</span> <span class="pag-item" ng-repeat="number in vm.numbers" ng-click="vm.setPage(number)" ng-class="{\'active\': vm.page==number}">{{number+1}}</span> <span class="pag-next" ng-click="vm.next()">Siguiente</span></div>');
$templateCache.put('app/components/tablero/filtros.html','<div class="filtros-tablero"><div class="loading" ng-show="!vm.loaded"><i class="fa fa-spinner fa-spin fa-2x"></i></div><h3 ng-show="vm.filtros.Geografia.length > 0 || vm.filtros.Distribucion.length >0" class="title">Filtros seleccionados</h3><div class="filtro-category" ng-repeat="(groupName, group) in vm.filtros"><div class="filtro-pill" ng-repeat="filtro in group" ng-click="vm.removeFilter(groupName, filtro)">{{filtro.valorMostar}}: {{filtro.valorA}} <i class="fas fa-times-circle" role="button"></i></div></div><div ng-show="vm.fechas.fechadesde != \'null\' && vm.fechas.fechahasta != \'null\'" class="filtro-pill" ng-click="vm.removeFecha()">Fecha: {{vm.fechas.fechadesde}} - {{vm.fechas.fechahasta}} <i class="fas fa-times-circle" role="button"></i></div><h3 class="title">Agregar filtros</h3><div class="filtros-list"><div class="filtros-list-categoria" ng-click="vm.abrirGeografia()">Geograf\xEDa <i class="fas fa-plus-circle"></i></div><div class="filtros-list-categoria" ng-click="vm.abrirDistribucion()">Distribuci\xF3n <i class="fas fa-plus-circle"></i></div><div ng-if="vm.filtroValido(\'Cadena\')" class="filtros-list-categoria" ng-click="vm.abrirModal(\'Cadena\')">Cadena <i class="fas fa-plus-circle"></i></div><div ng-if="vm.filtroValido(\'Tipo\')" class="filtros-list-categoria" ng-click="vm.abrirModal(\'Tipo\')">Tipo de tienda <i class="fas fa-plus-circle"></i></div><div class="filtros-list-categoria" ng-click="vm.abrirFecha()">Fecha <i class="fas fa-plus-circle"></i></div></div><div class="aceptar"><button class="btn btn-primary" ng-click="vm.aceptar()">ACEPTAR</button></div></div>');
$templateCache.put('app/components/tablero/tablero.html','<div class="tablero"><div class="tablero-canal" ng-repeat="canal in vm.canales | orderBy:\'Nombre\'"><div class="loading" ng-show="!vm.loaded[canal.Nombre]"><i class="fa fa-spinner fa-spin fa-2x"></i></div><div class="top"><h3 class="nombreCanal">CANAL {{canal.Nombre}}</h3><div class="top-menu" ng-if="vm.crumbMenu[canal.Nombre].length > 0"><div ng-repeat="menu in vm.crumbMenu[canal.Nombre] track by $index"><h4 class="crumbMenu" ng-click="vm.returnMenu(vm.menu[canal.Nombre][menu.IdMenu][0],canal.Nombre)">/ {{menu.NombreMenu}}</h4></div></div><div class="filter-button" ng-click="vm.mostrarFiltros(canal.Nombre)"><i class="fas fa-filter toolbar-btn" role="button"></i></div></div><div class="tablero-cards row"><!-- Menu inicial --><div ng-if="vm.hideMenu === false" class="tablero-card" ng-repeat="(index, menu) in vm.menu[canal.Nombre][0]" ng-click="vm.setOpcion(menu,canal)" ng-class="{\'double col-xs-12 col-sm-12 col-md-8 col-lg-6\':menu.Span === 2 || menu.span === 2, \'col-xs-12 col-sm-6 col-md-4 col-lg-3\':menu.Span === 1 || menu.span === 1}"><div ng-if="menu && menu.IdMenu !== null && menu.IdIndicador === null" class="tablero-card-inner"><h3 class="title-menu">{{menu.NombreMenu}}</h3></div><div ng-if="menu.info.IdIndicador !== null && menu.IdIndicador !== null" class="tablero-card-inner"><h3 ng-class="{\'title\': menu.info.IdMedidaIndicador !== 1068, \'title-menu\': menu.info.IdMedidaIndicador === 1068}">{{menu.info.NombreIndicador}}</h3><div><div class="data" ng-if="menu.info.IdMedidaIndicador !== 1068"><div class="percentage-number" ng-if="menu.resultado.resultado !== -1 && menu.resultado.Mascara && menu.resultado.Mascara !== \'SIN MASCARA\'">{{menu.resultado.PreMascara}}{{(menu.resultado.resultado*100).toFixed(2)}} {{menu.resultado.Mascara}}<span ng-if="menu.isPerfectStore"> %</span></div><div class="percentage-number" ng-if="menu.resultado.resultado !== -1 && menu.resultado.Mascara && menu.resultado.Mascara === \'SIN MASCARA\'">{{menu.resultado.PreMascara}}{{(menu.resultado.resultado*100).toFixed(2)}}<span ng-if="menu.isPerfectStore"> %</span></div><div class="percentage-number" ng-if="menu.resultado.resultado !== -1 && !menu.resultado.Mascara">{{menu.resultado.PreMascara}}{{(menu.resultado.resultado*100).toFixed(2)}} {{menu.resultado.Mascara}}<span ng-if="menu.isPerfectStore"> %</span></div><div class="percentage-number" ng-if="menu.resultado.resultado == -1">NA</div><div class="percentage-bar" ng-if="menu.resultado.resultado !== -1"><div class="percentage-bar-inner" style="width:{{(menu.resultado.resultado*100).toFixed(2)}}%"></div></div></div><div class="secundarias" ng-repeat="secundaria in menu.secundarias"><h4 class="secundaria-title"><strong><span ng-if="menu.isPerfectStore">{{secundaria.nombresFiltros[0]}}</span> <span ng-if="!menu.isPerfectStore">{{secundaria.Medida.Nombre}}</span> </strong><span class="secundaria-data"><span ng-if="menu.isPerfectStore  && secundaria.resultado !== -1">{{secundaria.PreMascara}}{{(secundaria.resultado*100).toFixed(2)}}{{secundaria.Mascara}}</span> <span ng-if="menu.isPerfectStore  && secundaria.resultado == -1">{{secundaria.PreMascara}} 0 % - Pts 0</span> <span ng-if="!menu.isPerfectStore && !vm.proyectColombia(menu, secundaria)">{{secundaria.Medida.PreMascara}}{{secundaria.resultado | number}}{{secundaria.Medida.Mascara}}</span> <span ng-if="!menu.isPerfectStore && vm.proyectColombia(menu, secundaria)">{{secundaria.Medida.PreMascara}}{{vm.valor}}{{secundaria.Medida.Mascara}}</span></span></h4></div></div></div></div><!-- Submenu elegido --><div ng-if="vm.menuElegido[canal.Nombre].length !== 0" class="tablero-card" ng-repeat="(index, menu) in vm.menuElegido[canal.Nombre]" ng-click="vm.setOpcion(menu,canal)" ng-class="{\'double col-xs-12 col-sm-12 col-md-8 col-lg-6\':menu.Span === 2 || menu.span === 2, \'col-xs-12 col-sm-6 col-md-4 col-lg-3\':menu.Span === 1 || menu.span === 1}"><div ng-if="menu.IdMenu !== null && menu.IdIndicador === null" class="tablero-card-inner"><h3 class="sub-title-menu">{{menu.NombreMenu}}</h3></div><div ng-if="menu.info.IdIndicador !== null && menu.IdIndicador !== null" class="tablero-card-inner"><h3 ng-class="{\'title\': menu.info.IdMedidaIndicador !== 1068, \'sub-title-menu\': menu.info.IdMedidaIndicador === 1068}">{{menu.info.NombreIndicador}}</h3><div><div class="data" ng-if="menu.info.IdMedidaIndicador !== 1068"><div class="percentage-number" ng-if="menu.resultado.resultado !== -1">{{menu.resultado.PreMascara}}{{(menu.resultado.resultado*100).toFixed(2)}}{{menu.resultado.Mascara}}<span ng-if="menu.isPerfectStore"> %</span></div><div class="percentage-number" ng-if="menu.resultado.resultado == -1">NA</div><div class="percentage-bar" ng-if="menu.resultado.resultado !== -1"><div class="percentage-bar-inner" style="width:{{(menu.resultado.resultado*100).toFixed(2)}}%"></div></div></div><div class="secundarias" ng-repeat="secundaria in menu.secundarias"><h4 class="secundaria-title"><strong><span ng-if="menu.isPerfectStore">{{secundaria.nombresFiltros[0]}}</span> <span ng-if="!menu.isPerfectStore">{{secundaria.Medida.Nombre}}</span> </strong><span class="secundaria-data"><span ng-if="menu.isPerfectStore  && secundaria.resultado !== -1">{{secundaria.PreMascara}}{{(secundaria.resultado*100).toFixed(2)}}{{secundaria.Mascara}}</span> <span ng-if="menu.isPerfectStore  && secundaria.resultado == -1">{{secundaria.PreMascara}} 0 % - Pts 0</span> <span ng-if="!menu.isPerfectStore && !vm.proyectColombia(menu, secundaria)">{{secundaria.Medida.PreMascara}}{{secundaria.resultado | number}}{{secundaria.Medida.Mascara}}</span> <span ng-if="!menu.isPerfectStore && vm.proyectColombia(menu, secundaria)">{{secundaria.Medida.PreMascara}}{{vm.valor}}{{secundaria.Medida.Mascara}}</span></span></h4></div></div></div></div></div></div></div>');
$templateCache.put('app/components/medidaSecundaria/medidaSecundaria.html','<div class="cadena" ng-init="vm.cargarSeleccionados()"><div class="container-menu"><div id="cadena" class="well container-cadena"><div><div class="titulo-submenu-cadena col-xs-6">Medidas Secundarias</div><div class="selectors search col-xs-4 single-line"><input ng-change="vm.busqueda()" ng-value="vm.filtro" ng-model="vm.filtro" type="search" class="form-control" placeholder="Search"></div><div class="col-xs-1 span1rem single-line"><i class="fa fa-search ilupa inline-margin" aria-hidden="true"></i></div><div class="col-xs-1"></div><div class="cadena-lista" style="margin-bottom: 2rem"><hr><div class="custom-control custom-radio" ng-repeat="opc in vm.datosTabla track by $index"><input type="checkbox" class="custom-control-input" id="radioB{{$index}}" value="{{$index}}" ng-checked="false" ng-click="vm.seleccionoValor($index)"><label class="custom-control-label" for="radioB{{$index}}">{{opc.Nombre}}</label></div><div class="container-button"><button class="btn btn-primary" ng-class="{\'disabled-button\': vm.disabledButtonCadena}" ng-click="vm.aceptarCadena()">ACEPTAR</button></div></div></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated">Activated</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span>Profiles</span></th><th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login">Activated</button></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-inverse" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><span style="horiz-align: center">PerfectStoreDashboard</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span>Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span>Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span>Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span>Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span>Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span>Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span>Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li></ul></div></div></nav>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row no-margin-left-right"><div class="col-md-8 col-md-offset-2"><h1>Restablecer la contrase\xF1a</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>La direcci\xF3n de correo no est\xE1 registrada!</strong>Por favor revisa e intenta de nuevo.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Ingrese la direcci\xF3n de correo electr\xF3nico que utiliz\xF3 para registrarse.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p>Revise sus correos electr\xF3nicos para obtener detalles sobre c\xF3mo restablecer su contrase\xF1a.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Su email" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Su correo electr\xF3nico es obligatorio.</p><p class="help-block" ng-show="form.email.$error.email">Su correo electr\xF3nico es inv\xE1lido.</p><p class="help-block" ng-show="form.email.$error.minlength">Su correo electr\xF3nico debe tener al menos 5 caracteres.</p><p class="help-block" ng-show="form.email.$error.maxlength">Su correo electr\xF3nico no puede tener m\xE1s de 100 caracteres.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reiniciar</button></form></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row no-margin-left-right"><div class="col-md-4 col-md-offset-4"><h1>Restablecer contrase\xF1a</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Falta la clave para restablecer la contrase\xF1a.</p></div><div class="alert alert-danger" ng-show="vm.error"><p>La contrase\xF1a no se pudo restablecer. Recuerde que una solicitud de contrase\xF1a solo es v\xE1lida por 24 horas.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Tu contrase\xF1a ha sido restablecida.</strong> Por favor <a class="alert-link" href="" ng-click="vm.login()">volver a ingresar.</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">La contrase\xF1a y su confirmaci\xF3n no coinciden!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">Nueva contrase\xF1a</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Tu contrase\xF1a es requerida.</p><p class="help-block" ng-show="form.password.$error.minlength">Su contrase\xF1a debe tener al menos 4 caracteres.</p><p class="help-block" ng-show="form.password.$error.maxlength">Su contrase\xF1a no puede tener m\xE1s de 50 caracteres.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Se requiere la confirmaci\xF3n de su contrase\xF1a.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">La confirmaci\xF3n de su contrase\xF1a debe tener al menos 4 caracteres.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">La confirmaci\xF3n de su contrase\xF1a no puede tener m\xE1s de 50 caracteres.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Restablecer la contrase\xF1a</button></form></div></div></div></div>');}]);})();